var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlacklogomark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 412.99 294.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clip-path);}.cls-2{clip-path:url(#clip-path-2);}.cls-3{clip-path:url(#clip-path-3);}.cls-4{clip-path:url(#clip-path-4);}.cls-5{clip-path:url(#clip-path-5);}.cls-6{clip-path:url(#clip-path-6);}.cls-7{clip-path:url(#clip-path-7);}.cls-8{clip-path:url(#clip-path-8);}.cls-9{clip-path:url(#clip-path-9);}.cls-10{clip-path:url(#clip-path-10);}.cls-11{clip-path:url(#clip-path-11);}.cls-12{clip-path:url(#clip-path-12);}.cls-13{clip-path:url(#clip-path-13);}.cls-14{clip-path:url(#clip-path-15);}.cls-15{clip-path:url(#clip-path-16);}.cls-16{clip-path:url(#clip-path-17);}.cls-17{clip-path:url(#clip-path-18);}.cls-18{clip-path:url(#clip-path-22);}.cls-19{clip-path:url(#clip-path-25);}.cls-20{clip-path:url(#clip-path-26);}.cls-21{clip-path:url(#clip-path-27);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 39.05,
    width: 1.09,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 39.05,
    width: 0.54,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.51,
    y: 39.59,
    width: 0.54,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.25,
    y: 39.59,
    width: 1.09,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 39.59,
    width: 0.54,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.79,
    y: 39.59,
    width: 1.09,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 39.59,
    width: 1.09,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.33,
    y: 39.59,
    width: 1.09,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 108.86,
    width: 1.09,
    height: 1.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 110.5,
    width: 0.54,
    height: 2.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 110.5,
    width: 0.54,
    height: 1.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 112.14,
    width: 0.54,
    height: 2.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 109.95,
    width: 1.09,
    height: 2.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 111.59,
    width: 1.09,
    height: 2.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 113.77,
    width: 1.09,
    height: 2.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 115.95,
    width: 0.54,
    height: 2.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.33,
    y: 204.86,
    width: 1.09,
    height: 0.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.7,
    y: 204.31,
    width: 1.63,
    height: 1.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.25,
    y: 204.31,
    width: 1.09,
    height: 1.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 117.59,
    width: 1.09,
    height: 2.18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 119.77,
    width: 1.09,
    height: 2.18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.29,60.55l-.63.6.52-.37.62-.6-.51.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74,48.12l-.76.39.57-.23.76-.38-.57.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.66,48.69l-.75.41.56-.24.75-.4-.56.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.24,66.29c-.19.22-.39.44-.58.67l.46-.42c.19-.23.38-.45.58-.67l-.46.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,82.14c-.13.27-.26.54-.4.8l.36-.51c.13-.27.26-.54.4-.8l-.36.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.82,67.82l-.56.69c.14-.15.29-.29.44-.43s.37-.46.57-.69c-.16.14-.3.28-.45.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.22,48.76l-.77.4.55-.23.76-.4-.54.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.72,84l-.38.81c.11-.17.22-.35.34-.52s.25-.54.38-.81c-.12.17-.23.34-.34.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.35,47.69l-.77.37.54-.22.77-.37-.54.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.86,55.79l-.7.54.51-.33c.23-.17.46-.36.7-.53l-.51.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,76.41l-.47.77.38-.49.47-.76-.38.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.45,69.39c-.19.23-.37.47-.55.71l.43-.45.54-.7-.42.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,53.38c.17.1.35.19.52.3-.24-.17-.48-.34-.73-.5l-.51-.29.72.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72,59.9l-.66.6.48-.37.66-.59-.48.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9,64.44l-.61.66.46-.41.6-.65-.45.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.22,64.65c.16.13.3.27.45.4l-.61-.65-.45-.4c.21.21.41.43.61.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2,57l-.69.56.5-.34c.22-.19.46-.37.69-.55l-.5.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.83,87.73l-.35.83c.09-.18.2-.36.3-.53l.35-.84c-.1.18-.21.36-.3.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,44c-.26.09-.52.17-.78.27l.51-.15.78-.26-.51.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.55,48.53l-.77.4.53-.23.76-.4-.52.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6,52l.51.28-.74-.47-.52-.28.75.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.33,54.5l.51.31-.72-.51-.5-.31.71.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.93,79.93l-.44.79c.11-.17.23-.33.35-.5l.44-.79c-.12.17-.24.33-.35.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.91,43.14l-.77.23.49-.13L98.4,43l-.49.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.82,72.63l-.52.74c.13-.15.26-.31.4-.46s.34-.49.52-.73l-.4.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.58,58.27l-.68.58.48-.35c.23-.19.45-.39.68-.57l-.48.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.86,52.94l-.74.5.5-.3.74-.49-.5.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,67.46l-.58.69c.14-.15.28-.29.43-.43l.57-.69-.42.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.16,55.5l-.71.54c.16-.12.32-.22.49-.33l.7-.53-.48.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.86,81.74l-.42.8.33-.51.42-.8-.33.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,91.58c-.11.28-.22.57-.32.85l.27-.55c.1-.28.19-.57.31-.85-.1.18-.18.37-.26.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.77,49.42l-.76.43.51-.25.76-.42-.51.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,53.1l.5.3-.74-.49-.5-.29.74.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.25,102.23c.07.19.13.39.2.58-.07-.29-.13-.59-.2-.88s-.12-.39-.19-.59c.07.3.13.59.19.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.43,49.57l.5.24-.76-.42-.51-.24.77.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.91,48.3c-.25.14-.51.27-.77.4l.51-.23c.26-.14.51-.27.77-.39l-.51.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.9,91.82l.26.56c-.1-.29-.21-.57-.31-.86s-.18-.36-.26-.55c.1.29.2.57.31.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.52,74.54c.13.15.26.31.38.47l-.51-.75-.37-.47.5.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,59.58c-.23.19-.45.4-.67.6l.46-.37.67-.59-.46.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.84,83.57l-.4.81c.1-.17.2-.35.31-.52l.4-.81c-.1.18-.21.35-.31.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.07,47.25l-.78.37.51-.21.78-.37-.51.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.92,51.62l-.75.47.5-.28.75-.46-.5.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.36,93.54c-.1.28-.19.57-.29.86.08-.19.16-.38.25-.56s.19-.57.29-.86c-.09.19-.17.37-.25.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66,69l-.57.71c.14-.15.27-.3.41-.44l.57-.7c-.14.14-.28.28-.41.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,104.27c.06.2.12.4.17.59-.05-.29-.11-.59-.17-.89s-.11-.39-.17-.58c.06.29.12.59.17.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,64.1c-.21.21-.42.43-.62.65l.43-.4.62-.65-.43.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.14,47.38l.51.21-.78-.36-.51-.21.78.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.37,76c-.17.25-.33.51-.49.77l.36-.49.49-.76-.36.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,46.4l.5.19-.79-.34-.49-.19.78.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.27,51.77l.5.28-.75-.46-.49-.28.74.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,54.05l-.73.52.49-.31c.24-.17.48-.35.73-.51l-.49.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,69.24c.13.15.28.29.41.44L185.3,69l-.41-.43c.2.23.38.46.57.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.17,43.65l-.78.25.48-.14.78-.25-.48.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,64.3l.43.4c-.21-.21-.41-.43-.62-.65l-.44-.4.63.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,54.22c.16.1.33.2.48.31-.24-.18-.48-.34-.72-.51l-.49-.31.73.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.73,76.25l.36.48-.5-.76q-.17-.24-.36-.48c.17.25.34.5.5.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,50.37l-.76.44.5-.26c.25-.15.5-.3.76-.44l-.5.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.64,95.52l-.27.86c.07-.19.15-.38.23-.56s.17-.58.27-.87c-.08.19-.16.38-.23.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.87,85.43l-.39.83.3-.53c.13-.28.26-.55.38-.82l-.29.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22,106.33l.15.6-.15-.9c-.05-.2-.1-.39-.16-.59.06.3.11.6.16.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.33,70.62l-.55.72.39-.45.55-.72-.39.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.44,60.93l-.66.62.45-.38.66-.61-.45.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,50.52l.49.26-.76-.44-.5-.26.77.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.21,77.76l-.47.78c.11-.17.23-.33.34-.49s.31-.52.48-.78l-.35.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,44.38l-.78.28.48-.16.78-.27-.48.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7,65.58l-.61.67.42-.42.61-.66-.42.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.15,49.19l-.76.41.49-.24.77-.41-.5.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.2,85.67c.1.18.2.35.29.53l-.39-.82c-.08-.18-.19-.35-.29-.53l.39.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.21,52.67l-.74.49.48-.29.74-.49-.48.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,61.12l.45.38-.66-.61-.45-.38.66.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.8,70.84l.38.45-.55-.72-.39-.45.56.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,58c-.24.19-.47.39-.69.58.15-.12.3-.24.46-.35s.46-.38.69-.57L69.9,58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,97.52c-.09.29-.17.58-.25.87l.21-.57.25-.88-.21.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.06,49.32l.49.25-.76-.42-.5-.23.77.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,87.32c-.13.28-.25.56-.37.83l.28-.54.36-.82c-.09.17-.19.35-.27.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.62,108.4c0,.2.1.41.13.6,0-.3-.08-.6-.13-.9s-.09-.39-.14-.59c.05.3.1.6.14.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.89,78l.34.5-.48-.78-.34-.49.48.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.49,55.21l-.72.53c.16-.11.31-.22.48-.32l.71-.53-.47.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.31,48.08l-.78.39.49-.23.78-.39-.49.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.45,65.78l.42.42-.62-.67-.42-.41.62.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,52.83l.49.29-.75-.48c-.16-.1-.31-.2-.48-.29l.74.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.48,47l-.78.36.48-.21.78-.35-.48.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,58.14l.46.36-.69-.58-.46-.34.69.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.92,48.21l.49.23-.78-.39-.49-.23.78.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,72.26,55.5,73l.38-.46c.17-.24.35-.49.54-.73-.13.15-.26.3-.38.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.58,46.19l.48.2-.78-.34-.48-.18.78.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1,79.53c-.15.27-.31.53-.46.79l.33-.5c.15-.26.3-.53.46-.78-.12.16-.22.33-.33.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.76,47.16c.16.08.32.14.48.21l-.78-.36-.49-.2.79.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.06,97.76c.07.19.14.38.2.57-.08-.29-.16-.58-.25-.87l-.21-.57c.09.29.17.58.26.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,87.56c.1.18.19.36.28.54-.12-.28-.24-.56-.38-.83a5.44,5.44,0,0,0-.27-.54c.13.28.25.55.37.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.93,62.32c-.22.21-.44.42-.65.64l.43-.4.65-.62c-.15.12-.29.25-.43.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,51.36c-.26.15-.51.31-.76.47l.48-.28.76-.46c-.16.09-.33.17-.48.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.18,42.7l-.76.22.44-.12.76-.21-.44.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.29,67.1c-.19.23-.4.45-.59.69.13-.15.26-.29.4-.43l.6-.68-.41.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.36,99.53c-.09.29-.16.58-.24.88.06-.2.12-.39.19-.58s.15-.58.24-.88c-.07.19-.13.39-.19.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,110.49c0,.2.08.4.11.6l-.12-.9c0-.2-.07-.4-.11-.6l.12.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,72.48c.13.15.26.3.38.46-.18-.24-.36-.49-.55-.73s-.24-.31-.37-.46c.19.24.37.48.54.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.08,89.23c-.13.28-.24.56-.36.84l.26-.54.35-.84c-.09.18-.17.36-.25.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.64,41.33l-.71.15.38-.07.71-.14-.38.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,79.77c.11.16.22.33.32.5-.15-.26-.3-.53-.46-.79s-.21-.33-.32-.5c.15.26.31.52.46.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,51.51l.48.28-.76-.46-.48-.27.76.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.24,62.52c.15.12.29.26.43.39l-.65-.63-.43-.39.65.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.45,44.21l-.79.28.47-.16.78-.27-.46.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,67.31c.13.14.27.28.4.43-.2-.24-.4-.46-.6-.69l-.4-.42.6.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.32,59.26l-.68.6c.14-.13.29-.25.44-.37l.68-.59-.44.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.53,53.77l-.74.51.47-.31.74-.5-.47.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.67,99.78c.07.19.13.38.19.57l-.24-.88-.18-.57c.08.29.15.58.23.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.42,50.12l-.77.44.48-.26c.25-.15.51-.29.77-.43l-.48.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8,73.93l-.53.75.36-.48.53-.74c-.12.16-.25.31-.36.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,81.34l-.44.8c.1-.18.21-.34.31-.51l.44-.8c-.1.17-.21.33-.31.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.86,56.41c-.24.18-.48.36-.71.55l.45-.34.71-.54-.45.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,89.47c.09.18.17.37.26.55-.12-.28-.24-.56-.35-.85l-.26-.54c.12.28.24.56.35.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.79,101.56l-.21.89c.05-.2.11-.39.17-.59L42,101c-.06.19-.11.39-.17.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,112.58c0,.2.07.4.1.6,0-.3-.07-.6-.1-.9s-.06-.4-.1-.6c0,.3.07.6.1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87,59.45l.44.36c-.22-.2-.45-.4-.69-.59l-.43-.36.68.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.81,50.27l.48.25c-.26-.15-.52-.28-.77-.43l-.48-.26.77.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.17,41.9c-.24.05-.49.11-.73.18l.4-.1.73-.17-.4.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.25,91.16l-.33.86.24-.56.33-.85-.24.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.05,43.33l-.77.25.45-.14.77-.23-.45.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.93,68.66l-.59.7.39-.44c.19-.24.39-.47.58-.7-.13.15-.26.29-.38.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57,49l-.78.41.48-.24.77-.41-.47.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.33,74.15l.36.48-.53-.75-.36-.47.53.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.07,81.57l.3.51-.44-.8-.31-.5.45.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,41.23l-.7.14.36-.07.7-.14-.36.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73,47.85l-.78.39.47-.23.79-.38-.48.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,49.09l.47.24-.77-.41-.47-.24.77.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.91,46.83l-.78.36L87.6,47l.78-.35-.47.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.24,101.81c0,.19.11.39.17.58-.07-.29-.14-.59-.22-.89s-.11-.38-.17-.58c.08.3.15.59.22.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.73,64l.41.4-.64-.65c-.14-.13-.28-.26-.41-.4l.64.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.08,39.64h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6,52.4l-.75.49.46-.29.75-.48-.46.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.16,46l.46.19-.78-.34-.47-.18c.27.1.53.22.79.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.23,68.87c.13.15.26.29.38.44-.19-.24-.39-.47-.58-.7l-.39-.44.59.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.82,91.41l.24.55c-.12-.28-.23-.57-.34-.85l-.24-.55.34.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,83.17c-.15.27-.29.54-.43.81l.29-.52.43-.81c-.1.17-.2.34-.29.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5,114.68c0,.2.05.4.07.6,0-.3,0-.6-.07-.9s-.05-.41-.08-.61c0,.3.06.6.08.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,48l.47.23-.78-.39-.47-.22.78.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.28,103.61c-.07.29-.13.59-.19.89,0-.2.09-.39.15-.59s.13-.59.19-.89l-.15.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,75.63c-.17.26-.35.51-.51.76l.34-.48c.17-.25.33-.51.51-.75-.12.15-.23.31-.34.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,47l.47.21L156,46.8l-.46-.2.78.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.68,39.6h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.78,60.6l-.68.61.43-.37.67-.61-.42.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,39.61h0l-.36,0v0h.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.63,52.56l.46.29-.75-.48-.47-.29.76.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.48,93.12c-.11.29-.21.57-.31.86.07-.19.14-.37.22-.56s.21-.57.31-.86c-.07.19-.15.37-.22.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,54.92l-.73.53.45-.32.74-.53c-.16.1-.31.21-.46.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25,57.65l-.7.58.44-.35.71-.57-.45.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.65,41.77l-.73.18.39-.09.72-.17-.38.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.08,83.4l.3.52c-.15-.26-.29-.54-.43-.81l-.29-.51c.14.26.29.53.42.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.42,60.8l.42.37-.67-.61-.43-.37.68.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.53,75.86l.34.48-.51-.76L190,75.1l.51.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,70.25,57,71l.37-.45.57-.71c-.13.14-.25.29-.37.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.59,41.12l-.69.14.34-.06.69-.14-.34.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,65.23l-.63.67.4-.42c.21-.22.41-.44.63-.66l-.4.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.75,103.85l.15.59c-.06-.29-.13-.59-.2-.89l-.15-.59c.07.3.14.6.2.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.71,51.1l-.76.46.46-.27.76-.46-.46.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.35,55.09l.45.32c-.24-.18-.48-.36-.73-.53l-.46-.32.74.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,117.18c0,.2,0,.4.05.61l-.06-.91c0-.21,0-.41-.05-.61,0,.3,0,.6.06.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.83,105.67l-.18.89c0-.19.08-.39.13-.59l.18-.9c-.05.2-.09.4-.13.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.59,93.37c.08.18.15.37.22.56l-.32-.87c-.07-.18-.14-.37-.22-.55.11.28.22.57.32.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.05,85c-.14.28-.28.55-.41.83l.27-.53c.13-.28.27-.55.41-.82-.1.17-.18.35-.27.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.12,42.42l-.75.21.4-.11.75-.2-.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.53,51.25l.46.28-.76-.46-.47-.27.77.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.44,77.37l-.49.77.32-.49.49-.77-.32.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.56,70.47l.36.45c-.18-.25-.37-.48-.57-.72l-.37-.44.58.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,65.43l.4.42c-.21-.22-.41-.45-.63-.67l-.4-.41q.33.33.63.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.76,95.1c-.11.28-.2.57-.3.86.07-.19.13-.37.21-.56s.19-.58.29-.87c-.07.19-.14.38-.2.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.85,49.87l-.78.44.47-.26c.25-.15.51-.28.77-.43l-.46.25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 39.05,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.64,39.48h0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 39.05,
    width: 0.54,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.14,39.48h0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.27,62l-.67.63.42-.39.66-.63-.41.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,105.91c.05.2.09.4.13.6q-.08-.45-.18-.9c0-.2-.08-.39-.13-.59.07.3.13.59.18.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.06,85.26l.27.53c-.14-.27-.28-.54-.41-.82s-.19-.35-.27-.53c.13.28.27.55.41.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,53.49l-.75.51.45-.31.75-.49c-.16.09-.3.2-.45.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.81,118.89c0,.2,0,.41,0,.61,0-.3,0-.6,0-.91s0-.4,0-.61c0,.31,0,.61,0,.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,50l.46.25-.78-.43c-.14-.09-.3-.16-.45-.25.25.15.51.28.77.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.69,77.6l.32.49-.49-.77-.32-.49.49.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.14,41.65l-.72.18.37-.09.72-.17-.37.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,48.72l-.78.41c.15-.08.3-.17.46-.24l.78-.41-.46.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.42,107.74l-.15.9c0-.2.07-.4.11-.6s.1-.6.16-.9l-.12.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.32,71.88l-.56.73.35-.46.56-.73-.35.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.37,46.62l-.79.36.46-.21.78-.35-.45.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.31,95.34c.07.19.14.38.2.57-.1-.29-.19-.58-.3-.87s-.13-.37-.2-.56c.1.29.21.57.3.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.18,47.63,85.4,48l.46-.22.78-.37a3.82,3.82,0,0,0-.46.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,66.74c-.2.23-.41.45-.61.69a5.22,5.22,0,0,1,.39-.43c.2-.23.4-.46.61-.68l-.39.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,53.66l.45.3-.74-.5c-.15-.1-.3-.21-.45-.3l.74.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.69,58.94l-.7.59.43-.36.69-.58-.42.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,62.18l.41.39-.66-.63-.41-.38.66.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.25,56.11l-.72.55c.14-.12.29-.23.44-.34l.72-.54-.44.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.39,43.87c-.26.09-.52.19-.78.27L95,44l.77-.26-.42.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.25,48.85l.45.24-.78-.4-.45-.24.78.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9,46.74l.45.21-.79-.35-.45-.21.79.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,97.09c-.1.29-.19.59-.27.88,0-.19.12-.38.18-.57s.18-.58.28-.88c-.07.19-.13.38-.19.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,47.76l.45.23-.78-.39-.46-.21.79.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.33,79.14l-.48.79c.1-.17.2-.34.31-.51s.32-.52.47-.78l-.3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.84,72.1l.36.46-.56-.73-.36-.45.56.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.61,42.29l-.74.21.38-.11c.25-.08.5-.14.75-.2l-.39.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.53,59.13l.42.36-.7-.59-.42-.35.7.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,56.28l.43.34-.72-.55-.44-.33.73.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.61,108c0,.2.08.39.11.59-.05-.3-.11-.6-.17-.9s-.07-.39-.1-.59c.05.3.1.6.16.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.57,67c.14.14.26.29.39.43l-.62-.69-.38-.42.61.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,52.13l-.76.49.45-.29.75-.48-.44.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,87.15c.08.18.17.35.25.53-.12-.27-.26-.55-.39-.83s-.17-.35-.26-.53c.14.28.27.55.4.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,97.34l.18.57c-.09-.29-.18-.58-.28-.87l-.18-.57c.1.29.18.58.28.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,79.37l.31.5-.48-.79-.31-.49.48.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.65,41.54l-.71.17.34-.09.72-.16-.35.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.23,44.65l-.79.29.43-.16.78-.29c-.14,0-.29.1-.42.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.22,52.29l.45.29-.76-.48-.45-.28c.26.15.51.31.76.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.07,73.55l-.54.74.34-.47.54-.74-.34.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.48,99.11c-.09.29-.18.58-.26.88.05-.19.1-.39.16-.58s.18-.58.26-.88c-.06.19-.11.39-.16.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.24,68.29l-.6.7.37-.44.6-.69c-.12.15-.24.29-.37.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,110.07c0,.2.07.4.1.6l-.15-.9q0-.3-.09-.6c.06.3.1.6.14.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.15,50.85l-.76.45.44-.27.77-.45-.45.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.29,54.63l-.74.53.43-.32.74-.52-.43.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.27,80.94c-.16.26-.31.53-.46.79.09-.17.19-.34.29-.5l.45-.8-.28.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.41,63.61l.39.4-.65-.64c-.13-.13-.27-.26-.4-.4l.66.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15,60.28c-.23.2-.46.4-.68.61l.41-.38.68-.6c-.14.12-.28.24-.41.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.09,73.77l.33.47-.54-.74-.34-.47.55.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.66,57.35l-.72.56.43-.34.71-.57c-.14.12-.29.23-.42.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.85,89.06c.08.18.16.36.23.54-.12-.28-.24-.56-.37-.84s-.16-.36-.23-.54l.37.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,51l.45.27-.78-.46-.44-.26.77.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.13,42.16l-.74.2.37-.11.73-.19-.36.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,54.8l.44.32-.75-.53-.43-.31.74.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.59,99.35c.07.2.12.39.17.58-.09-.29-.17-.58-.26-.88s-.11-.38-.17-.57c.1.29.18.58.26.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.94,68.51l.37.43c-.21-.23-.4-.46-.61-.7l-.36-.43.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,81.17c.1.17.19.34.28.51l-.46-.8c-.09-.17-.19-.34-.29-.5.16.26.32.52.47.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,60.47l.4.37c-.22-.2-.46-.4-.68-.61s-.27-.24-.41-.36c.23.2.46.39.69.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.53,42.88l-.76.24a3,3,0,0,1,.39-.13l.76-.23c-.13.05-.26.08-.39.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.09,39.69l-.43,0h0l.43,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.91,101.14c-.07.3-.16.59-.24.89l.15-.59c.08-.29.15-.59.24-.88l-.15.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.22,39.71h0l-.42,0h0l.42,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57,57.53l.43.34-.72-.56-.42-.35.71.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.48,48.49l-.78.4.44-.24.78-.4-.44.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.18,41.43l-.71.16.33-.08.7-.16-.32.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,49.77l.44.26-.78-.43c-.14-.09-.29-.17-.44-.25l.78.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.25,112.16c0,.2.05.4.07.61,0-.31-.08-.61-.12-.91s0-.4-.07-.6l.12.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.88,75.24c-.18.26-.36.51-.53.77.1-.17.22-.32.32-.49l.53-.75c-.11.16-.22.31-.32.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.42,46.54l.43.2-.78-.35-.43-.2.78.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.36,64.88l-.64.66c.13-.13.25-.27.38-.41l.64-.66-.38.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.62,39.66l-.4,0h0l.4,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.79,48.62l.44.24-.79-.4-.43-.24.78.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,39.68h0l-.4,0h0a2.6,2.6,0,0,1,.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61,47.54l.44.22-.79-.37-.44-.22.79.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.37,53.22l-.76.5.44-.31.75-.49c-.15.09-.29.2-.43.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.25,82.76l-.44.81c.09-.17.17-.34.27-.52s.29-.53.44-.8l-.27.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.92,69.88l-.59.72.36-.45.58-.71c-.11.15-.23.29-.35.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.67,91c.08.18.15.37.22.55-.11-.28-.24-.56-.36-.85l-.21-.55c.12.28.24.57.35.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.16,101.39c.05.19.09.38.14.58l-.24-.89c-.05-.19-.09-.39-.15-.58.09.29.17.59.25.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.16,39.62l-.38,0h0l.39,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.74,44.47l-.79.29.41-.16.79-.29-.41.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.15,39.64h0l-.39,0h0l.39,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.29,75.47l.31.48-.53-.76-.31-.47.53.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.89,53.38l.42.3-.75-.5-.43-.3.76.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.85,65.08l.37.42c-.21-.22-.42-.45-.64-.67l-.38-.4.65.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.77,127.35c0,.2,0,.41,0,.62,0-.31,0-.61,0-.91s0-.41,0-.62c0,.3,0,.61,0,.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.55,128.92c0,.21,0,.42,0,.62,0-.3,0-.6,0-.9s0-.41,0-.62c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4,103.18c-.08.3-.15.6-.22.9,0-.2.08-.39.13-.59s.15-.59.22-.89c-.05.19-.09.39-.13.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.65,61.65l-.67.63q.18-.2.39-.39l.67-.62-.39.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,42l-.73.2.34-.11.73-.19-.34.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89,83l.26.52q-.21-.4-.45-.81c-.08-.17-.17-.35-.26-.52l.45.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.66,92.7c-.11.29-.23.58-.34.86.07-.18.13-.37.21-.56s.22-.57.33-.85c-.07.18-.13.37-.2.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,39.61h0l-.36,0h0l.36,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.49,114.26c0,.2,0,.41,0,.61,0-.3-.07-.61-.1-.91s0-.4-.05-.61c0,.31.07.61.1.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.68,55.81l-.74.55.42-.33c.25-.19.49-.37.74-.54-.14.1-.29.21-.42.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,70.1l.35.45-.59-.72-.34-.44.58.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.71,41.32l-.69.16.3-.08.69-.16-.3.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1,58.63l-.71.58c.14-.11.27-.24.41-.36l.7-.58-.4.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.26,39.57l-.35,0h0l.35,0h.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,51.87l-.77.48.43-.29.77-.47-.43.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.06,39.59H126l-.34,0h0l.35,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.73,77c-.18.25-.35.51-.52.77.1-.16.2-.33.31-.49s.33-.52.51-.77a4.94,4.94,0,0,0-.3.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.06,42.74l-.75.23.37-.13.75-.22-.37.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.57,61.85c.14.12.26.26.39.39-.22-.22-.45-.42-.67-.63l-.39-.38.67.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.57,56c.14.1.28.22.42.33l-.74-.55-.41-.32c.24.18.49.35.73.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81,39.55l-.33,0-.07,0,.33,0h.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.56,45.3l-.79.33.42-.19.78-.31-.41.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.28,84.62l-.43.82c.09-.18.17-.36.26-.53l.42-.82c-.08.18-.17.35-.25.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.51,39.56h-.08l-.32,0h.07l.33,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67,103.43c0,.2.09.39.12.59-.06-.3-.14-.59-.22-.89s-.09-.39-.13-.59c.08.3.15.6.23.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.78,52l.43.28-.77-.47-.43-.28.77.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.44,93a5.31,5.31,0,0,1,.2.56c-.11-.29-.22-.58-.34-.86s-.13-.37-.2-.56c.12.29.24.57.34.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.14,58.81l.41.36-.71-.58c-.13-.13-.27-.24-.41-.36l.71.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.37,39.53c-.1,0-.21,0-.31,0l-.09,0,.3,0h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,39.54h-.09l-.31,0h.1l.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,66.39c-.21.22-.42.45-.62.68.11-.15.24-.28.36-.43l.63-.67a5,5,0,0,0-.37.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,71.51c-.19.24-.39.48-.57.72.1-.15.22-.3.33-.45s.38-.49.58-.73c-.12.15-.23.3-.34.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,39.52l-.29,0-.11,0h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,105.25c-.08.29-.14.59-.21.89,0-.2.07-.39.11-.59s.13-.6.2-.9c0,.2-.07.4-.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.63,50.6l-.77.45.43-.27.77-.45-.43.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.4,39.52l-.12,0-.28,0h.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.67,117.74l0,.61c0-.3,0-.6-.08-.91l0-.61c0,.31,0,.61.08.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,77.21l.3.49c-.17-.26-.34-.52-.52-.77s-.19-.33-.29-.49l.51.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,39.5l-.27,0-.13,0h.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.51,
    y: 39.59,
    width: 0.54,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.84,39.51h-.14l-.26,0h.14l.26,0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.94,94.68c-.11.29-.21.58-.32.86.06-.19.12-.37.19-.56s.2-.58.31-.86l-.18.56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.25,
    y: 39.59,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121,39.5l-.25,0-.15,0h.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 122.97,
    y: 39.59,
    width: 0.54,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.28,39.5l-.16,0-.24,0h.4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.85,84.86c.09.17.17.35.25.52-.14-.27-.28-.55-.43-.82l-.25-.52c.15.27.29.54.43.82"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.79,
    y: 39.59,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.6,39.49l-.22,0h-.18l.22,0h.18"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 39.59,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.72,39.49l-.18,0-.22,0h.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.33,
    y: 39.59,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.16,39.49l-.2,0-.2,0h.4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.64,50.75c.15.08.29.17.43.26l-.78-.45-.42-.26.77.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.24,66.59c.13.14.25.29.37.43l-.63-.68-.37-.42.63.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.74,54.34l-.75.53.42-.32.75-.52-.42.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.27,41.21l-.69.16.29-.08c.22,0,.45-.11.68-.15l-.28.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.21,41.91l-.73.19.33-.1.72-.19-.32.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.55,71.72l.33.47c-.19-.25-.38-.49-.58-.73s-.22-.31-.33-.46l.58.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.19,63.07l-.67.65c.12-.14.25-.27.38-.4l.67-.64-.38.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,105.49c0,.2.08.4.11.6-.07-.3-.13-.6-.21-.9s-.07-.39-.1-.59c.07.3.14.59.2.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.48,49.53l.42.25-.78-.42-.42-.25.78.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.62,78.74l-.5.79c.09-.17.19-.34.29-.5s.32-.53.49-.79l-.28.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.36,86.5c-.14.27-.27.55-.41.83.08-.18.15-.36.24-.54s.27-.55.41-.82c-.09.17-.16.35-.24.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.12,47.33l.41.22-.79-.38-.41-.21.79.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.52,54.51l.42.32-.76-.52c-.13-.11-.27-.21-.41-.31.25.16.5.34.75.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.16,94.92q.1.28.18.57c-.1-.29-.21-.58-.32-.87s-.12-.37-.18-.56c.11.29.22.57.32.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3,48.39l.42.24-.78-.4-.42-.23.78.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.8,118.48c0,.2,0,.41,0,.61l-.06-.91c0-.2,0-.41,0-.61l.06.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.54,107.32c0,.3-.12.6-.18.9l.09-.6.18-.9-.09.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,57c-.25.19-.49.37-.73.57l.41-.35.72-.56-.4.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.57,60l-.7.61.4-.37.69-.6-.39.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.62,42.6l-.75.22a3.59,3.59,0,0,1,.35-.12l.74-.22-.34.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,43.39l-.76.26.37-.14.76-.25-.37.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,63.27l.38.4-.67-.64-.38-.4.67.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.27,96.67l-.3.88c.05-.19.11-.38.17-.57s.19-.59.3-.88c-.06.19-.12.38-.17.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.61,67.93l-.62.7.35-.44L60,67.5l-.35.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.41,73.17c-.19.24-.38.49-.56.74l.31-.47.56-.74c-.1.16-.22.31-.31.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.55,79l.28.5c-.16-.26-.33-.52-.5-.78l-.28-.5c.17.26.34.52.5.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.16,57.22c.13.11.27.22.4.35l-.73-.57-.4-.34.73.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.78,86.74l.23.53-.42-.83-.23-.53.42.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.16,133.67c0,.21-.06.41-.1.62,0-.3.07-.6.1-.9s.07-.41.1-.62c0,.3-.06.6-.1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67,60.14c.13.13.27.25.39.38l-.7-.61-.39-.37.7.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.83,41.11l-.67.15.26-.08.67-.14-.26.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1,45.12l-.78.31.39-.18.78-.31-.39.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.53,107.57c0,.2.06.39.08.59-.05-.3-.12-.6-.18-.9l-.09-.59c.07.3.13.6.19.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.77,41.78l-.71.19.3-.1.72-.18-.31.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.43,53.1l.41.3-.76-.49-.41-.3.76.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,68.14c.12.15.24.29.35.44l-.62-.7c-.11-.14-.22-.29-.34-.43l.61.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.83,96.92c.06.19.11.38.16.57q-.13-.43-.3-.87c-.05-.19-.11-.38-.16-.57.11.29.2.58.3.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.79,73.39l.31.47c-.18-.25-.37-.5-.56-.74s-.21-.31-.32-.47l.57.74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 108.86,
    width: 1.09,
    height: 1.64
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2,109.4c-.06.3-.11.6-.17.91,0-.21,0-.41.07-.61s.1-.6.16-.89l-.06.59"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5,88.4c-.14.28-.27.56-.4.84l.21-.54c.13-.28.26-.56.4-.84-.07.18-.15.36-.21.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.56,80.54l-.48.79.26-.51.48-.79c-.08.17-.18.34-.26.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.66,98.69c-.1.29-.19.58-.28.88,0-.19.09-.39.14-.58l.28-.88c0,.19-.09.39-.14.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.76,64.53c-.22.22-.43.45-.65.66l.36-.41.65-.65-.36.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.92,46l-.79.34.39-.2c.26-.12.53-.22.79-.33-.13.06-.27.12-.39.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.85,135.77c0,.2-.08.41-.13.62q.08-.45.12-.9c0-.2.09-.41.13-.61l-.12.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3,51.76l.41.29-.77-.48-.41-.27c.26.15.52.3.77.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.65,88.65c.06.18.14.36.21.54-.13-.28-.26-.56-.4-.84l-.21-.54.4.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.19,42.46l-.74.22a3,3,0,0,1,.32-.12l.74-.21-.32.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.61,80.77l.27.51-.49-.8c-.09-.17-.17-.34-.26-.5l.48.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.87,109.65c0,.2,0,.4.07.6-.05-.3-.11-.6-.17-.9s0-.4-.06-.6c.06.3.11.6.16.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.21,74.86l-.54.76c.1-.16.19-.32.3-.48s.36-.5.54-.76l-.3.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,122.71l0,.62c0-.31,0-.61,0-.91s0-.41,0-.62c0,.3,0,.61,0,.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.15,50.35l-.78.44.41-.26.77-.45-.4.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.08,61.32l-.69.63.38-.39.69-.62a4.54,4.54,0,0,0-.38.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,64.73l.36.42-.66-.66c-.12-.14-.23-.28-.36-.41l.66.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,55.69l.39.33-.74-.54c-.13-.11-.26-.22-.4-.32l.75.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3,69.51l-.61.72c.11-.15.22-.31.33-.45l.6-.71c-.11.15-.22.29-.32.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.72,47l-.79.37.4-.22.79-.36-.4.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,39.78l-.44.06,0,0,.44-.05,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.53,43.24l-.76.25.35-.14.76-.24-.35.13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 110.5,
    width: 0.54,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9,111.5c0,.3-.1.6-.14.9,0-.2,0-.4.05-.6s.09-.61.14-.91c0,.21,0,.41-.05.61"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.45,98.93c.05.2.1.39.14.58-.09-.29-.19-.59-.29-.88s-.09-.38-.14-.57c.1.29.2.58.29.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.52,48l-.79.39.4-.23.79-.39-.4.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.67,90.33c-.12.28-.25.57-.38.85.07-.18.14-.36.2-.55l.38-.84c-.07.18-.14.36-.2.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.15,50.49l.4.27-.78-.45-.4-.26.78.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.35,41.67l-.7.18.28-.1.71-.17a2.46,2.46,0,0,0-.29.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.48,137.86c0,.2-.09.41-.14.61,0-.29.09-.59.14-.89s.09-.41.14-.61c-.05.3-.09.59-.14.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.54,82.36l-.46.81c.08-.17.16-.35.25-.52l.46-.81-.25.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.32,39.74l-.42.06v0l.42-.05v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.17,61.52l.37.38-.69-.62-.37-.38.69.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.71,58.5l.39.36-.72-.59-.39-.35c.25.19.48.39.72.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,75.09q.15.22.3.48c-.18-.26-.37-.51-.55-.76s-.19-.32-.3-.48c.19.25.37.5.55.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1,100.72l-.27.88c0-.19.09-.38.13-.58s.17-.59.26-.88l-.12.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,49.29l.41.25-.79-.42-.4-.24.78.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.29,39.76v0l-.42-.07v0l.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.79,48.17l.4.23L158.4,48l-.4-.23.79.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,69.73c.12.14.22.3.33.44l-.61-.71c-.1-.14-.22-.29-.32-.44.2.24.41.47.6.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.17,111.74c0,.21,0,.41,0,.61,0-.3-.09-.61-.14-.91s0-.4,0-.6c.06.3.1.6.15.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.65,39.71l-.4,0,0,0,.41,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.67,44.94l-.79.31c.12-.06.25-.13.38-.18l.78-.31-.37.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69,39.73l0,0-.4-.06,0,0,.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.47,90.58c.06.18.13.36.19.55-.12-.29-.25-.57-.38-.85s-.12-.37-.19-.55c.13.28.25.56.38.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.37,66c-.22.22-.43.45-.64.68.11-.15.23-.28.35-.42l.64-.68-.35.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.63,82.6l.24.51c-.15-.27-.31-.54-.47-.8l-.24-.52.47.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.05,54.23c.13.1.27.2.39.31l-.75-.52-.4-.3.76.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.06,139.94c-.05.2-.11.41-.17.61.06-.29.11-.59.16-.88a6.29,6.29,0,0,0,.17-.62c-.05.3-.11.6-.16.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,101l.12.59c-.08-.3-.17-.59-.26-.89s-.08-.39-.13-.58c.1.29.18.59.27.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.26,39.68l-.39,0-.05,0,.39-.05.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.06,76.59l-.53.77.29-.49c.17-.26.35-.52.53-.77-.1.16-.2.32-.29.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09,39.69a.09.09,0,0,1,0,0l-.39,0,.06,0,.38,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.77,42.33l-.73.21.31-.12.73-.2-.31.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9,92.28l-.36.87.18-.56c.11-.29.25-.57.36-.86l-.18.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,71.13c-.2.24-.4.48-.59.73l.31-.46.59-.72-.31.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.59,102.77c-.09.29-.17.59-.25.89,0-.2.07-.4.11-.59l.24-.89c0,.19-.07.39-.1.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.86,39.65l-.37.05-.06,0,.36-.05.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,41.55c-.24.06-.46.13-.7.18l.27-.09.69-.18-.26.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,39.66l-.07,0-.36,0,.07,0,.36,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.86,66.24c.12.14.24.28.34.42l-.64-.68-.34-.41c.22.22.43.45.64.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.36,52.67l-.77.49c.14-.09.27-.19.4-.29l.77-.49c-.14.09-.27.19-.4.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.63,62.73l-.68.65.36-.4c.22-.22.45-.43.68-.64l-.36.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.58,84.21c-.15.27-.31.54-.45.82l.23-.53.45-.81c-.08.17-.16.34-.23.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.12,43.09l-.76.25.33-.14.76-.24-.33.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.48,45.82l-.79.34.38-.2.79-.33-.38.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.41,113.84c0,.21,0,.41,0,.61,0-.3-.08-.6-.12-.91s0-.4,0-.6c.05.3.09.6.13.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.47,39.62l-.35.05-.09,0,.35,0,.09,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88,39.64l-.1,0-.34-.05.09,0,.35,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.13,76.81l.28.49-.53-.76c-.1-.16-.18-.33-.28-.49l.53.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,56.92c.13.11.26.22.38.34l-.74-.56-.38-.34.74.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,142c-.06.2-.11.4-.18.61.06-.29.11-.59.18-.88l.18-.61-.18.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.94,52.83l.39.3-.77-.49-.39-.29.77.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.2,71.35c.11.15.2.31.31.46l-.59-.73-.31-.45.59.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09,39.6l-.33,0-.11,0,.32,0,.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,39.61l-.12,0-.33,0,.12,0,.33,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.24,92.53c.06.19.12.37.17.56-.11-.29-.23-.58-.36-.86s-.11-.37-.17-.55c.12.28.23.57.36.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.63,62.93c.11.14.23.27.35.4l-.68-.64L179,62.3l.68.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,51.35l-.78.47.39-.28.78-.47-.39.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.7,39.59l-.31,0-.13,0,.31,0,.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.52,103c0,.2.07.39.1.59-.07-.3-.16-.59-.24-.89s-.07-.39-.1-.59c.08.3.17.59.24.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.65,39.6l-.14,0-.3,0a.32.32,0,0,1,.14,0l.3,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.23,59.82l.37.37-.71-.6-.37-.36.71.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.59,84.45c.08.17.16.35.23.52l-.45-.81c-.07-.18-.15-.35-.23-.53l.45.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32,39.57l-.29,0-.15,0,.28,0,.16,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,39.58l-.16,0-.29,0,.16,0,.29,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.94,39.57l-.27,0-.18,0,.27,0,.18,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.42,39.57l-.19,0-.26,0,.18,0a2.48,2.48,0,0,1,.27,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.19,94.26c-.12.29-.24.58-.34.87,0-.19.1-.38.16-.57s.22-.57.33-.86l-.15.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.13,104.83c-.08.29-.15.59-.22.89,0-.2.05-.39.08-.59s.15-.6.23-.9c0,.2-.06.4-.09.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.56,39.56l-.25,0-.2,0,.25,0,.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.8,39.56l-.21,0-.24,0,.2,0a1.9,1.9,0,0,1,.25,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,78.35c-.17.25-.34.52-.51.78.08-.17.17-.33.26-.5s.34-.52.51-.78c-.08.16-.18.33-.26.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18,39.56l-.23,0-.22,0,.23,0,.22,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7,50.1l-.79.44.39-.26.78-.44-.38.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,51.5l.39.28-.78-.46L164,51l.78.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,46.9l.38.21-.79-.36-.38-.2.79.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.59,116c0,.21,0,.41,0,.61,0-.3-.07-.6-.11-.91V115c0,.31.06.61.1.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.38,42.2l-.73.21c.1,0,.19-.09.29-.12l.72-.2-.28.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.05,144.06c-.07.21-.13.41-.21.61.08-.29.14-.58.2-.87l.21-.61c-.07.29-.13.58-.2.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.56,41.44l-.69.18.25-.1.68-.17-.24.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.66,86.09c-.15.27-.29.55-.43.83l.21-.54.43-.82-.21.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.79,72.79l-.58.74.3-.47.57-.74c-.09.16-.19.31-.29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.62,50.24l.39.27c-.27-.15-.52-.3-.79-.44l-.38-.26.78.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.24,47.94l.38.23-.79-.39-.38-.22.79.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.44,49.06l.38.25-.79-.42-.39-.24.8.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.22,67.78l.32.43-.63-.69c-.11-.14-.21-.29-.33-.43l.64.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,94.51l.15.56c-.11-.29-.22-.58-.34-.87s-.11-.37-.16-.56l.35.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.24,78.58c.09.16.17.33.26.5-.17-.26-.34-.53-.52-.79l-.26-.49c.18.26.35.52.52.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.64,55.4l.38.32c-.26-.17-.5-.35-.76-.53l-.37-.32.75.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,105.07c0,.2.05.4.08.59-.07-.29-.15-.59-.23-.89s-.05-.4-.08-.59c.08.29.15.59.23.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.72,43l-.74.24.31-.14.74-.23-.31.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.43,73a4.57,4.57,0,0,1,.29.47l-.58-.75-.29-.46.58.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.73,106.9l-.21.9c0-.2,0-.4.07-.6s.13-.6.2-.9l-.06.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.51,86.33c.07.17.15.35.21.53l-.43-.83c-.07-.18-.15-.35-.21-.53l.43.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.72,118.07c0,.2,0,.41,0,.61l-.09-.91c0-.2,0-.41,0-.62l.09.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.52,96.26c-.11.28-.22.58-.32.87,0-.19.09-.38.14-.57s.21-.58.32-.87c0,.18-.1.37-.14.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.56,61l-.7.61.35-.38.7-.61c-.12.12-.24.25-.35.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.77,53.78l-.76.51.37-.31.77-.5-.38.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.08,45.63l-.79.33.36-.19.78-.33-.35.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.05,64.39c.12.13.23.27.34.41l-.67-.66-.34-.4.67.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,58.19l.37.35-.74-.58-.36-.35.73.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,42.07l-.72.21.27-.12.71-.2-.26.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.79,88c-.13.28-.27.56-.41.84l.19-.54.42-.84-.2.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,61.19c.12.12.23.25.35.38l-.71-.62c-.11-.13-.23-.25-.35-.38l.71.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.15,133.28c0,.21-.08.42-.13.62,0-.3.06-.6.08-.9s.08-.41.13-.62c0,.3,0,.6-.08.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.54,54l.37.31c-.25-.18-.51-.35-.76-.51l-.38-.31c.26.16.51.33.77.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.38,107.15c0,.19,0,.39.06.59-.06-.3-.14-.6-.21-.9l-.06-.59c.07.29.14.6.21.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.83,148.14c-.08.2-.16.4-.25.59l.24-.85.24-.6c-.08.29-.16.57-.23.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,96.5c0,.19.09.38.13.57q-.15-.43-.33-.87c0-.19-.08-.38-.13-.57l.33.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6,74.48l-.56.75.28-.48c.19-.24.37-.5.56-.75-.09.16-.18.32-.28.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.79,120.18l0,.62c0-.3,0-.61-.07-.91s0-.41,0-.62c0,.31,0,.61.06.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.38,109c-.06.3-.13.61-.18.91,0-.2,0-.4,0-.6s.12-.61.19-.91c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.92,52.4l-.78.49.37-.3.78-.48-.37.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,80.37l.24.51-.51-.8c-.08-.16-.15-.33-.24-.5l.51.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.89,46.58l-.8.35.36-.21.8-.35-.36.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9,98.27l-.3.88.12-.58c.1-.29.2-.59.31-.88,0,.19-.09.39-.13.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,69.36c.1.15.21.3.3.45-.2-.24-.41-.48-.62-.71l-.3-.44.62.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.87,44.58l-.78.3.33-.17.78-.29-.33.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.38,88.23c.07.18.12.37.19.55l-.42-.84c-.06-.18-.12-.36-.19-.54.15.27.28.55.42.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.11,56.44l-.75.56.36-.35.75-.55c-.12.11-.25.22-.36.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.84,39.93l-.46.08s0,0,0,0l.46-.08v0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.35,42.8l-.74.24.29-.14.74-.22-.29.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53,40v0l-.46-.08v0l.46.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.4,52.56c.13.1.25.19.37.3-.25-.17-.51-.33-.77-.49l-.37-.29.77.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.62,74.7c.1.16.19.32.28.48l-.57-.76-.27-.47.56.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.84,135.38l-.15.62c0-.3.07-.59.09-.89s.1-.41.15-.62l-.09.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.13,150.15c-.08.2-.17.4-.26.59.09-.28.18-.56.26-.84l.26-.6c-.08.28-.17.57-.26.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.09,51.09l-.79.47.37-.28.79-.46-.37.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.63,43.64l-.76.27.31-.15c.25-.1.51-.18.76-.27l-.31.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.27,49.86l-.78.43.36-.26.79-.43-.37.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,109.23c0,.2,0,.4,0,.6-.06-.3-.12-.6-.19-.9s0-.4,0-.6c.07.3.13.6.19.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2,56.62l.36.34-.75-.56-.36-.33.75.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,89.92c-.14.28-.27.56-.4.85.05-.19.11-.37.17-.55s.27-.57.4-.85c-.06.18-.12.37-.17.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.49,39.88,115,40l0-.05.45-.07,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.66,47.72,158,48l-.79-.38-.36-.22.79.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.81,122.3c0,.21,0,.42-.05.62,0-.3,0-.61,0-.91s0-.41,0-.62c0,.31,0,.61.05.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.24,51.24l.37.28-.78-.46-.37-.27.78.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88,39.91a.17.17,0,0,1,0,.05l-.44-.08,0-.05.44.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.24,98.51l.12.58-.31-.88c0-.19-.07-.38-.12-.57l.31.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.64,42l-.71.2.24-.11.71-.2-.24.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.12,62.4l-.69.63c.11-.13.21-.26.33-.39l.69-.63-.33.39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 110.5,
    width: 0.54,
    height: 1.64
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.09,111.08c-.06.3-.11.6-.17.91l0-.61c0-.3.11-.6.16-.9,0,.2,0,.4,0,.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.43,65.89c.11.14.22.27.32.42l-.66-.68c-.1-.14-.21-.28-.32-.41l.66.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.87,48.83l.36.24-.8-.41-.36-.24.8.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.06,50c.13.08.25.17.37.26l-.79-.44-.37-.25.79.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.39,152.14c-.09.2-.19.39-.28.59l.27-.84c.1-.19.19-.39.28-.59l-.27.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.45,70.76l-.6.72c.09-.15.19-.3.29-.45l.6-.72c-.09.15-.19.3-.29.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.47,137.48c-.06.2-.11.41-.17.61,0-.29.08-.59.11-.89s.12-.41.17-.61c0,.29-.08.59-.11.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.14,39.85l-.42.07,0-.05.43-.07,0,.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.34,100.3l-.28.88c0-.19.06-.39.1-.58s.18-.59.28-.88c0,.19-.06.38-.1.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.46,76.2c-.19.25-.36.51-.55.77l.26-.49c.18-.26.36-.51.55-.76-.09.16-.18.31-.26.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75,59.5c.11.13.23.24.35.37l-.73-.6c-.11-.12-.23-.23-.34-.36l.72.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.31,82.19c.08.17.14.35.22.52-.16-.27-.32-.54-.49-.81s-.14-.34-.22-.51l.49.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.17,62.6l.33.39-.69-.64-.34-.39.7.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.21,54.94l-.76.53a3.73,3.73,0,0,1,.36-.32c.25-.18.5-.36.76-.53l-.36.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.2,90.16c.06.19.12.37.17.55-.13-.28-.27-.56-.4-.85s-.11-.36-.17-.54c.14.28.27.56.4.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.81,39.81l-.41.08-.07-.06c.14,0,.27,0,.41-.06l.07,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.57,39.83l-.07.05-.4-.07.07-.05.4.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,111.33c0,.2,0,.4,0,.6,0-.3-.11-.6-.17-.9s0-.41,0-.61c.06.3.12.6.17.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.77,124.42c0,.21,0,.42-.07.62,0-.3,0-.6,0-.91s.05-.41.08-.61c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.8,71l.29.46-.62-.73c-.09-.15-.18-.3-.28-.45l.61.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.11,55.11l.36.32c-.25-.17-.5-.36-.76-.53s-.24-.21-.36-.32l.76.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.77,76.43l.26.49c-.19-.26-.37-.52-.56-.77s-.17-.33-.25-.49l.55.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,42.67l-.73.23.27-.13.73-.23-.27.13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 112.14,
    width: 0.54,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.85,113.18l-.15.91c0-.2,0-.4,0-.61s.09-.6.14-.91v.61"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.59,154.12c-.1.19-.19.39-.3.58.1-.27.2-.55.29-.82s.2-.4.31-.59l-.3.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.8,100.55c0,.19.07.38.1.58-.09-.3-.19-.59-.29-.89s-.06-.39-.1-.58c.1.29.2.59.29.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.21,91.87c-.13.28-.26.57-.38.86l.15-.56c.13-.29.26-.57.38-.85l-.15.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47,39.78l-.39.07L117,39.8l.39-.07.09.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,139.56c0,.21-.12.41-.19.62.05-.3.1-.59.14-.89s.13-.41.19-.61c-.05.29-.09.59-.14.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.91,39.8l-.09.05-.39-.07.1-.05.38.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5,44.41l-.77.3c.1-.07.21-.12.31-.18l.78-.28-.32.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,67.24l-.65.69.3-.44.65-.68c-.1.14-.21.28-.3.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.29,41.83l-.69.2.22-.11.69-.19-.22.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.51,46.37l-.79.36a3.87,3.87,0,0,1,.34-.21l.79-.35-.34.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.28,43.49l-.76.26.29-.15.76-.26-.29.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14,39.75l-.37.07-.11,0,.37-.06.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.34,53.5l-.77.51c.11-.1.23-.21.36-.31l.77-.5-.36.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,102.35c-.09.29-.17.59-.26.89,0-.2,0-.4.08-.59s.17-.6.27-.89l-.09.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.25,39.77l-.12,0-.36-.07.11,0,.37.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.59,57.7l-.74.57c.11-.12.23-.23.35-.35l.73-.57-.34.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81,39.73l-.35.07-.14,0,.36-.06.13,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58,39.75l-.14,0-.35-.07.14,0,.35.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68,126.55l-.09.62c0-.31,0-.61,0-.91s.07-.41.09-.62c0,.3,0,.6,0,.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,156.07l-.32.58.31-.81c.11-.2.22-.39.32-.59-.1.28-.21.55-.31.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,92.11c.06.19.1.38.15.56-.13-.28-.25-.57-.38-.86s-.11-.36-.15-.55c.12.29.25.57.38.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.27,84l.21.53-.48-.82c-.06-.17-.13-.35-.2-.52.16.27.32.54.47.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,113.43c0,.2,0,.41,0,.61,0-.3-.09-.61-.15-.91v-.61c0,.3.11.6.15.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.37,78c-.19.26-.36.53-.54.78l.24-.49.53-.78c-.08.16-.16.33-.23.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,53.67a2.59,2.59,0,0,1,.35.31c-.25-.18-.51-.35-.77-.51-.11-.11-.23-.2-.35-.3l.77.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.71,63.84,63,64.5a4.12,4.12,0,0,1,.32-.41l.68-.65-.32.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.78,67.42l.3.43c-.21-.23-.44-.46-.65-.68l-.3-.43c.22.22.43.45.65.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,39.71l-.32.07-.16-.05.33-.06.15,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,72.41c-.2.24-.4.49-.59.74l.27-.47c.19-.25.39-.49.59-.73l-.27.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.56,141.64c-.07.2-.13.4-.2.61l.15-.88.21-.61c-.05.29-.1.58-.16.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9,39.72l-.16.06-.32-.07.16-.05c.11,0,.21.05.32.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.73,57.88l.34.35-.74-.58-.34-.34.74.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31,47.38l-.8.38.34-.22.8-.38-.34.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,52.14l-.78.48.36-.29.78-.48-.36.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.16,39.7a2.84,2.84,0,0,1-.31.06l-.18,0,.31-.06.18.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.23,39.71l-.18,0-.31-.06.18-.05.31.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.31,102.59c0,.2.06.39.08.59l-.27-.89c0-.2-.05-.39-.08-.59l.27.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.84,39.69l-.29.06-.2,0,.29-.06.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.55,39.7l-.2,0-.29-.06.21,0,.28.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.52,39.69l-.27.06-.22-.06.26-.06.23.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.49,93.84l-.36.87c0-.19.09-.38.14-.57s.23-.57.36-.86c-.05.19-.1.37-.14.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88,39.69l-.23.06-.27-.06.23-.06.27.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.2,39.69l-.25.05-.24-.05.24-.06.25.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.05,47.51l.35.22-.8-.38-.34-.22.79.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.58,64l.31.41-.68-.65-.31-.41.68.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.69,50.84l-.79.46.35-.28.79-.45-.35.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.22,60.86c.11.12.23.25.33.38l-.71-.62c-.11-.12-.23-.24-.33-.37l.71.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,85.68l-.45.83c.06-.18.12-.36.19-.54s.29-.55.45-.82c-.07.17-.13.35-.19.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84,52.29l.35.3-.78-.49-.35-.28.78.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.87,78.18l.24.5-.54-.78-.24-.49c.18.25.37.51.54.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.89,49.62l-.79.43.34-.26.8-.43-.35.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,72.63l.27.47-.6-.74-.27-.46.6.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.38,104.41c-.09.29-.17.59-.25.89l.06-.59c.09-.3.17-.6.25-.9,0,.2,0,.4-.06.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66,42.53l-.73.23.25-.13.72-.22-.24.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,41.72l-.68.19.2-.11.68-.19-.2.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,143.7c-.07.2-.14.4-.22.61.06-.29.11-.58.17-.87s.16-.41.23-.61c-.06.29-.11.58-.18.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.26,48.6l.34.24-.79-.41-.34-.23.79.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.67,56.14l-.75.55.34-.33.75-.55-.34.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.66,51l.35.28-.79-.46c-.11-.09-.23-.19-.35-.27l.79.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.47,49.76l.34.26-.79-.43-.35-.26.8.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.69,94.09c.05.18.09.37.13.56-.12-.29-.24-.58-.37-.86s-.08-.38-.13-.57l.37.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,68.78c-.22.23-.43.47-.64.71l.29-.45.63-.7-.28.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,85.92l.18.54c-.14-.28-.3-.56-.45-.83l-.19-.54.46.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.94,43.34l-.75.26.27-.16.75-.25-.27.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.16,44.25l-.77.28.29-.17.77-.28-.29.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66,56.31l.34.34-.76-.55-.34-.33c.25.18.5.37.76.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,104.65c0,.2,0,.4.06.6-.08-.3-.16-.6-.25-.9s0-.4,0-.59l.24.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.31,79.74c-.17.26-.34.53-.52.79L51,80l.51-.79c-.07.16-.14.33-.22.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.33,130.78a6.21,6.21,0,0,1-.14.62c0-.3,0-.6,0-.9s.09-.41.13-.62c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.83,95.84l-.35.87.12-.57c.12-.29.23-.58.34-.87,0,.19-.08.37-.11.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.05,74.09c-.19.25-.39.5-.58.76.08-.16.17-.32.26-.48l.58-.75c-.09.16-.18.31-.26.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1,59c-.25.19-.49.39-.73.59.1-.12.22-.24.33-.36l.73-.59L69.1,59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,106.48c-.08.3-.15.6-.23.9,0-.2,0-.4,0-.6s.15-.6.23-.9c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.08,69l.29.44-.64-.71c-.1-.14-.19-.29-.29-.44l.64.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.34,65.33c-.22.22-.45.44-.67.67l.3-.42c.22-.22.45-.45.68-.66-.11.13-.21.27-.31.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.57,117.65l0,.62c0-.31-.07-.61-.12-.91s0-.41,0-.62c0,.31.08.61.11.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.16,87.58l-.44.84c.06-.18.11-.36.17-.54s.29-.56.44-.84c-.06.18-.11.36-.17.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.79,54.65l-.76.53.34-.32.76-.52-.34.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.65,62.07l-.7.63.31-.39c.24-.21.47-.43.71-.63l-.32.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.65,41.61c-.23,0-.46.12-.68.18l.18-.1c.23-.07.45-.13.68-.18a.77.77,0,0,0-.18.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.92,80c.08.17.15.34.22.51-.17-.26-.34-.53-.52-.79s-.14-.34-.22-.51l.52.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34,42.4l-.72.22.23-.12.71-.22-.22.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.22,59.18l.33.37-.74-.59-.32-.36.73.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.21,74.32l.25.48c-.19-.26-.39-.51-.58-.76l-.25-.47.58.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.35,96.08l.12.57c-.11-.29-.24-.58-.35-.87l-.12-.57c.12.29.24.58.35.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.55,54.82l.33.32-.76-.52-.34-.32.77.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,65.53c.1.15.21.28.3.43l-.67-.68-.3-.41.67.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07,132.89l-.15.62c0-.3,0-.6.05-.9a6.23,6.23,0,0,0,.15-.62c0,.3,0,.61-.05.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,106.73c0,.2,0,.39,0,.59-.07-.3-.16-.6-.24-.9s0-.4,0-.59c.08.3.15.6.23.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66,62.26c.1.13.21.26.31.4-.23-.22-.47-.42-.71-.64l-.31-.39.71.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.06,87.82c.05.18.1.36.16.54-.14-.28-.29-.56-.44-.83s-.1-.36-.16-.54c.14.28.29.55.44.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,47.17l-.8.38.33-.23.79-.37-.32.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,53.23l-.78.5.34-.3.77-.5-.33.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.63,108.57l-.21.9c0-.2,0-.4,0-.61l.21-.89c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.22,97.85c-.12.29-.23.58-.33.88,0-.19.06-.39.1-.58s.21-.58.32-.88c0,.19-.07.39-.09.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.64,119.77c0,.21,0,.42,0,.62l-.09-.91.06-.62c0,.31.05.61.08.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.31,81.56c-.18.26-.34.53-.51.8l.21-.51c.16-.27.33-.54.5-.81-.07.17-.14.34-.2.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.94,70.39l-.63.72.27-.45c.21-.25.42-.48.63-.72l-.27.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.62,43.19l-.74.25.25-.15.74-.24-.25.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.12,149.8c-.1.2-.2.4-.29.6.08-.29.16-.57.23-.85s.2-.4.29-.6c-.08.28-.15.57-.23.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.93,40.08l-.47.1a.43.43,0,0,1,0-.07l.46-.09.05.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4,53.39l.34.31-.78-.5-.33-.31.77.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.17,57.39l-.75.57c.1-.12.22-.23.33-.35s.49-.38.75-.56c-.12.11-.22.23-.33.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.13,51.88l-.79.48c.11-.1.22-.2.34-.29l.78-.48-.33.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.84,44.08l-.76.29.27-.17.76-.28-.27.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.91,75.81c-.19.25-.38.51-.56.77.07-.16.15-.33.23-.49l.57-.76-.24.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.34,89.51l-.42.84.15-.55.42-.84-.15.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.75,135c-.05.21-.11.41-.17.62,0-.3,0-.6.07-.9l.18-.62c0,.3-.05.6-.08.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,41.5l-.67.19.16-.11.66-.18-.15.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.54,49.38l-.8.43.33-.26.79-.42a3.92,3.92,0,0,0-.32.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.33,50.59l-.79.46.32-.28.8-.45-.33.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.63,48.37l.32.24-.8-.4-.32-.23.8.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.34,70.61l.27.45c-.21-.24-.41-.48-.63-.72s-.17-.3-.26-.45l.62.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,81.79c.07.17.14.34.2.52-.17-.27-.33-.54-.51-.81s-.12-.34-.19-.51c.16.27.34.53.5.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,98.09c0,.2.07.39.09.58-.11-.29-.21-.59-.33-.88s-.06-.38-.09-.57l.33.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.51,108.81c0,.2,0,.4,0,.6q-.09-.45-.21-.9c0-.2,0-.4,0-.6q.12.45.21.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.23,52c.12.1.23.19.33.29l-.78-.48-.33-.28.78.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.64,40l-.45.1-.06-.07c.15,0,.29-.07.44-.09l.07.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,57.57c.11.11.22.23.32.35l-.75-.57c-.11-.11-.21-.23-.32-.35l.75.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,42.27l-.71.23a1.37,1.37,0,0,1,.2-.13l.71-.22-.2.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77,40.06l-.07.07-.44-.09.07-.07c.14,0,.29.07.44.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.84,49.52l.32.26-.79-.43L160,49.1l.8.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,50.74l.33.27-.79-.45-.33-.27.79.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.37,151.8l-.3.59c.08-.28.16-.56.25-.84l.3-.59c-.08.28-.16.56-.25.84"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 109.95,
    width: 1.09,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.34,110.66c-.06.3-.13.61-.19.91V111c.06-.3.12-.6.19-.9v.6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.35,76c.08.16.16.32.23.49l-.57-.77c-.07-.16-.15-.32-.23-.48l.57.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.87,89.75c0,.18.11.36.15.55l-.42-.85-.15-.55.42.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.66,99.88c-.11.29-.22.59-.31.88,0-.19,0-.39.07-.58l.31-.88c0,.19,0,.38-.07.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.26,63.5l-.7.66.3-.41.7-.65c-.11.13-.2.27-.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.36,40l-.43.1-.09-.07.43-.09.09.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.38,137.1c-.06.2-.12.41-.19.61,0-.29.07-.59.1-.89l.19-.61c0,.29-.06.59-.1.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.06,40l-.1.07-.42-.09.09-.07.43.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,67.07c.1.14.18.28.28.43l-.67-.69c-.09-.15-.18-.29-.28-.43l.67.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.35,83.4c-.17.27-.33.54-.49.82.06-.18.12-.35.19-.53s.32-.54.49-.81c-.07.17-.13.35-.19.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.28,55.85l-.77.55.33-.34.76-.54-.32.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.68,60.54c.11.12.21.24.31.37l-.73-.61-.3-.37.72.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.08,40l-.41.09-.11-.07.41-.08.11.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.57,153.78c-.1.2-.21.39-.32.59l.27-.83c.11-.2.21-.4.32-.59l-.27.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.34,40l-.12.07-.4-.1.11-.06.41.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.58,91.46c-.14.28-.27.57-.41.85,0-.18.09-.37.14-.56l.4-.85c-.05.19-.09.37-.13.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.06,63.7l.3.41-.71-.65a3.69,3.69,0,0,0-.29-.4l.7.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.72,72l-.61.74c.09-.15.17-.31.25-.47l.62-.73-.26.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.81,110.91v.6c-.07-.3-.13-.6-.2-.9s0-.41,0-.61c.06.3.13.6.19.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.33,43.05c-.25.07-.49.16-.74.25.08,0,.15-.11.23-.15l.74-.25a1.82,1.82,0,0,0-.23.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.62,124c0,.21-.06.41-.09.62,0-.3,0-.61-.05-.91s.07-.41.09-.62c0,.3.05.61.05.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07,56l.33.34-.77-.55-.32-.33.76.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.82,77.56l-.55.78c.07-.17.14-.33.22-.5s.36-.52.55-.77l-.22.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,39.94l-.38.09-.14-.07.39-.08.13.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61,40l-.13.07-.39-.09.14-.07.38.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.71,44.9l-.78.31a2.68,2.68,0,0,1,.28-.18l.77-.31-.27.18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 112.14,
    width: 0.54,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1,112.77c-.06.3-.11.6-.17.91,0-.21,0-.41,0-.61s.11-.61.17-.91c0,.2,0,.4,0,.61"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203,139.19l-.21.61c0-.29.08-.59.11-.88s.15-.41.21-.62c0,.29-.07.59-.11.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.89,83.64c.07.17.12.35.18.52-.16-.27-.32-.54-.49-.81l-.18-.53c.16.28.33.54.49.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,47l-.79.37c.09-.08.19-.15.3-.23l.79-.36-.3.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,42.15l-.7.22.18-.13.7-.21-.18.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54,43.92l-.76.28L96,44l.77-.27a2.26,2.26,0,0,0-.26.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.53,39.92l-.37.09-.15-.08.37-.08.15.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.15,101.93c-.1.29-.2.59-.29.89,0-.2,0-.4.06-.59s.19-.6.29-.89l-.06.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.89,39.93l-.16.07-.37-.09.16-.06.37.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.73,155.74l-.35.58c.11-.27.2-.54.29-.82s.23-.39.34-.58l-.28.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,72.25l.25.47L187.2,72c-.08-.15-.17-.3-.25-.46.2.25.41.49.61.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.42,54.37l-.77.53c.1-.12.21-.22.32-.33l.77-.51-.32.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.64,91.7c.05.18.09.37.13.56l-.41-.86c0-.18-.08-.37-.13-.55.14.28.28.56.41.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.27,39.9l-.35.08-.18-.07.35-.08.18.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.16,39.91,125,40l-.34-.09a1.27,1.27,0,0,0,.18-.06l.35.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7,58.69l-.75.59c.1-.13.21-.24.31-.37l.75-.58a3.65,3.65,0,0,0-.31.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,77.79c.08.16.15.33.22.5l-.56-.78a4.25,4.25,0,0,0-.21-.49c.19.25.38.51.55.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.73,68.42l-.65.7c.08-.15.17-.29.26-.44L60,68l-.26.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,39.88l-.33.09-.2-.08.33-.07.2.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.42,39.89l-.2.07-.33-.08.21-.07.32.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.05,113c0,.21,0,.41,0,.61l-.18-.91c0-.2,0-.4,0-.61l.18.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.48,141.26c-.07.21-.15.41-.23.62.05-.29.09-.59.13-.88l.24-.62c-.05.3-.09.59-.14.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.74,39.87a1.77,1.77,0,0,1-.31.08l-.22-.07.31-.08.22.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.69,39.88l-.23.07-.3-.08.22-.07.31.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.43,48l-.8.4a3.65,3.65,0,0,1,.31-.24l.79-.39-.3.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44,85.27c-.16.28-.32.55-.47.83.05-.18.11-.36.16-.53l.48-.83-.17.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.48,39.87l-.29.08-.25-.08.29-.07.25.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,39.87l-.25.08-.28-.08a2.17,2.17,0,0,1,.24-.07l.29.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,39.86l-.27.09-.26-.08.27-.08.26.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.86,93.43c-.13.28-.26.57-.38.86,0-.19.07-.38.11-.56s.26-.58.38-.87c0,.19-.07.38-.11.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.82,157.68l-.35.58.3-.81c.12-.19.25-.39.36-.58-.09.27-.2.54-.31.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.59,53l-.78.5.32-.3.78-.5-.32.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,102.17a5.9,5.9,0,0,1,.06.59c-.09-.3-.2-.59-.29-.89l-.06-.59c.1.3.2.59.29.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.65,58.87l.3.37-.74-.59c-.1-.13-.2-.24-.3-.36l.74.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.24,61.73c-.25.21-.49.42-.72.64l.29-.4.72-.62c-.1.13-.2.25-.29.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9,65l-.68.67c.09-.14.18-.28.28-.42l.68-.66c-.1.13-.18.28-.28.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,48.15l.3.24-.8-.4-.3-.23.8.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,49.15l-.79.42.3-.25.8-.42-.31.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.58,68.63l.26.44-.65-.7c-.09-.14-.17-.29-.26-.44l.65.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.79,51.62c-.27.16-.53.31-.79.48l.31-.29.79-.47-.31.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,50.35l-.8.45.31-.28.8-.44-.31.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78,53.12c.11.1.21.2.31.31l-.78-.51-.32-.29.79.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.05,42.91l-.73.24.21-.14.73-.24-.21.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,104c-.09.29-.19.59-.27.89l0-.59.27-.9,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.55,73.71l-.6.75c.07-.16.16-.31.24-.47l.59-.75c-.07.16-.16.31-.23.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.78,79.34l-.54.8c.06-.17.13-.34.2-.51l.53-.79c-.06.17-.13.34-.19.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,85.51c.06.18.12.36.17.54l-.48-.83c-.05-.18-.11-.35-.16-.53.16.27.32.54.47.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,143.33c-.08.21-.16.41-.25.61.05-.29.11-.58.15-.87s.17-.41.25-.61q-.06.43-.15.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.48,42l-.69.21.16-.13.69-.2-.16.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18,49.28l.31.26-.8-.42-.31-.25.8.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,61.93l.3.39-.72-.63-.29-.39.71.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,128.27c0,.21-.08.41-.13.62,0-.3,0-.61,0-.91s.09-.41.13-.62c0,.3,0,.61,0,.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.35,93.67c0,.19.08.38.11.57q-.18-.43-.39-.87c0-.19-.07-.37-.1-.56.13.29.26.57.38.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.42,65.19a4.38,4.38,0,0,1,.28.42l-.69-.67c-.09-.14-.18-.28-.28-.42.23.23.47.44.69.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59,51.77l.32.29-.8-.48-.31-.28.79.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.39,50.49l.31.27-.8-.44c-.1-.1-.2-.18-.3-.27l.79.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.23,115.12c0,.21,0,.41,0,.62l-.15-.91c0-.21,0-.41,0-.62l.15.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.79,57.09l-.76.57.31-.35c.25-.19.5-.38.76-.56-.11.11-.21.23-.31.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2,175.86l-.51.5c.16-.23.32-.46.49-.68l.51-.5-.49.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.27,43.77l-.75.27.22-.16.76-.27a1.88,1.88,0,0,0-.23.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.42,44.73l-.77.31.25-.19.78-.3-.26.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.74,73.94c.07.16.16.31.23.47-.2-.25-.41-.49-.6-.75s-.15-.31-.23-.47l.6.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.49,79.58c.07.16.14.33.2.5l-.54-.79-.2-.5.54.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.49,104.23l0,.6-.27-.9,0-.59.27.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,95.42l-.37.87c0-.19.06-.38.1-.57l.36-.87-.09.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.58,87.17l-.46.84.15-.54c.15-.28.3-.56.46-.84-.06.18-.1.36-.15.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,57.27l.3.35-.76-.57-.3-.34.76.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.78,177.47l-.52.49.5-.66.53-.49-.51.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.18,130.39c-.05.2-.1.41-.16.62,0-.3,0-.6,0-.91s.11-.41.16-.62c0,.3,0,.61,0,.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.48,70l-.64.72c.08-.15.16-.3.25-.45l.64-.72c-.09.15-.17.3-.25.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.35,46.76l-.8.37.29-.22c.26-.13.53-.24.79-.36l-.28.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.29,106.06c-.08.3-.17.6-.25.9,0-.2,0-.4,0-.6s.17-.6.25-.9c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.26,60l-.73.61c.09-.13.19-.26.29-.38l.73-.61c-.09.13-.19.25-.29.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36,117.24l-.06.62c-.05-.31-.09-.61-.14-.92s0-.41.07-.61c0,.3.08.61.13.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.33,179.05l-.54.47.52-.65.54-.47-.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.93,55.56l-.78.54.3-.33.78-.54c-.1.11-.21.22-.3.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.23,41.92l-.68.21.14-.13.67-.19-.13.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,95.66q0,.3.09.57l-.37-.87-.09-.57c.12.29.24.58.37.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.79,42.77l-.72.25.19-.15.72-.24-.19.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.67,87.41c.05.18.09.36.14.54l-.46-.83c0-.18-.09-.36-.14-.54.16.27.31.55.46.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.78,81.16c-.18.26-.35.53-.53.8l.18-.52.53-.8c-.07.17-.12.35-.18.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.83,70.24c.09.15.17.3.25.45l-.64-.72-.24-.45.63.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.59,66.5l-.68.69c.08-.15.17-.29.26-.43s.45-.46.68-.68c-.09.14-.18.28-.26.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.42,75.43c-.19.25-.39.5-.58.76l.21-.49.59-.76c-.08.16-.15.33-.22.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.85,63.17l-.71.64.28-.4c.23-.22.47-.43.71-.64-.09.13-.19.26-.28.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.83,180.59l-.56.46c.19-.21.36-.42.54-.63l.56-.47-.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.09,60.21c.1.13.2.25.29.38l-.74-.61-.28-.37.73.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.89,106.31c0,.2,0,.39,0,.59-.08-.29-.16-.59-.25-.89s0-.4,0-.6c.08.3.17.6.25.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,55.73l.3.34-.77-.55-.3-.33.77.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.92,132.5c0,.21-.11.42-.17.63l0-.91c.06-.2.12-.41.17-.62q0,.45,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.14,47.81l-.8.39a3.36,3.36,0,0,1,.29-.24l.79-.39-.28.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.37,40.34l-.49.12-.06-.09.48-.12.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.59,97.43c-.12.29-.23.59-.35.88,0-.19,0-.39.07-.58s.23-.58.35-.88c0,.2,0,.39-.07.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.07,40.36l-.07.09-.48-.12.07-.08.48.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.09,54.09l-.78.52c.1-.1.19-.21.29-.32l.79-.51-.3.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,108.15c-.08.3-.16.6-.23.9,0-.2,0-.4,0-.6s.15-.61.24-.9c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.77,89.1c-.15.28-.3.56-.44.84,0-.18.08-.37.13-.55s.29-.56.44-.84c0,.18-.09.36-.13.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.75,66.71l.26.43-.68-.68c-.08-.15-.17-.29-.26-.43.23.22.45.45.68.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,81.39c.06.17.12.34.17.52l-.52-.81-.18-.51c.18.27.35.54.53.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,149.45c-.1.2-.2.4-.31.6.08-.28.15-.57.21-.85s.22-.4.31-.6c-.06.28-.13.57-.21.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.29,182.08l-.57.45c.18-.2.37-.4.55-.61l.57-.45c-.18.2-.36.41-.55.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.49,63.36l.28.41-.71-.65-.28-.4.71.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.87,75.65c.08.17.15.33.21.49-.19-.25-.38-.51-.58-.76l-.21-.49c.2.25.39.51.58.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.43,119.36c0,.21-.05.42-.08.62,0-.3-.07-.61-.11-.91s.06-.41.08-.62c0,.3.07.61.11.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,43.61l-.74.28.2-.17.75-.26-.21.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92,48.92l-.8.42.29-.26.8-.41-.29.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14,40.29c-.16,0-.31.08-.47.12l-.09-.09.47-.11a.73.73,0,0,0,.09.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.16,44.56l-.77.3.24-.18.76-.3c-.08,0-.15.12-.23.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.31,40.32l-.1.08-.46-.12a.73.73,0,0,0,.09-.08l.47.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.28,52.69l-.79.5.29-.3.79-.49-.29.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,183.54l-.59.44.57-.59.58-.45-.56.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.61,134.61c-.07.21-.13.42-.2.62,0-.3,0-.59.05-.89s.14-.42.2-.62c0,.3,0,.59,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.34,58.38l-.75.59c.09-.13.18-.25.28-.37l.76-.58-.29.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,50.11l-.8.44.29-.27.8-.44-.29.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.48,51.37l-.79.47a4,4,0,0,1,.29-.29l.8-.47a4.11,4.11,0,0,0-.3.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,49.05l.28.26c-.26-.14-.53-.29-.8-.42l-.28-.25.8.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.27,71.66l-.63.74c.08-.16.15-.32.23-.47l.63-.73-.23.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.48,89.34c0,.18.09.36.12.55-.14-.29-.29-.57-.44-.85l-.12-.55.44.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.29,151.45l-.33.6c.08-.28.16-.56.23-.84l.33-.6c-.07.28-.15.56-.23.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.24,108.39c0,.2,0,.4,0,.61-.08-.31-.16-.61-.23-.91v-.6c.09.3.16.6.24.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,40.25c-.15,0-.29.08-.44.12l-.12-.09.45-.11.11.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.12,52.85c.1.1.2.2.29.31-.26-.17-.52-.34-.79-.5l-.29-.3.79.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.55,42.65l-.71.23c.06,0,.1-.1.16-.14l.71-.23a1.07,1.07,0,0,0-.16.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.54,40.27l-.12.09-.44-.12.11-.08.45.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.83,83q-.27.41-.51.81c0-.17.1-.35.16-.52s.33-.54.51-.81c-.06.17-.11.34-.16.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.71,50.25l.28.27-.8-.45-.28-.26.8.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.92,51.51l.29.29-.8-.47-.29-.28.8.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,99.46l-.33.89.06-.59c.11-.29.21-.59.33-.88,0,.19,0,.39-.06.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,58.56l.29.36-.76-.58-.28-.36c.25.19.51.38.75.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45,121.49c0,.21-.07.41-.1.62,0-.3-.06-.61-.1-.91s.07-.41.11-.62l.09.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.66,110.25c-.07.3-.15.6-.22.9,0-.2,0-.4,0-.6l.21-.91,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.34,77.17c-.2.26-.38.52-.57.78.06-.17.12-.33.19-.5l.57-.77-.19.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.08,46.57l-.79.36.26-.22.79-.36-.26.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.69,40.21l-.43.12-.13-.09.42-.11.14.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.05,71.88l.22.46-.63-.73c-.07-.15-.15-.3-.22-.46l.63.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.76,40.24l-.14.08-.42-.11.13-.08a3,3,0,0,1,.43.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.24,136.72c-.07.2-.14.41-.22.61,0-.29,0-.59.07-.89s.15-.41.22-.62c0,.3,0,.6-.07.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.86,61.41c-.24.2-.49.41-.73.63.09-.13.18-.27.28-.4l.72-.62-.27.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.49,153.44l-.34.59.24-.83c.12-.2.23-.4.35-.59-.08.28-.16.56-.25.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,91c-.15.29-.29.57-.43.86,0-.19.07-.38.11-.56l.42-.85c0,.18-.07.37-.1.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.31,68.06c-.23.23-.45.47-.67.7l.25-.44.66-.69-.24.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.45,83.23c.05.18.11.35.16.53L194.1,83c-.06-.18-.11-.35-.16-.53l.51.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47,40.18l-.41.12-.15-.09.41-.11.15.08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.51,64.64l-.7.67c.08-.15.17-.28.26-.42l.7-.66c-.09.14-.18.27-.26.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,40.2l-.16.09-.41-.11.16-.08.41.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.46,56.79c-.26.19-.52.37-.77.57.09-.12.19-.24.29-.35l.76-.56c-.1.11-.19.23-.28.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,77.4a4.29,4.29,0,0,1,.19.5c-.18-.26-.38-.52-.57-.78l-.19-.49.57.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.53,110.49c0,.2,0,.41,0,.61-.08-.3-.15-.61-.22-.91s0-.4,0-.61c.07.31.15.61.22.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.78,43.47c-.25.08-.5.18-.74.27l.18-.17.74-.26a1.37,1.37,0,0,0-.18.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.51,61.6l.26.39-.73-.63c-.09-.12-.17-.26-.27-.38l.74.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.26,40.16l-.39.11-.18-.09.39-.11.18.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19,40.17l-.17.09-.39-.11.18-.08.38.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,68.27l.24.44-.67-.7c-.07-.14-.16-.29-.24-.43l.67.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.64,155.41l-.36.58c.09-.27.18-.54.26-.82l.37-.59-.27.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.41,123.62l-.12.62c0-.31,0-.61-.07-.91l.12-.62c0,.3,0,.6.07.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,45.43l-.78.33.23-.2.78-.33-.23.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.81,138.81c-.07.21-.15.41-.23.62l.09-.89c.08-.21.16-.41.23-.62,0,.3-.05.6-.09.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,91.29c0,.18.08.37.11.55-.14-.28-.28-.57-.43-.85s-.06-.37-.1-.56c.14.29.29.57.42.86"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 111.59,
    width: 1.09,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.42,112.35c-.07.31-.13.61-.19.91,0-.2,0-.4,0-.61s.12-.6.19-.91c0,.21,0,.41,0,.61"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.93,57l.28.35-.77-.57c-.09-.11-.19-.22-.28-.34l.77.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.84,64.84c.09.14.18.28.26.42l-.7-.67c-.09-.13-.17-.27-.26-.41.24.22.48.44.7.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,40.14l-.37.1-.2-.09.37-.1.2.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.88,47.59l-.8.39.26-.23.8-.39-.26.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41,40.15l-.21.09-.36-.1a1.76,1.76,0,0,1,.2-.09l.37.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.53,101.51c-.11.29-.21.59-.31.89,0-.2,0-.4,0-.59s.2-.6.31-.89c0,.19,0,.39,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.92,44.4l-.76.29.21-.18.76-.29a1.68,1.68,0,0,0-.21.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.33,42.52l-.7.23.13-.14.71-.23-.14.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.92,84.87c-.17.27-.33.55-.49.83,0-.18.09-.36.14-.54s.32-.55.49-.82c-.05.17-.1.35-.14.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.84,40.12l-.35.1-.22-.09.35-.1.22.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.61,40.13l-.22.09-.35-.1.23-.09.34.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.11,73.34c-.21.24-.41.49-.62.74l.21-.47.62-.75-.21.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.64,40.11l-.33.1c-.09,0-.16-.07-.24-.09l.33-.1.24.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.82,40.11l-.25.1-.32-.1.25-.09.32.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,55.27l-.78.54.28-.33.78-.54-.28.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.74,157.36l-.38.57c.1-.26.2-.54.29-.81l.38-.58c-.1.27-.19.54-.29.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43,40.1l-.31.1-.26-.09.31-.1.26.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,40.11l-.26.09-.31-.1.27-.09.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,40.1l-.29.1-.28-.1.28-.09.29.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,93l-.41.87.09-.57c.13-.29.27-.58.4-.86,0,.19-.06.37-.08.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3,79l-.56.79.18-.5c.18-.27.37-.53.56-.79a5,5,0,0,0-.18.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34,140.89l-.26.62c0-.29.08-.59.11-.88s.18-.41.26-.62c0,.3-.07.59-.11.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.77,112.6c0,.2,0,.4-.05.61-.06-.31-.12-.61-.19-.91s0-.41,0-.61c.07.3.14.6.2.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.32,125.75c0,.2-.09.41-.14.62,0-.31,0-.61-.06-.91s.1-.42.14-.62c0,.3,0,.6.06.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.92,59.71l-.75.6.27-.37.75-.6c-.1.12-.18.25-.27.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.66,48.7l-.8.41.27-.25.79-.41-.26.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,101.75c0,.2,0,.4,0,.59-.1-.3-.2-.59-.31-.89l0-.59c.11.3.21.59.31.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.22,73.56c.06.16.14.31.2.47-.2-.25-.41-.49-.61-.75l-.21-.47.62.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.36,85.1c0,.18.09.36.14.54-.16-.28-.33-.55-.5-.82s-.09-.36-.14-.54l.5.82"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 113.77,
    width: 1.09,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.24,114.47c-.07.3-.12.61-.18.91l-.06-.62c.06-.3.12-.6.17-.91,0,.21,0,.41.07.62"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.79,159.28l-.4.57c.1-.27.21-.53.3-.8s.27-.38.4-.58c-.09.27-.2.54-.3.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.79,53.82l-.78.52a4.15,4.15,0,0,1,.27-.32c.26-.18.53-.35.79-.51-.09.1-.19.2-.28.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.07,69.66l-.66.71c.07-.15.15-.3.23-.45l.65-.71c-.08.15-.15.3-.22.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.44,49.87l-.8.44L82.9,50l.8-.43c-.08.09-.18.17-.26.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.46,59.89c.1.13.18.26.27.38l-.75-.6-.26-.37.74.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.08,103.57l-.3.89c0-.2,0-.39,0-.59s.19-.6.29-.9c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,79.18c.05.17.12.34.17.51l-.56-.79c-.06-.17-.12-.34-.17-.5l.56.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.29,178.81c-.18.15-.36.32-.56.47.18-.21.34-.43.51-.65l.56-.48-.51.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,52.43l-.8.49.28-.3.79-.48-.27.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.56,43.33l-.73.26a1.21,1.21,0,0,1,.16-.16l.73-.26-.16.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.21,51.12l-.8.46.28-.28.79-.47-.27.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.81,143c-.1.2-.18.41-.28.61.05-.29.09-.59.13-.88s.19-.4.27-.61l-.12.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.49,62.83l-.72.65c.08-.14.17-.27.26-.41s.47-.43.72-.64l-.26.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,54l.27.32-.79-.52-.27-.31c.26.17.53.33.79.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.21,66.15l-.7.68.24-.43.69-.67c-.08.14-.16.28-.23.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.12,42.4l-.69.23a1.71,1.71,0,0,1,.11-.14l.69-.23-.11.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,50l.27.27-.81-.44-.26-.27.8.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.17,127.87c0,.21-.1.42-.16.62l0-.9c.05-.21.11-.42.16-.63,0,.31,0,.61,0,.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.8,180.35l-.58.47c.18-.21.35-.43.52-.64s.39-.31.58-.47c-.17.22-.35.43-.52.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.07,86.76q-.26.42-.48.84l.12-.54c.16-.28.31-.56.48-.83a4.54,4.54,0,0,0-.12.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.42,52.59c.09.1.19.2.27.3l-.79-.49-.27-.3.79.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,69.87l.23.46-.66-.72c-.07-.15-.14-.3-.22-.45.22.23.44.47.65.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,114.71c0,.2,0,.41-.06.61l-.18-.91.06-.61.18.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.21,51.26l.27.29-.8-.47c-.09-.09-.17-.19-.27-.28l.8.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.64,95l-.39.86c0-.19,0-.38.07-.57l.39-.87c0,.19-.05.38-.07.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.88,63c.09.13.17.27.25.4l-.72-.64c-.08-.14-.16-.27-.25-.4l.72.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,181.86l-.59.45.54-.62c.2-.14.39-.3.58-.45-.17.21-.35.41-.53.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8,45.25l-.78.33.21-.2.78-.32-.21.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.71,44.24l-.76.29.19-.18.76-.29-.19.18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 115.95,
    width: 0.54,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.11,116.59c-.06.3-.11.61-.16.91,0-.2-.05-.41-.08-.61s.1-.61.16-.92c0,.21,0,.41.08.62"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.15,103.81c0,.2,0,.4,0,.6l-.3-.9c0-.2,0-.39,0-.59l.3.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,58.07l-.76.58.27-.36.76-.58-.27.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,75l-.61.77c.06-.17.13-.33.19-.49s.4-.51.61-.76c-.07.16-.13.32-.19.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,145c-.1.21-.19.41-.29.61l.15-.87c.09-.2.19-.4.29-.6l-.15.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16,66.36c.08.14.16.28.23.43-.22-.23-.46-.46-.69-.68-.07-.15-.16-.28-.23-.43l.69.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.31,80.76l-.55.8c.06-.17.11-.34.16-.51l.54-.8c-.05.17-.11.34-.15.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.68,183.33l-.6.43.55-.59.6-.45c-.18.2-.36.41-.55.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.22,87l.12.55-.48-.84-.12-.54.48.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.68,105.65c-.1.29-.19.59-.28.89v-.6c.09-.29.17-.6.27-.9,0,.21,0,.41,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,130l-.18.63c0-.3,0-.61,0-.91a6.32,6.32,0,0,0,.18-.62c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.65,47.39l-.8.38.24-.24.8-.37c-.08.08-.17.15-.24.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.38,58.25l.26.36-.77-.58c-.08-.12-.17-.24-.26-.35l.77.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.07,184.75l-.61.43.56-.58.61-.43c-.19.19-.38.38-.56.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.34,75.27c.07.16.13.32.19.49l-.6-.76c-.06-.17-.13-.33-.19-.49l.6.76"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.33,
    y: 204.86,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.59,205l.41.09-.43-.09-.41-.09.43.09"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.58,147.07c-.1.2-.21.4-.31.61.06-.29.11-.58.17-.87l.31-.6c-.06.28-.11.57-.17.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.42,186.14l-.63.41.58-.56.62-.42-.57.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.08,116.83l-.09.62c0-.31-.1-.61-.15-.92s0-.41.08-.61c.05.3.11.61.16.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.81,40.64l-.5.15-.09-.11.5-.13.09.09"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.33,
    y: 204.86,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.6,205l.4.09-.41-.09-.39-.1.4.1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121.33,
    y: 204.86,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.62,205l.38.1-.39-.09-.37-.1.38.09"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.66,40.67l-.09.11-.5-.14.09-.1.5.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,81c.05.18.11.35.16.52l-.55-.8-.15-.51L193,81"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.33,
    y: 204.86,
    width: 1.09,
    height: 0.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.64,205l.36.1-.37-.1a3.58,3.58,0,0,1-.35-.09l.36.09"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.36,43.19l-.72.26a1.07,1.07,0,0,1,.14-.16l.72-.26-.14.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.73,187.48l-.63.4.58-.54.64-.41-.59.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.17,56.5l-.78.56c.08-.12.17-.24.26-.35l.78-.55-.26.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.87,71.29c-.22.24-.43.49-.64.73.07-.15.13-.31.2-.46l.65-.73-.21.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.53,61.08l-.74.63c.09-.13.17-.26.25-.39l.74-.62c-.09.13-.16.26-.25.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.26,88.69c-.16.28-.31.56-.46.84,0-.18.06-.37.1-.55s.3-.56.46-.84c0,.18-.07.36-.1.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.55,105.89c0,.2,0,.4,0,.6-.09-.3-.19-.6-.28-.9s0-.4,0-.6c.1.3.19.6.28.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,97c-.12.3-.25.59-.37.88,0-.19,0-.38.05-.57l.37-.88c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.71,132.11c-.07.21-.13.42-.2.63,0-.3,0-.6,0-.9l.21-.63c0,.3,0,.61,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,40.6l-.49.14-.11-.11.49-.13.11.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.43,48.48l-.8.41.24-.26.8-.4-.24.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.89,149.1l-.33.6c.06-.28.13-.57.19-.85l.33-.61c-.06.29-.12.58-.19.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.84,40.62a1.31,1.31,0,0,1-.12.11l-.48-.14a1.27,1.27,0,0,0,.12-.1l.48.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.33,107.73c-.08.3-.18.6-.25.91,0-.21,0-.41,0-.61s.17-.6.25-.9l0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.63,46.18l-.78.35.21-.21.79-.35-.22.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.94,67.7l-.68.7c.07-.15.14-.29.22-.44l.68-.69c-.08.14-.15.29-.22.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16,64.3l-.71.66c.07-.14.16-.28.24-.41.23-.23.47-.44.71-.66l-.24.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.86,61.27c.09.13.16.26.25.39l-.75-.62c-.07-.13-.16-.26-.24-.38l.74.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.48,71.51c.07.15.13.31.2.46l-.65-.73a4.58,4.58,0,0,0-.2-.46l.65.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.34,55l-.79.54c.08-.12.18-.22.26-.34l.79-.53-.26.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.15,119c0,.2-.07.41-.1.62-.05-.31-.1-.61-.14-.92s.07-.41.1-.62c.05.31.1.61.14.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.51,44.08c-.25.1-.5.19-.74.3a1.46,1.46,0,0,1,.16-.19l.75-.28-.17.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.91,76.79c-.2.25-.4.51-.59.77.06-.16.12-.33.17-.49s.39-.52.59-.77c-.06.16-.12.32-.17.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.36,82.6c-.18.27-.36.54-.53.81,0-.18.09-.35.14-.52s.35-.54.53-.81c0,.17-.1.34-.14.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,88.92c0,.19.07.37.1.56-.15-.29-.31-.57-.47-.85a5.12,5.12,0,0,0-.1-.54c.16.27.31.56.47.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.47,40.55l-.47.14-.13-.11.46-.13.14.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,40.58l-.13.1-.47-.13.14-.1.46.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,49.64l-.8.43a3,3,0,0,1,.24-.26l.8-.43a3,3,0,0,0-.24.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.14,151.11l-.34.6c.07-.28.13-.56.2-.85s.24-.39.35-.59l-.21.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.4,134.23c-.08.21-.15.41-.22.62,0-.3,0-.6,0-.9s.14-.42.22-.62c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.22,64.5a4.16,4.16,0,0,1,.23.42c-.23-.23-.47-.45-.71-.66l-.24-.42.72.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43,67.92c.08.14.15.29.22.43l-.69-.69-.21-.44.68.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.08,55.16l.26.33-.79-.54a3.92,3.92,0,0,0-.25-.32l.78.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.54,53.55l-.8.51c.08-.11.17-.21.26-.32l.79-.5a3.76,3.76,0,0,0-.25.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,50.87l-.81.46c.09-.09.17-.19.25-.28l.81-.46c-.09.09-.17.19-.25.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.89,108q0,.3,0,.6c-.08-.3-.17-.6-.26-.9s0-.41,0-.61c.08.3.17.6.25.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.75,52.18l-.8.48.26-.3.79-.48-.25.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.24,49.77c.08.09.17.18.24.27l-.8-.43-.24-.26.8.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,40.51l-.44.14-.16-.11.45-.13.15.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.18,40.54l-.16.11-.44-.14.16-.1.44.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,77c.06.17.12.33.17.5-.19-.26-.39-.52-.59-.77s-.11-.33-.17-.5l.59.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.47,99c-.11.3-.23.59-.35.89l0-.59c.11-.29.23-.58.35-.88l0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.62,59.4l-.75.6c.07-.13.16-.25.24-.38.25-.2.5-.4.76-.59-.09.12-.17.24-.25.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,82.83c.05.18.1.35.14.53l-.53-.81c0-.18-.1-.35-.14-.53.18.28.36.54.53.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18,43.06l-.71.25.12-.16.71-.25-.12.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5,90.63c-.15.28-.3.57-.44.86,0-.19,0-.38.08-.56s.29-.57.44-.85c0,.18-.06.37-.08.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.35,153.1c-.12.2-.24.4-.37.6.08-.28.15-.56.23-.84s.24-.39.36-.59c-.07.28-.15.55-.22.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,53.71c.08.1.17.2.25.31l-.8-.51c-.07-.1-.16-.2-.25-.31l.8.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,109.83l-.24.91c0-.2,0-.41,0-.61s.15-.6.23-.91c0,.21,0,.41,0,.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.47,51c.09.09.16.19.24.28l-.8-.46-.24-.28.8.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.17,121.08c0,.21-.09.42-.13.62,0-.3-.07-.6-.11-.91l.12-.62.12.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.69,52.33l.25.3-.8-.49-.25-.29c.27.15.53.32.8.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.14,40.48l-.43.13-.17-.11c.14,0,.28-.09.43-.12l.17.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.34,40.5l-.18.11-.42-.13.18-.11.42.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,136.34c-.08.2-.15.41-.24.62,0-.3,0-.6,0-.9s.17-.41.24-.62c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.44,47.19l-.79.37.22-.23.79-.37a2.44,2.44,0,0,0-.22.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.72,73l-.63.75.18-.48.63-.74-.18.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.79,59.58,175,60l-.76-.61c-.07-.12-.16-.24-.24-.36l.76.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,40.45l-.41.13-.2-.11.41-.12.2.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,40.47l-.2.11-.41-.13.2-.1.41.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,155.08c-.12.19-.26.39-.39.58.09-.27.17-.55.25-.82s.25-.4.38-.59c-.08.27-.15.55-.24.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,90.87c0,.19.05.38.08.56l-.45-.85c0-.19,0-.37-.08-.56l.45.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.18,62.5l-.73.64.23-.4.73-.63-.23.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.46,84.47l-.51.82c0-.18.07-.36.12-.53l.51-.82c0,.17-.09.35-.12.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.84,40.43l-.39.13-.23-.11.39-.13.23.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19,110.08l-.06.6q-.1-.45-.24-.9l.06-.61c.07.3.15.6.24.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,40.44l-.22.12-.39-.13.23-.11.38.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88,78.56c-.19.27-.39.53-.58.79.05-.17.11-.34.16-.51s.37-.52.57-.78l-.15.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.21,178.57l-.57.47.49-.65.57-.48-.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.64,73.18l.18.48c-.2-.25-.42-.5-.63-.75l-.18-.47.63.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.34,43.93l-.74.29.14-.18.74-.28-.14.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.71,69.3,59,70l.2-.45.67-.71c-.07.15-.14.3-.2.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75,57.77l-.77.58.24-.36.77-.58-.24.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.69,40.41l-.37.13a1.92,1.92,0,0,1-.25-.12l.37-.11.25.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,40.42l-.24.12-.37-.13.25-.1.36.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.13,123.21c0,.21-.09.42-.14.63,0-.31-.06-.61-.1-.92l.15-.62.09.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,101.09c-.11.3-.23.59-.33.89a5.86,5.86,0,0,1,0-.59l.33-.89c0,.2,0,.39,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,157l-.4.58c.09-.27.17-.54.26-.81l.4-.59c-.09.27-.17.55-.26.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.81,111.94c-.08.3-.15.61-.22.91,0-.21-.05-.41-.07-.61s.14-.61.22-.91c0,.2,0,.41.07.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.87,65.81l-.7.67c.07-.14.14-.28.22-.42s.46-.45.7-.68c-.08.14-.15.29-.22.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.45,46l-.79.35a2.09,2.09,0,0,1,.2-.22l.78-.34-.19.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.54,40.4l-.35.13-.27-.12.35-.11.27.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.72,180.12l-.59.46.5-.63.59-.47-.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,40.41l-.26.11-.35-.12.27-.11.34.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.39,40.4c-.11,0-.22.07-.33.12s-.19-.08-.28-.12l.33-.11.28.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.1,40.4l-.29.12-.32-.12.28-.12.33.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.25,40.4l-.31.11-.31-.11.31-.12.31.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,62.7l.23.4c-.24-.22-.49-.43-.74-.64-.07-.14-.14-.27-.22-.4l.73.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.23,48.26l-.8.41.22-.26.8-.39-.22.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.42,44.91l-.77.32c.06-.07.12-.13.17-.2l.77-.31-.17.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.79,92.6l-.42.86c0-.19,0-.38.06-.56s.28-.58.43-.86c0,.19,0,.37-.07.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.18,181.63l-.6.46c.17-.21.35-.41.51-.62l.61-.46c-.17.21-.34.42-.52.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,42.93l-.7.25.09-.16.71-.24a1.3,1.3,0,0,0-.1.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.86,84.7c0,.18.08.36.11.54l-.52-.83c0-.17-.07-.35-.11-.53.17.27.34.55.52.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.67,58c.08.12.17.24.24.36-.25-.2-.51-.39-.77-.58l-.24-.35.77.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.46,78.79l.15.51c-.19-.27-.39-.53-.58-.79l-.15-.5.58.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.66,69.51a4.43,4.43,0,0,1,.2.45c-.22-.24-.44-.48-.67-.71-.06-.15-.13-.3-.2-.45.23.23.45.47.67.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6,183.1l-.61.45.53-.6.62-.45a7.7,7.7,0,0,1-.54.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,159c-.13.19-.28.38-.42.57.1-.26.19-.53.28-.8s.29-.38.42-.58c-.09.27-.18.54-.28.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.52,66l.21.43-.7-.68c-.07-.14-.14-.28-.22-.42.24.22.48.44.71.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,184.54l-.63.43c.19-.19.37-.39.55-.58l.63-.44-.55.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.07,101.34v.59c-.1-.3-.22-.6-.33-.89s0-.4,0-.59c.11.29.23.59.34.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.91,56.21l-.78.55.24-.34.78-.55-.24.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,185.93l-.64.42.56-.57c.22-.14.43-.27.64-.42l-.56.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,112.18c0,.21,0,.41-.07.62-.07-.31-.14-.61-.22-.92s.05-.4.07-.61c.08.3.15.61.22.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,125.34c-.06.21-.11.42-.16.63l-.09-.91c.06-.21.12-.42.17-.63,0,.31.06.61.08.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.66,187.28l-.65.41.57-.55.65-.41-.57.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.65,160.87l-.44.56c.11-.26.21-.53.3-.79l.44-.57-.3.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,49.41l-.8.43.23-.27.8-.42c-.08.08-.15.17-.23.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.62,114.06c-.07.3-.13.6-.2.91,0-.21-.06-.41-.08-.62s.13-.6.19-.91c0,.21.07.41.09.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.61,74.67c-.21.25-.42.5-.62.76a4,4,0,0,1,.17-.49c.2-.26.4-.51.61-.76-.06.16-.11.33-.16.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.52,103.15l-.32.9v-.6c.1-.3.21-.59.31-.89,0,.2,0,.39,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.25,60.77l-.75.62c.08-.13.15-.27.23-.39l.75-.62-.23.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.61,86.36c-.17.27-.33.56-.5.83,0-.18.07-.36.1-.54l.5-.83c0,.18-.07.36-.1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1,54.71l-.79.53.24-.33.79-.52-.24.32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.7,
    y: 204.31,
    width: 1.63,
    height: 1.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.38,204.74l.41.11-.46-.1-.41-.12.46.11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.77,50.63l-.8.46a3.11,3.11,0,0,1,.23-.28c.26-.16.53-.31.8-.46l-.23.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.89,80.37c-.19.26-.37.53-.56.8,0-.18.08-.35.13-.52s.37-.53.57-.79c-.05.17-.1.34-.14.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.26,47l-.79.37c.07-.08.13-.16.2-.23l.79-.37c-.07.08-.14.15-.2.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.18,43.79l-.73.28.12-.18.74-.27-.13.17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.7,
    y: 204.31,
    width: 1.63,
    height: 1.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.45,204.74l.39.11-.44-.11a3.59,3.59,0,0,1-.39-.12c.14,0,.29.08.44.12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,53.28l-.8.51c.07-.11.15-.21.23-.32l.8-.5-.23.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,94.59c-.14.29-.28.58-.41.87,0-.19,0-.38,0-.57l.41-.87c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.54,51.92c-.27.16-.54.32-.8.49A3.55,3.55,0,0,1,80,52.1l.8-.47c-.08.09-.15.2-.23.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.89,127.48l-.18.62c0-.3,0-.61-.06-.91s.12-.42.18-.62c0,.3,0,.6.06.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.76,74.89l.16.48-.62-.75-.16-.49.62.76"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.7,
    y: 204.31,
    width: 1.63,
    height: 1.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.52,204.73l.37.11-.42-.1-.38-.12.43.11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.17,61l.22.39-.75-.62c-.08-.12-.14-.26-.22-.38l.75.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,42.81l-.69.25a1.19,1.19,0,0,1,.08-.16l.69-.24a1.09,1.09,0,0,0-.08.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.34,54.88l.24.33-.8-.53-.23-.33.79.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6,114.3c0,.2,0,.41-.09.61-.06-.3-.13-.6-.2-.91s.07-.41.09-.61c.07.3.13.61.2.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.69,50.77l.22.29c-.26-.16-.53-.31-.8-.46l-.22-.28.8.45"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.25,
    y: 204.31,
    width: 1.09,
    height: 1.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.59,204.73l.35.11-.4-.11-.36-.12.41.12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.53,70.93q-.35.36-.66.72c.05-.15.12-.31.18-.46l.66-.72c-.06.15-.13.3-.18.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.71,86.6c0,.18.07.36.09.54-.16-.28-.32-.56-.5-.83l-.09-.54c.17.27.33.55.5.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74,103.4c0,.19,0,.39,0,.59-.11-.3-.21-.6-.33-.89s0-.4,0-.6c.11.3.22.6.32.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.87,64c-.24.22-.49.43-.73.66.07-.14.14-.28.22-.41.24-.23.48-.44.72-.66-.07.14-.15.27-.21.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,144.66c-.1.21-.21.41-.31.62l.12-.88c.1-.2.22-.4.32-.61,0,.3-.09.58-.13.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.14,53.44c.08.1.15.21.23.32-.27-.17-.53-.35-.8-.51-.07-.11-.16-.21-.23-.31l.8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.92,52.07l.23.3-.81-.48a3.15,3.15,0,0,0-.22-.29l.8.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,116.18c-.07.3-.13.61-.18.91,0-.2-.07-.41-.11-.61s.11-.61.18-.92c0,.21.07.41.11.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.29,45.82l-.78.34.17-.21.78-.34a1.73,1.73,0,0,0-.17.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.45,80.6c.05.17.09.34.13.51l-.56-.79c-.05-.18-.09-.35-.13-.52.19.27.38.53.56.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.62,67.35l-.69.7c.06-.15.12-.3.19-.44l.7-.69c-.07.14-.14.29-.2.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.26,41l-.52.16-.11-.12.52-.16.11.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.24,41l-.11.13-.52-.17.12-.11.51.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.13,105.23c-.1.3-.21.6-.3.9,0-.2,0-.4,0-.6s.2-.6.29-.9c0,.2,0,.4,0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.37,59.09c-.26.19-.51.39-.77.6.07-.13.15-.26.23-.38.25-.2.5-.4.76-.59-.08.12-.15.24-.22.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.85,71.14c.07.15.13.31.19.47-.22-.25-.44-.49-.67-.73-.05-.16-.11-.31-.17-.46l.65.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.54,64.16c.07.14.15.27.21.41l-.72-.65-.21-.41.72.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.69,129.6l-.21.63c0-.3,0-.61,0-.91s.14-.42.21-.62c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,146.72l-.33.6c.05-.28.1-.57.14-.86s.23-.41.34-.61l-.15.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.06,48.05l-.8.4.2-.25.8-.39-.2.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.81,88.28c-.16.28-.33.56-.48.84a5.21,5.21,0,0,1,.08-.55l.48-.84c0,.19-.06.37-.08.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78,67.56c.07.14.13.29.19.44l-.69-.69c-.07-.15-.13-.3-.2-.44l.7.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,116.42c0,.21-.07.41-.11.62-.05-.31-.12-.61-.18-.91s.07-.42.11-.62c.06.3.13.61.18.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.14,41l-.5.16-.13-.12.5-.16.13.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.54,76.41l-.61.77.15-.5c.2-.26.41-.51.6-.77l-.14.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.07,59.27c.07.12.15.24.22.37l-.77-.59c-.07-.13-.14-.25-.22-.37l.77.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.37,41l-.14.12-.5-.16.14-.12.5.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.53,96.6l-.39.88c0-.2,0-.39,0-.58l.39-.88,0,.58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 117.59,
    width: 1.09,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.42,118.31c-.05.3-.1.61-.16.91l-.12-.62c0-.3.1-.61.16-.91,0,.2.08.41.12.62"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.14,105.47c0,.2,0,.4,0,.6-.09-.3-.2-.6-.3-.9s0-.4,0-.6l.3.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,82.2l-.54.81c0-.17.07-.35.11-.52l.55-.81c0,.17-.08.35-.12.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.05,43.65l-.72.28.09-.18.73-.27-.1.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.68,148.75c-.12.2-.23.41-.35.6.06-.28.11-.56.16-.85s.24-.41.36-.61c-.06.29-.11.58-.17.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.43,131.73c-.07.21-.15.41-.22.62,0-.3,0-.6,0-.9l.22-.63c0,.3,0,.61,0,.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.51,88.52a4.85,4.85,0,0,1,.08.55c-.16-.28-.32-.56-.49-.84,0-.19,0-.37-.07-.55.16.28.33.56.48.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.52,57.47l-.78.58c.07-.12.14-.24.22-.36l.78-.57-.22.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,40.91l-.49.16-.15-.13.48-.15.16.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.49,40.94l-.16.12-.49-.15c.06,0,.12-.08.16-.12l.49.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.83,76.63c0,.16.09.33.14.5l-.6-.78-.15-.49.61.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.78,107.32c-.09.3-.19.6-.28.9,0-.2,0-.4,0-.6s.18-.61.28-.91c0,.21,0,.41.05.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.92,62.18l-.75.63.21-.4.75-.63c-.07.13-.15.26-.21.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.84,49.19l-.81.42.21-.26c.26-.15.53-.29.8-.42a2.56,2.56,0,0,0-.2.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.94,150.77c-.13.19-.24.4-.37.6l.18-.85c.13-.2.25-.4.37-.6-.05.28-.12.57-.18.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.12,46.8l-.79.37.17-.24.79-.36a2,2,0,0,0-.17.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.38,72.59c-.21.25-.43.49-.65.74l.17-.47c.22-.25.43-.5.65-.74-.06.16-.12.31-.17.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.39,82.44l.12.52-.56-.81c0-.17-.07-.35-.1-.52.18.27.36.53.54.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.81,118.55c0,.2-.09.41-.13.62-.06-.31-.11-.61-.17-.92s.09-.41.13-.62c.06.31.11.61.17.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.92,40.87l-.47.16-.17-.13.46-.15.18.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6,40.9l-.18.12-.47-.15a1.88,1.88,0,0,1,.18-.12c.16,0,.31.1.47.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,44.6l-.75.31.12-.2.76-.3a1.27,1.27,0,0,0-.13.19"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.76,
    y: 119.77,
    width: 1.09,
    height: 2.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.41,120.44c0,.31-.09.61-.15.91,0-.2-.09-.41-.14-.62s.08-.61.14-.91c0,.21.1.41.15.62"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.51,62.37l.21.4-.75-.63c-.06-.14-.13-.27-.2-.4.25.2.49.42.74.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.12,133.85l-.24.62v-.9l.24-.63v.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7,55.92l-.79.55c.07-.11.14-.23.22-.34l.79-.55c-.08.11-.15.23-.22.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.06,90.22c-.16.29-.32.57-.47.86l.06-.56c.15-.29.31-.57.47-.85a5.14,5.14,0,0,0-.06.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,65.47l-.72.67c.07-.15.13-.29.2-.43.23-.23.47-.45.71-.67-.06.14-.13.28-.19.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,50.4c-.27.14-.53.3-.8.45.06-.1.13-.19.2-.29l.81-.44a2.92,2.92,0,0,0-.21.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.41,68.94l-.69.71.18-.45c.23-.24.45-.48.68-.71l-.17.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1,98.63c-.12.29-.24.59-.37.88v-.58c.13-.3.25-.59.38-.88,0,.19,0,.45,0,.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.14,152.77c-.13.2-.25.39-.39.59l.21-.83.39-.6-.21.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.48,107.56c0,.2,0,.4,0,.61-.09-.31-.19-.61-.28-.91s0-.4,0-.6c.1.3.19.6.28.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.82,40.84c-.15,0-.3.09-.45.15l-.2-.13.45-.15.2.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,40.86l-.2.13-.44-.16.2-.12.44.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,72.81c.05.15.11.31.16.47-.22-.24-.43-.49-.65-.74-.05-.16-.11-.31-.16-.47.21.25.43.49.65.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.54,187.08l-.66.41.55-.54c.22-.15.45-.28.67-.42l-.56.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87,184.33l-.64.43.53-.58.64-.44c-.17.2-.35.39-.53.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.22,185.73l-.65.42.54-.57.66-.43c-.18.2-.36.39-.55.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.91,54.44l-.8.53.21-.33.8-.52a3.53,3.53,0,0,0-.21.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,56.09l.21.35-.79-.55a2.39,2.39,0,0,0-.21-.34l.79.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.37,51.67l-.81.48c.06-.1.14-.2.21-.3l.8-.47c-.07.1-.14.19-.2.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.49,109.42c-.09.3-.17.6-.26.9,0-.2,0-.4-.07-.61s.17-.6.26-.9c0,.2,0,.4.07.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.13,53l-.8.51.21-.32.8-.5-.21.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.52,78.18c-.21.25-.41.52-.6.78,0-.17.09-.34.13-.51l.59-.78c0,.17-.09.34-.12.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.72,40.81c-.14,0-.29.09-.43.15l-.22-.13.43-.15.22.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.93,43.52l-.71.27a.87.87,0,0,1,.07-.17c.24-.09.48-.19.72-.27l-.08.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.83,65.67c.07.14.13.28.19.42l-.72-.67c-.06-.14-.12-.28-.19-.42l.72.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.8,40.82l-.22.13-.43-.15.23-.12.42.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.06,84.07c-.18.27-.36.54-.53.82,0-.18,0-.36.09-.54l.54-.81c0,.17-.07.35-.1.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,154.75l-.4.59c.07-.28.15-.56.22-.83s.27-.4.41-.59c-.08.27-.15.55-.23.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.82,120.68c0,.21-.1.41-.15.62,0-.3-.09-.61-.14-.91s.11-.42.15-.63c0,.31.1.61.14.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,69.15l.18.45-.69-.71-.18-.45.69.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,90.46l.06.56-.47-.85c0-.19,0-.37-.06-.55l.47.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.56,54.6c.07.11.15.22.21.33l-.8-.53a2.92,2.92,0,0,0-.21-.32c.27.17.54.34.8.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,60.45l-.75.61c.06-.12.13-.26.2-.38l.76-.61-.21.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.12,51.82l.2.3-.8-.48-.21-.29.81.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.62,40.78l-.41.15L118,40.8l.41-.14.24.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.9,40.8l-.25.13c-.13-.06-.27-.1-.4-.15.08-.05.16-.08.24-.12l.41.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.34,53.18l.21.31-.8-.5a3.37,3.37,0,0,0-.21-.31l.8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.92,47.85l-.8.39c0-.08.12-.16.18-.25l.79-.39a2.2,2.2,0,0,0-.17.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,156.71l-.43.58c.09-.27.16-.55.24-.82s.29-.39.43-.59l-.24.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.53,40.76l-.39.15-.26-.13.39-.14.26.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,40.77l-.27.14-.39-.15.27-.12.39.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.86,78.4c0,.17.09.34.12.51-.19-.27-.39-.52-.59-.79,0-.16-.08-.33-.13-.5l.6.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.77,109.66c0,.2-.05.4-.07.61-.09-.3-.17-.6-.26-.91s0-.4.07-.61c.09.3.18.61.26.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.44,40.75l-.37.15-.28-.14.37-.14.28.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.09,40.76l-.29.13-.37-.14.29-.13.37.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,84.3c0,.18.06.36.09.53l-.53-.82c0-.17-.06-.35-.1-.53.18.28.37.55.54.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.43,60.64c.07.12.14.25.2.38l-.76-.61c-.06-.13-.13-.26-.2-.38l.76.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.35,40.75l-.35.14-.3-.14.35-.14.3.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.17,40.75l-.3.14-.35-.14.31-.14.34.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.48,100.68c-.12.29-.25.59-.36.89,0-.2,0-.4,0-.59s.23-.6.36-.89c0,.19,0,.39,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.26,40.74l-.33.14-.32-.14.33-.13.32.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,204.42l.41.13-.5-.12-.41-.14.5.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.35,92.19l-.45.86c0-.19,0-.38,0-.56l.45-.86c0,.18,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45,158.64l-.44.58c.09-.27.17-.54.26-.81s.3-.38.44-.58c-.09.27-.17.54-.26.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.78,122.81c-.05.21-.11.42-.16.63-.05-.31-.08-.61-.13-.92s.12-.41.17-.62c0,.3.09.61.12.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.26,111.53c-.08.3-.17.6-.25.91l-.09-.62.24-.91c0,.21.06.41.1.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.28,74.29c-.21.25-.42.51-.64.76l.15-.49.63-.75c-.05.16-.09.32-.14.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,44.45l-.74.3a1.14,1.14,0,0,1,.1-.19c.24-.11.49-.21.74-.3,0,.06-.07.12-.1.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.19,204.41l.39.13-.48-.12-.39-.14.48.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62,63.63l-.74.65c.06-.14.13-.27.19-.41l.74-.65c-.06.14-.14.27-.19.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,46.61l-.78.36.15-.23.78-.36c0,.08-.11.15-.15.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,204.4l.37.13-.46-.12-.37-.14.46.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.15,58.78l-.77.6c.06-.13.13-.25.2-.38.26-.19.51-.39.78-.58-.08.12-.14.24-.21.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.45,160.55c-.15.2-.3.38-.46.57.1-.26.19-.53.28-.79l.46-.57c-.09.26-.18.53-.28.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,49l-.8.42c.06-.08.11-.18.17-.26l.81-.42a1.51,1.51,0,0,0-.18.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.83,43.39l-.7.27a1.21,1.21,0,0,1,.05-.18l.71-.26a.58.58,0,0,0-.06.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.43,204.39l.35.13-.44-.12-.35-.14.44.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,100.92c0,.19,0,.39,0,.59l-.36-.89c0-.2,0-.39,0-.59l.36.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.23,70.56l-.67.73c0-.16.1-.31.16-.47l.67-.72c0,.16-.1.31-.16.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,92.43c0,.19,0,.38,0,.57l-.45-.86c0-.19,0-.38,0-.57.16.29.3.58.45.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.11,74.51a3.94,3.94,0,0,1,.14.49c-.2-.26-.42-.51-.63-.76-.05-.16-.09-.32-.14-.48.21.25.43.5.63.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.22,86c-.18.27-.35.55-.52.83l.07-.54c.17-.28.34-.56.52-.83,0,.18,0,.36-.07.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.35,67l-.71.69.18-.44c.23-.24.47-.46.71-.69l-.18.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.54,80c-.2.26-.39.53-.58.8,0-.18.07-.35.11-.52s.38-.53.58-.79c0,.17-.08.34-.11.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,162.44c-.15.19-.31.38-.47.56l.3-.78.47-.57c-.09.27-.19.53-.3.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82,63.82l.19.42-.74-.65c-.06-.14-.12-.28-.19-.41l.74.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,111.77l-.09.61c-.08-.3-.16-.6-.25-.91s.07-.41.09-.61c.09.3.17.6.25.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.31,59l.19.38-.77-.6-.2-.37.78.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.69,125l-.18.62c0-.3-.07-.61-.11-.91s.13-.42.19-.63c0,.31.07.61.1.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,102.74c-.11.3-.23.59-.34.89l0-.59c.11-.3.22-.6.34-.9l0,.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.07,113.65c-.07.3-.14.6-.22.91,0-.21-.07-.41-.11-.62s.15-.61.22-.91c0,.2.08.41.11.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.32,57.18l-.78.57.2-.36.78-.56c-.07.11-.13.23-.2.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.32,142.24l-.32.61c0-.29.07-.58.08-.88s.22-.41.32-.62c0,.3-.05.59-.08.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.18,70.77c.06.16.11.31.16.47l-.68-.73-.15-.45.67.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.07,67.21l.18.44-.71-.69c-.06-.14-.12-.29-.17-.44l.7.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.46,50.16l-.8.45.18-.28.81-.44-.19.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7,94.18l-.43.87c0-.19,0-.38,0-.57l.43-.87c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14,86.19c0,.18.05.37.07.55l-.52-.83c0-.19-.05-.37-.07-.55l.52.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.84,80.2c0,.18.07.35.11.52l-.59-.79c0-.18-.07-.35-.1-.52l.58.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.53,55.64c-.27.18-.54.36-.8.55.06-.12.13-.23.2-.35l.79-.54-.19.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,127.08c-.06.21-.13.42-.2.63,0-.31-.05-.61-.09-.91s.15-.42.21-.63c0,.3.07.61.08.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,61.86c-.25.21-.51.41-.76.63.06-.14.12-.27.19-.4.25-.22.51-.42.76-.63-.07.13-.13.26-.19.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82,41.47l-.13.14-.54-.19.14-.13.53.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.22,51.43l-.8.47a2.82,2.82,0,0,1,.18-.29l.81-.47-.19.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.93,44.3l-.74.3a1.67,1.67,0,0,1,.08-.2l.74-.29a1.54,1.54,0,0,0-.08.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8,47.65,89,48l.15-.25L90,47.4l-.15.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74,144.3c-.11.21-.22.42-.34.62,0-.29.07-.58.1-.87l.34-.62c0,.29-.07.58-.1.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.27,103c0,.2,0,.4,0,.6l-.34-.9c0-.2,0-.39,0-.59.12.3.24.59.35.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.19,113.89c0,.2-.07.41-.11.61-.08-.3-.15-.6-.23-.91L203,113c.07.31.15.61.22.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.22,76l-.62.77c0-.16.08-.33.13-.49.2-.26.41-.52.62-.77-.05.16-.09.33-.13.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.75,54.17l-.81.52c.07-.11.13-.22.2-.32.26-.18.53-.35.8-.52l-.19.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,43.27l-.69.26a.55.55,0,0,1,0-.17l.69-.26a1,1,0,0,0,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,52.77l-.8.49.18-.31.81-.49c-.06.1-.13.2-.19.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.63,94.42c0,.19,0,.38,0,.57-.14-.29-.29-.58-.44-.86,0-.2,0-.39,0-.58.15.29.3.58.44.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,115.77c-.08.3-.14.61-.21.91l-.12-.61c.06-.31.13-.61.2-.92,0,.21.08.42.13.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,55.81l.19.34-.8-.54a3.72,3.72,0,0,0-.19-.34c.27.17.53.36.8.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.27,51.57c.07.1.13.2.19.3l-.81-.47-.18-.29.8.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.42,87.88c-.17.27-.34.56-.5.84,0-.19,0-.37,0-.55.17-.28.33-.57.51-.84a4.87,4.87,0,0,0-.06.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.76,62l.18.4-.75-.63-.19-.39.76.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.64,104.81c-.11.31-.22.6-.32.9,0-.2,0-.4-.06-.6l.32-.9.06.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,146.36c-.11.21-.23.41-.35.61l.12-.86.35-.61c0,.28-.07.57-.12.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.74,54.33c.07.11.13.22.19.33l-.8-.52c-.06-.11-.12-.22-.19-.33l.8.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.51,52.92a3.21,3.21,0,0,1,.19.31l-.81-.5c0-.1-.12-.2-.18-.31l.8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89,41.41l-.15.14-.52-.18.15-.14.52.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.61,81.81c-.2.27-.38.54-.57.81l.09-.53c.18-.27.38-.53.57-.8a4.34,4.34,0,0,0-.09.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.18,76.25l.12.49-.63-.77a4.37,4.37,0,0,0-.12-.49l.63.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.34,129.21l-.22.63c0-.3,0-.61-.07-.91s.16-.42.23-.63c0,.3.05.61.06.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.36,65.13l-.73.67c0-.15.12-.29.17-.43l.73-.67c-.06.14-.12.28-.17.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,72.22c-.22.25-.45.49-.66.74,0-.16.09-.31.14-.47l.66-.74c-.05.16-.09.32-.14.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1,96.19c-.14.29-.28.58-.41.88,0-.2,0-.39,0-.59s.27-.58.41-.87v.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.32,116c0,.21-.09.41-.13.62l-.21-.91c.05-.21.09-.42.13-.62.07.3.15.61.21.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.15,68.59c-.23.23-.47.46-.7.7,0-.15.1-.3.16-.45.23-.24.46-.47.7-.7-.06.15-.11.3-.16.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.94,88.11c0,.19,0,.37.05.55-.16-.28-.34-.56-.5-.84s0-.37-.06-.55c.18.28.34.56.51.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.59,41.33l-.5.18-.18-.15.51-.17.17.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.41,148.4c-.12.2-.25.4-.37.61.05-.29.1-.57.14-.86s.25-.4.37-.61c-.05.29-.09.58-.14.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.82,60.14l-.77.61.19-.39.76-.6-.18.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,41.36s-.12.09-.18.14l-.49-.18.17-.14c.17.06.34.11.5.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.59,48.76c-.27.13-.54.27-.8.42a2.34,2.34,0,0,1,.15-.27l.81-.41a2.26,2.26,0,0,0-.16.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.66,105.06c0,.2,0,.4,0,.6l-.33-.9c0-.2.05-.4.06-.6.11.3.22.6.32.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.78,82c0,.17.06.35.08.53-.18-.28-.37-.54-.57-.81,0-.18,0-.35-.08-.52l.57.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.09,65.32c.06.15.12.29.17.43l-.73-.67c-.05-.14-.12-.28-.17-.42l.73.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.32,72.44c0,.16.1.31.14.47l-.67-.74c0-.15-.09-.31-.13-.47l.66.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.09,131.34c-.09.2-.16.42-.25.62,0-.3,0-.6,0-.9s.17-.42.24-.63c0,.31,0,.61.05.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68,43.15l-.68.26a1,1,0,0,1,0-.17l.68-.26a.91.91,0,0,1,0,.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.86,44.16l-.73.3.06-.2.72-.29a1.8,1.8,0,0,0,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.67,150.43l-.39.6c.06-.29.1-.57.16-.85l.39-.61c-.05.29-.1.57-.16.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54,41.28l-.49.18-.19-.15.48-.17.2.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.28,68.79c.06.15.11.3.16.46-.23-.24-.46-.48-.7-.71-.05-.15-.1-.3-.16-.45l.7.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.65,60.32l.18.39-.77-.61-.18-.38.77.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3,106.9c-.11.31-.21.61-.31.91,0-.2,0-.41-.07-.61s.19-.6.3-.9c0,.2.05.4.08.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,41.31l-.2.15c-.16-.06-.32-.13-.48-.18l.2-.14.48.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.67,89.82l-.48.85,0-.56.49-.85c0,.19,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.21,77.79l-.61.78c0-.17.07-.33.1-.5l.61-.78c0,.17-.07.33-.1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.39,118.14l-.15.62c-.07-.3-.12-.61-.19-.91l.15-.62c.07.3.13.61.19.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.49,41.25l-.46.17-.23-.15.47-.17.22.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,58.48l-.78.59.18-.37.78-.58-.18.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.87,152.43c-.13.2-.26.4-.4.6l.18-.84.41-.6c-.06.28-.12.56-.19.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.36,49.94l-.81.44c0-.09.11-.18.16-.28l.81-.44c-.06.09-.11.19-.16.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.06,41.27l-.22.15-.47-.18.23-.14.46.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.86,120c-.06.3-.11.61-.16.91-.06-.21-.12-.41-.17-.62s.1-.61.16-.91c.05.2.11.41.17.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.55,98.22c-.13.29-.26.59-.4.88,0-.2,0-.39,0-.59s.26-.58.4-.88c0,.2,0,.39,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.71,47.45l-.79.39a2,2,0,0,0,.13-.25l.79-.38c0,.08-.08.16-.13.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.72,83.67c-.19.27-.36.55-.55.82,0-.18,0-.36.07-.53.18-.28.37-.55.55-.82,0,.18-.06.35-.07.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83,204l.39.15-.52-.14-.39-.16.52.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.42,63.3l-.75.65c0-.14.11-.27.17-.41l.74-.65c0,.14-.11.27-.16.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,107.15c0,.2,0,.4-.08.6-.1-.3-.2-.6-.31-.9s.06-.41.08-.61c.11.3.21.61.31.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.87,45.15l-.75.33a1.8,1.8,0,0,1,.08-.21L97,45c0,.07,0,.14-.08.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,41.22l-.45.17-.24-.15.45-.17c.08,0,.16.09.24.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1,41.23l-.24.15-.45-.17.25-.14.44.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,154.42l-.43.59c.07-.28.13-.56.2-.83l.43-.6c-.07.28-.13.56-.2.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.2,78c0,.16.07.33.1.5l-.61-.78c0-.17-.07-.33-.11-.5.21.26.42.51.62.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.69,90.06c0,.18,0,.37,0,.55l-.49-.85,0-.55c.16.28.33.56.49.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,204l.38.15-.5-.14-.37-.16.49.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.17,56.89l-.79.57.18-.36.79-.56-.18.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,109c-.1.3-.19.6-.29.9l-.09-.61c.09-.3.19-.6.28-.9,0,.2.06.4.1.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.41,41.19l-.43.17-.26-.15.43-.17.26.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.11,51.19l-.8.47.16-.3.81-.46-.17.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.14,41.2l-.26.16-.43-.17.27-.15.42.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,73.92l-.65.75c0-.16.08-.32.12-.48.21-.26.43-.5.65-.75l-.12.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.05,63.49l.16.42c-.24-.22-.5-.43-.75-.65-.05-.14-.1-.27-.16-.41l.75.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.14,156.38l-.45.59c.07-.28.15-.55.22-.82s.3-.39.44-.59c-.06.28-.14.55-.21.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.67,83.9l.06.54c-.18-.28-.36-.55-.55-.82,0-.18,0-.36-.07-.53l.56.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.41,120.28c-.06.2-.11.41-.18.62,0-.3-.1-.61-.16-.92s.12-.41.17-.62c.06.3.12.61.17.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.17,204l.35.15L118,204l-.35-.16.48.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.38,41.17l-.41.17-.29-.15.41-.17.29.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.13,66.66l-.72.69c.05-.15.11-.3.16-.44l.71-.68c0,.14-.1.29-.15.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.18,41.18l-.28.15-.41-.16.28-.15.41.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.89,122.18c0,.3-.09.61-.14.91-.07-.21-.13-.41-.19-.63s.09-.61.15-.91l.18.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.39,55.37c-.27.18-.54.35-.8.54.06-.12.11-.23.17-.34.27-.19.53-.37.8-.54l-.17.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.87,52.52l-.81.49c0-.11.11-.21.17-.32l.8-.48a3,3,0,0,0-.16.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8,44l-.71.29a.69.69,0,0,1,0-.2l.71-.28,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,70.2c-.23.24-.46.49-.69.72.05-.15.09-.31.14-.46.22-.24.46-.47.69-.71a3.88,3.88,0,0,0-.14.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.34,41.16l-.39.16-.3-.15L120,41l.3.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.32,57.06c.06.12.12.24.17.36-.26-.19-.52-.38-.79-.56l-.17-.36c.26.19.52.38.79.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.22,41.16l-.31.16-.39-.16c.1-.06.21-.1.31-.15l.39.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.63,53.91l-.81.52A3.41,3.41,0,0,1,78,54.1l.8-.52-.16.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.34,204l.34.16-.47-.15-.33-.16.46.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.19,158.32l-.46.58c.08-.27.16-.54.23-.8l.47-.59-.24.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31,41.15l-.37.16-.33-.15c.13-.06.26-.1.37-.16l.33.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.25,41.15l-.33.16-.37-.16.33-.15.37.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,41.15l-.35.16-.35-.16.35-.15.35.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,91.78l-.47.86c0-.19,0-.38,0-.56s.31-.58.47-.86c0,.19,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.42,74.14c0,.16.08.32.11.48l-.65-.75c0-.16-.07-.32-.12-.48l.66.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.05,100.26c-.13.3-.25.6-.38.89,0-.2,0-.39,0-.59s.26-.59.38-.89c0,.2,0,.4,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.65,52.66c0,.11.11.21.16.31l-.81-.49-.16-.31.81.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.11,55.53a2.7,2.7,0,0,1,.17.34l-.8-.54c0-.11-.11-.23-.17-.34l.8.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.32,66.86c.06.15.1.29.15.44l-.72-.68-.15-.44.72.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.51,48.55l-.8.41a2.1,2.1,0,0,1,.13-.26l.8-.41c0,.09-.09.17-.13.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.19,160.24l-.47.58c.08-.27.17-.54.25-.8l.48-.58-.26.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,54.06l.16.33-.8-.52-.17-.32.81.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,137.68c-.1.21-.2.42-.31.63,0-.3,0-.6,0-.89l.31-.63c0,.3,0,.6,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.53,61.54c-.26.2-.51.42-.77.63,0-.14.1-.27.16-.41l.77-.62a2.78,2.78,0,0,0-.16.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.24,79.59l-.6.8.09-.52.59-.79c0,.17-.06.34-.08.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.45,70.41c.05.16.1.31.14.47l-.69-.72c-.05-.16-.09-.31-.14-.46.23.24.47.47.69.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.77,111.12c-.09.3-.18.6-.26.91l-.12-.62.27-.91c0,.21.07.41.11.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.37,122.41l-.19.63-.15-.92c.07-.21.13-.41.19-.62l.15.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.15,162.14c-.16.19-.33.37-.5.56.1-.26.2-.52.28-.78l.49-.57c-.09.26-.17.53-.27.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.88,85.56c-.17.28-.36.55-.54.83l.06-.54c.17-.28.35-.56.53-.83,0,.18,0,.36,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.82,45l-.74.33a1.41,1.41,0,0,1,.06-.22l.74-.31a1.52,1.52,0,0,0-.06.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.28,100.5c0,.2,0,.4,0,.6-.12-.3-.25-.6-.38-.89s0-.4,0-.59c.13.29.26.59.38.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.51,139.78c-.1.21-.21.42-.32.62,0-.29,0-.59,0-.88s.21-.42.32-.62c0,.29,0,.59,0,.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.17,79.82a4.5,4.5,0,0,1,.08.51l-.59-.79-.09-.51c.2.26.41.52.6.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.51,85.79c0,.18,0,.37.05.55l-.54-.83c0-.18,0-.36-.05-.54l.54.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,43.9l-.7.29a1.34,1.34,0,0,1,0-.2l.71-.28a1.23,1.23,0,0,0,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.28,49.72l-.81.44c0-.1.1-.19.14-.28.27-.14.54-.3.81-.43a1.38,1.38,0,0,0-.14.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,75.65l-.64.77c0-.17.07-.34.1-.5.21-.26.43-.51.64-.76,0,.16-.07.32-.1.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.28,124.55l-.21.62c0-.3-.08-.6-.13-.91s.14-.42.21-.62c0,.3.09.61.13.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.17,64.79l-.74.67.15-.43.74-.66-.15.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.67,59.83l-.77.61c0-.13.1-.26.16-.39l.77-.6c0,.13-.1.26-.16.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.61,102.32c-.13.3-.24.6-.36.9l-.06-.6.36-.89c0,.2,0,.4.06.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.33,93.77c-.16.29-.3.58-.46.87v-.57l.45-.87c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,141.87l-.34.62.06-.88c.11-.21.22-.42.34-.62l-.06.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.17,41.91l-.55.21c-.05-.06-.11-.11-.15-.17l.55-.2.15.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.59,113.24l-.24.91c-.06-.21-.09-.41-.14-.62s.16-.61.25-.91c0,.21.09.41.13.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.9,172.9l-.58.52c.13-.24.25-.48.38-.71l.58-.52c-.12.24-.25.47-.38.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.54,174.58l-.6.51.4-.69.6-.51c-.14.23-.27.46-.4.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.13,176.23l-.61.5c.14-.23.28-.45.41-.68l.62-.5-.42.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.39,42l-.15.16-.55-.21.15-.16c.18.07.37.13.55.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.87,71.86c-.23.24-.45.49-.68.74,0-.17.07-.32.12-.48.22-.25.45-.49.68-.73-.05.15-.08.31-.12.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,68.24l-.71.7c0-.15.08-.3.13-.45l.71-.7c0,.15-.09.3-.13.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.47,75.87c0,.16.07.33.1.5l-.64-.77c0-.17-.06-.33-.1-.49.21.25.43.5.64.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.4,144c-.12.2-.23.41-.36.61,0-.29.06-.58.08-.87l.36-.62c0,.29,0,.58-.08.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.73,102.57l-.06.59c-.13-.29-.24-.59-.37-.89,0-.2,0-.4.07-.6.11.3.24.6.36.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,51l-.81.46c0-.1.09-.2.14-.29l.81-.46A2.59,2.59,0,0,0,84,51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.32,81.42c-.2.27-.4.53-.59.8,0-.17,0-.35.07-.52l.58-.8c0,.17-.05.34-.06.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.09,87.48c-.17.28-.35.55-.52.84l0-.56.52-.83c0,.18,0,.36,0,.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.86,58.19l-.8.58c.06-.12.11-.24.16-.37l.79-.58c-.05.12-.11.24-.15.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.13,126.68l-.23.63c0-.3-.07-.6-.11-.91s.16-.42.24-.62c0,.3.07.6.1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.16,41.85l-.54.2-.17-.16.54-.2.17.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.71,113.48c0,.2-.09.41-.13.62l-.26-.92.15-.61.24.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,72.07c0,.16.08.32.11.48-.22-.25-.45-.49-.68-.74,0-.16-.07-.31-.11-.47l.68.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.79,44.86l-.73.31,0-.21.74-.31a1.55,1.55,0,0,0,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.47,115.37c-.08.3-.16.6-.23.91-.06-.21-.1-.41-.15-.62s.14-.61.22-.91c0,.2.1.41.16.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.46,48.35l-.8.41c0-.09.07-.18.11-.27l.8-.4c0,.09-.08.17-.11.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.76,146c-.12.2-.25.4-.37.61,0-.29.07-.58.1-.87l.37-.61c0,.29-.06.58-.1.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.22,104.4l-.35.9c0-.2,0-.4-.08-.6s.23-.6.35-.9c0,.2,0,.4.08.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.79,52.27l-.81.49c0-.11.1-.21.14-.31l.81-.49c-.05.1-.1.21-.14.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.06,56.61l-.79.56a3.68,3.68,0,0,1,.15-.35l.8-.56c0,.12-.1.23-.16.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.75,43.78l-.7.28c0-.07,0-.13,0-.19l.69-.28c0,.06,0,.12,0,.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.1,81.65c0,.17.05.35.06.52l-.58-.8c0-.18,0-.35-.07-.52.2.26.4.53.59.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.3,87.71c0,.18,0,.37,0,.55-.17-.28-.35-.56-.53-.84a5.06,5.06,0,0,0,0-.55c.18.28.35.56.52.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.26,63l-.75.64c0-.13.09-.27.14-.41l.76-.64-.15.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.16,41.8l-.52.2-.2-.17.52-.19.2.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.73,95.78l-.44.87c0-.19,0-.38,0-.58s.29-.58.44-.87c0,.2,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.54,53.65l-.81.51c0-.11.1-.21.15-.33l.81-.5a1.87,1.87,0,0,0-.15.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3,55.1l-.81.53.15-.34.8-.53a3.45,3.45,0,0,0-.14.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.08,148.05c-.13.21-.26.41-.4.61,0-.28.09-.57.12-.85l.4-.62c0,.29-.07.58-.12.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.45,56.78c.05.11.11.24.15.35l-.79-.56-.15-.35.79.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.58,203.6l.38.17-.53-.16c-.13-.06-.26-.11-.38-.18l.53.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,77.41l-.63.78c0-.17.05-.34.08-.51l.63-.77c0,.17-.06.33-.08.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,53.8l.15.33-.81-.51a2.41,2.41,0,0,0-.15-.33l.81.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.84,115.6c-.05.21-.11.42-.16.62-.08-.3-.15-.6-.23-.91s.11-.41.16-.62c.08.3.15.61.23.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,55.26l.15.34-.81-.54c0-.11-.09-.22-.14-.34l.8.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.12,104.64c0,.2-.05.4-.08.61-.11-.3-.23-.6-.35-.9,0-.2.06-.4.09-.6.11.3.23.59.34.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.16,41.75l-.5.2a1.84,1.84,0,0,1-.22-.17l.5-.19.22.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.39,117.5c-.06.3-.14.61-.2.91l-.18-.62c.08-.3.14-.61.21-.91.05.2.11.41.17.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.34,150.08l-.41.61c0-.29.09-.57.13-.85l.42-.61c0,.29-.09.57-.14.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,203.58l.36.17-.52-.16-.35-.18.51.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.35,89.42l-.51.85c0-.19,0-.38,0-.57.16-.28.33-.56.5-.84,0,.18,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,66.32c-.24.23-.48.46-.73.68,0-.14.09-.29.13-.44l.73-.67-.13.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.88,106.49c-.12.3-.22.6-.33.91,0-.21-.07-.41-.1-.61s.21-.6.33-.9c0,.2.06.4.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.24,49.51l-.81.43a1.39,1.39,0,0,1,.12-.28c.26-.15.53-.29.8-.43a2.33,2.33,0,0,0-.11.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17,41.71l-.49.2-.24-.17.49-.19.24.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.44,83.28c-.2.27-.38.54-.57.82a4.93,4.93,0,0,1,.05-.54l.57-.81c0,.17,0,.35-.05.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.48,77.63c0,.17.06.34.08.51l-.63-.78c0-.17-.05-.33-.08-.5l.63.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,41.74l-.24.16-.48-.19.24-.16.48.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.79,73.55l-.66.75.09-.48.67-.75c0,.16-.07.32-.1.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.55,152.09l-.43.6c0-.27.11-.56.15-.84l.43-.6-.15.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,203.56l.34.17-.5-.16c-.11-.06-.22-.11-.33-.18l.49.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4,61.22l-.78.63c0-.13.09-.27.15-.4l.76-.62c0,.13-.1.26-.13.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8,69.85l-.7.72c0-.16.07-.31.11-.47.24-.23.47-.47.7-.71,0,.15-.07.31-.11.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.78,44.72l-.72.31a1.48,1.48,0,0,1,0-.21l.73-.31a1.49,1.49,0,0,0,0,.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.19,97.81c-.15.29-.28.59-.42.88,0-.2,0-.39-.05-.59l.42-.88c0,.2,0,.39,0,.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.18,41.68l-.46.19-.27-.17.47-.18a2.26,2.26,0,0,1,.26.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.91,117.73c-.06.21-.11.42-.18.63-.06-.31-.13-.61-.21-.92s.13-.41.18-.62c.08.31.14.61.21.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4,41.7l-.26.17-.47-.19.27-.17.46.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.71,154.09l-.45.59c.06-.28.12-.55.17-.83s.3-.4.45-.6c-.06.28-.11.56-.17.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25,203.54l.32.18-.48-.17a2,2,0,0,1-.32-.18l.48.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,89.65c0,.19,0,.37,0,.56l-.51-.85c0-.18,0-.37,0-.56l.51.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.38,119.64c-.07.3-.13.61-.19.91-.07-.21-.13-.41-.19-.62l.18-.92c.07.21.13.42.2.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.36,133.08c-.09.21-.19.42-.29.63,0-.3,0-.6,0-.91s.19-.41.29-.62c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,83.51c0,.17,0,.35.05.53l-.58-.81c0-.18,0-.36,0-.53.19.26.39.53.57.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.66,73.77c0,.16.07.32.1.48l-.67-.75L186,73l.66.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.46,106.73c0,.21-.06.41-.1.61-.11-.3-.21-.6-.33-.9,0-.2.07-.41.11-.61.11.3.22.6.32.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2,41.65l-.45.19-.28-.17.45-.18.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.39,41.67l-.29.17-.45-.19.29-.16c.15,0,.3.12.45.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67,70.06c0,.15.07.31.11.46l-.7-.72c0-.15-.07-.3-.11-.46l.7.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.81,156.06c-.15.19-.3.39-.46.58.06-.27.13-.54.19-.82s.31-.39.47-.59c-.06.28-.13.55-.2.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,50.73l-.81.46.12-.29.81-.46-.12.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.22,41.63l-.43.19-.3-.17c.14-.06.28-.13.43-.18l.3.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.37,41.64l-.31.18-.43-.19.31-.17.43.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.57,59.53l-.79.6c0-.13.09-.26.14-.38l.78-.6c0,.12-.09.25-.13.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.59,108.6l-.31.9c0-.2-.07-.41-.12-.61.11-.3.21-.6.31-.91l.12.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.87,158l-.48.58c.07-.27.15-.54.21-.81s.33-.39.48-.59l-.21.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.73,45.76,96,46.1a1.85,1.85,0,0,1,0-.23l.76-.33a1.43,1.43,0,0,0,0,.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.25,41.62l-.41.18c-.12,0-.22-.12-.33-.17l.41-.18.33.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.35,41.63l-.33.17-.41-.18.33-.17.41.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,79.21c-.21.26-.42.52-.62.79,0-.17,0-.35.07-.52.2-.26.4-.53.61-.79,0,.17,0,.34-.06.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.27,41.61l-.39.18-.35-.17.39-.18.35.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.32,41.62l-.35.17-.39-.18.35-.17.39.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,135.2c-.1.21-.21.42-.31.62l0-.89.31-.63,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.3,41.61l-.37.18-.37-.18.37-.17.37.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.66,91.38c-.17.28-.33.57-.49.86,0-.19,0-.38,0-.57l.49-.86c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,119.87c-.06.21-.14.42-.2.63-.06-.31-.12-.61-.19-.92s.14-.41.2-.62c.06.3.13.61.19.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.88,159.93c-.16.2-.33.39-.5.58.08-.27.16-.54.23-.8l.5-.58c-.07.27-.15.54-.23.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6,46.9l-.77.38a1.83,1.83,0,0,1,.06-.25c.26-.12.52-.25.78-.36a1.55,1.55,0,0,0-.07.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,64.46l-.76.66c0-.14.09-.28.13-.42l.75-.66a3.31,3.31,0,0,0-.12.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.84,161.83l-.52.57c.09-.26.17-.52.26-.79l.51-.57c-.08.27-.17.53-.25.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,52l-.81.48.12-.31c.27-.16.55-.31.81-.48l-.12.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,85.16l-.56.83,0-.54c.19-.27.37-.55.55-.83,0,.18,0,.36,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.69,99.85c-.13.3-.27.59-.4.89,0-.2,0-.39-.06-.59s.26-.59.4-.89c0,.2,0,.4.06.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.77,57.9l-.8.58c0-.13.09-.25.14-.37l.79-.58c-.05.12-.09.25-.13.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.75,163.71c-.17.19-.36.37-.53.56.09-.26.19-.52.27-.78s.36-.37.53-.56c-.09.26-.17.52-.27.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41,177.6l-.64.49c.14-.22.28-.44.41-.66l.64-.49c-.13.22-.27.44-.41.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8,44.58l-.72.31a1.48,1.48,0,0,1,0-.21l.71-.3a1.36,1.36,0,0,0,0,.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.45,79.43c0,.17,0,.34.06.52-.21-.26-.42-.53-.62-.8l-.06-.51.62.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.61,165.55l-.54.56.29-.77.54-.55c-.09.25-.19.51-.29.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58,137.31c-.1.21-.22.42-.33.63v-.89l.32-.63c0,.3,0,.6,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.85,176l-.62.5.39-.67.63-.51c-.13.23-.26.46-.4.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.49,53.4l-.81.51a3.21,3.21,0,0,1,.12-.33l.81-.51-.12.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43,167.37c-.18.19-.37.36-.56.55l.31-.75.56-.55c-.11.25-.2.5-.31.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,56.33l-.81.56c0-.12.08-.24.13-.36l.8-.55-.12.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.25,174.33l-.61.51c.13-.23.26-.46.38-.69l.61-.52c-.12.24-.25.47-.38.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.76,75.28,56.1,76c0-.17,0-.33.08-.5l.65-.76c0,.17,0,.33-.07.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2,169.16l-.57.53c.11-.24.22-.48.32-.73l.58-.54-.33.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,172.64l-.6.52c.13-.24.24-.47.36-.71l.61-.52-.37.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.24,54.83l-.81.53.12-.34.81-.52c0,.11-.09.22-.12.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.93,170.92l-.59.52c.12-.24.23-.48.34-.72l.59-.53-.34.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.76,58.07c.05.12.09.25.13.37l-.79-.58c0-.12-.08-.25-.13-.37l.79.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.79,67.89l-.72.7c0-.15.07-.3.11-.45l.72-.7c0,.15-.07.3-.11.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.36,110.71c-.11.3-.19.61-.29.91,0-.21-.09-.41-.14-.62s.19-.6.29-.91c.05.21.08.42.14.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.89,122l-.21.63-.18-.92c.08-.2.15-.41.22-.62.06.3.12.61.17.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,85.39l0,.55c-.18-.28-.37-.55-.56-.83,0-.18,0-.36,0-.54l.56.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,123.92c0,.31-.09.61-.14.92l-.24-.64.15-.91c.07.21.16.42.23.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7,71.5c-.24.25-.46.49-.7.73,0-.16.06-.32.1-.47.22-.25.46-.49.69-.73,0,.16-.07.31-.09.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.68,100.09l-.06.6c-.13-.3-.27-.59-.41-.89,0-.2,0-.4.07-.59l.4.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.06,53.54a2.19,2.19,0,0,1,.12.33l-.81-.51c0-.1-.08-.21-.12-.32l.81.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.55,56.5a2.06,2.06,0,0,1,.12.35l-.8-.55-.12-.36.8.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.31,55c0,.11.09.22.13.34l-.81-.53a3.42,3.42,0,0,0-.13-.34l.81.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.11,139.41l-.35.63c0-.3,0-.59,0-.89l.34-.62c0,.29,0,.59,0,.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.64,42.44l-.57.23-.18-.18c.19-.08.38-.16.57-.22l.18.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.71,75.49c0,.17,0,.33.07.5-.22-.26-.43-.51-.66-.76,0-.17,0-.33-.07-.5l.66.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,68.09c0,.15.07.3.11.45-.25-.23-.48-.47-.73-.69,0-.15-.07-.3-.1-.45l.72.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.15,62.66l-.77.64c0-.14.08-.27.13-.41l.76-.64-.12.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,93.37l-.48.86,0-.57.48-.87c0,.2,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,111c0,.2-.09.41-.14.61-.09-.3-.19-.6-.29-.91l.15-.61c.1.3.19.6.28.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.75,45.61l-.75.33c0-.07,0-.15,0-.22l.75-.34a1.77,1.77,0,0,0,0,.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79,71.71l.09.48-.7-.74-.09-.47c.23.25.47.49.7.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,101.92c-.13.29-.26.59-.38.89l-.09-.6c.13-.3.25-.6.38-.89,0,.2.05.4.09.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.09,81l-.61.81c0-.18,0-.35.05-.53.19-.27.4-.53.6-.8,0,.17,0,.35,0,.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.58,141.51c-.12.2-.25.41-.36.62l0-.88c.13-.21.24-.42.36-.62,0,.29,0,.59,0,.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.65,126.06c0,.31-.09.61-.13.91-.08-.2-.17-.41-.25-.62s.08-.61.13-.92c.08.22.16.43.25.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.18,112.83c-.1.3-.18.61-.27.91,0-.2-.11-.41-.16-.62l.27-.91c0,.21.1.42.16.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.83,87.08c-.19.27-.36.56-.55.84,0-.19,0-.37,0-.56l.54-.83v.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,42.38l-.55.23-.2-.19.55-.22.2.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,46.73l-.78.37c0-.08,0-.16,0-.25l.76-.36,0,.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92,42.41l-.19.19-.56-.23.2-.17.55.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.34,203.1l.36.2-.55-.18-.36-.2.55.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,143.59c-.12.21-.25.41-.38.62,0-.3,0-.59,0-.88l.39-.62-.06.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.13,102.16l-.09.59-.39-.89.09-.6.39.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.36,81.26c0,.17,0,.35,0,.53L190.8,81c0-.17,0-.35,0-.52.2.27.41.53.6.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.31,60.92l-.78.62a2.64,2.64,0,0,1,.12-.4l.78-.62c0,.13-.09.26-.12.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.85,66c-.26.22-.5.45-.75.67,0-.14.07-.29.11-.43l.74-.68c0,.15-.07.29-.1.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.6,87.31c0,.18,0,.37,0,.55l-.54-.84c0-.18,0-.36,0-.55.18.28.37.56.54.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.61,203.08l.34.19-.53-.17-.34-.21.53.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,42.33l-.54.22-.21-.19.53-.21.22.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.76,77l-.64.78.06-.51.64-.77-.06.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.88,42.36l-.22.18-.54-.22.22-.18.54.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.37,145.66c-.13.2-.27.4-.4.61,0-.29.05-.58.07-.87l.4-.61c0,.29,0,.58-.07.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.86,104l-.37.9c0-.2-.07-.4-.1-.6l.36-.9c0,.2.07.4.11.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.22,61.1c.05.13.08.26.12.4l-.78-.62c0-.14-.07-.27-.12-.4.26.2.53.41.78.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.05,115c-.09.31-.17.61-.25.91l-.18-.62c.08-.3.17-.6.25-.91l.18.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.43,95.37c-.16.29-.32.58-.46.88,0-.2,0-.39,0-.58.15-.3.3-.59.46-.88,0,.2,0,.39,0,.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.73,51.8c-.27.16-.54.31-.81.48,0-.11.06-.21.1-.32l.81-.47a2.81,2.81,0,0,0-.1.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.66,69.5l-.71.71c0-.15,0-.31.09-.46.23-.24.47-.48.71-.71l-.09.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.88,203.06l.32.19-.51-.18-.32-.2.51.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.63,73.19c-.23.24-.46.49-.68.74,0-.16,0-.32.07-.48.23-.25.45-.5.68-.74,0,.15-.05.31-.07.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.68,147.71l-.41.61c0-.29.07-.57.09-.86s.27-.41.42-.61c0,.28-.06.57-.1.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,42.28l-.52.22c-.09-.06-.16-.13-.24-.19l.52-.21.24.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.78,45.46l-.74.33a1.62,1.62,0,0,1,0-.22l.74-.33a1.62,1.62,0,0,0,0,.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,77.26c0,.16,0,.33,0,.5l-.64-.77-.06-.51.65.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.82,42.3a2.23,2.23,0,0,1-.24.19l-.52-.22.24-.18.52.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.45,128.43l-.27.63c0-.3-.08-.6-.11-.91l.27-.63c0,.31.08.61.11.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.22,82.89l-.59.81a4.7,4.7,0,0,1,0-.53l.59-.81a4.61,4.61,0,0,0,0,.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.47,53.15l-.81.5c0-.11.07-.22.1-.32l.81-.5c0,.1-.06.21-.1.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.16,203l.3.19-.5-.18-.3-.2.5.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.09,89l-.53.85c0-.19,0-.37,0-.56.17-.28.35-.56.53-.84,0,.18,0,.37,0,.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.52,104.24c0,.2-.07.4-.11.6l-.37-.9c0-.2.08-.4.11-.6.13.29.25.59.37.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,149.74l-.44.61.12-.85c.14-.21.28-.41.43-.61,0,.28-.08.57-.11.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,59.41c0,.13.08.25.11.38-.26-.19-.52-.4-.79-.59,0-.13-.07-.26-.11-.39l.79.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.84,69.7c0,.16.06.31.09.47l-.72-.72c0-.15-.06-.3-.09-.46.24.24.49.47.72.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.86,73.4c0,.16,0,.32.07.48-.23-.24-.46-.49-.68-.74,0-.16,0-.32-.07-.48.23.24.45.49.68.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.85,42.23l-.5.22a2.48,2.48,0,0,1-.26-.19c.17-.06.33-.14.5-.21s.17.13.26.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76,42.26l-.26.18-.5-.21.26-.18.5.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,56.06l-.81.55c0-.12.07-.24.11-.35l.81-.55c0,.12-.08.23-.11.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,117.1c-.08.3-.16.61-.23.91-.07-.21-.13-.42-.2-.62.08-.31.15-.61.23-.92.06.21.13.42.2.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.94,64.14l-.76.66c0-.15.07-.29.1-.43l.76-.65c0,.13-.07.28-.1.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.16,151.76l-.45.6c0-.28.08-.56.13-.84l.45-.6c0,.28-.08.56-.13.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.46,47.78l-.78.39c0-.08,0-.17,0-.26l.78-.39c0,.09,0,.17,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.52,106.08c-.12.3-.23.61-.35.91l-.12-.61c.11-.3.23-.6.35-.9l.12.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.83,57.78a2.59,2.59,0,0,1,.11.37c-.26-.19-.53-.39-.8-.57,0-.13-.07-.25-.11-.37l.8.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.2,130.57l-.3.63-.09-.91.3-.63.09.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.24,83.12c0,.17,0,.35,0,.53l-.59-.81c0-.18,0-.36,0-.53.2.26.39.54.59.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.92,42.2l-.48.21-.29-.18.49-.21.28.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,42.22l-.29.19c-.16-.07-.32-.15-.48-.21l.28-.19.49.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.36,54.72c0,.12.07.23.1.34l-.82-.52a3.37,3.37,0,0,0-.1-.34l.82.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.34,89.25c0,.19,0,.37,0,.56L194.8,89c0-.18,0-.37,0-.55.19.27.36.56.53.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6,56.22c0,.12.08.24.11.36L166.9,56l-.1-.35.8.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.32,153.76c-.15.2-.31.4-.47.59.05-.27.11-.55.15-.83l.47-.6-.15.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.61,179l-.66.48.41-.64.66-.49c-.13.22-.27.44-.41.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.88,97.4c-.14.3-.29.59-.44.88,0-.19,0-.39-.07-.59.15-.29.29-.59.45-.87,0,.19,0,.38.06.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,42.17l-.47.21-.31-.19.47-.2.31.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.63,42.19l-.31.19-.47-.21.31-.19.47.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.43,155.73l-.48.6c.06-.28.11-.55.17-.83l.48-.59c0,.28-.11.55-.17.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.09,177.36l-.66.49c.14-.22.26-.44.4-.66l.65-.49-.39.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.81,78.83l-.63.79c0-.18,0-.35,0-.52l.63-.79c0,.18,0,.35,0,.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.36,117.33c-.06.21-.12.42-.2.63-.07-.31-.15-.61-.23-.92s.14-.41.2-.62c.08.3.16.61.23.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.86,106.33c-.05.2-.09.4-.13.6l-.35-.9c0-.2.09-.4.13-.61.12.3.23.6.35.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,42.15l-.45.21-.32-.19.45-.2.32.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.49,157.69c-.16.2-.33.39-.5.59.06-.27.13-.55.19-.82s.34-.39.5-.59c-.06.28-.12.55-.19.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.52,175.74l-.64.5c.13-.22.26-.45.38-.68s.43-.33.64-.51c-.12.23-.25.46-.38.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.89,132.7c-.11.21-.21.42-.31.63,0-.3-.05-.6-.08-.91l.32-.62c0,.3,0,.6.07.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.55,42.16l-.33.2-.44-.21.33-.19.44.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,119.24l-.21.91c-.07-.21-.14-.42-.22-.62.08-.31.14-.62.21-.92.08.21.15.42.22.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.69,67.55l-.74.7q0-.24.09-.45l.74-.7-.09.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.84,45.32l-.74.33,0-.23.73-.32a1.7,1.7,0,0,0,0,.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,159.62l-.51.58c.07-.27.13-.53.21-.8l.51-.58c-.06.27-.14.53-.21.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.92,174.07l-.63.52.36-.7.63-.51-.36.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.15,42.14l-.43.2-.35-.19.43-.2.35.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.47,42.14l-.35.2-.42-.21.35-.18.42.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,42.13l-.41.2-.37-.2.41-.19.37.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.4,42.13l-.38.2-.4-.2.37-.19.41.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.41,91c-.18.28-.35.57-.51.86,0-.19,0-.38,0-.57l.51-.86c0,.19,0,.38,0,.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.47,161.53l-.54.57c.09-.26.16-.52.23-.79l.54-.57c-.08.26-.16.53-.23.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.27,172.38l-.61.52c.11-.24.22-.47.34-.71l.61-.53c-.11.24-.22.48-.34.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.31,42.13l-.39.2-.39-.2.4-.2.38.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.24,108.19l-.33.9-.15-.61.33-.9.15.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.61,74.91l-.68.76c0-.17,0-.33.06-.5l.67-.75c0,.16,0,.32,0,.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.66,79.05c0,.17,0,.34,0,.52-.21-.27-.42-.53-.64-.79a4.41,4.41,0,0,0,0-.52c.21.27.43.52.63.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.38,163.41l-.55.57c.09-.26.17-.52.25-.78l.55-.57c-.08.26-.16.52-.25.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58,170.65l-.6.53c.11-.24.22-.48.32-.72l.61-.54c-.11.24-.21.49-.33.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.39,84.77l-.57.83v-.55c.19-.27.38-.55.58-.82,0,.18,0,.36,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25,165.26l-.56.56.27-.76.56-.57-.27.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.85,168.88l-.59.54c.1-.24.21-.49.3-.74l.59-.54c-.09.25-.2.5-.3.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.57,71.15l-.71.72c0-.16,0-.31.07-.47.24-.24.48-.48.71-.73,0,.16,0,.32-.07.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.07,167.09l-.58.55c.1-.25.2-.5.29-.76l.58-.55c-.09.25-.19.51-.29.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.52,134.82q-.15.31-.33.63c0-.3,0-.6-.05-.9s.22-.42.34-.63c0,.3,0,.6,0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.38,119.47l-.22.63c-.07-.3-.14-.61-.22-.91.08-.21.16-.42.23-.63l.21.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.46,62.53c0,.14.07.27.09.41-.25-.21-.52-.42-.77-.64l-.1-.4.78.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.39,99.45l-.42.88-.09-.59c.14-.3.28-.59.43-.89,0,.2,0,.4.08.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,121.38c-.07.31-.13.61-.19.92l-.24-.63c.06-.31.13-.61.19-.92.08.21.15.43.24.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.71,46.41l-.76.36v-.25l.75-.35a1.93,1.93,0,0,0,0,.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,75.12c0,.17,0,.33.05.5-.22-.26-.45-.51-.67-.76,0-.17,0-.33-.05-.49l.67.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,91.21c0,.19,0,.38,0,.57-.17-.29-.34-.57-.52-.85,0-.19,0-.38,0-.57l.51.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.94,71.35c0,.16.05.32.07.48l-.71-.73c0-.16,0-.31-.07-.47l.71.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.12,84.86v.68c-.19-.27-.38-.55-.58-.82,0-.18,0-.36,0-.54l.57.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.11,136.94l-.35.63,0-.89c.11-.22.23-.42.35-.64l0,.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.51,47.6l-.78.39c0-.09,0-.18,0-.26l.78-.38c0,.08,0,.17,0,.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,43l-.59.25-.2-.2.59-.25.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1,202.55l.34.21-.56-.19-.34-.22.56.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,184.72l-.71.43.45-.58.72-.44c-.15.2-.3.4-.46.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,110.3c-.11.31-.22.61-.32.91-.06-.2-.11-.41-.16-.61.11-.31.21-.61.31-.91.06.2.11.41.17.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,99.69l-.09.59c-.14-.3-.28-.59-.43-.89l.09-.59c.14.29.29.59.43.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.49,52.91l-.81.5c0-.11,0-.22.07-.33l.82-.49c0,.1,0,.21-.08.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.29,60.79l.09.4-.79-.62a2.74,2.74,0,0,0-.09-.39l.79.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.77,65.66l-.75.67c0-.15,0-.29.08-.44l.75-.67c0,.15-.06.29-.08.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.91,45.19l-.72.32a1.55,1.55,0,0,1,0-.23l.71-.31.06.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.91,80.65c-.21.26-.41.53-.62.8,0-.18,0-.35,0-.53.2-.27.41-.53.62-.79,0,.17,0,.35,0,.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,139.05l-.37.62c0-.29,0-.59,0-.88l.37-.63c0,.3,0,.59,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.77,93c-.17.29-.34.58-.5.87,0-.19,0-.38-.05-.58.16-.29.32-.58.49-.86l.06.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.23,54.32l-.81.52c0-.11,0-.23.08-.34l.81-.52a3.38,3.38,0,0,0-.08.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.42,202.52a3.62,3.62,0,0,0,.32.22l-.55-.2-.32-.22.55.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.62,183.28l-.71.45.44-.6.71-.45-.44.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.62,86.68c-.19.28-.38.56-.56.84,0-.19,0-.37,0-.56.19-.27.37-.55.56-.83,0,.19,0,.37,0,.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,101.51c-.14.3-.27.59-.4.89,0-.2-.08-.4-.11-.6.13-.3.26-.59.41-.89,0,.2.07.4.1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2,43c-.18.09-.38.17-.57.25l-.22-.2.58-.24.21.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.09,59.11l.09.39-.8-.59-.09-.38.8.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.37,110.54c-.05.21-.1.41-.16.62-.1-.3-.21-.61-.32-.91.06-.2.12-.41.17-.62.11.3.22.61.31.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.43,43a2.09,2.09,0,0,1-.22.2l-.57-.24.22-.2.57.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.57,80.87c0,.18,0,.36,0,.53-.21-.27-.41-.54-.62-.8,0-.18,0-.35,0-.53l.62.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.11,141.15l-.38.62c0-.29,0-.59,0-.88s.26-.42.38-.63c0,.3,0,.59,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,54.47a3.38,3.38,0,0,1,.08.34l-.82-.53c0-.11,0-.22-.07-.33l.81.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.62,76.66l-.66.78c0-.17,0-.34,0-.51l.66-.77c0,.17,0,.34,0,.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.58,69.15l-.73.72.06-.47.73-.7c0,.15,0,.3-.06.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.86,57.5l.09.37-.81-.57c0-.12,0-.24-.08-.37l.8.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.25,123.76c-.08.21-.17.42-.26.63-.05-.3-.11-.61-.17-.91.09-.21.18-.42.26-.63.06.3.11.6.17.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.67,93.2c0,.19,0,.38,0,.58-.16-.3-.33-.58-.5-.87,0-.19,0-.38,0-.57.17.28.34.57.5.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,181.8l-.7.46.42-.61.7-.47-.42.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.62,56c0,.12.06.24.08.36l-.81-.55c0-.12,0-.24-.08-.35l.81.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.24,125.67c-.06.31-.11.61-.16.92l-.27-.63L42,125c.09.21.18.43.28.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.83,112.43c-.11.3-.2.6-.29.91-.07-.21-.13-.41-.19-.62.1-.3.19-.61.29-.91.06.2.12.41.19.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75,202.5l.29.21-.53-.19-.3-.23.54.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.52,72.83l-.7.74c0-.16,0-.32,0-.49l.7-.74c0,.17,0,.33,0,.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.79,46.26l-.75.35a1,1,0,0,1,0-.24l.75-.35a1,1,0,0,0,0,.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.85,86.91c0,.19,0,.37,0,.56l-.57-.84c0-.18,0-.37,0-.55l.57.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.54,143.23c-.14.21-.27.42-.41.62,0-.29,0-.58,0-.87l.41-.63,0,.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.46,101.75c0,.2-.07.4-.11.6-.13-.3-.27-.6-.41-.89,0-.2.07-.4.11-.6.14.29.28.59.41.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33,42.94a2.31,2.31,0,0,1-.24.2l-.55-.24.24-.2.55.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,69.36l.06.46c-.24-.24-.48-.48-.73-.71l-.06-.46.73.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.74,180.28c-.22.16-.46.31-.69.47.14-.2.28-.42.41-.63l.69-.48-.41.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.88,76.88l0,.51-.66-.78,0-.5.66.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.08,202.47l.28.22-.52-.2-.28-.22.52.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,73c0,.16,0,.32.05.48-.23-.25-.46-.5-.7-.74,0-.16,0-.32,0-.48L185,73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.91,145.3c-.14.21-.28.42-.43.62,0-.29,0-.58.05-.87s.29-.41.43-.62c0,.29,0,.58-.05.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.18,95l-.48.87c0-.19-.05-.38-.07-.58l.48-.87c0,.19,0,.39.07.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.11,125.9l-.28.63c-.05-.3-.1-.6-.16-.91.1-.21.2-.42.28-.63.06.31.11.61.16.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.43,127.82c0,.3-.09.61-.13.91L42,128.1c0-.31.08-.61.13-.91l.29.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.66,64c0,.13.05.28.07.42l-.77-.65c0-.15-.05-.29-.07-.43l.77.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.57,103.59l-.39.9c0-.21-.09-.41-.13-.61l.39-.9c0,.21.09.41.13.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.25,178.72l-.68.49c.14-.22.26-.44.39-.65l.68-.49-.39.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.42,42.86l-.54.24-.26-.21.54-.23.26.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.05,82.5l-.61.82v-.54l.61-.81c0,.18,0,.35,0,.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.23,42.89l-.27.2-.54-.24.27-.2.54.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.71,114.56c-.1.3-.19.61-.28.91-.07-.2-.13-.41-.2-.62l.27-.91c.07.2.13.41.21.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.41,202.45l.26.21-.5-.2-.26-.22.5.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.22,147.36l-.43.62c0-.29.05-.58.07-.87s.29-.4.43-.61c0,.29,0,.58-.07.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.89,88.62c-.19.28-.37.56-.55.85l0-.57.54-.84c0,.19,0,.37,0,.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.72,177.13l-.67.49c.13-.22.25-.44.37-.66l.67-.5c-.12.22-.25.44-.37.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.54,42.81l-.53.24a2.83,2.83,0,0,0-.28-.2l.52-.24.29.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.49,149.4,197,150c0-.28.05-.57.09-.85l.45-.61c0,.28-.05.57-.09.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,42.84c-.1.06-.19.14-.29.21l-.51-.24a2.83,2.83,0,0,1,.28-.2l.52.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.91,128l-.3.64c0-.31-.09-.61-.13-.91s.2-.42.29-.64c0,.31.09.61.14.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.64,67.21c-.26.23-.51.46-.75.7,0-.15,0-.31.06-.45l.75-.69a3.56,3.56,0,0,0-.06.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.14,175.49l-.65.51c.12-.22.24-.45.35-.68s.44-.34.66-.51c-.12.23-.23.45-.36.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,82.73c0,.18,0,.36,0,.53l-.6-.81v-.53l.61.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.85,103.83c0,.2-.09.4-.13.6-.13-.3-.27-.6-.39-.9,0-.2.09-.4.13-.6l.39.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,185.92l-.73.43.45-.56.74-.44c-.15.19-.3.39-.46.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.71,151.43l-.47.6c0-.28.07-.56.1-.84s.33-.4.48-.61c0,.28-.07.57-.11.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.55,52.67l-.82.5c0-.11,0-.22,0-.33l.82-.49c0,.11,0,.21,0,.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.51,62.22c0,.13,0,.27.07.41-.26-.22-.53-.42-.79-.63,0-.14,0-.28-.07-.41l.79.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.69,78.45l-.65.79c0-.18,0-.35,0-.52l.65-.78c0,.17,0,.34,0,.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.53,173.82l-.64.52c.11-.23.23-.47.33-.7s.44-.34.65-.52c-.11.23-.22.47-.34.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.66,42.78l-.5.23-.31-.21.51-.23.3.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.58,88.85c0,.19,0,.38,0,.56-.18-.28-.36-.56-.55-.84,0-.19,0-.38,0-.56.19.28.36.56.55.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.89,46.11l-.74.35-.06-.24.74-.35.06.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,42.8l-.31.21-.5-.24.31-.2.5.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.87,153.43l-.49.6c0-.28.09-.56.13-.83s.33-.41.49-.61c0,.28-.08.56-.13.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.63,116.7c-.09.3-.17.61-.25.91-.08-.2-.15-.41-.22-.62.08-.31.16-.61.25-.92l.22.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.23,105.68l-.37.9-.15-.61c.12-.3.24-.6.37-.9l.15.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.88,172.12l-.63.52c.11-.23.21-.47.32-.71l.63-.53-.32.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,70.79l-.72.73c0-.16,0-.32,0-.47.23-.24.47-.49.71-.72,0,.15,0,.31,0,.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.65,97l-.47.88-.09-.59.46-.88c0,.2.06.39.1.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,155.41c-.17.2-.33.4-.51.6.06-.28.1-.55.15-.82l.51-.6-.15.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.65,130.19l-.31.63-.12-.91.32-.63c0,.3.08.6.11.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,42.75l-.49.23-.32-.21.48-.23.33.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.51,74.54l-.69.76,0-.49.69-.76c0,.17,0,.33,0,.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.86,42.76l-.32.21-.49-.22.33-.21.48.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19,170.38c-.21.18-.42.35-.62.54.1-.25.2-.49.29-.73l.63-.54-.3.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.28,54.07l-.82.52.06-.34.82-.52c0,.12,0,.23-.06.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.05,157.38c-.17.19-.34.39-.52.58.06-.26.12-.54.17-.81l.52-.59c-.06.27-.11.54-.17.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,184.52l-.72.44c.15-.19.29-.39.43-.58l.73-.45c-.14.2-.29.39-.44.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.45,168.61l-.61.54c.1-.24.19-.49.28-.74l.61-.55c-.1.25-.19.5-.28.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.82,78.67c0,.17,0,.35,0,.52l-.65-.79c0-.17,0-.34,0-.51l.65.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,159.31l-.54.59c.07-.27.13-.54.19-.81l.54-.58c-.06.27-.12.54-.19.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.92,42.72l-.47.23-.34-.21.47-.22.34.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,60.49c0,.13.05.27.07.4l-.8-.61c0-.13,0-.27-.06-.4l.79.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.66,166.81l-.59.55c.08-.25.18-.5.26-.75l.6-.56-.27.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.73,42.74l-.35.21-.46-.23.35-.2.46.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,161.23l-.55.57c.07-.26.14-.52.2-.79s.38-.38.55-.58c-.06.27-.13.53-.2.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.69,47.27l-.77.38a2.45,2.45,0,0,1,0-.27l.76-.37,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.83,165l-.57.56c.07-.26.16-.52.24-.77l.58-.57c-.08.26-.16.52-.25.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,163.12c-.19.18-.37.38-.57.56.08-.26.15-.52.23-.78l.57-.57c-.08.26-.16.52-.23.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,71c0,.16,0,.31.05.47l-.72-.72c0-.16,0-.32-.05-.47L183,71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.24,84.38c-.2.28-.4.55-.59.83l0-.55.6-.82c0,.18,0,.36,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.06,42.71l-.45.22-.37-.21.45-.22.37.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.6,42.72l-.37.21-.45-.22.37-.21.45.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.75,116.93c-.07.21-.15.42-.23.63-.08-.31-.17-.61-.25-.91l.22-.63c.09.3.17.61.26.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.18,105.92c-.05.2-.09.41-.15.61-.12-.3-.24-.6-.37-.9l.15-.61.37.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.21,90.58l-.53.85c0-.18,0-.37,0-.56l.52-.86.06.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,74.76l0,.49-.69-.75,0-.5.69.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19,42.7l-.43.22-.39-.21.43-.22.39.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,42.7l-.4.22-.42-.22.39-.21.43.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.33,42.7l-.41.22-.41-.22.41-.21.41.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.35,132.32c-.11.21-.22.42-.34.63,0-.3,0-.6-.09-.9l.33-.64c0,.31.06.61.1.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.75,65.33,66,66l.06-.44.76-.66c0,.14,0,.28,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,58.82l.06.39-.81-.59c0-.13,0-.25-.06-.38l.81.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.86,202l.33.23c-.2-.06-.39-.14-.58-.21l-.33-.24.58.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.62,118.84c-.09.31-.16.61-.24.92l-.24-.63c.07-.31.16-.61.23-.92.08.21.16.42.25.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6,55.69c0,.11,0,.23.05.35l-.81-.54c0-.12,0-.24-.06-.35.27.18.55.35.82.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,183.07l-.72.46.42-.6.72-.46-.42.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.85,57.22c0,.13.05.25.07.37L167.1,57c0-.13,0-.25-.06-.37l.81.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,107.79l-.35.9c-.06-.2-.12-.41-.17-.61.12-.3.23-.61.35-.91,0,.21.11.41.17.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.25,188.42l-.76.41.47-.53.75-.41-.46.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.26,84.61l0,.55-.59-.83c0-.18,0-.36,0-.54l.6.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,90.81l-.06.57-.53-.85.06-.57c.17.29.35.57.53.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,46l-.74.34-.07-.25.73-.34c0,.08,0,.16.08.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,134.45c-.12.21-.23.42-.36.63,0-.3,0-.6-.07-.9l.35-.63c0,.3.05.6.08.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.16,99l-.45.89c0-.2-.07-.4-.11-.6l.45-.88a5.59,5.59,0,0,0,.11.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.24,201.91a3.36,3.36,0,0,0,.29.24l-.56-.21a2.48,2.48,0,0,1-.3-.25l.57.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.81,181.59l-.71.46.4-.62.71-.46-.4.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77,119.07c-.08.22-.16.43-.25.64-.08-.31-.15-.62-.23-.92l.24-.63.24.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8,80.27l-.64.8c0-.18,0-.35,0-.53.21-.26.42-.53.64-.79a4.51,4.51,0,0,0,0,.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.65,121c-.07.3-.15.61-.21.91-.09-.21-.18-.42-.26-.63s.14-.61.21-.91l.26.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.54,68.81l-.74.71c0-.16,0-.31,0-.46l.74-.71c0,.16,0,.31,0,.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.57,136.57l-.37.63c0-.3,0-.6-.06-.89l.38-.63c0,.29,0,.59,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,190.77l-.78.38.48-.49.78-.38-.48.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.94,187.1l-.75.42.45-.55.75-.42-.45.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.61,201.88c.09.09.19.16.28.24l-.55-.22a2.09,2.09,0,0,1-.28-.24l.55.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.35,180.06l-.71.48c.13-.21.27-.42.39-.64l.7-.48-.38.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.54,76.3c-.23.25-.45.51-.68.77,0-.17,0-.34,0-.51l.67-.77c0,.17,0,.34,0,.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.58,92.57c-.17.29-.35.57-.51.86,0-.19-.06-.38-.08-.58L48.5,92c0,.19.06.38.08.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.72,109.9c-.11.3-.23.61-.33.91-.07-.21-.13-.41-.19-.62l.33-.91c.06.21.12.42.19.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.72,80.49c0,.18,0,.35,0,.53l-.63-.8c0-.17,0-.35,0-.52l.63.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.46,72.47c-.23.25-.47.49-.71.74l0-.48c.23-.25.47-.5.71-.74,0,.16,0,.32,0,.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.81,47.11l-.76.37a2,2,0,0,1,0-.26l.76-.37a2.38,2.38,0,0,0,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.63,52.44l-.81.49c0-.11,0-.21,0-.32l.81-.49,0,.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.47,86.29l-.58.84c0-.19,0-.37,0-.56l.58-.83c0,.19,0,.37,0,.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.68,63.69l.06.42-.79-.65a3,3,0,0,0,0-.42c.27.21.52.43.78.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.73,121.22c-.08.21-.17.42-.26.63-.07-.3-.14-.61-.22-.91.09-.21.18-.42.26-.63.08.3.15.61.22.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,138.68c-.13.21-.25.42-.39.63,0-.29,0-.59,0-.89l.39-.63,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.74,123.14c-.06.3-.13.61-.2.91-.09-.21-.19-.42-.27-.63s.12-.61.19-.92c.09.22.19.43.28.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.54,48.35c-.26.12-.52.26-.78.4a2.64,2.64,0,0,1,0-.28l.78-.4c0,.09,0,.18,0,.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.84,178.49l-.69.49c.13-.21.24-.44.37-.65l.69-.49-.37.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,201.85l.26.24-.53-.22-.26-.24.53.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.72,101.11c-.14.29-.28.59-.43.89,0-.2-.08-.4-.13-.6.15-.3.29-.6.43-.89,0,.2.09.4.13.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,76.51c0,.17,0,.34,0,.51l-.67-.77c0-.17,0-.34,0-.51l.67.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.09,72.68c0,.16,0,.32,0,.49-.23-.25-.47-.5-.71-.74,0-.17,0-.33,0-.49l.71.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.15,45.84l-.73.34a2.44,2.44,0,0,0-.1-.24l.73-.34a1.22,1.22,0,0,0,.1.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.89,92.8c0,.19,0,.38-.07.58l-.52-.87c0-.19,0-.38.08-.57.17.29.35.57.51.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.6,185.73l-.75.43.44-.56.74-.44-.43.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,86.52c0,.18,0,.37-.05.56l-.58-.84c0-.18,0-.37,0-.55l.58.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.58,140.79c-.13.21-.27.41-.41.62,0-.29,0-.58,0-.88l.41-.63c0,.3,0,.59,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.36,53.83l-.81.51c0-.11,0-.23,0-.34l.82-.51c0,.11,0,.22,0,.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3,176.89l-.68.5.35-.67.68-.5-.35.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89,43.54l-.57.27-.26-.22.57-.26.26.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,189.53c-.25.14-.51.27-.77.4l.46-.51.78-.4-.47.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.78,43.58l-.26.22-.57-.26.26-.22.57.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.51,61.91c0,.14,0,.27,0,.41-.26-.21-.53-.41-.79-.63,0-.13,0-.27,0-.4l.8.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.38,201.83l.24.24-.52-.23a2.61,2.61,0,0,1-.23-.24l.51.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.64,123.37l-.28.63c-.07-.3-.14-.61-.2-.91.09-.21.19-.42.28-.64.07.31.13.61.2.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,66.88l-.76.69c0-.15,0-.3,0-.45.25-.23.5-.46.76-.68,0,.15,0,.3,0,.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.54,112c-.11.3-.21.61-.31.91l-.21-.62c.11-.31.21-.61.32-.91.06.2.13.41.2.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,142.88c-.14.21-.28.42-.43.62,0-.29,0-.58,0-.88L199,142v.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.73,101.34c0,.2-.09.4-.14.6-.14-.29-.28-.59-.43-.89.05-.2.09-.4.14-.6.14.3.29.6.43.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.94,82.12l-.62.81c0-.18,0-.36,0-.53l.62-.81c0,.18,0,.35,0,.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.72,175.25l-.67.51c.11-.23.23-.46.33-.69s.45-.33.67-.51c-.1.23-.22.46-.33.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.24,191.82l-.79.37c.17-.16.32-.32.48-.48l.78-.37-.47.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.22,184.32l-.73.44c.14-.19.28-.38.41-.58l.74-.45-.42.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,94.57c-.16.29-.34.58-.5.87,0-.19-.07-.39-.1-.58l.5-.87c0,.2.07.39.1.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.05,43.49l-.55.26-.28-.22.55-.25.28.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3,60.2c0,.13,0,.26,0,.39l-.81-.6a2.71,2.71,0,0,0,0-.4l.81.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.62,43.52l-.28.22-.56-.26.29-.21.55.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.38,145l-.44.62c0-.29,0-.58,0-.87l.45-.62q0,.42,0,.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78,201.8l.22.24-.51-.22-.21-.25.5.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54,55.43c0,.12,0,.23,0,.35-.27-.18-.54-.36-.82-.53,0-.12,0-.24,0-.36l.82.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.1,173.57l-.66.52c.1-.23.22-.46.31-.7l.67-.52c-.11.23-.22.47-.32.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.75,88.23l-.56.84a5.32,5.32,0,0,1-.06-.56c.18-.28.37-.56.56-.84,0,.19,0,.37.06.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,47l-.75.37c0-.09-.06-.18-.08-.26l.75-.37A2.58,2.58,0,0,0,98,47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.34,103.19l-.41.89c-.06-.2-.1-.4-.15-.61l.41-.89c.05.2.09.4.15.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06,58.54c0,.13,0,.26,0,.39l-.81-.59c0-.12,0-.25,0-.38l.81.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8,57c0,.13,0,.25,0,.37l-.82-.56a2.19,2.19,0,0,0,0-.36l.81.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5,125.52c-.11.2-.2.42-.31.63-.05-.3-.12-.61-.18-.91.1-.22.21-.42.31-.64l.18.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.58,82.35l0,.53-.63-.81a4.71,4.71,0,0,0,0-.53l.63.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.48,70.45l-.74.72,0-.47L62.5,70c0,.16,0,.31,0,.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,147c-.15.21-.3.41-.46.61,0-.28,0-.57,0-.86.16-.2.31-.41.46-.61,0,.28,0,.57-.05.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.84,188.25l-.77.41c.16-.18.3-.36.45-.54l.76-.41-.44.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.62,78.08l-.67.78c0-.17,0-.34,0-.51l.67-.78c0,.17,0,.34,0,.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.44,171.86l-.65.53.3-.72.65-.53-.3.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.23,43.45l-.54.25-.31-.22.54-.25.31.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.42,114.16l-.3.92c-.08-.21-.15-.42-.22-.63.09-.31.2-.61.29-.91l.23.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.45,43.47l-.3.23-.54-.26.3-.22.54.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.48,94.81c0,.19-.07.39-.1.58l-.5-.87c0-.2.07-.39.1-.58l.5.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.46,74.19l-.69.75v-.5l.7-.75c0,.17,0,.33,0,.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,149.07c-.17.2-.32.41-.48.61,0-.29.05-.57.06-.86.17-.2.32-.41.48-.61,0,.29,0,.57-.06.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,182.87l-.73.45c.13-.19.26-.4.4-.6l.73-.46c-.13.2-.26.41-.4.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.73,170.11l-.63.54c.09-.24.19-.48.28-.73l.63-.54c-.09.25-.18.49-.28.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.69,48.18c-.26.12-.52.26-.78.4,0-.1,0-.19,0-.28l.78-.4c0,.09,0,.18,0,.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.75,88.46c0,.18,0,.37-.06.56-.19-.28-.37-.57-.57-.84,0-.19,0-.38.07-.56l.56.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.19,151.09c-.16.21-.32.41-.49.61l.09-.84c.16-.21.33-.41.49-.61l-.09.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.11,103.42,199,104l-.42-.9c.05-.2.11-.4.16-.6.14.29.28.59.41.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.4,43.41l-.52.25-.32-.23.52-.24.32.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,168.34l-.63.54.27-.74.62-.55c-.09.25-.18.5-.26.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.06,192.83l-.79.36.47-.46.79-.36-.47.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,43.43l-.33.23-.52-.26.33-.22.52.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3,127.66c-.11.21-.21.42-.32.64,0-.31-.1-.61-.16-.91l.32-.64c.05.3.11.61.16.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.93,78.3c0,.17,0,.34,0,.52l-.66-.79c0-.17,0-.34,0-.51l.67.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.63,201.29l.3.25-.59-.23-.3-.26.59.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,190.62l-.78.38c.16-.16.32-.33.46-.49l.78-.39-.46.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.37,153.1l-.51.61c0-.28.07-.56.1-.84l.51-.61c0,.29-.07.56-.1.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2,166.53l-.61.55.24-.75.61-.56-.24.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.09,74.39c0,.17,0,.34,0,.5l-.71-.75a4.17,4.17,0,0,0,0-.5l.7.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,65.2l0,.44-.78-.67a3.25,3.25,0,0,0,0-.44l.78.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.49,155.1c-.18.19-.35.39-.53.59,0-.27.08-.55.13-.82l.52-.6-.12.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,164.69l-.6.56c.08-.25.16-.51.23-.76s.39-.39.59-.57c-.07.25-.14.51-.22.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.59,43.38l-.51.25-.34-.23.5-.25.35.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.56,157.06l-.54.59c0-.27.09-.54.14-.81l.54-.6c0,.28-.1.55-.14.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1,43.39l-.35.23-.5-.25.35-.22.5.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.48,162.82l-.58.57c.07-.26.13-.52.2-.78l.58-.57c-.06.26-.13.52-.2.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.47,96.6c-.16.29-.33.58-.48.88-.05-.2-.08-.4-.12-.59l.48-.88.12.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.38,181.37c-.24.16-.48.32-.73.47l.39-.62.72-.47c-.12.21-.25.42-.38.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.55,160.93l-.57.58c.06-.27.13-.53.19-.8l.57-.58c-.06.27-.12.53-.19.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.51,186.92l-.76.42.44-.55.76-.43-.44.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,105.28q-.21.45-.39.9l-.18-.61c.13-.3.26-.6.4-.9,0,.2.11.41.17.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.35,116.3c-.09.31-.19.61-.28.92l-.24-.63c.09-.31.17-.61.27-.92.08.22.16.42.25.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,84l-.61.82c0-.18,0-.36,0-.54.2-.28.4-.55.61-.82,0,.18,0,.36,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,43.35l-.48.25-.37-.23.49-.24.36.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,43.37l-.38.23-.48-.25.37-.22.49.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.05,129.8l-.34.64c0-.3-.1-.61-.14-.91l.34-.63c.05.3.09.6.14.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.05,201.25l.28.26-.58-.23-.28-.27.58.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,43.34l-.46.24-.39-.23.47-.24.38.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.08,90.19l-.55.85c0-.19-.06-.38-.08-.57.18-.29.36-.57.55-.85,0,.19,0,.38.08.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73,43.35l-.39.23-.47-.24.39-.23c.16.07.31.16.47.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.12,46.81l-.74.37c0-.09-.07-.18-.1-.26l.74-.37c0,.09.07.18.1.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.48,53.59l-.82.51c0-.11,0-.23,0-.34l.82-.5c0,.11,0,.22,0,.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15,43.33l-.45.24-.4-.24.45-.23.4.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.55,68.48l-.75.7c0-.15,0-.31,0-.46.24-.24.49-.47.75-.7,0,.15,0,.3,0,.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54,43.33l-.41.24-.45-.24.41-.23c.15.08.29.16.45.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35,43.33l-.44.24-.42-.24c.14-.08.29-.15.43-.24.14.09.28.16.43.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,96.83c0,.2-.07.4-.12.59l-.48-.87.12-.59.48.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,179.84l-.71.48c.12-.21.25-.42.36-.64l.72-.48c-.12.21-.25.42-.37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.45,105.51l-.18.62c-.13-.3-.26-.61-.4-.9.07-.21.13-.41.18-.61.14.29.27.59.4.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.39,84.22c0,.19,0,.37,0,.55l-.61-.82c0-.18,0-.36.05-.54l.61.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.66,63.38c0,.14,0,.28,0,.42l-.79-.65c0-.14,0-.28,0-.42.26.21.53.43.78.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.07,116.53c-.08.21-.16.42-.25.64-.09-.31-.18-.61-.28-.92.09-.21.17-.42.25-.63.1.3.19.61.28.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.14,50.72l-.8.45a1.62,1.62,0,0,1,0-.31l.8-.45c0,.1,0,.2,0,.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,189.37l-.78.4.45-.52.78-.4-.45.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74,131.94c-.11.22-.24.43-.36.64,0-.3-.08-.6-.12-.91l.36-.63c0,.3.08.6.12.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16,185.54c-.25.15-.5.3-.76.44.15-.19.28-.38.42-.57l.75-.44-.41.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.81,191.67,160,192l.46-.48.79-.37-.46.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.73,79.9l-.65.79,0-.52.65-.79,0,.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.33,118.45c-.09.3-.17.61-.26.91-.08-.21-.18-.42-.26-.63.08-.3.17-.61.26-.91.08.21.17.42.26.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.48,201.21l.26.26-.57-.23-.26-.27.57.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.43,90.42a5.62,5.62,0,0,1-.09.57c-.18-.29-.36-.57-.55-.85l.09-.57c.18.28.37.56.55.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.85,48l-.77.4a2.86,2.86,0,0,1-.07-.28c.26-.13.51-.27.77-.39a2.68,2.68,0,0,0,.07.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.73,107.39l-.38.9c-.06-.21-.12-.41-.19-.62l.38-.9c.06.21.12.41.19.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.46,72.12l-.73.74c0-.16,0-.33,0-.49.24-.24.47-.49.72-.73,0,.16,0,.32,0,.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.39,178.27l-.71.49.35-.66.71-.49c-.12.22-.24.44-.35.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.52,49.31l-.79.43c0-.1,0-.2,0-.3l.79-.42a2.93,2.93,0,0,0,0,.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,98.64c-.16.3-.32.59-.47.89-.05-.2-.09-.4-.13-.6.15-.29.3-.59.46-.88,0,.2.1.39.14.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.46,61.61l0,.41-.8-.62c0-.14,0-.27,0-.41l.8.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.38,134.08l-.37.63c0-.3-.07-.6-.1-.9l.37-.63c0,.3.07.6.1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.82,80.12c0,.17,0,.35,0,.52l-.65-.79c0-.18,0-.35,0-.53l.66.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.91,201.18l.24.26-.55-.23-.24-.27c.19.08.37.15.55.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.09,118.68l-.27.63c-.09-.3-.17-.61-.26-.91l.27-.63c.09.3.17.61.26.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.24,59.91c0,.13,0,.26,0,.4l-.81-.61c0-.13,0-.26,0-.39l.81.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.84,176.65l-.7.51.33-.67.69-.51c-.1.23-.21.45-.32.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.72,56.69c0,.12,0,.24,0,.37l-.82-.56c0-.12,0-.24,0-.36.27.17.55.36.82.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.38,85.91c-.2.27-.4.55-.59.83,0-.18,0-.37-.07-.55l.6-.83c0,.18,0,.36.06.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.67,66.56l-.77.68a3.39,3.39,0,0,1,0-.45l.76-.68c0,.15,0,.3,0,.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.77,184.12c-.25.15-.49.31-.74.45l.39-.58.75-.46c-.13.2-.26.4-.4.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.37,120.6l-.24.91c-.1-.2-.19-.42-.28-.63.07-.31.15-.61.24-.91.08.21.18.42.28.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,58.26c0,.13,0,.26,0,.39l-.82-.58c0-.13,0-.25,0-.38l.81.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.06,76.15c0,.16,0,.33,0,.51l-.69-.77c0-.17,0-.34,0-.51l.69.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.46,92.17c-.19.29-.37.57-.54.86,0-.19-.07-.38-.1-.57l.53-.86c0,.19.07.38.11.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.39,188.08l-.77.41.43-.54.77-.41-.43.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.31,46.68l-.74.36-.12-.26.73-.36.13.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,44.3l-.61.29-.26-.24.61-.28.26.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.61,192.69l-.79.36.46-.46.79-.36-.46.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,98.88c0,.2-.09.4-.14.6l-.47-.89c.05-.2.09-.39.14-.59l.47.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,136.2c-.13.22-.26.43-.4.64,0-.3,0-.6-.07-.9l.39-.63c0,.3.06.6.08.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,109.5l-.36.91-.21-.62.36-.91c.07.21.13.42.21.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.24,175l-.68.51c.11-.23.22-.45.31-.69l.69-.51c-.1.23-.21.46-.32.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.36,201.15l.21.26c-.17-.09-.35-.16-.53-.24l-.22-.27.54.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.53,190.46l-.78.39c.15-.17.3-.33.44-.5L163,190l-.45.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.94,66.75c0,.15,0,.3,0,.45l-.77-.68c0-.15,0-.3,0-.45l.77.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.15,86.13c0,.19,0,.37-.07.56l-.6-.83c0-.19.05-.37.07-.55.21.27.41.54.6.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,138.32c-.13.21-.27.42-.41.63l-.06-.89.42-.63c0,.3,0,.6.05.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.05,120.83l-.28.63c-.09-.3-.17-.61-.25-.91.1-.21.19-.43.29-.64l.24.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.06,92.4c0,.2-.07.39-.11.58-.17-.29-.35-.57-.54-.86,0-.19.08-.38.11-.57l.54.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,200.62l.3.27-.63-.24-.3-.29.63.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.56,100.71l-.45.89c-.06-.2-.11-.4-.16-.61l.45-.88c.05.2.11.4.16.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.46,122.75c-.08.31-.15.61-.22.91q-.16-.31-.3-.63l.21-.92c.1.22.21.43.31.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.48,44.24l-.59.28-.29-.24.6-.28.28.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.35,182.67l-.74.45c.13-.19.26-.4.38-.6l.74-.46-.38.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,173.32l-.67.52c.1-.23.2-.46.29-.7l.68-.52-.3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9,81.75c-.22.26-.43.53-.65.8,0-.18,0-.36,0-.53l.65-.81a4.93,4.93,0,0,0,0,.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.51,70.11l-.75.72v-.48l.74-.71c0,.15,0,.31,0,.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,47.86c-.26.12-.51.25-.76.39,0-.1-.07-.19-.1-.28l.76-.39c0,.09.06.18.1.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,140.43l-.43.63c0-.29,0-.59,0-.88s.29-.43.43-.64c0,.3,0,.6,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.31,50.52l-.8.45c0-.1,0-.21,0-.31l.79-.45,0,.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.05,186.74l-.77.42c.14-.18.28-.36.41-.55s.52-.28.77-.43c-.13.19-.27.38-.41.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.94,171.6l-.66.54c.09-.24.18-.48.28-.72l.66-.54c-.09.24-.18.48-.28.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7,49.14l-.79.42c0-.1,0-.2-.07-.3l.79-.41c0,.09,0,.19.07.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.93,100.94c-.05.2-.11.4-.16.6l-.45-.89c.05-.2.11-.4.16-.6l.45.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,44.18l-.58.28-.3-.24.57-.27.31.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42,142.53l-.45.62c0-.29,0-.58,0-.88l.45-.62c0,.29,0,.58,0,.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.33,111.63c-.12.3-.23.61-.34.91-.08-.21-.16-.42-.23-.62l.33-.91c.09.2.16.41.24.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,123l-.3.63c-.08-.3-.16-.6-.23-.91l.31-.64c.07.31.15.62.22.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.48,73.83c-.25.25-.48.5-.72.75,0-.16,0-.33,0-.49l.71-.75,0,.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.79,64.88c0,.15,0,.29,0,.44-.26-.22-.51-.45-.78-.66,0-.15,0-.29,0-.44l.79.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6,124.91c-.06.3-.14.6-.2.91l-.32-.64c.06-.3.13-.61.2-.91l.32.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.51,46.55l-.73.36c0-.1-.1-.18-.14-.27l.72-.35c0,.08.09.17.15.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.66,82c0,.18,0,.35,0,.53-.22-.26-.43-.54-.64-.8,0-.18,0-.36.05-.54l.64.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.88,94.18c-.18.28-.35.57-.52.87,0-.2-.09-.39-.12-.59.17-.29.34-.58.52-.86,0,.19.08.38.12.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41,200.57l.28.28-.61-.25-.29-.28.62.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9,181.16l-.73.47.36-.62.73-.47-.36.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.35,191.52l-.8.38.44-.48.8-.38-.44.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.23,169.85l-.65.54c.08-.24.17-.48.26-.73l.65-.54c-.09.24-.17.48-.26.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.67,87.84l-.58.84L51,88.12l.59-.84c0,.19,0,.38.08.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23,189.21l-.78.4c.15-.17.29-.34.43-.52l.78-.41-.43.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,144.61l-.46.62q0-.43,0-.87c.16-.21.31-.42.47-.62,0,.29,0,.58,0,.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.47,168.07l-.63.55c.08-.25.16-.5.23-.75l.64-.55q-.11.38-.24.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.92,44.13l-.56.28-.32-.24.56-.27.32.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.18,102.79c-.15.29-.3.59-.44.89-.06-.2-.11-.4-.17-.61.14-.29.28-.59.43-.89,0,.2.12.41.18.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.12,74c0,.16,0,.33,0,.5q-.36-.39-.72-.75c0-.17,0-.33,0-.5l.72.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,77.93c0,.17,0,.34,0,.52l-.68-.78c0-.18,0-.35,0-.52l.68.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.79,44.16c-.1.09-.21.16-.33.25l-.55-.28.33-.24.55.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,146.68l-.48.62c0-.29,0-.58,0-.86l.48-.63c0,.29,0,.58,0,.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.64,94.41c0,.19-.09.39-.13.58l-.52-.87.12-.58c.17.29.35.58.53.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.68,166.25l-.63.56c.07-.25.15-.5.22-.76l.63-.56c-.08.25-.15.51-.22.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.68,185.36l-.76.43.39-.57.77-.44c-.13.19-.27.38-.4.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.82,125.13c-.11.21-.21.43-.33.64-.06-.31-.13-.61-.2-.92.11-.21.22-.42.32-.63l.21.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.87,88.07l-.09.56-.59-.84c0-.19.07-.37.09-.56l.59.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.6,63.07v.42l-.79-.64c0-.14,0-.28,0-.42.27.21.54.42.8.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,148.73c-.17.2-.33.41-.5.62,0-.29,0-.58,0-.86l.5-.62c0,.29,0,.57,0,.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.41,179.62l-.73.48c.13-.21.24-.42.35-.63l.73-.49-.35.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.87,200.53l.27.28-.6-.25a3.58,3.58,0,0,1-.26-.29l.59.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.83,164.4l-.61.57c.07-.25.13-.51.2-.77l.61-.57c-.06.26-.13.52-.2.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61,68.15l-.76.7c0-.16,0-.31,0-.46l.76-.7c0,.15,0,.3,0,.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.15,44.09l-.54.28-.35-.25.54-.26.35.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.21,113.77c-.12.3-.22.6-.33.91l-.25-.63c.11-.3.22-.6.32-.91.09.21.16.42.26.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.14,192.55l-.8.37.44-.46.8-.38c-.14.16-.29.32-.44.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.62,150.76l-.51.62c0-.29,0-.57.06-.85l.51-.61c0,.28,0,.56-.06.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.56,44.12l-.35.24-.53-.27.34-.24.54.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.07,51.8l-.81.47c0-.11,0-.22,0-.33l.81-.47c0,.11,0,.22,0,.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.94,162.53c-.19.2-.39.38-.6.57.07-.26.13-.52.19-.78l.59-.58c-.06.27-.11.53-.18.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,152.78l-.53.61c0-.28.06-.56.08-.84.18-.2.36-.4.53-.61,0,.28-.06.56-.08.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.31,103l-.18.61c-.14-.3-.28-.6-.43-.89l.18-.61c.15.29.28.59.43.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25,47.71l-.76.38-.12-.28.76-.38.12.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.92,154.78l-.54.6c0-.28.07-.55.1-.83l.54-.6c0,.27-.06.55-.1.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,158.7l-.57.59c0-.27.09-.54.14-.81l.57-.59c0,.27-.09.54-.14.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,156.75l-.56.6.12-.82.56-.6c0,.28-.07.55-.12.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.38,61.32v.41l-.81-.62a2.81,2.81,0,0,0,0-.41l.81.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1,83.62l-.63.82c0-.18,0-.36-.07-.55l.63-.81c0,.18,0,.36.07.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59,56.43c0,.12,0,.25,0,.37l-.82-.55c0-.12,0-.25,0-.37l.82.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.39,44.06l-.53.27-.36-.24.52-.27.37.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.33,44.08l-.37.25-.52-.27.37-.24.52.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,68.34c0,.16,0,.31,0,.46l-.76-.69c0-.16,0-.31,0-.46l.76.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.62,127.28c-.11.21-.23.42-.34.64-.06-.31-.12-.61-.19-.91l.35-.64.18.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,187.91l-.78.41.41-.54.78-.41-.41.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.36,96.21c-.17.28-.34.58-.51.87-.05-.2-.1-.4-.14-.59l.5-.88c0,.2.1.4.15.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,59.63c0,.13,0,.26,0,.39-.27-.2-.54-.4-.82-.59,0-.14,0-.27,0-.4l.81.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.87,58c0,.12,0,.25,0,.38L166,57.8c0-.12,0-.25,0-.38l.82.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.88,178c-.23.17-.47.33-.71.49.11-.21.22-.43.32-.65s.48-.33.72-.5q-.15.33-.33.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.05,190.31l-.79.39.43-.5.79-.4-.43.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.35,200.49l.24.28-.58-.25c-.08-.1-.17-.19-.24-.29l.58.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.63,44l-.51.26-.39-.24.51-.27.39.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,44.05l-.39.25-.5-.26.39-.25.5.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.28,183.93l-.76.45c.13-.19.26-.39.38-.59l.76-.45c-.12.2-.25.4-.38.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.51,50.33l-.8.45c0-.1,0-.21-.07-.31l.8-.44c0,.1,0,.2.07.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.85,104.88l-.42.9-.19-.61c.13-.3.27-.6.41-.9.06.21.14.41.2.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,89.8l-.57.85c0-.19-.07-.38-.11-.57l.57-.85c0,.19.07.38.11.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,49c-.26.13-.51.28-.77.42a1.71,1.71,0,0,1-.09-.3l.77-.41.09.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,71.78c-.25.24-.49.49-.73.73l0-.48.74-.73c0,.16,0,.32,0,.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.87,44l-.49.27L119,44c.17-.08.33-.17.49-.26l.41.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.85,44c-.13.09-.27.17-.41.25L124,44l.41-.25.49.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,83.84c0,.18-.05.37-.07.55l-.63-.82c0-.18.05-.36.07-.54l.63.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.13,115.91l-.3.91-.27-.63.3-.91.27.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.73,79.53c-.23.26-.44.53-.67.79,0-.17,0-.35-.05-.53l.66-.79.06.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.12,44l-.47.26-.43-.25.47-.26.43.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.61,44l-.43.25-.47-.26.43-.25.47.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.36,44l-.45.26-.45-.26.45-.25.45.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.37,129.43l-.36.63c0-.3-.11-.6-.16-.9l.36-.64c0,.3.11.6.16.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.53,75.58c-.23.25-.47.5-.7.76,0-.17,0-.34,0-.51l.71-.76c0,.17,0,.34,0,.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.16,96.44c0,.19-.09.39-.14.59l-.51-.88.15-.59c.17.29.34.58.5.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.32,176.42l-.71.51c.11-.23.21-.45.31-.68l.71-.5c-.1.22-.2.45-.31.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,200.45c.07.09.14.19.22.28l-.57-.25-.22-.29.57.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.53,90a5.67,5.67,0,0,1-.1.57c-.19-.29-.38-.57-.58-.85,0-.19.08-.38.11-.57.2.28.39.56.57.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.64,105.11c-.06.21-.13.41-.19.62l-.42-.9c.07-.2.13-.41.19-.61.14.3.29.59.42.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.85,79.74c0,.18,0,.36,0,.53l-.68-.79a4.6,4.6,0,0,0,.06-.52l.67.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.88,66.43c0,.15,0,.3,0,.45-.27-.23-.52-.46-.79-.68,0-.15,0-.3,0-.45l.78.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.33,116.14c-.1.21-.18.42-.28.63-.09-.3-.2-.61-.3-.91l.27-.63c.11.3.21.61.31.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,191.38l-.79.37.42-.48.79-.38c-.14.16-.27.33-.42.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.06,75.79c0,.16,0,.33,0,.5l-.7-.76c0-.17,0-.34,0-.5.24.25.47.5.7.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.85,182.46l-.75.47.36-.61.75-.47-.36.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.55,186.56c-.25.15-.51.29-.78.43l.4-.56c.26-.14.52-.28.77-.43l-.39.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.07,131.57c-.12.22-.25.43-.38.64,0-.31-.09-.61-.15-.91.13-.21.26-.42.38-.64l.15.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.47,47.56l-.74.39-.14-.28.74-.38c0,.09.1.18.14.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.72,174.77l-.7.51c.1-.23.2-.46.29-.69l.7-.52c-.09.24-.19.47-.29.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.12,118.06c-.1.3-.19.61-.29.91l-.28-.63c.09-.31.18-.61.28-.91.09.21.19.42.29.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.88,98.25l-.49.88c0-.2-.11-.4-.16-.6l.49-.88c.05.2.11.4.16.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.57,107l-.4.9-.21-.62c.12-.3.26-.6.4-.9.06.21.13.41.21.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.73,189l-.78.41c.13-.17.27-.34.4-.52l.79-.41c-.13.18-.27.35-.41.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.33,200.41l.2.29-.56-.26-.19-.29.55.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.36,85.53c-.21.27-.42.55-.62.83,0-.19-.06-.38-.09-.56l.61-.83c0,.19.06.37.1.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,45.05l-.62.31-.29-.26.63-.3.28.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.71,133.71c-.13.21-.26.42-.4.63,0-.3-.08-.59-.12-.9.14-.21.26-.42.4-.63l.12.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.28,51.6l-.81.47-.06-.33.81-.47.06.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.58,69.78l-.75.71,0-.47.76-.72c0,.16,0,.32,0,.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.64,192.42l-.8.36.42-.46.8-.37-.42.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.08,173.08l-.69.52c.09-.23.19-.47.27-.7l.69-.53c-.08.23-.18.47-.27.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.39,91.78l-.55.86c-.05-.19-.09-.38-.13-.58l.56-.85.12.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.7,64.57c0,.15,0,.29,0,.44-.27-.22-.53-.45-.8-.66,0-.15,0-.29,0-.44l.79.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.34,118.29c-.09.21-.19.42-.29.63-.09-.3-.18-.61-.29-.91.11-.21.21-.42.3-.64.1.31.19.61.28.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.64,98.48c0,.2-.1.4-.16.6-.16-.3-.33-.59-.49-.88.06-.2.11-.4.16-.6l.49.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.38,181l-.74.48.34-.62.74-.48-.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.13,48.81l-.77.41-.11-.3.77-.41c0,.1.07.2.11.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.21,85.75c0,.19-.06.37-.09.55l-.62-.82c0-.19.07-.37.1-.56l.61.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.15,120.21c-.09.3-.18.61-.26.92-.11-.21-.21-.43-.31-.64.09-.3.17-.61.26-.91.11.21.21.42.31.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,135.84c-.13.21-.27.42-.41.63,0-.29-.07-.59-.11-.89.14-.21.29-.42.42-.64,0,.3.07.6.1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.73,50.15l-.79.44c0-.1-.06-.21-.09-.31l.79-.44.09.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,171.35l-.68.53c.09-.23.17-.47.26-.71l.67-.54-.25.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.18,199.8l.27.3-.63-.26-.26-.31c.21.09.41.19.62.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.17,185.17l-.77.44c.13-.19.25-.38.37-.57l.77-.45c-.12.2-.25.39-.37.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9,81.37l-.65.81c0-.18-.06-.36-.08-.54l.66-.8c0,.18.05.36.07.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16,92c0,.19-.09.39-.13.58-.18-.29-.37-.58-.56-.86.05-.19.09-.38.13-.58.18.29.37.57.56.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.07,45l-.61.31-.3-.26.61-.3a3.61,3.61,0,0,0,.3.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.35,109.11c-.13.3-.27.6-.38.91q-.13-.31-.24-.63c.12-.3.25-.6.38-.9.07.2.16.41.24.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.54,73.48l-.73.75c0-.16,0-.33,0-.5l.72-.74c0,.17,0,.33,0,.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.49,62.77c0,.14,0,.28,0,.42l-.8-.63c0-.14,0-.28,0-.42l.8.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.54,190.16l-.79.39.4-.5.79-.4-.4.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.64,77.35c-.23.27-.47.52-.7.78l-.06-.51.7-.78c0,.17,0,.34.06.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.84,138l-.43.64-.09-.9.44-.63c0,.3.06.6.08.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.46,100.31c-.17.3-.33.59-.48.89l-.18-.6c.16-.3.32-.59.47-.89.06.2.12.4.19.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68,169.59l-.67.54c.08-.24.16-.48.23-.73l.67-.55c-.07.25-.16.49-.23.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.72,47.43l-.73.38-.17-.28.74-.38c0,.09.1.19.16.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,120.44l-.3.64-.27-.92c.1-.21.21-.42.31-.64.1.31.18.61.26.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.39,187.74l-.79.41c.14-.17.26-.35.39-.53l.79-.43-.39.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.88,179.41l-.74.48c.11-.21.22-.42.32-.64l.74-.49c-.11.21-.21.43-.32.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.72,57.73c0,.13,0,.26,0,.39l-.82-.57c0-.13,0-.26,0-.39l.83.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.25,61c0,.14,0,.27,0,.41l-.81-.61c0-.14,0-.28,0-.41l.81.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.69,81.59c0,.18-.05.36-.08.54l-.66-.8c0-.18.05-.36.08-.54l.66.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.24,122.37l-.24.91-.33-.64.24-.91.33.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,59.35a2.8,2.8,0,0,1,0,.4l-.81-.6c0-.13,0-.26,0-.39.28.19.55.39.82.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,73.69a4.21,4.21,0,0,1,0,.5c-.24-.26-.49-.5-.73-.75,0-.17,0-.33.05-.49l.72.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33,140.08c-.16.2-.3.42-.45.63,0-.3,0-.59-.07-.89l.45-.63c0,.29.05.59.07.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.72,67.83l-.78.69,0-.46c.26-.24.52-.46.78-.69a3.67,3.67,0,0,0,0,.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,44.93l-.59.3-.33-.26.59-.3.33.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.91,167.8c-.22.18-.44.36-.65.55l.21-.75.66-.55c-.07.25-.14.5-.22.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7,199.76l.24.29-.61-.26-.24-.31.61.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,77.56l-.06.52c-.23-.26-.46-.52-.7-.77a4.6,4.6,0,0,0,.06-.52l.7.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.65,87.46l-.6.84c0-.19-.08-.38-.11-.57l.6-.83c0,.18.07.37.11.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.82,93.79c-.18.28-.35.58-.54.86-.05-.19-.09-.39-.14-.58.18-.29.35-.58.54-.87,0,.2.1.39.14.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.75,183.74l-.77.45.36-.59.76-.46c-.11.2-.23.4-.35.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.76,142.18c-.15.21-.31.42-.47.62,0-.29,0-.58,0-.88.16-.2.31-.41.47-.63,0,.3,0,.59,0,.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.1,166l-.64.57c.07-.26.14-.51.2-.76l.64-.57c-.07.26-.14.51-.2.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.17,111.24l-.36.91c-.09-.21-.17-.42-.25-.63.11-.3.24-.61.36-.91l.25.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.33,191.23l-.8.39.4-.49.8-.38-.4.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93,68c0,.15,0,.3,0,.46l-.78-.7c0-.15,0-.3,0-.46.26.23.52.46.77.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.22,122.59l-.33.64c-.08-.31-.17-.61-.25-.91l.33-.64c.09.3.17.61.25.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.38,124.52c-.07.31-.15.61-.22.92l-.35-.64c.08-.31.15-.61.23-.91l.34.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,44.88c-.19.1-.39.19-.58.3l-.34-.27.57-.29.35.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,177.82l-.73.49c.11-.21.2-.43.3-.65l.73-.5-.3.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.14,144.26l-.48.63c0-.29,0-.58,0-.87l.48-.63c0,.29,0,.58,0,.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25,164.12l-.63.57c.07-.25.12-.51.18-.77s.42-.38.63-.57l-.18.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.92,87.68c0,.19-.07.38-.11.57l-.61-.84.12-.56.6.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.52,51.4l-.81.47-.09-.33.81-.46a2.23,2.23,0,0,0,.09.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.47,146.34c-.16.21-.33.41-.5.62,0-.29,0-.58,0-.86l.5-.63c0,.29,0,.58,0,.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.73,94l-.15.59c-.18-.29-.36-.57-.54-.87,0-.19.1-.38.15-.58l.54.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.08,102.39l-.46.9c-.07-.21-.13-.41-.2-.61.15-.3.3-.6.46-.89.06.2.13.4.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,162.24c-.2.2-.41.39-.62.58.06-.26.11-.52.16-.78l.62-.59c0,.27-.1.53-.16.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23,199.71a3.3,3.3,0,0,0,.22.3c-.2-.08-.4-.18-.6-.27a3.46,3.46,0,0,1-.22-.31l.6.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.11,192.28l-.8.37c.13-.15.26-.31.4-.46l.8-.38-.4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,186.39l-.78.43c.13-.19.26-.37.37-.56l.79-.44c-.12.19-.25.38-.38.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.75,148.4l-.51.62c0-.29,0-.58,0-.86l.52-.62,0,.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.9,44.84l-.56.29c-.12-.09-.24-.18-.37-.26l.56-.29.37.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6,71.44l-.75.73c0-.16,0-.32-.05-.49l.75-.72c0,.16,0,.32.05.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,50l-.79.44c0-.1-.08-.21-.11-.31.25-.15.52-.29.78-.43L94,50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,47.3l-.73.38-.18-.29.72-.36.19.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,188.89l-.79.4c.12-.17.26-.34.38-.52l.8-.41-.39.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.41,160.33l-.6.59c0-.27.09-.53.13-.8.21-.19.41-.39.61-.59-.05.27-.09.54-.14.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.12,83.25l-.65.82-.09-.55L55,82.7c0,.18.07.37.1.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,150.44l-.52.61,0-.85.54-.61c0,.28,0,.57-.05.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.42,158.4l-.59.59.12-.81c.2-.19.4-.39.59-.59l-.12.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.08,124.75l-.35.64c-.07-.31-.15-.61-.23-.92.12-.21.24-.42.35-.64.08.31.15.61.23.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.58,126.68l-.21.91L44,127c.07-.3.13-.61.2-.91.12.21.24.43.37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.17,152.46c-.19.2-.36.41-.55.61l.06-.84.55-.61-.06.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.38,156.44l-.57.6c0-.27.06-.54.1-.82l.57-.6c0,.28-.06.55-.1.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.89,193.3l-.8.36.4-.45.8-.36-.4.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,154.46c-.18.21-.37.41-.56.61,0-.28,0-.56.08-.83.18-.2.38-.4.56-.61,0,.28,0,.56-.08.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,176.19l-.72.51c.1-.22.19-.45.29-.68l.72-.51c-.09.23-.19.45-.29.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,182.26l-.76.47c.12-.2.22-.41.34-.61l.76-.47c-.12.2-.23.41-.34.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.05,113.38c-.12.3-.23.6-.34.91-.1-.21-.19-.42-.28-.63.11-.31.23-.61.35-.91l.27.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.19,44.8l-.54.29-.39-.26.54-.29.39.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.77,66.11c0,.15,0,.3,0,.45l-.78-.67,0-.45.79.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.61,75.23l-.72.76-.06-.51.72-.76.06.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,79.16c-.23.27-.46.53-.68.8,0-.18-.06-.36-.08-.53.22-.27.45-.53.68-.79,0,.18,0,.35.08.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.48,83.47c0,.18-.07.36-.1.54l-.65-.81c0-.18.07-.36.1-.55l.65.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3,95.81c-.17.29-.35.58-.52.88-.06-.2-.11-.4-.16-.6.17-.29.34-.58.52-.87,0,.2.11.39.16.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.77,199.67c.06.1.12.2.19.3l-.58-.27-.2-.31.59.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.48,44.78l-.52.29-.41-.28.53-.28.4.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,44.79l-.41.27-.52-.28c.14-.09.27-.19.41-.27l.52.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,89.42c-.2.28-.4.56-.59.85,0-.2-.09-.39-.13-.58l.59-.84c0,.19.08.38.13.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,126.9c-.12.21-.24.43-.37.64-.06-.31-.13-.61-.2-.91l.36-.64c.08.3.14.61.21.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.78,44.76l-.51.28-.42-.27.5-.28.43.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.15,174.53c-.24.17-.48.34-.71.52l.27-.69.71-.53-.27.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,44.77l-.43.27-.5-.28.43-.27.5.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.75,104.49c-.14.3-.29.6-.44.9l-.21-.62c.14-.3.28-.6.43-.9.07.21.15.41.22.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.08,44.75l-.49.28-.45-.27.49-.28.45.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,190l-.8.39.39-.5.8-.4L161,190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,75.43c0,.17,0,.34-.07.51l-.72-.76c0-.17.05-.34.07-.51l.72.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.68,44.75l-.45.28-.49-.28.45-.27.49.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84,79.38l-.09.53-.68-.79c0-.18.06-.35.08-.53l.69.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.38,44.75c-.16.09-.32.18-.47.28l-.47-.28.47-.27.47.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.57,64.26c0,.15,0,.3,0,.44l-.8-.65c0-.15,0-.29,0-.44l.8.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.61,185l-.78.44.36-.57.77-.45-.35.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.66,48.5l-.76.41c-.06-.1-.11-.2-.16-.3l.76-.4a2.69,2.69,0,0,0,.16.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,96c-.05.2-.11.4-.17.6-.17-.3-.35-.59-.52-.88.06-.2.11-.39.16-.59.18.29.36.58.53.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,180.75l-.75.47c.11-.2.22-.41.32-.62l.76-.48c-.11.21-.21.42-.33.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,115.52c-.11.31-.22.61-.32.91-.11-.21-.2-.42-.3-.63.11-.3.21-.61.33-.91.09.21.19.42.29.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.58,89.64c0,.19-.08.38-.13.57l-.59-.85c0-.19.09-.37.13-.56l.59.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,69.45l-.76.71c0-.16,0-.32-.06-.48l.77-.7c0,.15,0,.31,0,.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.31,199.63c.06.1.11.2.18.3l-.57-.27-.18-.31.57.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.83,187.57,164,188l.37-.54.79-.42-.37.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.63,129.05l-.38.64c-.06-.3-.12-.6-.19-.91l.39-.64.18.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.49,172.83c-.22.18-.46.35-.7.53.09-.24.17-.47.25-.71l.71-.53c-.08.24-.17.47-.26.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.53,57.48l-.06.38-.82-.57c0-.12,0-.25,0-.38l.83.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.34,62.48c0,.14,0,.28,0,.42l-.81-.63c0-.14,0-.28,0-.42.27.2.54.42.81.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.77,191.09l-.8.39c.13-.16.26-.32.38-.49.27-.12.54-.25.8-.39-.12.17-.25.33-.38.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,59.08c0,.13,0,.27-.05.4l-.82-.59c0-.13,0-.26.05-.4l.82.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.08,60.75c0,.13,0,.27,0,.41l-.82-.61c0-.14,0-.27.05-.41l.81.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.38,85.15l-.63.83c0-.19-.08-.37-.11-.56.2-.27.41-.55.63-.82,0,.18.07.37.11.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25,49.81l-.78.43c0-.1-.1-.21-.14-.31l.78-.43c0,.1.09.2.14.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.78,51.21l-.8.47a2.13,2.13,0,0,1-.11-.33l.79-.46.12.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.51,115.75c-.09.21-.19.42-.29.63l-.33-.91.3-.63c.11.3.22.6.32.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.83,97.86c-.17.29-.34.58-.5.88-.07-.2-.13-.4-.19-.6l.51-.88.18.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.33,131.2c-.13.21-.26.43-.4.64-.05-.3-.11-.6-.17-.91.14-.21.27-.42.4-.64.06.31.12.61.17.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,45.85l-.64.33-.31-.27.64-.33.31.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.87,199.59c0,.1.09.2.15.31l-.55-.28c-.06-.1-.11-.21-.16-.31l.56.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.8,171.09l-.69.55c.08-.24.16-.49.23-.72.23-.19.47-.36.69-.55-.07.24-.15.49-.23.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.48,106.6l-.42.9-.24-.62.42-.9.24.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,117.67c-.11.31-.21.61-.31.92-.11-.21-.21-.43-.31-.64l.3-.91c.1.21.21.42.32.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,179.19l-.75.49.3-.64.75-.5-.3.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.55,192.15l-.8.37.38-.46.8-.38-.38.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.65,73.14l-.74.75c0-.17,0-.33-.07-.5l.74-.74c0,.16.05.33.07.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.39,91.4c-.19.28-.39.57-.57.86-.06-.2-.11-.39-.15-.58.18-.29.38-.58.57-.86l.15.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.18,183.55l-.78.45c.12-.19.23-.39.34-.59l.77-.46-.33.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,85.37l-.12.56-.63-.83.12-.55.63.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,81c-.23.27-.46.53-.68.8,0-.18-.07-.36-.09-.54l.67-.8A5.12,5.12,0,0,0,57,81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.87,67.51l-.78.69c0-.15,0-.31,0-.46.26-.24.51-.46.78-.69,0,.15,0,.3.05.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,133.34l-.42.64-.15-.9.42-.64c.06.3.1.6.15.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.73,77l-.71.78c0-.18-.06-.35-.08-.52l.7-.78.09.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,169.33c-.23.18-.46.36-.68.55l.21-.74c.23-.18.46-.36.68-.55-.06.25-.14.5-.21.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.63,188.73l-.8.41.37-.52.8-.42c-.12.18-.24.36-.37.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.72,98.09l-.18.6-.51-.88.18-.6c.18.29.35.58.51.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,48.37l-.74.4-.19-.3.75-.4.18.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,73.34c0,.17,0,.33-.07.5l-.74-.74c0-.17.05-.33.07-.5l.74.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54,198.93l.22.32-.63-.29c-.08-.1-.15-.22-.23-.32l.64.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.44,186.21l-.79.44.35-.56.79-.44c-.11.19-.23.37-.35.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.67,45.79l-.63.32-.32-.28.62-.32.33.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.53,117.9c-.1.21-.21.42-.31.64-.1-.31-.2-.62-.31-.92.1-.21.21-.42.31-.64.11.31.21.61.31.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2,91.62c0,.2-.1.39-.16.58l-.57-.85.15-.58.58.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8,67.69c0,.16,0,.31-.05.47-.26-.23-.52-.47-.79-.69,0-.16,0-.31.06-.46l.78.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.66,81.22c0,.18-.07.36-.11.54l-.67-.8c0-.18.07-.36.1-.54.23.27.45.54.68.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,119.83c-.1.3-.19.61-.29.91l-.33-.64c.1-.3.19-.61.29-.91.1.21.22.43.33.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.57,135.48c-.14.21-.29.42-.43.64,0-.3-.09-.6-.13-.9l.44-.64.12.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.74,177.6l-.73.5c.1-.22.18-.44.28-.66l.74-.51c-.09.23-.18.45-.29.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.29,167.53l-.67.56c.07-.25.14-.5.2-.75l.67-.56c-.07.25-.13.5-.2.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.91,77.21c0,.17,0,.34-.08.52l-.72-.77c0-.18.06-.35.09-.52.24.26.48.51.71.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.26,108.72c-.14.3-.28.6-.41.9l-.26-.62c.13-.31.27-.61.41-.91.07.21.17.42.26.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.41,99.92l-.49.89c-.07-.2-.14-.41-.2-.61.16-.29.32-.59.49-.88.06.2.13.4.2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.11,137.61c-.15.2-.3.42-.45.63,0-.3-.07-.59-.11-.89l.46-.64c0,.3.06.6.1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.47,165.7l-.65.57c.06-.26.12-.51.17-.76l.66-.57c-.05.25-.12.51-.18.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.71,182.06l-.77.47.32-.6.77-.48-.32.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,45.73l-.61.32-.34-.28.6-.32.35.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.41,189.86l-.8.4.37-.51.8-.4-.37.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.69,87.08l-.62.84c0-.19-.09-.38-.13-.57.2-.28.41-.55.62-.83,0,.18.08.37.13.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54,49.65l-.77.43c-.06-.11-.11-.21-.16-.32l.77-.42.16.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,198.88a3.45,3.45,0,0,0,.2.32l-.61-.29a1.81,1.81,0,0,1-.2-.33l.61.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,120.05c-.11.22-.22.43-.34.64-.09-.3-.18-.61-.29-.91l.34-.64c.1.3.19.61.29.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.74,71.11l-.76.73c0-.17,0-.33-.07-.49.25-.25.51-.49.76-.72,0,.16,0,.32.07.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.09,122c-.09.3-.19.6-.27.91l-.35-.64c.09-.3.17-.61.27-.91l.35.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.07,51c-.27.14-.54.3-.8.45a2.26,2.26,0,0,1-.13-.33l.79-.45a2.33,2.33,0,0,0,.14.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,139.72l-.47.64c0-.3,0-.59-.09-.89l.48-.63c0,.29.06.59.08.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.83,93.4l-.56.87c-.06-.2-.12-.39-.17-.59.18-.29.37-.58.56-.86.05.19.11.39.17.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,163.84l-.64.57.15-.77.65-.58c-.05.27-.11.52-.16.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16,176l-.74.51c.1-.22.18-.45.27-.67l.73-.52c-.08.23-.18.45-.26.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,109c-.08.21-.17.42-.27.62-.13-.3-.26-.61-.4-.91.09-.2.18-.41.26-.62.14.3.28.6.41.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.32,45.68l-.59.31-.37-.28.59-.31.37.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.19,191l-.81.38.37-.48.8-.4-.36.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,141.83l-.49.63c0-.29,0-.58-.06-.88L197,141l.06.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,87.3c0,.19-.09.38-.14.57l-.62-.84c.05-.19.09-.37.14-.56.2.28.41.55.62.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.71,162c-.22.2-.42.4-.64.59.05-.26.09-.53.14-.79l.63-.58c0,.26-.08.52-.13.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,184.81l-.79.44c.11-.19.23-.38.33-.57l.79-.46-.33.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,48.24l-.74.39c-.08-.1-.14-.2-.21-.3l.74-.39c.07.1.13.2.21.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.24,187.41l-.79.42.35-.54.79-.43-.35.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.09,110.85c-.14.3-.27.6-.39.91-.1-.21-.19-.42-.28-.63.13-.31.26-.61.38-.91.09.21.19.42.29.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,82.88l-.67.81c0-.18-.07-.36-.11-.55.21-.27.43-.54.66-.8,0,.18.08.36.12.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.43,143.92l-.5.63c0-.29,0-.58-.05-.87l.5-.63c0,.29,0,.58.05.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,192l-.8.38.36-.47.8-.38L156,192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.75,160l-.62.59.12-.8.62-.59-.12.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.76,93.63c0,.19-.11.39-.17.59-.19-.29-.37-.58-.57-.87.07-.2.12-.39.18-.59l.56.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.74,74.88c-.24.25-.49.5-.73.76l-.09-.51.73-.76.09.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.41,122.21l-.35.64c-.09-.31-.18-.61-.28-.91l.36-.64.27.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.7,198.83c0,.11.12.22.18.33l-.6-.29a2.68,2.68,0,0,1-.18-.33l.6.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.23,124.15c-.08.3-.17.6-.25.91l-.37-.64c.08-.31.16-.61.25-.91.12.21.25.42.37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.77,146l-.52.63,0-.87c.18-.2.35-.41.52-.62l0,.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.21,180.54l-.76.48c.09-.21.2-.41.3-.62l.76-.49-.3.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.65,45.63l-.57.32-.39-.29.58-.3.38.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,158.1c-.2.2-.4.4-.61.59l.09-.8.61-.6-.09.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,174.29l-.72.52.24-.69.73-.52c-.09.23-.16.46-.25.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,102l-.47.9-.23-.62.48-.89c.07.21.15.41.22.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.88,78.81l-.69.79c0-.18-.08-.36-.11-.54l.7-.78c0,.18.07.35.1.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.59,58.82c0,.13-.05.26-.07.4l-.83-.59c0-.13.06-.26.08-.39l.82.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.29,148.07l-.54.62v-.86l.53-.62c0,.28,0,.57,0,.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.15,62.19c0,.14-.05.28-.07.43-.27-.22-.55-.42-.82-.63,0-.14.05-.29.07-.43l.82.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.71,156.14l-.59.6c0-.27,0-.55.07-.82l.6-.61c0,.28,0,.55-.08.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,60.47c0,.14,0,.28-.08.41l-.82-.6c0-.14.05-.28.07-.41l.83.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,150.11c-.18.21-.36.42-.55.62,0-.28,0-.56,0-.85.19-.2.37-.41.56-.62,0,.29,0,.57,0,.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.62,154.15l-.58.61c0-.28,0-.56.05-.83l.59-.61-.06.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.48,152.14l-.57.61c0-.27,0-.56,0-.84.19-.2.38-.4.56-.61q0,.42,0,.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.43,83.1c0,.18-.07.36-.12.55l-.66-.82.12-.54c.23.26.44.54.66.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.92,75.08l-.09.51-.73-.76.09-.5.73.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.89,69.13c-.26.23-.52.46-.78.71,0-.16,0-.32-.07-.48l.77-.71c0,.16,0,.32.08.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,45.6l-.55.31-.41-.29c.19-.1.37-.21.56-.3l.4.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,124.37c-.13.21-.25.43-.37.64-.09-.3-.17-.61-.25-.91l.36-.65.26.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.42,126.31c-.08.3-.15.6-.23.91-.13-.22-.26-.43-.38-.65.06-.3.14-.6.23-.91.12.22.25.43.38.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.76,79c0,.17-.07.35-.1.53l-.7-.79c0-.17.07-.35.1-.53.24.26.47.52.7.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,188.57l-.8.42.34-.53.8-.42c-.11.18-.22.36-.34.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,89l-.6.84c-.06-.19-.11-.38-.16-.57.2-.28.41-.56.61-.85L53,89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.52,102.23l-.22.61-.48-.89c.07-.2.15-.41.23-.61.16.3.31.6.47.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.34,45.57l-.54.31-.43-.29.54-.3.43.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.31,95.43l-.54.87c-.06-.2-.13-.4-.19-.6l.54-.87c.07.2.13.4.19.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3,198.79l.15.32-.58-.29c-.06-.11-.11-.22-.16-.33l.59.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,113c-.12.3-.25.6-.36.91q-.16-.32-.3-.63c.12-.31.25-.61.37-.91.09.21.19.42.29.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.86,172.59l-.71.53c.07-.24.15-.47.23-.71l.71-.53c-.07.23-.15.47-.23.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.76,198.1c.07.12.15.23.22.34l-.65-.3-.23-.34.66.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,183.36l-.78.46c.11-.2.21-.4.32-.59l.78-.47c-.1.2-.21.4-.32.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8,69.31c0,.16-.05.32-.08.48-.26-.24-.51-.47-.78-.7,0-.16.06-.32.08-.48l.78.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.84,52.33l-.8.48-.14-.35.81-.47c.05.11.09.23.13.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.69,45.55l-.52.31-.45-.29c.17-.11.35-.21.52-.3l.45.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,45.56c-.15.1-.3.2-.46.29l-.52-.3.45-.28.53.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.68,179l-.76.49.28-.64.76-.5c-.09.22-.19.43-.28.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,45.54l-.51.3-.46-.29.5-.3.47.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.83,186l-.8.44.34-.56.79-.45-.33.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.74,45.55l-.47.29-.5-.3.47-.29c.17.1.34.19.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.38,50.86l-.79.46c-.06-.11-.11-.23-.16-.34l.79-.44c0,.11.1.21.16.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.18,48.18l-.23.31-.73-.39.23-.3c.25.12.49.25.73.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,45.54l-.49.3-.48-.3.49-.29.48.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,55.33l-.82.54c0-.12-.07-.25-.1-.37.27-.18.54-.36.82-.53,0,.12.07.24.1.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.67,128.46c-.08.31-.15.61-.21.91-.14-.21-.28-.42-.41-.64l.21-.91c.13.22.27.43.41.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.57,89.26c0,.19-.1.38-.16.57L190.8,89c.06-.19.11-.38.16-.57l.61.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.07,126.52c-.13.22-.25.43-.39.65-.07-.31-.15-.61-.23-.91.14-.22.27-.43.39-.65.09.31.16.61.23.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.72,104.1l-.46.9-.24-.62c.15-.3.3-.6.46-.9l.24.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.28,95.65c-.06.2-.13.4-.2.6l-.54-.87c.06-.2.13-.4.19-.6.19.29.37.58.55.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.8,189.71l-.8.4.34-.5.81-.41-.35.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.57,113.22l-.3.63c-.12-.31-.24-.61-.37-.91.1-.21.21-.42.3-.63.12.3.25.6.37.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16,170.84l-.71.55.21-.72c.23-.19.47-.37.71-.55l-.21.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.81,72.81l-.75.74-.09-.5.75-.74.09.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.91,198.75c0,.11.08.21.13.32l-.57-.29c0-.11-.1-.22-.14-.33.2.09.39.2.58.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.47,84.78c-.22.28-.44.55-.65.83,0-.19-.09-.38-.14-.56l.65-.82c0,.18.09.37.14.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9,115.14c-.12.3-.24.6-.35.91-.11-.21-.21-.42-.32-.64.11-.3.23-.61.35-.91.1.22.21.42.32.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,130.62c-.06.3-.13.6-.19.9l-.42-.64c.06-.3.13-.6.19-.91l.42.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.57,190.82l-.8.39.34-.49c.27-.13.54-.26.8-.4l-.34.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.38,198.05a3,3,0,0,0,.2.34l-.65-.3-.2-.35.65.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.83,128.68l-.41.64-.21-.91.41-.64.21.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,46.71l-.65.35-.33-.29.66-.35.32.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.11,177.38l-.75.5.26-.66.75-.51c-.09.22-.17.45-.26.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87,73c0,.17-.06.34-.1.5l-.75-.74a4.21,4.21,0,0,0,.09-.49l.76.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.41,169.07l-.69.55c.06-.24.13-.49.18-.73.24-.18.47-.37.7-.56-.06.25-.12.5-.19.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.87,76.65l-.72.77c0-.17-.07-.34-.11-.52.24-.25.48-.51.73-.76,0,.17.07.34.1.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.09,80.65c-.24.26-.47.53-.69.8,0-.18-.09-.36-.13-.54l.69-.8c0,.18.08.36.13.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.08,181.87l-.78.47.3-.61.78-.48-.3.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.85,97.47l-.53.88-.21-.6c.18-.29.36-.58.53-.88l.21.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.17,85c0,.18-.09.37-.14.56l-.66-.83.15-.55.65.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.19,49.36l-.75.41-.21-.31L99,49l.2.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.44,91l-.59.85c-.06-.19-.12-.38-.17-.58.19-.29.39-.57.59-.85,0,.19.12.39.17.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.31,132.77c-.06.3-.12.6-.17.9L45.7,133c.06-.31.11-.61.17-.91l.44.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.62,187.24l-.8.43.33-.54.8-.43-.33.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.64,115.36c-.1.21-.21.42-.32.64-.11-.31-.23-.61-.35-.92.11-.21.22-.42.32-.63.12.3.24.61.35.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.84,48.07l-.25.3-.72-.39c.09-.1.17-.2.26-.29l.71.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.53,130.83l-.42.64c-.07-.3-.13-.6-.2-.9.15-.21.29-.43.43-.64.06.3.13.6.19.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.45,106.21l-.44.9-.26-.62c.14-.3.28-.61.44-.9l.26.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.38,184.63l-.79.45.32-.58.79-.46-.32.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,65.5c0,.15,0,.3-.09.45l-.8-.67.09-.45.8.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8,76.86c0,.17-.08.34-.11.52l-.73-.77.12-.52.72.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,167.27l-.68.56c.06-.25.11-.5.17-.75.23-.19.46-.37.68-.57,0,.25-.11.51-.17.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.88,117.29l-.33.92c-.11-.22-.23-.43-.33-.64.1-.31.21-.62.32-.92.11.22.22.43.34.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,80.86c0,.18-.08.36-.13.54-.22-.27-.46-.53-.69-.8.05-.18.09-.36.13-.54l.69.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,46.64c-.21.12-.42.24-.64.35l-.34-.3.64-.34.34.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.74,97.7c-.07.2-.13.4-.21.6l-.53-.88c.08-.2.15-.4.22-.6.17.29.35.58.52.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,198l.18.35-.63-.31a3.84,3.84,0,0,1-.18-.35l.63.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.94,70.79c-.26.23-.52.47-.77.72,0-.17-.06-.33-.1-.49l.77-.72c0,.16.06.32.1.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.17,91.24c0,.19-.11.39-.17.58l-.6-.85.18-.58.59.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,175.73c-.24.18-.49.35-.74.52l.24-.68.75-.52c-.08.23-.16.46-.25.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,50.7l-.78.45c-.07-.11-.12-.22-.18-.33l.78-.45.18.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.18,133l-.44.64c-.05-.3-.12-.6-.18-.9l.45-.64c.05.3.11.6.17.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.17,52.14l-.8.48c-.06-.11-.11-.23-.16-.34L92,51.8a3.49,3.49,0,0,0,.15.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,63.67l-.09.45-.81-.65c0-.15.06-.29.08-.44l.82.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.79,165.43c-.22.2-.45.38-.67.57l.15-.76.67-.58c0,.26-.09.52-.15.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.91,61.91l-.09.43-.82-.63.09-.42c.28.2.55.41.82.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,188.42l-.8.42.33-.53.8-.42-.33.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.66,117.51c-.11.22-.23.43-.34.64-.11-.3-.22-.61-.34-.91.12-.21.24-.42.34-.64.12.31.23.61.34.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.56,180.34l-.77.48.28-.63.77-.48c-.09.21-.18.42-.28.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.79,86.71l-.64.83c-.06-.19-.11-.37-.16-.56l.64-.84c0,.19.1.38.16.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.78,135.12l-.46.64-.15-.9c.15-.21.31-.42.46-.64l.15.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.92,119.45c-.12.3-.22.61-.31.91-.13-.21-.25-.42-.36-.64.1-.3.2-.61.31-.91.11.21.23.43.36.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.64,46.58l-.62.34c-.13-.09-.25-.2-.37-.3l.63-.33.36.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,163.56l-.66.58c0-.26.09-.52.13-.77l.66-.58c0,.26-.08.51-.13.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.44,99.54c-.18.29-.35.59-.52.88-.08-.2-.15-.4-.23-.61l.51-.88c.08.2.15.4.24.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.49,48c-.09.1-.18.21-.28.31l-.7-.38.28-.3.7.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.23,108.33c-.15.3-.29.6-.42.91-.1-.21-.2-.42-.29-.63.14-.3.28-.61.43-.9.09.2.18.41.28.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.86,174.06l-.73.52c.08-.22.15-.45.22-.69.25-.17.49-.35.73-.53-.07.24-.15.47-.22.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.92,74.54c-.25.25-.5.5-.74.76,0-.17-.08-.35-.11-.52l.74-.75c0,.17.07.34.11.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.64,197.94a3.73,3.73,0,0,0,.16.35l-.62-.31c-.06-.12-.11-.23-.16-.35l.62.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,137.25c-.15.22-.31.43-.47.64,0-.3-.08-.59-.13-.89l.47-.64c.05.3.09.59.13.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.16,189.57l-.8.4c.11-.17.21-.34.32-.5l.8-.42-.32.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.89,93c-.19.29-.38.58-.58.86-.06-.19-.13-.39-.19-.59l.58-.86c.06.2.13.39.19.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,161.67c-.21.2-.43.39-.65.58,0-.26.08-.52.11-.78l.65-.59c0,.26-.07.53-.11.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,185.87l-.8.44c.11-.18.21-.37.31-.56l.8-.45c-.1.19-.2.38-.31.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.24,49.3l-.24.32-.74-.42a3.55,3.55,0,0,0,.23-.31l.75.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.91,183.17l-.79.47q.16-.3.3-.6l.79-.47c-.1.2-.19.41-.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.11,68.81l-.79.71L67.23,69l.78-.7c0,.16.06.31.1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.85,86.93c0,.19-.1.37-.16.56l-.64-.83c.06-.19.11-.38.17-.56l.63.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.33,82.52l-.68.81c0-.19-.1-.37-.14-.55l.67-.81.15.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,46.53l-.61.34c-.13-.1-.25-.21-.38-.3l.61-.34.38.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.62,119.67c-.11.22-.24.43-.35.64-.11-.3-.21-.61-.32-.91l.36-.64c.11.3.21.61.31.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.82,139.37c-.16.22-.33.43-.49.64,0-.29-.07-.59-.12-.88.17-.22.34-.43.5-.65,0,.3.08.6.11.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,78.46l-.71.78c0-.18-.09-.35-.13-.53l.72-.78.12.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.16,99.76c-.07.21-.15.41-.23.61l-.51-.89c.07-.2.15-.4.23-.6l.51.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,159.75c-.21.2-.42.4-.64.59,0-.26.07-.53.09-.8l.64-.59c0,.27,0,.53-.09.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,121.61c-.1.3-.2.61-.29.91-.13-.21-.25-.42-.37-.64.09-.3.19-.61.29-.91.12.21.25.42.37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77,74.74c0,.17-.07.34-.12.51l-.74-.75c0-.17.07-.34.12-.51l.74.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.26,141.49l-.51.63-.09-.88.51-.64.09.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,178.77c-.25.17-.51.33-.77.49.1-.21.18-.43.26-.64l.77-.5c-.08.22-.17.43-.26.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56,197.17l.2.36-.67-.31-.2-.37.67.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.6,69c0,.15-.06.31-.1.47l-.78-.7c0-.16.07-.32.1-.47.26.23.53.46.78.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,157.8l-.62.6c0-.27.05-.54.07-.81l.63-.6c0,.27-.05.54-.08.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.73,93.24c-.06.2-.13.4-.19.59-.2-.28-.39-.57-.59-.86l.2-.59.58.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,172.34l-.72.54c.06-.23.14-.47.2-.71l.73-.54-.21.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,56.61l-.83.56a2.91,2.91,0,0,1-.12-.39l.82-.55c0,.13.08.25.13.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.41,46.48l-.59.34-.41-.31.59-.32.41.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33,82.73c0,.18-.09.37-.14.55l-.68-.81.15-.55.67.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,143.58c-.17.22-.34.43-.52.64,0-.29,0-.59-.07-.88l.52-.63c0,.29.06.58.07.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,53.49l-.81.5c-.06-.12-.11-.24-.16-.36l.82-.49.15.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,47.85l-.3.31-.69-.38.3-.3.69.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,155.84l-.61.6c0-.27,0-.55,0-.82L191,155c0,.28,0,.55-.05.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.07,50.54l-.78.45-.2-.34.78-.44c.06.11.13.22.2.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29,197.9c0,.11.08.23.13.34l-.6-.31a3.62,3.62,0,0,1-.13-.35l.6.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.06,110.46c-.14.31-.27.61-.41.91l-.3-.63c.14-.3.27-.61.41-.91l.3.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.63,78.66a4.56,4.56,0,0,1-.13.53l-.71-.78c.05-.18.09-.35.13-.53l.71.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,145.67l-.54.63c0-.29,0-.58-.05-.87l.54-.63c0,.29,0,.58.05.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.88,153.84c-.19.21-.4.4-.6.61,0-.28,0-.55,0-.83l.6-.61c0,.27,0,.55,0,.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,147.74c-.18.21-.36.42-.55.62l0-.85.55-.63c0,.29,0,.57,0,.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.73,151.83l-.58.61c0-.28,0-.56,0-.84l.58-.62c0,.28,0,.56,0,.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.07,101.62c-.17.29-.34.59-.5.89-.09-.21-.17-.41-.25-.62l.5-.88.25.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.53,121.83c-.12.22-.25.43-.37.64l-.3-.91.38-.64c.1.3.2.6.29.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.54,149.79l-.57.62c0-.28,0-.56,0-.85.19-.21.37-.42.57-.62,0,.28,0,.57,0,.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.14,123.77c-.09.31-.19.61-.27.91-.14-.21-.26-.42-.39-.64.08-.3.18-.61.27-.91l.39.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,52l-.79.47c-.07-.12-.12-.23-.18-.35l.79-.46.18.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,187.08l-.8.43.3-.54.81-.44c-.1.19-.2.37-.31.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,46.45l-.57.33-.43-.31.58-.32.42.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.15,88.67c-.21.28-.42.55-.62.84a5.58,5.58,0,0,1-.18-.58l.62-.84.18.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,72.48l-.77.74c0-.17-.08-.34-.11-.51l.76-.73c0,.17.07.33.12.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.41,67.07c0,.16-.07.31-.11.47l-.8-.69c0-.15.07-.3.11-.46l.8.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41,181.68l-.79.47c.09-.2.18-.41.28-.61l.78-.48-.27.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,170.6l-.72.54c.07-.24.13-.48.19-.72l.72-.55c-.06.25-.13.48-.19.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.87,49.17l-.25.32-.74-.41.26-.32.73.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.2,46.42l-.56.33-.45-.31.56-.32.45.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.39,95.05l-.57.87-.21-.6.56-.87c.07.2.14.4.22.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.72,184.45l-.8.45c.1-.19.2-.38.29-.58l.8-.45-.29.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,177.16l-.76.51c.09-.22.16-.45.24-.67l.77-.51c-.09.22-.16.45-.25.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.53,101.84c-.08.21-.16.41-.25.62-.16-.3-.33-.6-.5-.89.09-.21.18-.41.25-.62.18.3.34.6.5.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,197.85a3.38,3.38,0,0,0,.11.34l-.59-.31a3.58,3.58,0,0,1-.11-.35l.59.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.22,197.11q.09.19.18.36l-.65-.31a3.26,3.26,0,0,1-.18-.38c.22.12.43.23.65.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.6,46.4l-.54.33-.47-.32.55-.32.46.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.33,125.93c-.09.31-.17.61-.25.92-.15-.22-.28-.43-.41-.65.08-.3.16-.61.25-.91.13.22.27.43.41.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,124c-.12.22-.25.43-.39.65l-.27-.92.39-.64c.1.3.19.61.27.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.21,46.41l-.47.31-.54-.32.47-.31.54.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,47.76l-.32.31-.68-.38.32-.3.68.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,112.61l-.39.91c-.11-.22-.21-.43-.32-.64l.39-.91c.11.21.21.43.32.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,46.39l-.52.32L120,46.4l.53-.32.48.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.81,46.39c-.16.11-.32.22-.49.32l-.52-.32.49-.31.52.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.72,188.27l-.8.42c.1-.17.21-.35.3-.53l.81-.42c-.1.17-.2.36-.31.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49,88.88l-.18.58-.63-.85c.07-.19.13-.38.19-.57l.62.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.68,72.67c0,.17-.07.33-.11.5l-.77-.74.12-.49.76.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41,46.39l-.51.32-.5-.32.5-.31.51.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.61,84.42l-.66.82c-.06-.19-.12-.37-.17-.56.22-.28.44-.55.67-.82,0,.19.11.37.16.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.66,54.91l-.82.52-.15-.37.82-.52.15.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.7,168.82l-.71.55c.06-.24.12-.49.17-.73l.71-.56c-.06.24-.11.49-.17.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.07,76.31c-.24.26-.49.51-.74.77,0-.18-.08-.35-.13-.53l.74-.76c0,.17.08.35.13.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.24,95.27c-.07.2-.14.4-.22.6l-.56-.88c.07-.2.15-.39.22-.59l.56.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.92,63.39c0,.15-.08.29-.11.44l-.83-.64.12-.44.82.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75,103.71l-.48.9L48,104l.48-.89.27.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.57,128.1c-.08.3-.16.6-.23.91l-.43-.65c.07-.31.16-.61.23-.91l.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.26,80.29l-.7.8a5.44,5.44,0,0,1-.15-.54c.23-.27.46-.53.7-.79l.15.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.2,126.15c-.13.22-.27.43-.41.65-.08-.31-.17-.61-.25-.91.13-.22.27-.43.41-.65.09.3.17.61.25.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.62,197.81a2.14,2.14,0,0,0,.09.34l-.58-.31c0-.12,0-.24-.08-.35l.57.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.63,112.83c-.1.21-.21.42-.32.63l-.39-.91.32-.63.39.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,47.62l-.67.37-.34-.31.67-.36.34.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.18,70.47l-.78.71-.12-.49.78-.71a5,5,0,0,0,.12.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8,175.51l-.75.52c.08-.23.14-.45.22-.68l.75-.52c-.07.23-.14.45-.22.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.06,84.63l-.17.56c-.22-.27-.44-.55-.67-.82.06-.19.12-.37.17-.56.23.27.45.55.67.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.63,76.51c0,.17-.09.35-.13.52-.24-.26-.5-.51-.74-.76.05-.18.09-.35.14-.52.24.25.49.5.73.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.35,47.67,135,48c-.22-.12-.44-.25-.67-.36l.35-.31.67.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.87,180.14l-.78.49.26-.63.78-.5c-.09.22-.17.43-.26.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9,197.06c0,.12.1.24.16.36l-.65-.32c0-.13-.11-.25-.16-.38l.65.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.9,167l-.7.56c.06-.25.1-.5.15-.75l.7-.57-.15.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.49,49.05l-.28.32-.73-.41.28-.32.73.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.87,114.76c-.12.3-.24.61-.37.91-.11-.21-.22-.43-.34-.64.13-.3.25-.61.37-.91.11.21.23.42.34.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5,185.7l-.81.45c.11-.19.2-.38.3-.57l.8-.45c-.1.19-.2.38-.29.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3,53.3l-.81.5a3,3,0,0,1-.18-.36l.81-.49a2.91,2.91,0,0,0,.18.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,130.26l-.21.9-.44-.64.21-.91c.15.22.3.43.44.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.43,80.5l-.15.54-.7-.79.15-.54.7.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.85,103.94l-.27.62-.48-.9.27-.62c.17.3.32.6.48.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.56,90.64,53,91.5c-.07-.2-.14-.39-.2-.59.2-.28.41-.56.61-.85.06.2.14.39.2.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9,51.8l-.79.47-.2-.35.79-.46.2.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,128.31l-.43.65c-.08-.3-.15-.61-.24-.91l.44-.65c.08.31.16.61.23.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.93,97.09c-.19.29-.37.59-.55.88l-.24-.6.55-.88.24.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.22,183l-.79.47.27-.6.79-.47-.27.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.37,56.39l-.82.55-.15-.39.83-.55.14.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.06,165.16l-.69.58c0-.26.09-.51.13-.77l.68-.57c0,.25-.07.51-.12.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,132.41c-.06.3-.14.6-.19.9-.16-.21-.31-.43-.46-.64.06-.31.12-.61.19-.91l.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.88,47.55l-.65.37c-.13-.11-.25-.21-.36-.32l.65-.36.36.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,115c-.11.21-.23.42-.34.64l-.38-.92.35-.63c.12.3.25.6.37.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.48,105.82l-.46.91-.29-.63.46-.9c.1.21.19.42.29.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,130.47l-.44.64c-.07-.3-.14-.6-.22-.9l.45-.65c.07.3.15.61.21.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.09,90.86c-.06.2-.13.39-.2.59l-.61-.86c.07-.19.14-.38.2-.58l.61.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.14,173.83l-.74.53c.07-.23.14-.46.2-.7l.75-.53-.21.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,68.5l-.8.7-.12-.47.79-.7c0,.16.08.32.13.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.7,97.32c-.07.2-.15.4-.23.6-.18-.3-.37-.59-.55-.88.08-.2.16-.4.23-.6.19.29.37.58.55.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.86,116.91l-.36.91-.35-.64c.11-.3.23-.6.35-.91l.36.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,197c0,.12.08.24.13.36l-.63-.32c0-.12-.09-.24-.14-.37l.64.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.15,74.21,63.4,75c-.06-.17-.09-.34-.14-.51L64,73.7c0,.17.09.34.13.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.26,186.93l-.8.43c.09-.18.19-.36.28-.55l.81-.44c-.09.19-.19.38-.29.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.17,163.29l-.67.58c0-.26.07-.52.1-.78.23-.19.46-.38.68-.58l-.11.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.94,86.34l-.65.84q-.1-.29-.18-.57c.21-.28.43-.56.65-.83l.18.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.3,178.56l-.77.5c.08-.21.15-.43.23-.65l.78-.5-.24.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.09,48.93l-.3.32c-.24-.13-.48-.26-.71-.4.1-.1.2-.21.29-.32.24.14.49.26.72.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.32,132.62c-.15.22-.31.43-.47.64-.06-.3-.13-.6-.19-.9l.46-.64c.07.3.14.6.2.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.07,57.94l-.83.57c0-.14-.1-.27-.14-.41l.83-.56c0,.13.09.26.14.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.36,68.68l-.12.48-.8-.7c.05-.15.09-.31.13-.47l.79.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.37,196.19l.18.38-.68-.33a3.39,3.39,0,0,1-.18-.39l.68.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3,47.49l-.64.36-.38-.32c.21-.11.42-.24.64-.35l.38.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,50.34l-.25.34-.76-.44.25-.33.76.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.57,74.4c0,.17-.09.34-.14.52-.25-.26-.51-.51-.76-.75.05-.18.1-.34.14-.51l.76.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.25,161.39l-.67.59.09-.79.66-.59c0,.26-.05.53-.08.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26,78.11l-.73.78-.15-.53.72-.78c.06.18.1.36.16.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.71,117.13c-.11.22-.23.43-.36.64-.11-.3-.23-.6-.35-.91l.36-.64c.12.3.24.61.35.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.51,82.16l-.69.81c-.06-.19-.11-.37-.17-.55l.7-.81c0,.19.11.37.16.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.52,99.15c-.18.3-.36.59-.53.89-.09-.2-.18-.41-.26-.61l.53-.88.26.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.92,134.76l-.48.65-.18-.9c.17-.21.33-.43.48-.65l.18.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,172.11l-.74.54.18-.71.74-.55-.18.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.73,86.56c0,.19-.12.38-.18.57l-.66-.84c.06-.18.13-.37.19-.56.22.27.44.55.65.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,184.28l-.8.45.27-.58.8-.46-.27.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.89,119.07l-.33.92c-.13-.22-.25-.44-.38-.65l.33-.91.38.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.69,181.49l-.79.48.26-.62.79-.48c-.09.2-.17.41-.26.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,92.65c-.2.28-.41.57-.6.86-.08-.2-.15-.4-.22-.59.2-.29.39-.58.6-.86.06.19.14.39.22.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.27,108c-.16.3-.3.6-.45.9-.11-.21-.21-.42-.31-.63l.45-.9c.1.21.2.42.31.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.27,159.46l-.65.6c0-.27,0-.54.07-.8l.65-.6c0,.27,0,.54-.07.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.29,197c0,.12.07.24.11.36l-.62-.33c0-.12-.08-.24-.11-.37.2.12.41.23.62.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,47.43l-.62.36-.41-.32.63-.35.4.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,66.77c0,.16-.08.31-.12.47-.27-.23-.55-.45-.81-.68,0-.16.09-.31.13-.47l.8.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3,51.64l-.79.46-.22-.35c.26-.15.52-.31.79-.45l.22.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.47,136.9l-.5.64c0-.3-.1-.59-.15-.89.17-.21.33-.43.49-.64.06.29.11.59.16.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,78.31l-.15.54c-.24-.27-.48-.53-.73-.78.05-.18.11-.36.16-.53l.72.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.69,53.12l-.81.5-.2-.37.81-.48.2.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.18,82.37c-.05.18-.11.37-.17.55l-.69-.81c.06-.18.11-.36.17-.54l.69.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26,157.51l-.65.6c0-.27,0-.54,0-.81l.64-.6c0,.27,0,.54,0,.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.12,99.38c-.09.2-.17.4-.26.61l-.54-.89c.09-.2.18-.4.26-.6l.54.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.7,176.94l-.77.52c.08-.22.14-.45.21-.67l.78-.51c-.07.22-.14.44-.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,139l-.51.64c-.05-.3-.09-.59-.14-.89l.51-.64c0,.3.1.59.14.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.29,72.16l-.78.73c0-.17-.09-.34-.13-.5.25-.25.51-.49.77-.73,0,.16.08.33.14.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.68,48.82l-.32.33-.71-.4c.11-.11.22-.21.32-.32l.71.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.64,92.86c-.07.2-.14.4-.22.6l-.6-.86c.08-.2.15-.4.23-.59l.59.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.68,119.29c-.13.21-.25.43-.38.65-.11-.31-.22-.61-.34-.92l.39-.64.33.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.19,155.53c-.2.21-.41.41-.63.61,0-.27,0-.55,0-.82l.63-.61c0,.27,0,.55,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.17,47.39l-.61.35-.42-.32.6-.35.43.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.08,196.13c0,.13.1.25.16.38l-.67-.34c-.06-.13-.11-.26-.16-.39l.67.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.72,170.35l-.74.55c.06-.24.11-.48.17-.72l.73-.56c0,.25-.11.49-.16.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,121.24c-.11.3-.22.61-.32.91l-.39-.64c.1-.31.2-.61.31-.92l.4.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.42,141.14l-.53.64c0-.29-.08-.58-.12-.88l.54-.64c0,.29.07.59.11.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.08,153.53l-.61.62v-.84l.62-.61c0,.28,0,.56,0,.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.82,143.25l-.54.63c0-.29-.07-.58-.1-.87l.54-.64c0,.29.07.59.1.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.78,185.54,163,186a5.77,5.77,0,0,0,.27-.56l.81-.45-.27.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.93,151.51c-.2.21-.4.42-.61.62,0-.28,0-.56,0-.84.2-.21.41-.41.6-.62,0,.28,0,.56,0,.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.45,72.34c0,.17-.1.34-.14.51l-.78-.74.15-.5c.25.25.51.49.77.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,196.9l.09.36-.6-.32c0-.13-.07-.25-.1-.38l.61.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.17,145.34l-.56.63c0-.29-.05-.57-.08-.86l.56-.64c0,.29.06.58.08.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75,56.17l-.82.55c-.06-.13-.12-.26-.17-.39l.82-.54c.06.13.11.26.17.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,50.2c-.08.12-.18.23-.27.34l-.75-.43c.09-.11.19-.22.27-.33l.75.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.72,149.47l-.59.63c0-.29,0-.57,0-.85l.59-.63,0,.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.47,147.42l-.57.62c0-.28,0-.57-.06-.86l.58-.63c0,.29,0,.58.05.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.32,88.3l-.65.84c-.07-.19-.14-.39-.2-.58l.64-.84c.07.2.13.38.21.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.61,47.35l-.59.35-.44-.33.59-.34.44.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,110.08c-.15.3-.29.61-.43.91l-.33-.63.43-.91.33.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.16,101.24c-.18.29-.35.59-.52.89-.1-.21-.18-.42-.27-.62l.51-.89c.1.21.18.41.28.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.14,179.94l-.79.49.24-.63.78-.49c-.07.21-.15.42-.23.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.59,121.46l-.39.64c-.1-.3-.21-.61-.32-.91l.4-.65c.11.31.21.61.31.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.12,123.4c-.11.31-.21.61-.3.92-.14-.22-.27-.44-.41-.65.09-.3.19-.61.29-.91.14.21.27.43.42.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.32,76l-.75.76c-.06-.17-.11-.35-.16-.52l.75-.76c.05.17.1.34.16.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.06,47.32l-.57.35-.47-.33.58-.34.46.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,168.57l-.72.55c.05-.24.09-.49.14-.73.24-.19.49-.37.73-.57l-.15.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.49,182.81l-.8.47c.09-.2.17-.4.25-.6l.8-.47c-.08.2-.16.4-.25.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.52,94.67l-.59.87-.23-.6c.19-.29.38-.58.58-.87.07.2.16.4.24.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.25,48.73l-.35.32-.69-.39.34-.32.7.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.06,175.29l-.76.52c.06-.22.12-.45.19-.68l.77-.52-.2.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.47,70.15l-.79.72c-.05-.17-.1-.33-.14-.49l.79-.71c0,.16.09.32.14.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,88.51c-.06.19-.13.39-.2.58l-.65-.84a5.71,5.71,0,0,0,.21-.58l.64.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51,47.3l-.55.35-.49-.33L119,47l.48.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,84.06c-.23.27-.46.54-.68.82-.07-.19-.13-.38-.19-.56l.68-.82c.06.19.13.37.19.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.54,186.77l-.81.44c.09-.18.18-.36.26-.55l.81-.44c-.08.18-.17.37-.26.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,101.46l-.27.61-.53-.88c.1-.21.19-.41.28-.62l.52.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81,196.06a2.55,2.55,0,0,0,.13.39l-.66-.34c0-.13-.1-.26-.14-.39l.67.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.48,80l-.71.79c-.06-.18-.12-.36-.17-.54.23-.27.47-.53.71-.79.06.18.11.36.17.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,47.29l-.54.34-.51-.33.54-.34.51.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88,47.3c-.17.1-.34.22-.51.33l-.54-.34.51-.33.54.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.72,196.85c0,.12,0,.25.07.37-.2-.11-.4-.22-.59-.34,0-.12,0-.24-.07-.37l.59.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,47.29l-.52.34-.52-.34.52-.33.52.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41,76.17c0,.17-.1.35-.16.52-.24-.25-.49-.51-.75-.76a5.16,5.16,0,0,0,.16-.52l.75.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,57.71l-.83.56c-.06-.13-.11-.26-.17-.4l.83-.56c.06.13.11.27.17.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.28,70.34c0,.16-.09.32-.14.49l-.79-.72c.05-.16.1-.32.14-.49l.79.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3,125.57c-.1.3-.18.61-.27.91-.15-.21-.29-.43-.43-.65.08-.3.18-.6.27-.91l.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.46,123.62l-.42.65c-.09-.31-.2-.61-.3-.92l.42-.64.3.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,112.23c-.14.3-.28.6-.41.9-.11-.21-.24-.42-.34-.63.13-.31.27-.61.41-.91.11.21.22.43.34.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.14,94.89q-.1.3-.24.6c-.19-.29-.38-.58-.58-.87.08-.2.17-.39.24-.59.2.28.39.57.58.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.13,166.75l-.71.56c0-.24.08-.5.12-.75.24-.19.48-.37.71-.57l-.12.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1,53l-.8.49c-.07-.13-.15-.24-.22-.37l.8-.48c.08.12.15.24.22.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,84.27c-.06.19-.12.37-.19.56L186,84c.07-.18.13-.37.19-.56l.68.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.23,80.15c0,.18-.11.36-.17.54l-.72-.79.18-.54.71.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13,50.07l-.3.35-.74-.43.3-.34c.24.15.49.29.74.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.84,103.33l-.5.9c-.09-.21-.19-.42-.29-.62l.5-.9c.09.21.19.42.29.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.38,173.6l-.75.53c.06-.23.12-.46.17-.69l.76-.54c-.05.23-.11.47-.18.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,178.36l-.79.5c.08-.22.15-.43.22-.65l.79-.51c-.08.22-.15.44-.22.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.54,127.74c-.08.3-.17.6-.26.9l-.44-.64c.08-.31.16-.61.25-.91l.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.14,59.31l-.83.59-.17-.42.84-.59c0,.14.1.28.16.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.26,184.11l-.8.46c.08-.2.16-.39.25-.59l.8-.46c-.08.2-.16.39-.25.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,125.78c-.14.22-.29.44-.44.65-.08-.3-.18-.6-.28-.91.15-.22.3-.43.44-.65.09.31.19.61.28.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.63,112.45l-.35.64c-.13-.31-.27-.61-.41-.91l.34-.64c.14.3.29.6.42.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.73,90.28c-.2.28-.42.56-.63.85-.07-.2-.15-.39-.22-.59l.63-.85c.07.2.15.39.22.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.27,164.9l-.7.57c0-.25.07-.51.1-.76l.71-.58c0,.26-.07.51-.11.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,68.38l-.15.48-.81-.7.15-.47.81.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.54,196c0,.12.07.25.12.38l-.65-.34-.12-.39.65.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.43,73.88l-.76.75c-.06-.17-.11-.34-.16-.51l.76-.75c0,.17.11.34.16.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19,195.16l.16.4-.7-.35c-.05-.13-.11-.27-.16-.41l.7.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.94,181.3l-.79.48c.08-.2.15-.41.23-.61.26-.17.53-.33.8-.49l-.24.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07,96.72c-.19.29-.39.58-.57.87-.09-.2-.18-.4-.26-.61l.57-.87c.08.2.17.4.26.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,103.56l-.3.62c-.16-.3-.33-.6-.5-.9.1-.2.2-.41.29-.62l.51.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.91,114.38l-.39.91-.36-.64.39-.91.36.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,61c-.27.2-.56.4-.83.61-.06-.15-.11-.29-.16-.43.27-.21.55-.41.83-.61,0,.14.1.29.16.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.83,129.9l-.24.9-.46-.65c.08-.29.16-.6.24-.9l.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5,48.51l-.67.39-.38-.33.67-.38.38.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,128l-.45.65c-.09-.31-.18-.61-.26-.91l.45-.65c.09.3.17.6.26.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.17,56c-.28.17-.56.36-.83.54-.07-.13-.13-.27-.19-.39l.82-.54c.06.13.13.26.2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.37,163c-.22.2-.46.39-.69.58,0-.26.06-.52.08-.77l.7-.59c0,.26-.05.52-.09.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,90.49a5.77,5.77,0,0,1-.22.58l-.63-.85c.08-.19.15-.38.23-.58l.62.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.32,74.07c-.06.17-.11.35-.17.52l-.77-.75c.06-.17.12-.34.17-.51l.77.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.67,171.87l-.75.55c.06-.24.11-.48.16-.72l.75-.54c-.05.24-.1.48-.16.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.15,86l-.67.83-.21-.57c.22-.28.45-.55.67-.82l.21.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,96.94c-.08.2-.17.4-.26.6l-.57-.87c.09-.2.17-.41.26-.61.2.29.38.58.57.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.68,50l-.32.34-.73-.42.32-.34.73.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.17,132.06c-.07.3-.15.6-.22.9-.16-.22-.31-.44-.48-.65.08-.3.15-.6.22-.9l.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,185.38l-.81.45c.08-.19.17-.38.24-.57l.81-.46-.24.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.52,77.77l-.74.78c-.06-.18-.12-.36-.17-.53l.73-.78.18.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.58,105.45c-.17.3-.33.59-.48.89-.11-.2-.21-.41-.32-.62l.49-.9c.1.21.2.42.31.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7,114.6c-.13.21-.24.43-.37.64-.13-.31-.27-.61-.4-.91.13-.21.25-.43.37-.64.14.3.27.61.4.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.73,130.11l-.46.65-.24-.91c.15-.22.31-.43.47-.65.07.3.16.6.23.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.93,176.73l-.78.52c.06-.22.13-.44.19-.67l.78-.52c-.06.23-.12.45-.19.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,81.81l-.7.81c-.07-.19-.13-.37-.19-.56l.7-.8c.06.19.13.37.19.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.43,161.11l-.68.59c0-.26.05-.52.07-.79l.68-.59c0,.26,0,.53-.07.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,196l.09.38-.63-.34-.09-.39.63.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,48.45l-.66.38-.4-.33.65-.38.41.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9,116.54c-.13.3-.25.61-.38.91l-.38-.64c.12-.31.25-.61.38-.91l.38.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.87,54.33q-.41.24-.81.51l-.22-.38.81-.51.22.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.56,134.21c-.06.3-.13.6-.2.89l-.49-.64c.06-.3.13-.6.19-.9.17.22.34.43.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.55,52.78l-.8.49-.24-.37.79-.48a3.27,3.27,0,0,0,.25.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,71.84l-.79.73c0-.17-.11-.34-.16-.5l.78-.73c0,.17.11.33.17.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,86.19l-.21.58c-.22-.28-.44-.56-.68-.83.08-.19.15-.38.22-.57l.67.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.22,78l-.18.53c-.24-.26-.49-.51-.74-.77l.18-.53c.25.25.49.51.74.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,195.09l.13.4-.68-.35c-.05-.14-.09-.28-.14-.41l.69.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.39,132.26l-.48.65-.22-.9.48-.65c.07.3.15.6.22.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.45,159.18l-.67.6c0-.27,0-.54,0-.81.23-.19.45-.4.67-.6,0,.27,0,.54,0,.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.73,182.63l-.81.47.23-.6.8-.47-.22.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,82c-.06.18-.13.36-.19.55l-.71-.81c.07-.18.13-.36.2-.55l.7.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2,92.28l-.62.85c-.08-.2-.17-.39-.24-.59.2-.29.41-.57.61-.85.08.19.16.39.25.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.66,98.78c-.18.3-.37.58-.55.88-.1-.2-.19-.41-.28-.61l.55-.88c.09.2.19.4.28.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36,179.75l-.79.49.21-.63.8-.5c-.07.21-.14.43-.22.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.87,57.49l-.83.56c-.07-.13-.13-.27-.19-.4l.83-.56c.06.13.12.27.19.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.92,170.11l-.74.55c0-.24.09-.48.14-.72l.74-.56c-.05.25-.09.49-.14.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17,72c0,.17-.11.34-.17.51l-.78-.73c.06-.17.11-.33.16-.5l.79.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,48.39c-.21.12-.42.26-.64.38l-.43-.34.64-.37.43.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.71,116.76l-.38.64c-.13-.3-.25-.61-.38-.91l.39-.65c.13.31.25.61.37.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,134.41l-.5.65c-.07-.3-.14-.6-.2-.9.17-.21.33-.43.5-.65.06.3.13.6.2.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.42,157.22l-.66.6c0-.27,0-.54,0-.81.21-.2.44-.4.65-.61,0,.27,0,.55,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.22,49.85c-.11.11-.22.23-.34.34l-.72-.42.34-.33.72.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.93,118.7l-.35.92c-.14-.22-.28-.43-.4-.65.11-.3.23-.61.35-.91.14.21.27.43.4.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,107.57c-.16.3-.32.6-.47.9l-.33-.63.46-.9c.12.21.22.42.34.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.06,195.9c0,.12,0,.25.07.38l-.63-.35c0-.13,0-.26-.07-.39l.63.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.55,136.55l-.51.65c-.06-.3-.13-.59-.18-.89.17-.22.35-.43.51-.65.07.3.13.6.18.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,155.24l-.65.61V155c.22-.2.44-.4.65-.61v.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.49,92.49c-.07.2-.16.4-.24.6-.2-.29-.41-.58-.62-.86.09-.2.17-.39.25-.59.21.28.41.57.61.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.27,175.07l-.78.53c.07-.23.12-.46.18-.68l.77-.53c-.05.23-.12.45-.17.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.81,69.85l-.8.71a4.75,4.75,0,0,1-.17-.49l.8-.71c0,.16.11.33.17.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.94,48.34l-.63.38-.44-.34c.2-.13.41-.25.62-.37l.45.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.61,75.65l-.76.76c-.06-.18-.11-.36-.17-.53l.75-.76.18.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.06,138.69c-.17.21-.36.42-.53.64-.06-.3-.11-.59-.16-.89l.53-.64c0,.29.11.59.16.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.23,153.23l-.63.62c0-.28,0-.56,0-.84l.63-.62c0,.28,0,.56,0,.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.13,168.32l-.73.56.12-.74.73-.57c0,.25-.07.5-.12.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.56,59.07l-.84.59-.18-.42c.27-.2.55-.39.83-.58.06.13.12.28.19.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.54,87.94c-.22.28-.45.55-.66.83-.08-.19-.16-.38-.23-.58l.66-.83c.07.19.15.38.23.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72,195a3.17,3.17,0,0,0,.12.41l-.68-.36-.12-.41c.23.12.45.25.68.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.68,118.92l-.41.64c-.11-.3-.23-.6-.35-.91l.4-.64.36.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52,140.81c-.19.21-.37.43-.55.64-.05-.29-.1-.59-.14-.88l.55-.65c0,.3.09.59.14.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,183.94l-.81.46.22-.58.81-.47c-.07.2-.14.39-.22.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,151.2l-.62.63c0-.28,0-.56,0-.85l.62-.62c0,.28,0,.56,0,.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,120.87c-.12.3-.23.61-.34.91l-.42-.65c.11-.3.23-.6.34-.91l.42.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.43,48.31l-.61.37-.47-.35L116,48l.47.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.92,142.92l-.56.64-.12-.88.56-.64c0,.29.09.59.12.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.85,149.16c-.2.21-.4.42-.61.62,0-.28,0-.56-.06-.85.21-.2.41-.42.61-.62l.06.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.28,145l-.58.64c0-.29-.06-.58-.1-.87.19-.21.39-.42.58-.64,0,.29.07.58.1.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.59,147.09l-.59.63c0-.28-.06-.57-.08-.85.19-.22.39-.42.59-.64,0,.29.05.58.08.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.14,75.84c0,.17-.12.35-.18.52-.25-.25-.5-.51-.76-.76.06-.17.13-.34.18-.52.26.25.51.5.76.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.83,195.84c0,.13,0,.26,0,.39l-.61-.35c0-.13,0-.26,0-.39l.61.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.76,79.61c-.24.26-.49.52-.73.79-.07-.19-.14-.37-.19-.55.24-.26.48-.53.73-.79.06.19.13.36.19.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.31,100.86c-.19.3-.37.59-.54.89-.11-.2-.2-.41-.3-.62.18-.3.35-.59.54-.89.09.21.2.42.3.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.75,49.75l-.37.35c-.23-.15-.47-.28-.7-.42l.36-.34.71.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.75,178.15q-.39.27-.78.51c.06-.21.13-.43.19-.65l.79-.51c-.06.22-.13.44-.2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.07,83.71l-.7.81c-.08-.19-.14-.37-.21-.56.23-.27.45-.55.69-.81.07.18.14.37.22.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.24,60.72l-.83.61c-.07-.14-.13-.29-.19-.43l.84-.61a3.25,3.25,0,0,0,.18.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2,109.71l-.45.9L48.4,110l.45-.91.35.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18,88.15c-.07.19-.15.38-.23.57-.21-.28-.43-.56-.66-.83.09-.2.16-.39.24-.58l.65.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.93,48.28l-.6.36-.48-.34.59-.36.49.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.33,54.15l-.81.51-.25-.38.81-.51.25.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15,181.11l-.8.49.21-.62.8-.49c-.07.21-.13.42-.21.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.71,94.3c-.2.29-.41.58-.6.87l-.27-.6.6-.87.27.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,166.49l-.72.57c0-.25.07-.5.1-.75l.72-.57c0,.25-.06.5-.1.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.57,173.37l-.76.54c.06-.23.11-.46.15-.7l.77-.54c0,.24-.1.47-.16.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.43,48.26l-.58.36-.5-.35.58-.36.5.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.59,121.09l-.42.64c-.11-.3-.22-.6-.34-.91l.42-.65c.12.31.23.61.34.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.15,123c-.1.3-.21.61-.32.91-.15-.21-.29-.43-.43-.65.1-.3.21-.61.32-.91l.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,79.8c-.07.19-.14.37-.2.55l-.74-.79.21-.54.73.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.93,48.25l-.56.35-.52-.35.56-.35.52.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,194.07c0,.14.09.29.14.43l-.71-.37c0-.15-.1-.29-.14-.43l.71.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.67,83.91l-.21.56-.7-.81c.07-.19.15-.37.21-.56l.7.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,51.16c-.1.12-.21.24-.32.35l-.75-.44.32-.35.75.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.76,73.56l-.78.75-.18-.52.78-.74c0,.17.12.34.18.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.51,195l.09.4-.66-.36c0-.13-.07-.27-.1-.41l.67.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.61,195.8l0,.38-.59-.35,0-.39.59.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43,164.64l-.71.57c0-.25.05-.51.07-.76.25-.19.49-.39.72-.58,0,.25,0,.51-.08.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.31,57.28l-.83.56-.21-.41.83-.55.21.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.34,125.21c-.1.3-.21.61-.3.91-.16-.21-.31-.43-.45-.65.09-.31.19-.61.3-.91.14.22.3.43.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.46,123.25c-.15.22-.29.44-.44.65-.11-.3-.22-.6-.32-.91.15-.21.29-.43.43-.65.12.31.22.61.33.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.08,111.85c-.14.31-.29.61-.43.91-.13-.21-.25-.42-.36-.64l.43-.91.36.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,73.75l-.18.52-.78-.75.19-.51.77.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,103l-.52.89c-.11-.21-.22-.41-.32-.62.17-.3.34-.6.52-.89.1.21.21.41.32.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,89.91l-.64.85c-.09-.2-.17-.39-.25-.59l.65-.84.24.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.11,176.52l-.78.52c.06-.22.11-.44.17-.66l.78-.53c-.05.23-.11.45-.17.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.84,171.64l-.76.55c0-.24.1-.48.14-.71l.76-.56c0,.24-.09.48-.14.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.92,182.45l-.81.48.21-.6.81-.48-.21.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.52,162.75l-.7.59c0-.26,0-.52.05-.78l.71-.59-.06.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.58,127.38c-.1.3-.19.6-.29.91l-.46-.65c.08-.31.18-.61.27-.91.16.21.31.43.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.84,77.44l-.76.77c-.07-.17-.13-.36-.2-.53l.76-.77a3.39,3.39,0,0,0,.2.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.12,49.53l-.68.41-.4-.35c.22-.14.45-.27.68-.4l.4.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.26,96.35l-.58.87c-.1-.2-.19-.4-.29-.61l.59-.87.28.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.55,179.55l-.8.5c.06-.21.13-.42.19-.63l.8-.5c-.06.21-.12.42-.19.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.27,125.42l-.45.65c-.1-.3-.2-.61-.31-.91l.46-.65.3.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.56,112.07c-.12.22-.24.43-.37.64l-.43-.91.37-.64c.14.31.29.61.43.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,71.53l-.79.73c-.07-.17-.13-.34-.19-.51l.8-.72c0,.17.12.33.18.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.31,194.9c0,.14,0,.27.07.4l-.65-.36c0-.13,0-.27-.07-.41.21.13.43.25.65.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.82,194l.12.42-.7-.37-.12-.43.7.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.76,90.12c-.08.2-.16.4-.25.59l-.65-.85c.09-.19.18-.39.26-.58l.64.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.26,51c-.11.12-.23.23-.34.36l-.74-.45c.12-.11.23-.23.34-.35l.74.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,58.85l-.83.58L84,59l.83-.58.21.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,114l-.42.91c-.12-.22-.26-.43-.38-.65.13-.3.27-.6.41-.91L49,114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.05,81.47l-.72.8c-.08-.18-.15-.37-.22-.56l.72-.79c.07.18.15.36.22.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.86,129.54c-.09.31-.18.61-.26.91l-.49-.65c.09-.3.18-.61.26-.91l.49.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.93,77.64c-.06.17-.13.35-.2.53L180,77.4c.07-.18.14-.36.2-.53.25.25.51.51.75.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,160.84l-.7.59c0-.26,0-.53,0-.79l.7-.6c0,.27,0,.53,0,.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,127.59c-.15.22-.31.43-.47.65-.09-.3-.19-.61-.29-.91l.48-.65c.1.3.19.6.28.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.67,183.77l-.81.47c.07-.19.14-.39.2-.58l.81-.48a5.84,5.84,0,0,1-.2.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.08,169.87l-.75.56c0-.24.07-.49.11-.73.25-.19.51-.37.75-.56,0,.25-.07.49-.11.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.64,49.46l-.67.4-.42-.35.67-.4.42.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.32,85.84c-.07.19-.15.38-.23.57l-.69-.83.24-.57c.23.28.46.55.68.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.74,105.07l-.51.9-.33-.63c.16-.3.33-.6.5-.89l.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.19,69.55c-.28.23-.54.47-.81.71-.07-.17-.13-.33-.19-.5l.8-.7c.06.17.13.33.2.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2,131.71q-.14.45-.24.9l-.51-.65.24-.91.51.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,81.67l-.22.55-.72-.8.22-.55.72.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.43,174.86l-.78.53c.06-.23.11-.46.16-.69l.78-.53c-.05.23-.1.46-.16.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.63,114.23l-.39.64-.42-.91c.14-.21.26-.43.39-.64l.42.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,158.9l-.68.6c0-.27,0-.54,0-.81l.68-.6c0,.27,0,.54,0,.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.68,60.49l-.83.6-.21-.44.83-.59c.08.14.14.28.21.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.74,129.75c-.15.22-.32.44-.49.65-.08-.3-.17-.6-.26-.9l.49-.65c.09.3.18.6.26.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.12,194.84c0,.14,0,.27,0,.41l-.64-.37c0-.13,0-.27,0-.41l.63.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,116.17c-.14.3-.27.61-.4.91l-.4-.65.4-.91c.13.22.26.44.4.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.58,133.86c-.08.3-.15.6-.22.9l-.52-.65c.07-.3.15-.6.22-.9.17.22.34.44.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.44,91.91l-.64.86c-.09-.2-.18-.4-.26-.6l.63-.85.27.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,75.32l-.77.76c-.07-.17-.14-.35-.2-.52.25-.26.51-.51.77-.76.06.18.13.35.2.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.32,180.93l-.8.49.18-.62.81-.49c-.06.21-.12.41-.19.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.64,193.93c0,.14.06.28.1.42l-.69-.37c0-.14-.06-.29-.1-.43l.69.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.17,49.4l-.66.4-.44-.35.66-.4.44.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.76,50.92c-.12.13-.24.25-.37.37l-.73-.44.37-.36.73.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.27,156.93l-.67.61c0-.27,0-.54,0-.81l.68-.62v.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.86,98.41l-.57.88-.3-.61.57-.88.3.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.37,62.18c-.29.2-.56.41-.84.63l-.21-.45.84-.62c.06.14.13.29.21.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.92,178l-.8.51c.06-.22.12-.44.17-.65l.8-.52c-.06.22-.11.44-.17.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.41,131.91l-.51.65c-.08-.3-.17-.6-.25-.9l.51-.65c.08.3.16.6.25.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.79,57.08l-.83.55-.24-.41.83-.55a4.36,4.36,0,0,0,.24.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.27,168.07l-.74.57c0-.25.06-.49.09-.74l.75-.57c0,.25-.06.49-.1.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.45,154.94l-.67.62c0-.28,0-.55,0-.83l.66-.62,0,.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.64,116.38l-.4.65-.4-.91.4-.65.4.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,134.07c-.17.21-.34.43-.52.64-.07-.3-.14-.59-.22-.89l.52-.65c.08.29.15.59.22.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.83,75.51l-.21.53-.78-.76c.08-.17.15-.35.21-.52l.78.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.53,107.2c-.17.3-.33.6-.49.9-.12-.21-.24-.42-.35-.63q.23-.47.48-.9c.11.21.24.42.36.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,49.35l-.65.4-.46-.36.64-.39.47.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.84,98.63c-.1.2-.21.4-.31.61-.18-.29-.38-.58-.57-.88.1-.21.21-.41.31-.61l.57.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,118.34c-.13.3-.26.61-.38.91-.14-.22-.29-.43-.42-.65.12-.31.25-.61.37-.91l.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.81,87.58l-.67.84-.25-.58.67-.84c.08.19.16.39.25.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.72,173.15l-.77.54c0-.23.09-.46.13-.7l.77-.54c0,.24-.08.47-.13.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.31,152.93l-.65.62c0-.28,0-.55,0-.83l.65-.63c0,.28,0,.56,0,.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,194.79c0,.13,0,.27,0,.4l-.62-.37,0-.41.63.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1,79.27c-.26.26-.5.53-.75.79-.07-.19-.15-.37-.22-.55l.74-.78c.07.18.15.36.23.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.57,136.21c-.17.22-.35.44-.53.65l-.21-.89.54-.65c.07.29.14.59.2.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.14,150.9c-.21.21-.43.41-.64.63l-.06-.85.64-.63.06.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.09,138.35l-.55.65c-.06-.3-.13-.59-.19-.89l.55-.65c.06.3.13.59.19.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.43,166.24l-.74.57c0-.25.05-.5.08-.75l.73-.58c0,.26-.05.51-.07.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25,49.32q-.31.18-.63.39l-.48-.37.62-.38.49.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.08,182.28l-.81.49c.06-.2.13-.41.18-.61l.81-.48q-.07.3-.18.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.91,148.85l-.62.63c0-.29-.06-.57-.08-.85l.62-.64c0,.29.06.57.08.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.14,73.25l-.79.74c-.08-.17-.14-.34-.21-.51l.79-.74.21.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.55,140.47l-.57.65c0-.29-.11-.59-.16-.88l.57-.65c.05.3.11.59.16.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.48,193.86c0,.14,0,.28.07.43l-.68-.38c0-.14,0-.29-.07-.43l.68.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.65,146.78l-.61.63c0-.29-.07-.57-.11-.86.21-.21.41-.42.61-.64,0,.29.07.58.11.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,142.59c-.19.21-.38.43-.58.64,0-.29-.09-.58-.14-.87l.58-.65c.05.29.1.59.14.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.69,79.47l-.23.54-.74-.78.22-.54.75.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,87.79c-.08.19-.16.38-.25.57l-.68-.83c.09-.19.18-.38.26-.58.22.28.45.55.67.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33,144.69l-.6.64-.12-.87.6-.64.12.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.61,118.55l-.42.65-.39-.91.43-.65c.13.3.25.61.38.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.48,58.63l-.83.58c-.08-.14-.16-.28-.23-.42.28-.19.55-.39.83-.57l.23.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.12,120.51l-.36.91-.44-.65.36-.92.44.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,49.29l-.62.38-.5-.36.61-.38.51.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.52,100.49c-.19.3-.38.59-.56.89l-.32-.62.56-.89c.1.21.21.42.32.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,93.94c-.21.29-.42.57-.62.86-.1-.2-.2-.4-.29-.6.2-.29.41-.58.62-.86.09.2.19.4.29.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.25,176.32l-.79.52.15-.67.79-.52c0,.22-.09.45-.15.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.39,83.56q-.1.28-.24.57l-.71-.81c.08-.19.17-.38.24-.57l.71.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67,73.43l-.21.52-.79-.74.21-.51.79.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7,179.37l-.81.5c.06-.21.12-.42.17-.64l.8-.5c-.05.21-.1.42-.16.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.78,194.74c0,.13,0,.27,0,.4l-.61-.37v-.41l.6.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.36,109.34c-.15.3-.32.6-.47.9-.13-.21-.25-.42-.37-.64l.47-.9c.12.21.25.42.37.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.34,49.26l-.59.39-.52-.37.59-.38.52.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.54,164.38l-.73.58c0-.26.05-.51.06-.77l.73-.58-.06.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,171.41c-.25.19-.51.37-.77.55l.12-.71.76-.56c0,.24-.07.48-.11.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.53,120.72c-.15.22-.29.43-.45.65-.11-.31-.24-.61-.36-.91l.44-.65c.12.3.25.6.37.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36,71.23l-.81.72-.21-.5.8-.72c.07.17.14.33.22.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.25,122.68l-.34.91-.45-.65c.11-.3.22-.61.34-.91l.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.71,192.86c0,.15.07.29.1.44l-.71-.38c0-.15-.07-.31-.1-.45l.71.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.17,60.26l-.84.59c-.08-.14-.16-.28-.23-.43l.83-.6c.08.15.15.29.24.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2,77.12c-.26.25-.51.51-.76.77-.09-.18-.16-.36-.23-.54l.77-.77c.07.18.14.36.22.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.33,193.8c0,.14,0,.28,0,.42l-.66-.38c0-.14,0-.29-.06-.43l.67.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.25,89.56l-.66.84-.27-.59L57,89l.27.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61,162.48l-.71.59,0-.77c.24-.21.48-.4.72-.6,0,.26,0,.52,0,.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63,194.69c0,.13,0,.27,0,.4l-.59-.37c0-.13,0-.27,0-.41l.59.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25,111.49l-.46.9-.39-.64c.15-.3.31-.6.46-.91l.39.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.44,124.85c-.12.31-.22.61-.33.91-.16-.22-.32-.43-.47-.65.1-.3.21-.61.32-.91l.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.39,122.89l-.46.65c-.11-.3-.23-.6-.34-.91l.46-.65.34.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.21,102.59l-.54.89-.34-.62.54-.89.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.6,77.31c-.07.18-.15.35-.23.53l-.76-.77c.07-.17.15-.35.22-.53.26.26.52.51.77.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.84,61.94l-.84.62-.22-.45.83-.61c.08.14.16.29.23.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.56,174.64l-.79.54c0-.23.08-.46.13-.69l.79-.53c0,.23-.09.46-.13.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75,50.6l-.69.42c-.14-.12-.29-.24-.42-.37l.69-.41c.14.12.28.23.42.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.46,180.75l-.81.5c.06-.21.1-.42.16-.62l.81-.5c-.05.21-.11.42-.16.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.39,81.13l-.73.8-.24-.56.73-.79.24.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.19,169.64l-.77.56c0-.24.07-.49.1-.73l.76-.56-.09.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.74,85.28c-.24.27-.47.55-.7.83-.1-.19-.18-.39-.26-.58.23-.27.47-.54.7-.82.08.19.17.38.26.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.52,96l-.61.87-.3-.61.6-.87c.1.21.21.41.31.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,63.68l-.84.65-.22-.46c.27-.22.55-.43.83-.64.07.15.15.3.23.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.65,160.56l-.71.6c0-.26,0-.52,0-.79l.71-.6c0,.26,0,.53,0,.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,177.76c-.26.18-.53.35-.8.52l.15-.66.8-.52c-.05.22-.09.44-.15.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.67,127l-.3.9c-.17-.21-.33-.43-.5-.65.1-.31.21-.61.31-.91l.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49,194.64c0,.14,0,.27,0,.41l-.58-.37c0-.14,0-.28,0-.42l.57.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.21,125.06l-.48.66c-.1-.31-.21-.61-.33-.91l.48-.66.33.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.39,81.33l-.24.56c-.24-.27-.49-.54-.74-.8.09-.19.17-.37.25-.56l.73.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,85.49c-.09.19-.18.38-.26.57l-.71-.82c.1-.19.18-.38.26-.57l.71.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.19,193.74l0,.42-.65-.38c0-.14,0-.29,0-.43l.65.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,192.78c0,.15,0,.3.07.45l-.7-.39c0-.15,0-.3-.07-.45l.7.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.36,75l-.78.75c-.09-.17-.16-.35-.23-.52l.78-.76c.07.18.15.35.23.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,58.43l-.83.57-.26-.42.83-.57.26.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.22,96.19c-.1.21-.21.41-.31.62-.2-.29-.4-.59-.61-.88.11-.2.21-.4.31-.6l.61.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.32,50.53l-.68.42-.45-.37.69-.42.44.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.19,113.64c-.16.3-.3.61-.44.91-.14-.21-.28-.43-.41-.65l.44-.9.41.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.51,158.62l-.7.6v-.8l.7-.61v.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,129.19c-.1.31-.19.61-.29.91l-.5-.65c.09-.31.19-.61.28-.91l.51.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.36,167.83l-.75.57c0-.25,0-.49.07-.74l.76-.58c0,.25-.05.5-.08.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,127.23l-.49.66c-.1-.31-.2-.61-.31-.91l.5-.66.3.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,104.71c-.18.3-.36.59-.53.89l-.36-.63c.18-.3.35-.6.53-.89q.16.32.36.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.46,75.19c-.08.18-.15.36-.23.53l-.79-.75c.08-.18.16-.35.23-.52.27.24.53.49.79.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,172.93l-.78.55c0-.23.07-.47.11-.7l.78-.55c0,.23-.07.47-.11.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.73,91.56l-.65.85-.28-.6c.21-.28.43-.56.64-.85.1.2.2.4.29.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.28,131.36c-.09.3-.17.6-.26.9-.18-.21-.35-.43-.53-.65l.27-.9.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.58,156.65l-.68.61,0-.82.69-.61c0,.27,0,.54,0,.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,113.86l-.41.64c-.15-.3-.29-.6-.44-.91l.41-.64c.15.3.29.6.44.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9,50.47c-.23.13-.45.28-.67.42l-.47-.38.67-.41.47.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.69,129.4l-.51.65c-.1-.3-.19-.6-.29-.9l.51-.66c.1.31.19.61.29.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.13,98.05c-.2.29-.4.58-.59.88l-.33-.62.6-.88c.1.21.21.41.32.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.07,193.68v.42l-.63-.38c0-.14,0-.29,0-.43l.64.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.66,133.52l-.24.9-.54-.65.24-.9.54.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.48,79l-.76.78c-.09-.18-.17-.37-.24-.55l.75-.78.25.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.17,115.81l-.42.91-.43-.65.42-.91.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,179.18l-.81.51c0-.21.09-.43.14-.64l.81-.51c0,.22-.09.43-.14.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.56,73c-.27.24-.53.49-.79.74-.09-.18-.16-.35-.24-.52l.8-.74c.08.18.15.35.23.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,60l-.84.59c-.09-.14-.17-.29-.25-.44l.83-.59.26.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.49,154.65l-.68.62c0-.27,0-.55-.05-.82l.68-.63c0,.28,0,.56.05.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.35,176.12l-.79.52.12-.66.8-.54c0,.23-.08.45-.13.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,192.71c0,.15,0,.3.05.45l-.69-.4c0-.15,0-.3,0-.45l.69.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.09,135.68c-.07.29-.15.59-.22.89-.19-.22-.37-.44-.56-.65.08-.3.15-.6.23-.9l.55.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5,166l-.75.58c0-.25,0-.5.05-.76.25-.19.51-.38.75-.58,0,.25,0,.51-.05.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.35,131.56l-.52.66-.27-.91c.18-.21.35-.43.53-.65.08.3.17.6.26.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.15,87.23q-.36.42-.69.84c-.1-.2-.19-.39-.28-.59l.69-.83c.09.2.18.39.28.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.48,50.42l-.66.41-.48-.38.65-.4.49.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35,152.64l-.67.62c0-.28,0-.56-.07-.84.23-.2.45-.41.67-.62,0,.28.05.56.07.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33,79.14l-.24.54-.76-.78.25-.54.75.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.27,73.13l-.23.51c-.27-.24-.54-.48-.8-.73.07-.17.15-.34.23-.51l.8.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.61,98.26c-.1.21-.22.41-.33.62-.19-.3-.39-.59-.59-.88l.33-.62.59.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,133.72l-.54.65c-.08-.29-.16-.59-.25-.89l.54-.66c.09.3.17.6.25.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.51,116c-.13.22-.28.43-.42.65-.14-.31-.28-.61-.43-.91l.43-.65c.15.3.29.6.42.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75,106.83q-.27.45-.51.9c-.13-.21-.26-.42-.38-.63.16-.31.34-.6.51-.9.12.21.25.42.38.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.16,150.6l-.65.63-.09-.85.65-.63.09.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.05,171.19c-.25.18-.51.37-.78.55,0-.24.07-.48.09-.71l.78-.56q0,.36-.09.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.63,87.44c-.08.19-.18.39-.27.58-.23-.28-.46-.56-.7-.83.1-.2.2-.39.28-.59.23.28.47.56.69.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.07,50.38l-.64.41-.5-.39.64-.4.5.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.54,135.87c-.19.22-.37.44-.56.65-.07-.29-.15-.59-.23-.89.19-.22.38-.43.56-.65l.23.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.35,61.71l-.84.61-.25-.45.84-.61c.08.15.16.3.25.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.06,83.22c-.08.19-.17.38-.26.57l-.73-.81c.09-.19.19-.38.27-.56.24.26.49.53.72.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.61,191.67c0,.15,0,.31.08.46l-.72-.4c0-.16-.06-.31-.08-.47l.72.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,193.62c0,.15,0,.29,0,.43l-.62-.39c0-.14,0-.29,0-.43l.62.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.92,148.54l-.64.63c0-.28-.07-.56-.1-.85.21-.21.42-.43.64-.64,0,.29.07.57.1.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05,138c-.19.21-.37.43-.57.64l-.21-.88.58-.66c.07.3.14.6.2.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,164.12l-.74.59c0-.26,0-.51,0-.77l.74-.59,0,.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.64,146.46c-.2.22-.41.43-.62.64,0-.29-.09-.57-.13-.86l.63-.64c0,.29.09.58.12.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.52,140.15c-.19.22-.39.43-.58.64-.06-.29-.13-.58-.19-.88.19-.22.39-.43.59-.65.06.3.13.59.18.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53,61.84c-.08.15-.17.3-.25.46-.28-.22-.56-.42-.84-.62l.25-.45.84.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.67,50.35l-.63.4-.53-.38.63-.4.53.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.32,144.37c-.2.22-.41.43-.62.64,0-.29-.09-.58-.14-.86l.61-.65c.05.29.11.58.15.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.94,142.27l-.59.64c-.06-.29-.12-.58-.17-.87l.6-.65c.05.29.11.58.16.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.26,93.58l-.63.86c-.11-.2-.21-.4-.31-.6L56,93l.31.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,63.44l-.84.64-.25-.47.84-.63c.08.15.16.31.25.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.78,100.13l-.57.88c-.12-.2-.23-.41-.35-.62l.58-.88.34.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.62,76.8c-.27.25-.52.51-.78.77-.09-.18-.17-.36-.25-.54.26-.26.51-.51.78-.76.07.18.16.35.25.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.36,192.64l0,.45c-.22-.14-.45-.27-.68-.4l0-.45.68.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,118.19c-.14.22-.29.43-.44.65-.14-.3-.27-.61-.41-.91l.45-.65c.13.3.27.6.4.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.26,50.32l-.61.4-.54-.38.61-.4.54.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.69,65.23l-.83.66c-.09-.16-.17-.32-.25-.48l.84-.65.24.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,174.44l-.79.53c0-.22.07-.45.1-.68l.8-.54c0,.23-.07.46-.11.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,177.57l-.81.52.12-.66.81-.52-.12.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.59,109l-.5.91-.39-.65c.17-.3.33-.6.49-.9.13.22.27.43.4.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5,93.79c-.1.2-.2.4-.31.6l-.64-.86c.11-.2.21-.4.31-.6.22.28.43.57.64.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.86,193.57c0,.14,0,.28,0,.43l-.61-.39c0-.14,0-.29,0-.43l.61.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.21,77c-.08.18-.16.36-.25.54-.26-.26-.51-.52-.78-.77.09-.18.18-.36.26-.54l.77.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.66,162.22l-.73.6c0-.26,0-.52,0-.78l.73-.6c0,.26,0,.52,0,.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.25,169.4l-.78.57c0-.24.05-.49.07-.73l.78-.57c0,.25,0,.49-.07.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,100.34c-.12.21-.23.42-.35.62-.19-.29-.38-.59-.58-.88.12-.2.24-.41.35-.62.2.29.39.59.58.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,89.21l-.68.84c-.11-.2-.2-.39-.3-.59l.68-.84c.09.19.19.39.3.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.79,80.8l-.75.8c-.09-.19-.18-.37-.26-.56.25-.26.49-.53.75-.79.08.18.17.37.26.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,120.36c-.16.21-.31.44-.46.65l-.39-.91.46-.65.39.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.52,191.59l.06.46-.71-.4c0-.16,0-.32-.06-.47l.71.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.11,85c-.24.26-.48.54-.71.81-.1-.19-.19-.38-.28-.57l.71-.82c.09.19.18.39.28.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.22,59.83l-.83.59c-.1-.15-.2-.3-.28-.44l.83-.59c.09.15.18.3.28.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.39,51.72l-.71.44-.44-.39.71-.43.44.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8,74.7l-.79.75c-.09-.17-.17-.35-.25-.53.26-.24.52-.5.79-.74.08.17.16.35.25.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.27,192.58c0,.15,0,.3,0,.44l-.66-.39c0-.15,0-.3,0-.46l.66.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.68,160.3l-.73.6c0-.26,0-.53,0-.8.25-.19.49-.4.73-.6,0,.27,0,.53,0,.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,81l-.27.55-.75-.79.27-.56.75.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49,102.23c-.19.29-.38.59-.56.89-.13-.21-.25-.42-.37-.63l.56-.89c.12.21.24.42.37.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.77,193.52c0,.15,0,.29-.06.43l-.59-.39c0-.15,0-.29.06-.43l.59.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.48,111.12c-.17.3-.33.6-.48.91-.14-.22-.28-.43-.41-.65.15-.3.31-.6.47-.9.14.22.27.43.42.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.83,95.63c-.21.28-.41.57-.62.86l-.33-.61L55.5,95l.33.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,122.53q-.22.33-.48.66c-.11-.31-.24-.61-.36-.91l.48-.66c.13.3.25.61.36.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.69,85.14c-.09.19-.18.39-.28.58-.23-.28-.47-.55-.72-.82.1-.19.2-.38.29-.57l.71.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.88,172.72l-.79.55c0-.24.06-.47.08-.7l.8-.56c0,.24-.06.48-.09.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.87,179l-.81.51c.05-.21.08-.43.12-.64l.82-.51c0,.21-.08.43-.13.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.41,167.59c-.26.19-.51.39-.77.57,0-.24,0-.49.05-.74l.77-.57c0,.25,0,.49-.05.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,74.88c-.08.18-.17.35-.25.53l-.8-.75c.09-.17.18-.35.26-.52.27.24.53.49.79.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.65,158.34c-.23.21-.47.41-.71.61l0-.8.71-.61c0,.27,0,.54,0,.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41,175.92l-.8.53c0-.22.07-.45.1-.67l.81-.53c0,.22-.07.45-.11.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,51.65l-.7.43c-.16-.12-.31-.25-.46-.38l.69-.44.47.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9,61.49c-.29.2-.56.4-.84.61l-.28-.45.84-.61.28.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.94,95.83l-.33.62-.63-.87.33-.61.63.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,124.71c-.16.22-.32.44-.49.65-.11-.3-.24-.6-.35-.9.16-.23.33-.44.49-.66.12.3.24.6.35.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,193.48a3.15,3.15,0,0,0-.09.42l-.58-.39.09-.43.58.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46,191.51c0,.16,0,.31,0,.47l-.7-.41,0-.47.71.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.91,78.63c-.26.26-.52.51-.77.77l-.27-.55.77-.77c.08.18.18.36.27.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,192.52c0,.15,0,.3,0,.44l-.66-.4c0-.15,0-.3,0-.45l.65.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,61.61c-.1.15-.19.31-.28.46l-.84-.61.28-.45.84.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.41,113.28c-.15.3-.31.6-.46.91l-.43-.65c.15-.3.3-.61.46-.91l.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,156.37l-.7.61c0-.27,0-.54,0-.81.24-.2.47-.42.7-.62,0,.27,0,.55.05.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.09,91.21c-.23.28-.45.56-.67.85-.11-.2-.21-.4-.31-.6l.66-.85.32.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.83,72.83l-.26.52-.81-.73.26-.52.81.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.24,104.35c-.19.29-.37.59-.55.89-.13-.21-.26-.42-.38-.64l.54-.89.39.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,165.75l-.76.58c0-.25,0-.51,0-.76l.77-.58,0,.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.85,126.88l-.51.66-.33-.91.51-.66.33.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.56,63.2l-.84.64-.27-.47.84-.63.27.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,51.58l-.69.44-.48-.39.68-.43c.17.12.33.25.49.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,78.81l-.27.55-.77-.78.27-.54.77.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.52,190.43l.06.48-.74-.42c0-.16,0-.32,0-.49l.73.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.09,171l-.79.55c0-.24,0-.47.07-.71.26-.19.52-.38.79-.56,0,.24,0,.48-.07.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.43,131c-.1.3-.2.6-.29.9-.19-.21-.36-.44-.54-.65.09-.3.19-.61.29-.91.17.22.36.44.54.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.47,154.37l-.69.62c0-.28,0-.55-.07-.83l.69-.62c0,.27,0,.55.07.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.53,86.89l-.7.83c-.11-.19-.2-.39-.3-.58l.7-.83.3.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45,97.69c-.21.29-.41.58-.61.88-.11-.21-.23-.42-.35-.62.21-.29.41-.59.61-.88l.35.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,113.49l-.44.65-.46-.91c.15-.21.29-.43.44-.65.15.31.31.61.46.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.34,63.34l-.28.47-.84-.64c.1-.15.19-.3.28-.46l.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.7,91.41c-.1.2-.2.4-.31.6-.23-.28-.45-.56-.67-.85l.32-.6.66.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.23,65l-.84.66-.27-.48.84-.65.27.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.59,68.71l-.83.69c-.09-.16-.18-.33-.26-.5l.82-.69c.08.17.18.33.27.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.57,129.05l-.53.66c-.1-.3-.2-.6-.31-.9l.53-.66c.11.3.21.6.31.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9,66.82l-.83.67A4.67,4.67,0,0,1,76.8,67l.83-.67.27.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.81,133.19c-.09.3-.19.6-.28.89l-.55-.65c.08-.3.18-.6.27-.9l.56.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,115.45l-.45.91c-.15-.22-.3-.43-.44-.65.14-.31.29-.61.44-.91l.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.26,51.53c-.22.15-.45.29-.68.43l-.5-.39.67-.43.51.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,177.38l-.81.52c0-.21.07-.43.1-.65l.81-.53c0,.22-.07.44-.1.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.32,152.34l-.68.63-.09-.83.68-.64.09.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.15,192.46c0,.15,0,.3-.05.44l-.64-.4c0-.15,0-.3.05-.45l.64.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.68,82.88l-.28.57c-.25-.26-.5-.53-.74-.8l.28-.57.74.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.67,174.23l-.8.54c0-.23,0-.45.08-.68l.8-.55c0,.23-.05.46-.08.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.23,135.35c-.08.29-.18.59-.25.89l-.58-.66c.09-.3.17-.59.25-.89.19.22.39.43.58.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28,87.09l-.3.59c-.24-.28-.47-.56-.71-.83.11-.2.2-.39.3-.59l.71.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.24,131.22l-.54.66c-.1-.3-.19-.6-.3-.9l.55-.66c.1.3.2.6.29.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,163.87l-.75.59c0-.25,0-.51,0-.77l.76-.59c0,.26,0,.51,0,.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.08,76.49l-.79.76L67,76.71,67.8,76c.09.18.18.36.28.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.4,191.44c0,.16,0,.31,0,.47-.23-.15-.46-.28-.69-.42,0-.15,0-.31,0-.47l.69.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.12,150.3l-.67.63c0-.28-.07-.56-.11-.84l.67-.64c0,.28.08.57.11.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.89,51.49l-.65.43-.52-.4.65-.42.52.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,106.47c-.18.3-.36.6-.53.9-.14-.21-.27-.42-.4-.64.18-.3.35-.6.53-.89l.4.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.86,133.38l-.56.66-.27-.9c.19-.21.38-.43.56-.66.1.3.18.61.27.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,115.66c-.14.22-.3.43-.45.65-.15-.3-.29-.61-.44-.91l.45-.65c.15.3.3.6.44.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.88,148.24l-.66.63c0-.28-.09-.56-.13-.85l.66-.64c0,.29.08.57.13.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,76.67c-.09.18-.18.36-.28.54l-.78-.76.27-.54.79.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,135.54l-.58.66c-.08-.3-.17-.6-.25-.9l.57-.66c.09.3.17.6.26.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.26,169.18l-.78.57.05-.73.78-.58c0,.25,0,.49-.05.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.63,93.23l-.66.86-.33-.61c.21-.29.43-.57.65-.86.11.21.22.41.34.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.54,51.46l-.65.42-.54-.4.64-.42.55.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.59,146.16l-.65.64-.15-.87.64-.64c.06.29.11.58.16.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,137.68l-.59.66c-.07-.3-.16-.59-.23-.89l.59-.66c.08.3.16.6.23.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25,144.06l-.63.64c-.05-.29-.11-.58-.17-.86l.63-.65c0,.29.12.58.17.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.48,190.34c0,.17,0,.33,0,.49l-.73-.42,0-.49.72.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.44,139.82c-.2.22-.4.44-.61.65-.06-.29-.14-.58-.21-.88l.61-.65.21.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,192.4c0,.15,0,.3-.07.45l-.62-.41c0-.15,0-.3.07-.45l.62.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.87,142l-.62.65c-.06-.3-.12-.59-.19-.88.2-.22.41-.43.62-.65.06.29.13.58.19.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,162l-.74.6c0-.26,0-.52,0-.78l.75-.6c0,.26,0,.52,0,.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.11,99.77l-.59.89c-.13-.21-.25-.42-.37-.63l.6-.88c.11.21.24.41.36.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,51.44l-.63.42-.55-.41.62-.41.56.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47,61.27l-.84.61-.3-.46.84-.6.3.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.24,80.48c-.25.27-.51.53-.76.79-.1-.18-.19-.37-.29-.56.25-.26.5-.53.76-.78.09.18.2.36.29.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.29,74.41l-.8.74-.28-.53.8-.74c.1.17.18.35.28.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.17,93.44l-.33.6-.66-.86c.12-.2.23-.4.34-.6.22.28.43.57.65.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.29,117.83c-.15.22-.31.44-.47.65l-.43-.91c.16-.21.32-.43.47-.65.15.3.29.6.43.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,88.87c-.23.27-.47.55-.69.83-.11-.19-.21-.39-.32-.59.23-.27.46-.56.7-.83l.31.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.37,191.37c0,.16,0,.31,0,.47l-.68-.42c0-.16,0-.31,0-.47l.68.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.89,172.51l-.8.55c0-.23,0-.47.06-.7l.8-.56c0,.24,0,.47-.06.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.87,108.62l-.51.89-.42-.64.51-.9c.14.22.29.43.42.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.43,175.72l-.81.54c0-.23,0-.45.08-.67l.81-.54c0,.23,0,.45-.08.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.61,80.67l-.29.56c-.26-.26-.51-.53-.76-.79.09-.19.19-.37.29-.56l.76.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58,74.58l-.28.53-.8-.74.28-.53.8.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,160l-.73.61c0-.26,0-.53,0-.8l.74-.6c0,.26,0,.53,0,.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,167.36l-.77.57c0-.24,0-.49,0-.74l.78-.58,0,.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.14,63l-.85.63c-.1-.16-.19-.32-.29-.47l.84-.63.3.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.06,192.36c0,.14-.06.29-.08.44l-.61-.41c0-.15,0-.3.08-.45l.61.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.83,89.07c-.1.19-.21.39-.33.59-.22-.28-.46-.56-.69-.84l.32-.59c.23.28.47.55.7.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.21,120l-.49.66c-.13-.31-.27-.61-.41-.91l.49-.66c.14.3.28.61.41.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,84.81c-.1.19-.2.38-.31.57l-.73-.81c.11-.19.21-.39.31-.58.24.27.49.54.73.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,63.11c-.09.15-.19.31-.3.47-.28-.22-.55-.43-.84-.63l.3-.47.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.46,190.26c0,.17,0,.33,0,.49-.24-.14-.48-.28-.71-.43a4,4,0,0,1,0-.49c.23.15.47.29.71.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2,95.27l-.64.87-.35-.61.64-.87c.11.21.24.41.35.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8,64.74l-.84.65-.3-.48.85-.64c.09.16.19.31.29.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.82,101.87l-.58.89-.39-.63.58-.89c.13.21.25.43.39.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.83,70.38l-.83.71-.28-.51.82-.71.29.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61,158.07l-.72.62-.06-.81.73-.61c0,.27,0,.54.05.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.39,78.31l-.78.78-.29-.55c.26-.26.51-.52.78-.77.09.18.19.36.29.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.32,57.69c-.28.18-.55.37-.82.56-.12-.15-.24-.29-.35-.44l.82-.55.35.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.76,110.77c-.17.3-.34.6-.49.9-.15-.21-.3-.43-.44-.65.16-.3.33-.6.5-.9l.43.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.35,191.3c0,.16,0,.32,0,.47l-.67-.42c0-.15,0-.31,0-.47.22.14.44.29.67.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.46,66.56l-.84.68-.29-.49.84-.67.29.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.14,68.45q-.42.33-.84.69l-.28-.5.83-.69c.09.17.19.33.29.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.45,189.14l0,.5-.74-.43c0-.17,0-.34,0-.51l.75.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.12,64.88l-.3.48-.84-.65.3-.47.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,192.31c0,.15-.08.29-.11.44l-.59-.41c0-.15.07-.3.1-.45l.6.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.08,122.18l-.5.66c-.13-.3-.26-.61-.4-.91l.51-.66.39.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,52.81l-.71.46-.49-.4.72-.46c.16.14.31.27.48.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,170.75l-.79.56c0-.24,0-.48,0-.72l.79-.56c0,.24,0,.48,0,.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,165.51l-.77.58c0-.25,0-.5,0-.75l.77-.59c0,.25,0,.5,0,.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,102.08c-.13.21-.25.42-.39.63l-.58-.88c.13-.22.27-.42.39-.63.2.29.39.59.58.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.48,78.5l-.3.55-.78-.78.3-.55.78.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.53,156.09l-.72.62c0-.27-.05-.54-.07-.82l.71-.62c0,.28.06.55.08.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,111l-.44.64c-.16-.3-.33-.6-.5-.9.15-.22.3-.43.44-.65.17.3.34.6.5.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,90.86l-.69.85-.33-.6.68-.84c.11.2.22.4.34.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.66,174l-.81.55c0-.23,0-.46.06-.69l.81-.55c0,.23,0,.46-.06.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.61,82.37c-.25.27-.51.53-.75.8-.11-.19-.21-.38-.31-.57l.75-.8c.1.19.2.38.31.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.9,124.36l-.52.66c-.12-.31-.25-.61-.37-.91l.52-.66.37.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.08,61.07q-.42.28-.84.6l-.32-.46.84-.6c.1.16.21.3.32.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37,52.75l-.7.45-.5-.41.69-.44.51.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,86.56l-.72.82-.32-.58.72-.83c.1.2.21.39.32.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7,112.93l-.48.91c-.15-.22-.31-.44-.45-.66q.23-.45.48-.9l.45.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,104c-.19.3-.38.59-.56.89l-.41-.63.57-.9.4.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.41,154.09l-.71.62c0-.27-.06-.55-.1-.82l.71-.63c0,.27.07.55.1.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.59,76.19l-.8.76-.3-.54.8-.76c.1.18.19.36.3.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46,190.19c0,.16,0,.32,0,.48l-.7-.43c0-.16,0-.32,0-.49l.71.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.34,191.24c0,.16,0,.31-.07.47l-.65-.42.06-.47.66.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,91.06c-.11.21-.23.4-.34.61l-.69-.85c.12-.2.23-.4.34-.6l.69.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.25,82.56c-.1.19-.2.38-.31.57-.25-.27-.51-.53-.75-.8l.31-.57.75.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.67,126.54c-.18.22-.36.43-.53.66l-.36-.91.54-.66c.12.3.23.6.35.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.83,97.34l-.63.87-.37-.62.63-.87.37.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.57,163.62l-.76.6c0-.26,0-.51,0-.77l.76-.6c0,.26,0,.52,0,.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.87,86.75c-.1.2-.21.39-.32.59l-.73-.83.33-.58.72.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.64,130.69c-.1.3-.21.6-.32.9l-.56-.66c.11-.3.21-.6.31-.9l.57.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,52.7l-.68.45-.53-.42.69-.44.52.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,76.37l-.3.54-.8-.76.3-.54.8.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.24,152.06l-.7.63c0-.28-.07-.56-.11-.84l.69-.63.12.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.23,169l-.79.58c0-.25,0-.49,0-.73l.8-.58c0,.25,0,.49,0,.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.06,113.13l-.46.66c-.16-.31-.32-.61-.49-.91l.46-.65c.17.3.33.6.49.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.46,189.05a4.34,4.34,0,0,0,0,.51l-.74-.44c0-.17,0-.34,0-.51l.74.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,59.25l-.83.58-.35-.45.83-.57.35.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.39,128.71l-.54.66c-.12-.3-.23-.6-.34-.9l.55-.66.33.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.75,62.76c-.29.2-.56.42-.84.62-.12-.15-.22-.31-.33-.46.28-.21.56-.42.85-.62l.32.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,132.86c-.1.3-.21.59-.3.89-.19-.22-.39-.43-.57-.66.09-.29.19-.6.29-.89l.58.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.69,115.09l-.47.91c-.16-.21-.31-.43-.47-.65l.46-.91.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,150l-.69.64c0-.28-.09-.56-.14-.84l.69-.64c.05.28.09.56.14.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.42,135l-.27.89-.59-.66.27-.89.59.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,52.65l-.67.45-.54-.42c.23-.14.45-.29.67-.44l.54.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,175.54l-.82.53c0-.22,0-.45.06-.67l.82-.54-.06.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.19,62.89l-.32.46-.84-.62.32-.46.84.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,130.88l-.56.66c-.11-.3-.22-.59-.32-.9l.56-.66c.11.3.22.6.32.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.86,172.3l-.8.55,0-.7.81-.56c0,.24,0,.48,0,.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.34,191.19c0,.15-.06.31-.08.46l-.64-.42c0-.16,0-.32.08-.47l.64.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.59,161.71l-.75.6c0-.26,0-.52,0-.78l.76-.6,0,.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.74,80.17,66,81c-.1-.19-.2-.38-.31-.57l.77-.78c.1.19.21.37.32.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.77,147.94l-.67.64c0-.28-.11-.57-.16-.86l.68-.64.15.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,106.12c-.19.3-.37.6-.55.9l-.42-.65.55-.89.42.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,92.89l-.67.85c-.12-.2-.24-.4-.35-.61.22-.28.44-.57.67-.85l.35.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,133.05l-.58.66-.3-.9c.2-.22.39-.43.58-.66l.3.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.47,190.12c0,.16,0,.32,0,.48l-.69-.43c0-.16,0-.33,0-.49l.69.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.41,64.51l-.85.65-.32-.48.85-.64c.1.16.2.31.32.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.41,52.62l-.66.44-.55-.42.65-.43.56.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,115.3l-.47.66-.47-.91.47-.65c.16.3.32.6.47.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.47,145.85l-.66.64-.18-.86.67-.64c0,.28.12.57.17.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,72.09l-.82.72c-.11-.17-.2-.35-.31-.52l.83-.72c.09.17.2.34.3.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.28,135.21l-.6.66c-.09-.3-.18-.6-.28-.9l.6-.66c.1.3.19.6.28.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.12,143.75l-.64.65c-.06-.29-.14-.58-.2-.87l.65-.65c.07.29.14.58.19.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.14,80.35l-.31.56-.78-.78c.11-.19.21-.38.32-.56l.77.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.81,137.36l-.61.66c-.08-.3-.17-.59-.26-.89l.61-.66.26.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53,64.65c-.1.16-.21.32-.32.48l-.84-.65c.11-.16.22-.31.32-.47.28.21.57.42.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,99.42l-.62.88-.39-.62.62-.88c.12.21.26.42.39.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,167.13l-.78.58V167l.78-.58c0,.25,0,.5,0,.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.73,141.63l-.63.65c-.07-.29-.15-.58-.22-.87l.63-.65c.08.29.15.58.22.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.29,139.5l-.62.66c-.07-.3-.16-.59-.24-.89l.63-.65c.07.29.16.59.23.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,84.29l-.75.81L63,84.52l.74-.81c.1.19.21.39.33.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.06,66.32l-.84.67c-.11-.16-.21-.33-.31-.49l.84-.67c.1.17.2.33.31.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4,70.11l-.83.71c-.11-.17-.21-.35-.31-.52.28-.23.56-.46.83-.7.1.18.2.34.31.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.73,68.19l-.84.69c-.11-.17-.21-.34-.31-.51l.83-.68c.1.17.21.33.32.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.72,60.87l-.84.6c-.12-.15-.23-.31-.34-.46l.83-.59.35.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.58,159.77l-.75.61-.06-.79.75-.61c0,.26,0,.53.06.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.48,189c0,.17,0,.33,0,.5l-.73-.44c0-.17,0-.34,0-.51l.73.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.36,191.13c0,.16-.08.31-.11.47-.2-.15-.41-.29-.62-.43,0-.16.07-.31.11-.47.2.15.41.29.62.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.87,66.46l-.31.5-.85-.67c.11-.16.22-.32.32-.49l.84.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.39,187.81c0,.17,0,.34,0,.52l-.75-.45c0-.18,0-.35,0-.53l.76.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.52,70.27l-.31.51-.83-.7.31-.51.83.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,117.47l-.49.66-.45-.9.49-.66.45.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,84.48l-.33.58-.74-.82.33-.57.74.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.21,68.34c-.11.17-.22.33-.32.5l-.84-.68.32-.5.84.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,88.73l-.34.59-.71-.83.35-.6.7.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.22,108.26l-.54.9c-.14-.22-.29-.43-.44-.64l.54-.9.44.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.92,78l-.79.77-.32-.55.79-.77.32.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,170.53l-.81.57c0-.24,0-.48,0-.72l.81-.57c0,.24,0,.48,0,.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.69,59.08l-.83.57-.37-.45.83-.57.37.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,190.05a3.93,3.93,0,0,0-.06.48l-.68-.44a3.93,3.93,0,0,1,.06-.48l.68.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.61,173.83c-.26.19-.54.37-.81.55,0-.23,0-.45,0-.68l.81-.56c0,.23,0,.46,0,.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.52,157.81l-.74.62c0-.27-.05-.54-.08-.81l.74-.62c0,.27.06.54.08.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.43,165.27c-.25.2-.52.39-.78.59,0-.25,0-.51,0-.76.27-.2.53-.39.78-.59,0,.25,0,.51,0,.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,78.19l-.32.55-.79-.77.32-.55.79.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.63,94.93c-.22.29-.44.57-.66.87l-.37-.62.66-.86c.12.2.24.41.37.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,119.65l-.51.66c-.14-.3-.29-.6-.43-.91.17-.22.34-.43.51-.66.14.31.29.61.43.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.39,62.55c-.29.2-.56.41-.85.62l-.34-.47.84-.62c.11.16.23.32.35.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.21,101.53l-.6.88-.41-.64.6-.88.41.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.12,82.05l-.76.8q-.18-.28-.33-.57c.25-.27.5-.53.76-.79.1.19.22.37.33.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.14,75.9c-.27.25-.54.5-.8.76L70,76.11l.8-.75c.1.18.21.36.32.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.11,110.42c-.18.29-.35.6-.52.9l-.46-.65c.17-.31.35-.61.52-.9l.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.52,188.89l0,.5-.72-.44c0-.17,0-.34,0-.51l.71.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42,155.82c-.24.21-.48.42-.73.62,0-.27-.06-.54-.1-.81l.73-.63c0,.27.08.55.1.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.83,121.83c-.17.23-.35.44-.52.67l-.42-.91.53-.66.41.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.6,101.73c-.13.21-.27.42-.41.63-.19-.29-.4-.59-.6-.88.14-.21.28-.42.41-.63.2.29.41.58.6.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54,190l-.09.49-.66-.44c0-.16,0-.33.08-.49l.67.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,187.71c0,.18,0,.35,0,.52l-.75-.45c0-.17,0-.35,0-.53l.75.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.46,86.23c-.24.28-.49.55-.73.82l-.35-.58.74-.83c.1.2.23.4.34.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.43,191a4.11,4.11,0,0,0-.15.46l-.6-.43c0-.16.1-.31.16-.47l.59.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.77,76.07l-.32.54-.81-.75c.11-.18.22-.36.32-.54l.81.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,82.24c-.1.19-.22.38-.33.57l-.76-.8.33-.57.76.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,64.29l-.84.64-.34-.48.84-.64.34.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.16,168.73l-.8.58v-.73l.79-.58c0,.25,0,.49,0,.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.48,163.38l-.78.6c0-.26,0-.51,0-.77l.78-.6c0,.26,0,.51,0,.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.11,54l-.71.47-.52-.43.71-.47.52.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.68,110.62l-.46.65-.52-.9.46-.65.52.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.38,60.68l-.83.6-.37-.46.84-.59.36.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28,153.81l-.72.63c0-.28-.07-.55-.12-.83l.73-.63c0,.28.08.55.11.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,73.83l-.81.74L72.26,74l.82-.73c.1.18.21.36.32.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.91,64.42l-.34.48-.84-.64.34-.48.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.65,124c-.17.23-.35.45-.54.67-.12-.31-.26-.61-.39-.91l.54-.66.39.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41,86.42c-.11.2-.23.4-.35.59-.24-.28-.49-.55-.73-.82l.35-.59.73.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,103.64c-.2.3-.39.6-.59.89l-.42-.64.58-.89c.14.22.29.43.43.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.05,112.58c-.17.3-.34.6-.5.91-.17-.22-.32-.44-.48-.66l.5-.91.48.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,66.09l-.85.66-.33-.49.84-.66c.11.16.22.33.34.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.26,97l-.64.87-.39-.63.64-.87.39.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.48,191l-.18.47-.58-.43.18-.48.58.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52,74l-.33.53-.82-.73c.12-.18.23-.36.33-.53l.82.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,71.82l-.83.72c-.12-.18-.22-.35-.33-.53l.83-.71.33.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.83,53.91l-.7.47-.54-.43.7-.46.54.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,151.77l-.71.64c0-.28-.09-.56-.14-.84.24-.21.48-.42.71-.64,0,.28.1.56.14.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.35,68l-.84.68-.33-.51.84-.68.33.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,126.19c-.18.23-.37.45-.56.67-.12-.3-.24-.6-.37-.9.18-.23.37-.45.55-.67.13.3.26.6.38.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.28,79.86l-.78.79-.33-.57L68,79.3l.33.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,69.85l-.84.71L76.85,70l.83-.7c.11.17.22.34.34.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.26,66.23l-.34.49-.84-.66.34-.49q.42.32.84.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.6,189.92c0,.16-.08.32-.11.48l-.66-.44c0-.16.07-.32.11-.49l.66.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,188.81l-.06.5-.7-.44a4.43,4.43,0,0,1,.06-.51l.7.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,161.46l-.76.61c0-.26-.05-.52-.07-.78l.77-.61q0,.39.06.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.91,130.36c-.12.3-.23.6-.34.9-.2-.22-.39-.45-.58-.67l.33-.9.59.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,72l-.33.52-.83-.72.33-.52.83.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.74,112.78q-.23.33-.48.66l-.5-.91.48-.65c.17.3.34.6.5.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.88,149.72l-.7.64c-.05-.28-.11-.57-.16-.85l.7-.64c.05.28.11.56.16.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6,68.09l-.34.5-.84-.68c.12-.16.23-.33.34-.5l.84.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.56,53.87l-.69.46-.56-.43.69-.46.56.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.93,70l-.33.51-.84-.7.33-.51.84.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.16,128.37l-.57.67-.36-.9.57-.67.36.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.26,166.9l-.8.59c0-.25,0-.5,0-.75l.79-.59,0,.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.27,132.53c-.11.3-.22.6-.32.9-.21-.22-.4-.44-.6-.66.1-.3.21-.6.32-.9l.6.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,80l-.33.57c-.27-.26-.53-.52-.79-.79l.34-.56.78.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,114.75l-.48.91-.49-.66.48-.91.49.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.51,187.62l0,.53-.74-.46,0-.53.74.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,62.35l-.85.62-.36-.47.84-.62.37.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,92.55c-.24.28-.47.57-.69.86l-.38-.62c.23-.28.45-.57.69-.85.12.21.24.41.38.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.68,134.7c-.1.3-.21.59-.3.89l-.61-.66.3-.89.61.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.61,147.64l-.69.65-.18-.86.69-.64.18.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.54,84l-.75.81-.35-.58c.24-.28.5-.54.75-.81l.35.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,130.55l-.59.66c-.11-.3-.22-.59-.34-.89l.59-.67.34.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.29,53.83l-.67.46-.58-.43.67-.46.58.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77,105.77l-.57.9c-.15-.21-.3-.43-.44-.65l.57-.89c.14.22.29.43.44.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,88.2l-.73.84-.36-.6.72-.83.37.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3,145.55l-.68.65c-.06-.29-.13-.57-.2-.86l.68-.65c.06.29.13.58.2.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,132.72l-.6.67c-.1-.3-.21-.6-.32-.9l.6-.67c.11.3.22.6.32.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.67,189.86c0,.16-.09.33-.14.49l-.63-.45.12-.49.65.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.45,159.52l-.76.61c0-.26-.05-.53-.08-.79.25-.21.5-.42.76-.62,0,.27.06.53.08.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.49,77.72l-.8.77-.34-.56.8-.77.34.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,115l-.5.66-.48-.91.49-.65c.17.29.33.6.49.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,143.45l-.66.65c-.07-.29-.14-.58-.23-.87l.67-.66c.08.29.15.58.22.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.94,99.08c-.22.29-.43.59-.63.88l-.42-.63c.22-.29.42-.59.64-.88.13.21.27.42.41.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.06,134.89l-.62.66c-.09-.3-.19-.6-.3-.89.21-.22.42-.44.62-.67l.3.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.35,84.15c-.11.2-.23.39-.35.59l-.76-.81.35-.58.76.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.08,60.51l-.84.59-.39-.47.84-.58c.13.15.25.31.39.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54,141.32l-.65.66c-.08-.29-.16-.59-.25-.88l.66-.66.24.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.6,137l-.63.66-.28-.88.63-.67c.09.3.19.6.28.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.66,188.74c0,.17-.06.33-.08.5l-.7-.45c0-.17.06-.34.08-.51l.7.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.09,139.19l-.64.66c-.08-.3-.17-.59-.26-.88l.64-.67c.09.3.18.59.26.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.93,88.39c-.12.2-.24.4-.37.6l-.72-.83.37-.59.72.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.43,77.89c-.11.19-.22.37-.34.55l-.8-.76c.11-.19.23-.37.34-.55.27.25.54.5.8.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,64.08l-.85.64-.36-.49.84-.63.37.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,165c-.27.19-.53.39-.79.59,0-.25,0-.51-.05-.76.27-.2.53-.39.79-.6,0,.26,0,.51,0,.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,157.55l-.75.62c0-.27-.07-.54-.11-.81.25-.2.51-.41.75-.62,0,.27.07.54.11.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.74,75.62q-.4.36-.81.75l-.35-.55.82-.75c.1.19.22.36.34.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.73,117.13l-.52.66-.47-.91c.17-.22.35-.44.51-.66l.48.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,107.92c-.19.3-.37.59-.55.9-.16-.22-.31-.44-.47-.65l.56-.9.46.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,189.81c-.06.16-.11.32-.16.48l-.62-.44.15-.49.63.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,187.54l-.06.52-.73-.46.06-.53.73.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,186.33a4.84,4.84,0,0,0,0,.53l-.76-.46c0-.19,0-.37,0-.55l.76.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.68,81.75l-.77.79L66.55,82l.78-.8.35.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.11,94.59l-.67.87-.4-.62c.23-.29.45-.58.68-.86l.39.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.37,65.87c-.29.21-.57.43-.85.65-.13-.16-.24-.33-.36-.49l.85-.66c.11.17.23.33.36.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,73.56l-.82.73c-.12-.17-.23-.36-.35-.53l.83-.73.34.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75,188.67c0,.17-.07.34-.1.5l-.69-.45c0-.17.07-.34.11-.51l.68.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66,101.18c-.21.3-.42.59-.62.89l-.43-.64.62-.88.43.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.26,155.55l-.74.63-.12-.82.74-.63.12.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,67.71l-.84.68c-.12-.18-.24-.34-.36-.51l.85-.68.35.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.64,119.31l-.52.66c-.15-.3-.3-.6-.46-.9l.53-.67c.16.3.31.6.45.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.23,81.93c-.12.19-.23.38-.36.57-.25-.27-.51-.53-.77-.79.12-.19.24-.38.35-.57l.78.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.76,62.16l-.84.61c-.14-.15-.26-.31-.39-.47l.84-.61.39.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.34,163.14l-.78.61c0-.26,0-.52-.07-.78l.78-.6c0,.26,0,.52.07.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.48,90.2l-.72.84c-.13-.2-.26-.4-.38-.6l.71-.84c.12.2.26.4.39.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.34,71.56l-.84.71-.35-.52L77,71l.35.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.67,69.61l-.85.69-.35-.52.84-.69.36.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.84,189.76c-.06.16-.12.32-.17.48l-.62-.44.18-.49.61.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.92,73.72l-.34.54-.83-.73.35-.54.82.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.52,110.07c-.19.3-.37.6-.55.9-.16-.21-.32-.43-.47-.65q.26-.45.54-.9c.15.22.31.44.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.62,71.71l-.35.53-.84-.72.36-.52.83.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,60.34c-.27.19-.54.4-.82.59l-.41-.47.82-.58.41.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.3,69.75l-.36.52-.84-.7.36-.51.84.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.86,55.23l-.73.49-.53-.44.72-.49.54.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,86.1l-.37.59-.75-.82c.13-.19.25-.39.37-.59l.75.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11,153.54l-.73.63-.15-.83.73-.63c.06.27.1.55.15.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,121.49l-.54.67c-.14-.31-.29-.61-.44-.91.18-.22.37-.44.54-.66.15.3.3.6.44.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.71,187.46c0,.17-.06.35-.08.52l-.72-.46c0-.18,0-.36.08-.53l.72.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.87,79.57l-.79.78-.36-.57.8-.78c.11.19.24.38.35.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.31,110.27l-.48.66c-.18-.31-.36-.6-.55-.9l.49-.66.54.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.94,189.72l-.2.48-.59-.45c.06-.16.13-.33.2-.49.19.16.39.31.59.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,188.61c0,.16-.09.33-.13.5l-.67-.46c0-.17.08-.34.13-.5l.67.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.56,186.23c0,.18,0,.36-.06.54l-.75-.47c0-.18,0-.36,0-.54l.76.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.76,96.66l-.67.87c-.14-.21-.28-.42-.41-.63.21-.29.44-.58.66-.87q.19.31.42.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.33,161.22l-.78.61-.09-.78.78-.62.09.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.66,125.67c-.14.3-.27.6-.4.9l-.57-.66c.13-.31.26-.61.4-.91l.57.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.42,63.88l-.85.63c-.12-.17-.26-.33-.38-.49l.84-.63.39.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.91,151.49l-.72.64c-.05-.28-.11-.55-.17-.83l.73-.64c.06.27.11.56.16.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.42,103.3l-.6.89-.45-.64.6-.89.45.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.06,79.74l-.36.57-.8-.78c.12-.19.25-.38.36-.57l.8.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.62,55.18l-.71.48-.56-.44.72-.48.55.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.35,123.68l-.56.66-.42-.9.56-.67.42.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.46,112.24c-.18.3-.36.6-.53.9l-.49-.66c.17-.3.34-.6.52-.9l.5.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.92,127.85c-.13.3-.26.61-.38.91-.2-.22-.39-.45-.58-.67l.37-.9c.2.21.4.44.59.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.12,83.66l-.77.81L66,83.88c.26-.26.51-.53.77-.8.12.19.24.39.37.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.68,149.43l-.72.65-.18-.85.71-.65c.07.29.12.57.19.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.11,77.43l-.81.77-.36-.56.81-.76c.11.18.24.37.36.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.13,125.86c-.19.22-.38.45-.58.67-.12-.3-.26-.6-.4-.91l.58-.66.4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39,55.13l-.7.49-.57-.46.7-.47.57.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,92.23l-.7.84c-.14-.2-.27-.4-.4-.61.23-.29.46-.57.7-.85l.4.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.23,130l-.36.9-.6-.67.36-.9.6.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.37,112.44l-.5.66c-.17-.31-.35-.61-.52-.91l.5-.66.52.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.07,65.65l-.85.65c-.13-.16-.26-.33-.38-.5l.84-.64.39.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,188.55a4.13,4.13,0,0,0-.15.5l-.66-.46.15-.51.66.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.49,62c-.29.2-.56.41-.84.61l-.41-.48.84-.6a6,6,0,0,0,.41.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.83,187.38c0,.18-.07.35-.1.52l-.71-.46c0-.18.07-.35.1-.53l.71.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.27,159.27l-.77.62c0-.27-.06-.53-.1-.8l.77-.62c0,.27.07.53.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.4,147.36l-.71.64-.21-.85.71-.65.21.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.59,132.21c-.12.3-.23.6-.34.9l-.62-.67c.11-.3.22-.6.34-.9.2.23.41.45.62.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.86,128c-.19.23-.39.45-.59.67-.12-.3-.25-.6-.38-.9l.59-.67c.13.3.26.6.38.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,77.6l-.37.56-.81-.77c.13-.18.25-.37.37-.55l.81.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8,83.84l-.37.59-.77-.81L177,83c.26.27.52.53.77.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.17,55.1l-.69.48-.59-.46.69-.47.59.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.44,114.41l-.51.91-.51-.66c.17-.31.33-.61.51-.91.16.22.34.44.51.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,134.38c-.11.3-.22.6-.32.9l-.63-.67c.11-.3.21-.6.32-.89l.63.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.85,92.41l-.4.62-.71-.85.41-.61.7.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.44,136.55c-.11.29-.21.59-.31.88l-.64-.66.3-.89.65.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.38,75.34l-.82.75c-.13-.18-.25-.37-.36-.55.27-.25.54-.5.82-.74.11.18.24.36.36.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.23,105.43c-.2.3-.4.6-.59.9-.16-.22-.31-.44-.47-.65.2-.3.4-.6.59-.9.16.22.31.44.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.07,145.26l-.69.65c-.07-.29-.15-.57-.23-.86l.69-.66c.08.29.15.58.23.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.55,130.22c-.2.23-.4.45-.61.67-.11-.3-.24-.6-.36-.9.2-.22.41-.44.6-.67.13.3.25.61.37.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.46,184.89c0,.19,0,.37-.06.56l-.76-.48a5.48,5.48,0,0,1,0-.57l.77.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.41,88.07c-.13.2-.26.4-.4.6l-.73-.83.39-.6c.24.28.49.55.74.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.69,186.14c0,.18,0,.36-.08.54l-.74-.47c0-.18,0-.36.08-.55l.74.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.71,67.48l-.85.67c-.13-.17-.25-.33-.37-.51.28-.22.56-.45.84-.66l.38.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.44,98.75l-.65.87L58.35,99l.65-.88.44.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.7,143.15l-.68.65c-.08-.29-.17-.58-.25-.87l.69-.65.24.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.19,132.4l-.62.67c-.11-.3-.23-.6-.35-.9.21-.22.42-.44.62-.67l.35.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.58,75.5c-.12.18-.24.37-.37.55l-.82-.75.37-.54.82.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.69,73.3l-.84.73c-.12-.18-.25-.36-.36-.54.27-.25.55-.49.83-.73l.37.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.38,114.61l-.51.66-.51-.9.52-.66.5.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.29,141l-.67.66-.27-.88.67-.66c.1.29.19.59.27.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.78,134.57l-.63.66c-.1-.3-.22-.59-.32-.89l.63-.66c.1.29.21.59.32.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.36,69.37c-.28.23-.57.45-.85.69-.12-.18-.25-.35-.37-.52l.84-.69.38.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.28,67.62l-.38.5-.85-.67.39-.5.84.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.83,138.88l-.66.66-.28-.88.66-.67c.09.3.19.59.28.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.33,136.73l-.64.66c-.11-.29-.21-.59-.31-.88l.65-.67.3.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,71.31l-.84.71-.37-.53.84-.71c.13.17.25.35.37.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,157.29c-.25.22-.5.42-.76.63,0-.27-.08-.54-.13-.81l.77-.63c0,.27.09.54.12.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.29,81.45c-.26.26-.52.53-.79.79-.12-.19-.25-.38-.37-.58l.78-.78.38.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.11,188.49c-.06.17-.12.33-.17.5l-.65-.46.18-.51.64.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.29,73.45l-.37.54-.84-.73.37-.53.84.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,71.45c-.12.18-.25.36-.38.53l-.84-.71.38-.52.84.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,187.31l-.12.52-.7-.47c0-.17.08-.35.13-.53l.69.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.15,63.69l-.84.62c-.14-.16-.28-.32-.41-.49l.84-.62.41.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.65,81.62l-.38.58-.79-.79c.13-.19.26-.38.38-.57l.79.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.65,94.27l-.69.86c-.15-.21-.28-.42-.42-.63l.69-.85.42.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.08,107.58l-.57.89c-.16-.21-.33-.43-.48-.65l.57-.89.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,116.79l-.53.66-.49-.9.53-.67c.17.3.33.6.49.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.05,155.29l-.75.63-.15-.81.75-.64c.06.28.1.55.15.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,89.88l-.72.84c-.15-.2-.28-.41-.41-.61l.73-.83c.13.2.26.4.4.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.26,188.44c-.07.17-.14.33-.2.5l-.63-.46c.06-.17.13-.34.2-.51l.63.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.24,61.82c-.28.19-.56.4-.84.6-.14-.16-.28-.33-.43-.48l.84-.6.43.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.16,100.85c-.21.29-.43.58-.63.88l-.46-.64c.21-.3.43-.59.64-.88l.45.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.84,186.06c0,.18-.07.36-.1.54l-.73-.48c0-.18.07-.36.1-.54l.73.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.25,94.46l-.42.62-.7-.86.43-.62.69.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.51,79.28l-.8.78-.38-.57c.26-.27.53-.52.8-.78l.38.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,184.8c0,.18-.06.37-.08.55l-.76-.48c0-.19,0-.38.08-.57l.76.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.33,85.78c-.12.2-.26.4-.39.6l-.76-.81c.13-.2.27-.4.39-.6.26.28.52.54.76.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8,65.45l-.85.64c-.14-.16-.27-.33-.4-.5L87.4,65l.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.28,119c-.19.22-.36.45-.55.67-.15-.31-.32-.61-.48-.91.19-.22.37-.44.55-.67l.48.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.87,90.07l-.4.61-.73-.84.41-.61.72.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.88,153.27l-.74.63c0-.27-.11-.55-.17-.82l.74-.64c.06.27.12.55.17.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13,187.24l-.15.52-.68-.47c0-.17.09-.35.15-.53l.68.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.45,79.45l-.39.57-.8-.78c.13-.19.26-.38.38-.57l.81.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.72,101c-.15.22-.3.43-.46.64l-.64-.88c.16-.21.31-.42.46-.64.22.29.43.59.64.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,109.74c-.19.29-.38.59-.56.9-.17-.22-.33-.45-.5-.66.18-.3.37-.6.56-.9l.5.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.41,188.39c-.07.17-.15.33-.22.5l-.61-.47c.07-.16.14-.33.22-.5.21.15.41.32.61.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.77,77.15l-.82.76c-.13-.18-.26-.37-.38-.56.27-.25.54-.51.82-.75l.38.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.15,121.16l-.56.67c-.15-.31-.31-.61-.46-.91.19-.22.38-.44.56-.67.16.3.31.6.46.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.44,67.27l-.85.66-.4-.51.85-.67c.13.18.27.34.4.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,151.22c-.24.22-.49.43-.74.64-.05-.27-.12-.55-.19-.83l.74-.65c.07.28.13.56.19.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,96.33l-.68.87-.44-.63.68-.87c.14.22.29.42.44.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.75,83.36l-.78.81-.4-.59.78-.8c.13.19.26.39.4.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.88,109.93l-.5.66c-.19-.3-.37-.6-.57-.9l.51-.65c.18.3.38.59.56.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.93,103l-.62.88-.47-.64.62-.89.47.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.91,63.51l-.84.62-.43-.5.84-.61.43.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,67.39l-.4.51-.85-.66.4-.51.85.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.49,183.42a5.58,5.58,0,0,0-.08.57l-.78-.5c0-.19.05-.38.08-.58l.78.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,186c0,.18-.09.36-.13.54l-.72-.48c0-.18.08-.37.13-.55l.72.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.07,75.07l-.83.75c-.13-.19-.27-.37-.39-.55l.83-.75.39.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.05,125.34l-.42.91-.59-.67.42-.91c.19.23.39.45.59.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.58,188.35l-.24.5-.6-.47.24-.51.6.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.08,69.14l-.85.68c-.13-.17-.27-.34-.39-.52l.84-.68c.13.17.26.35.4.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,123.35l-.57.67-.45-.91c.2-.22.39-.45.58-.67.15.3.3.6.44.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3,187.18c-.06.17-.12.35-.17.52l-.67-.48c.05-.17.11-.34.17-.52l.67.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.92,111.9c-.19.3-.37.6-.55.9l-.51-.66.54-.9.52.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,83.54l-.39.58-.79-.8c.14-.19.27-.39.4-.58.26.26.53.53.78.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42,149.16l-.73.65c-.06-.29-.14-.57-.21-.85l.73-.65.21.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.62,91.9l-.72.85-.42-.62c.24-.28.47-.56.72-.84.13.21.28.41.42.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.39,73.05l-.84.72q-.21-.27-.39-.54c.28-.25.56-.48.83-.73l.4.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.05,159l-.78.62c0-.26-.09-.52-.13-.79l.78-.62c0,.26.09.53.13.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.24,56.45l-.72.5-.59-.47.71-.5.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.73,71.06c-.29.24-.56.48-.85.71l-.39-.53.84-.7.4.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8,184.7c0,.19-.07.37-.1.56l-.76-.49c0-.19.07-.37.1-.56l.76.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.92,75.23l-.39.55L167.7,75l.39-.55.83.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.31,127.53c-.14.3-.27.6-.4.9-.21-.22-.41-.44-.6-.67l.39-.9c.2.23.4.45.61.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.92,69.27l-.39.52-.85-.68c.13-.18.27-.35.4-.52l.84.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,103.16c-.15.22-.31.43-.47.65l-.63-.89.48-.64.62.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.77,125.53l-.6.68c-.13-.31-.27-.61-.42-.91l.59-.67.43.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,73.19l-.39.55-.85-.73.4-.54.84.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.12,147.07c-.24.22-.47.44-.72.65-.07-.28-.15-.56-.22-.85l.72-.65.22.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.05,56.41l-.7.5c-.2-.16-.4-.32-.61-.47l.71-.5.6.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.61,129.72c-.13.3-.26.6-.38.9l-.62-.67.38-.9c.21.22.42.44.62.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,112.1l-.52.66c-.18-.3-.36-.6-.55-.9l.52-.66c.19.3.37.6.55.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.83,87.76l-.41.6c-.25-.28-.5-.55-.76-.82l.42-.61.75.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,81.16c-.27.26-.54.52-.8.79-.13-.2-.27-.39-.4-.58l.8-.79c.13.2.26.39.4.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,131.9c-.12.3-.25.6-.36.9-.22-.22-.43-.45-.63-.67.12-.3.23-.6.36-.9l.63.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5,127.72c-.19.23-.4.45-.6.67l-.41-.9c.21-.22.41-.45.61-.67.14.3.27.6.4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79,145l-.71.66c-.08-.29-.17-.58-.25-.87l.71-.66c.08.29.17.58.25.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.36,134.07c-.12.3-.24.6-.35.9-.22-.22-.43-.45-.64-.67.11-.3.22-.6.34-.9.21.23.43.45.65.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.28,138.4c-.11.29-.21.59-.31.88l-.67-.66.3-.89.68.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.56,65.25l-.84.65-.43-.51.85-.64.42.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.74,105.1l-.61.89-.48-.65c.2-.3.4-.6.61-.89l.48.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8,136.24c-.11.3-.23.59-.33.89l-.66-.67.32-.89c.22.23.44.45.67.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,98.42l-.67.87-.45-.64.66-.87c.15.22.31.43.46.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49,187.12c-.07.17-.14.35-.2.52l-.66-.48c.06-.17.13-.35.2-.52l.66.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.94,157l-.77.63c-.06-.27-.1-.54-.16-.81.26-.2.52-.42.78-.63l.15.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.21,185.9c-.06.18-.1.36-.15.54l-.71-.48.15-.55.71.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2,129.9l-.62.68-.39-.9.62-.67.39.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.41,142.85l-.7.66-.27-.87.7-.66.27.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,81.33l-.4.58-.8-.79.4-.57c.27.25.54.52.8.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.84,132.08l-.63.67c-.12-.3-.25-.59-.37-.89.21-.23.43-.45.64-.67l.36.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,140.72l-.68.66c-.09-.29-.19-.58-.29-.87l.68-.67c.1.3.2.59.29.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,114.27c-.17.23-.35.45-.53.67-.18-.3-.35-.61-.53-.9l.53-.67c.18.3.36.6.53.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.45,134.25l-.65.68c-.12-.3-.24-.6-.35-.89.21-.23.43-.45.65-.68.12.3.23.6.35.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.51,138.58l-.67.66-.31-.88c.23-.22.46-.44.67-.67.11.3.21.59.31.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.14,105.29l-.49.66c-.2-.3-.4-.6-.61-.89l.49-.65c.21.29.42.59.61.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,136.42l-.66.67-.33-.89.66-.67c.11.3.23.59.33.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.69,183.32c0,.19-.07.38-.1.57l-.77-.5c0-.2.06-.39.1-.58.26.17.52.33.77.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,184.61c0,.19-.09.38-.13.56l-.74-.49c0-.19.08-.38.13-.56l.74.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.24,85.31c-.26.26-.52.53-.77.81q-.23-.3-.42-.6l.77-.81.42.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2,79l-.82.77L72,79.2l.81-.77.41.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7,63.33l-.84.62-.45-.49.84-.62.45.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.24,94l-.71.85c-.15-.2-.29-.41-.44-.62.23-.29.47-.57.71-.86l.44.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.21,67.06l-.85.66c-.15-.17-.29-.34-.43-.52l.85-.65.43.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.79,155l-.76.63-.18-.82.77-.63c.06.27.12.54.17.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.68,187.07c-.07.17-.14.34-.22.51l-.64-.47c.07-.18.14-.35.22-.53l.64.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.66,89.57l-.74.84-.43-.62c.25-.27.5-.55.74-.83.15.2.29.41.43.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.79,79.16l-.41.58-.81-.78.41-.57.81.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,107.25l-.6.89-.5-.66c.2-.29.39-.59.59-.89l.51.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.72,85.48q-.19.3-.42.6c-.25-.28-.51-.54-.77-.82.14-.19.29-.39.42-.59l.77.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.92,116.45c-.18.23-.36.45-.55.67l-.51-.9c.18-.23.37-.45.55-.67.17.3.35.6.51.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,185.83c-.06.18-.12.36-.17.54l-.7-.49.18-.54.69.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.48,76.89l-.83.75-.41-.56.83-.75.41.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.72,100.52l-.65.88-.48-.64c.22-.3.43-.59.66-.88.15.22.31.43.47.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.84,68.92,84,69.6l-.42-.53.85-.68.42.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.29,89.75c-.14.21-.29.41-.44.62-.24-.28-.49-.57-.74-.84l.43-.61.75.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.6,153l-.75.64c-.07-.28-.13-.55-.2-.83.26-.21.51-.43.76-.65.07.28.13.56.19.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.54,181.9c0,.19-.07.39-.1.59l-.79-.52c0-.19.06-.39.1-.59l.79.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.29,107.44c-.16.22-.34.44-.51.66-.19-.3-.39-.6-.59-.89l.5-.66.6.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.79,74.82l-.84.74-.4-.56c.27-.25.55-.49.83-.73l.41.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.19,69l-.43.53c-.28-.23-.56-.46-.85-.68l.43-.52.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.48,70.83c-.29.23-.57.47-.85.71L81.21,71l.85-.7.42.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.89,187l-.24.52-.63-.49.24-.52.63.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.13,72.8l-.85.72L78.87,73l.84-.72.42.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.42,83.07l-.79.8-.42-.59.79-.8.42.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.85,118.64l-.57.67c-.16-.3-.33-.6-.5-.9l.57-.68.5.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.36,65.07l-.85.64-.44-.51.84-.63.45.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22,184.53c-.06.18-.1.37-.15.56l-.73-.5c0-.19.09-.37.14-.56l.74.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,75l-.41.55-.84-.74c.14-.18.28-.36.41-.55l.84.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.54,71l-.42.53-.84-.7.42-.53.84.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.92,183.22c0,.19-.09.38-.13.57-.25-.16-.5-.34-.76-.5l.12-.58.77.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,109.41c-.2.29-.39.59-.58.89-.18-.21-.35-.44-.52-.66.18-.3.38-.59.57-.89l.53.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.89,72.94l-.42.55-.84-.72.42-.54.84.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,151l-.75.65c-.07-.28-.14-.56-.22-.84l.75-.64c.08.27.15.55.22.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9,96l-.7.87c-.16-.21-.31-.43-.46-.64l.7-.86a7.26,7.26,0,0,0,.46.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.56,83.24l-.42.59c-.27-.26-.53-.53-.79-.8l.42-.58c.26.26.53.52.79.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.63,185.77c-.06.18-.13.36-.19.53l-.69-.49.2-.54.68.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,187l-.27.52-.61-.48c.09-.18.17-.35.27-.53l.61.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.73,120.83c-.2.22-.39.45-.58.67-.16-.3-.32-.6-.49-.9l.59-.68.48.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.77,87.27c-.26.28-.52.55-.77.83-.15-.2-.29-.41-.43-.61.25-.28.51-.55.76-.82l.44.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.39,109.6l-.52.66c-.19-.3-.38-.6-.58-.89l.52-.67.58.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5,102.64l-.64.88c-.17-.21-.33-.43-.49-.64L60,102c.16.22.33.43.5.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.11,148.88l-.74.66-.24-.85.75-.66c.08.29.15.57.23.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.65,80.88l-.81.78-.42-.58.81-.78c.13.19.28.39.42.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,125c-.15.3-.3.6-.44.9-.2-.23-.41-.45-.61-.67.15-.31.3-.61.44-.91l.61.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,66.86l-.85.66L87.71,67l.84-.65.45.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2,87.45c-.14.2-.29.4-.43.61-.25-.28-.51-.55-.77-.83l.44-.6.76.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.44,111.57l-.56.91c-.19-.22-.37-.45-.54-.67l.56-.9c.18.22.36.45.54.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,123l-.6.68c-.15-.31-.3-.61-.46-.91l.6-.68c.15.31.31.61.46.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,102.83l-.49.65c-.21-.3-.43-.59-.65-.88.17-.22.34-.43.5-.65.22.29.43.59.64.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.34,186.93l-.29.52-.6-.49.29-.52.6.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.8,146.79l-.73.66c-.08-.28-.17-.57-.26-.85l.74-.66.25.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.45,184.45l-.17.56-.72-.5c0-.19.11-.37.17-.56l.72.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.34,81c-.13.2-.28.39-.42.59l-.81-.79c.14-.19.29-.38.43-.58l.8.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.78,181.79l-.12.59-.78-.51.12-.6.78.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.75,127.22l-.42.9-.62-.67.42-.91.62.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.87,185.71c-.08.17-.15.35-.22.53l-.67-.49c.07-.18.14-.36.22-.54l.67.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65,156.8l-.79.63c-.05-.27-.11-.54-.17-.81l.78-.63.18.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.35,125.21l-.61.68-.45-.91c.21-.22.41-.44.61-.67q.24.45.45.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.45,111.77l-.54.66c-.19-.3-.38-.6-.56-.9l.54-.66c.19.3.38.6.56.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.05,129.41c-.13.3-.27.59-.4.89-.21-.22-.42-.45-.64-.67.14-.3.27-.6.4-.9l.64.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.16,183.13c0,.19-.1.38-.14.57l-.76-.51.15-.58.75.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.92,78.73l-.82.77c-.14-.19-.29-.38-.43-.58l.82-.76.43.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.45,144.69l-.72.66c-.09-.29-.19-.58-.28-.86l.73-.67.27.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.63,68.71l-.85.68c-.15-.18-.29-.36-.44-.53l.85-.68.44.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.59,98.1l-.68.87-.48-.64.69-.87c.15.22.31.43.47.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4,131.59q-.21.45-.39.9l-.65-.67c.12-.31.25-.6.38-.9.22.22.43.45.66.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09,127.4c-.21.23-.42.45-.62.68-.14-.3-.28-.6-.43-.9l.63-.68.42.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.31,104.78c-.21.29-.42.58-.62.88-.18-.21-.35-.43-.51-.65.2-.3.41-.59.62-.89l.51.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,64.89l-.85.64L91.86,65l.85-.63c.16.17.31.34.47.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,138.1l-.33.89-.69-.67c.12-.29.22-.59.33-.89l.69.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.78,133.77c-.12.3-.25.6-.37.89l-.66-.67c.13-.3.24-.6.37-.89l.66.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,135.94l-.35.89-.67-.67c.11-.3.23-.59.34-.89l.68.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.93,85l-.79.81-.43-.6.78-.81.44.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.41,68.83c-.14.18-.29.35-.44.53l-.85-.68.44-.52.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.05,142.56c-.23.23-.47.45-.71.67-.09-.29-.19-.58-.29-.87.24-.22.48-.44.71-.67.1.29.21.58.29.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.09,78.89l-.43.58-.82-.77c.14-.2.29-.39.43-.58l.82.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.79,129.59c-.21.22-.42.45-.64.67l-.41-.89.64-.68c.14.3.28.6.41.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.22,76.63l-.83.75L76,76.81c.28-.25.56-.49.83-.75l.43.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.27,70.61l-.85.7c-.16-.18-.3-.36-.44-.54l.85-.69.44.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.62,140.43l-.7.66-.31-.87.7-.67c.1.29.21.58.31.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6,180.33l-.12.61-.79-.53c0-.2.07-.41.12-.61l.79.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.44,131.77c-.21.23-.43.45-.65.68l-.39-.9.65-.67c.14.3.27.59.39.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.48,154.78l-.78.64c-.06-.27-.13-.54-.19-.81l.77-.65c.07.28.14.55.2.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.12,185.65c-.09.18-.17.36-.25.53l-.65-.49q.11-.27.24-.54l.66.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.88,93.64l-.72.85-.47-.63.72-.85.47.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.55,74.57l-.84.74-.43-.56.84-.73.43.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.06,85.18l-.44.6-.78-.81c.14-.2.29-.39.44-.59l.78.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.61,105l-.51.65-.63-.89.51-.65.63.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9,72.57l-.84.71c-.15-.18-.3-.36-.44-.55l.85-.71c.14.18.28.37.43.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.14,138.28l-.69.67-.33-.88.69-.67c.11.29.23.58.33.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,89.27l-.76.83-.45-.61c.25-.28.5-.56.76-.83l.45.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.05,134l-.66.67c-.12-.29-.25-.59-.37-.89l.66-.67c.13.3.25.59.37.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.47,113.94l-.56.67c-.18-.3-.36-.6-.55-.9l.56-.67.55.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.62,136.12l-.68.67c-.11-.29-.23-.59-.35-.88l.68-.68c.11.3.24.59.35.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,70.74l-.44.54-.85-.7c.14-.18.29-.35.44-.53l.85.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.71,184.38c-.07.18-.14.37-.2.55l-.71-.5c.06-.19.13-.37.2-.56l.71.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.48,74.72l-.44.55-.84-.73.44-.55.84.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65,89.44c-.15.21-.3.42-.46.62l-.75-.83.45-.61c.25.27.5.55.76.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.05,181.69c0,.2-.1.39-.14.59l-.78-.52.15-.6.77.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.17,106.92l-.61.9-.53-.66c.21-.3.41-.6.62-.89l.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.82,66.67l-.85.66c-.15-.18-.31-.35-.46-.52l.85-.65.46.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.43,183c-.07.19-.12.38-.17.57l-.75-.51c.06-.19.12-.39.17-.58l.75.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.14,82.79c-.27.27-.54.53-.8.8L70.9,83l.8-.79c.14.2.29.39.44.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.27,152.75c-.25.22-.51.43-.77.64l-.21-.82.77-.65c.07.28.15.55.21.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.34,100.2l-.68.88-.49-.65.67-.87c.16.22.33.43.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.44,116.13c-.19.22-.38.45-.58.67-.17-.3-.35-.6-.53-.9l.57-.68.54.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.38,185.6c-.1.17-.18.35-.27.53l-.64-.49c.08-.19.17-.36.26-.55l.65.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87,83c-.15.19-.3.39-.44.59l-.81-.8.45-.59.8.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.75,107.11c-.17.23-.35.44-.53.66l-.61-.89.53-.66.61.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,184.31l-.21.55-.7-.5c.07-.19.15-.37.22-.56l.69.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,150.69l-.76.65-.24-.83.76-.66.24.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.46,68.51l-.86.67-.46-.53L88,68c.15.18.31.35.47.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.47,87l-.78.82-.45-.61.77-.82c.15.21.31.41.46.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.36,118.32l-.58.67-.52-.9.58-.68c.18.3.35.6.52.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.39,80.61l-.81.78-.45-.59L74,80c.15.19.3.38.44.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.55,95.7l-.72.86-.48-.63c.24-.29.47-.58.71-.86l.49.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.64,185.55l-.28.53-.63-.5c.09-.17.19-.36.29-.53l.62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.07,109.09l-.6.89-.54-.66.6-.9.54.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.89,180.22c0,.2-.1.41-.14.61L94,180.3c0-.21.09-.41.14-.62.26.19.53.36.79.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.63,80.77l-.45.58c-.27-.26-.54-.52-.82-.77l.45-.59.82.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.53,87.15c-.15.2-.3.41-.46.61-.25-.28-.52-.54-.77-.82l.45-.61.78.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.71,183c-.07.19-.13.39-.19.58l-.74-.52c.06-.19.13-.38.2-.57l.73.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.11,102.32l-.65.88c-.18-.21-.35-.43-.52-.65l.66-.88.51.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.75,148.62l-.76.65c-.08-.28-.17-.56-.25-.84l.75-.66c.08.28.17.56.26.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.24,120.51l-.6.67c-.16-.3-.33-.6-.5-.9l.6-.67c.17.29.34.6.5.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09,70.4l-.86.69-.46-.54.86-.69.46.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.34,181.59c0,.2-.11.4-.17.59l-.76-.52c0-.2.11-.4.17-.6l.76.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.85,109.27l-.54.67-.6-.9.54-.66.6.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.69,78.47l-.83.77-.45-.58c.27-.26.55-.51.83-.76.15.19.29.38.45.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.05,91.47c-.15.21-.31.41-.47.62l-.75-.84.48-.62.74.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.93,185.51l-.31.53-.62-.5.31-.54.62.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.26,184.24l-.24.56-.68-.51c.07-.19.15-.37.23-.56l.69.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,70.52l-.47.54-.85-.69.47-.54.85.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.68,178.73c-.05.2-.09.41-.14.62l-.8-.54c.05-.21.09-.42.14-.63.27.18.54.36.8.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.72,72.34l-.86.71-.45-.55.85-.71c.15.19.3.37.46.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,76.38l-.84.75-.45-.57.84-.75c.14.19.3.38.45.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.83,102.51c-.16.22-.34.43-.51.65l-.66-.88.51-.65c.23.29.45.58.66.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.67,66.5l-.85.65-.48-.53.85-.64.48.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.36,74.34l-.85.73-.46-.56.85-.73.46.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,111.26c-.2.3-.4.59-.59.89l-.55-.66c.19-.3.38-.6.58-.9l.56.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.42,146.52l-.74.66-.28-.85.74-.66c.1.28.19.56.28.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.08,122.7l-.61.68c-.17-.3-.33-.6-.49-.9l.62-.68.48.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.66,84.73l-.8.81-.45-.61.79-.8.46.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,72.47c-.15.19-.3.37-.46.55l-.85-.71c.16-.18.31-.36.46-.55l.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.21,185.47l-.33.53-.6-.5c.12-.18.22-.36.34-.54l.59.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.25,97.79c-.23.29-.46.58-.7.86l-.5-.64.7-.86.5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.06,144.41l-.74.66c-.09-.28-.19-.57-.29-.86l.73-.66.3.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.87,124.9c-.2.23-.41.45-.63.67l-.46-.9.63-.67c.16.3.31.59.46.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.91,111.44l-.56.67-.59-.9.56-.66c.2.29.39.59.59.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.64,140l-.33.87-.71-.67c.1-.29.22-.59.33-.88l.71.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.35,84.89c-.14.21-.3.41-.46.61l-.79-.81.46-.6.79.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.94,104.46c-.23.29-.44.59-.65.89l-.53-.66.64-.89c.18.22.35.44.54.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,182.88c-.08.19-.14.38-.21.57l-.73-.52c.07-.19.14-.38.22-.58l.72.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,184.19l-.27.55-.67-.51c.09-.19.17-.38.26-.56l.68.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.14,137.82c-.12.29-.24.59-.35.88l-.71-.67.36-.89.7.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2,180.11c-.06.21-.11.41-.17.61l-.77-.53a6.06,6.06,0,0,1,.16-.61l.78.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,142.28l-.72.67-.32-.87.72-.67c.11.29.22.58.32.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.68,135.65c-.13.3-.25.59-.37.89-.23-.23-.47-.45-.69-.68.11-.29.24-.59.37-.89.22.23.46.46.69.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.26,133.47l-.39.9-.68-.68c.13-.3.25-.6.39-.89.22.23.45.45.68.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.62,127.09l-.64.68-.45-.9.64-.68c.16.3.3.6.45.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.57,93.34l-.74.84-.48-.63c.24-.28.49-.56.73-.85.16.21.33.42.49.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.31,68.32l-.85.67c-.17-.18-.33-.35-.49-.54l.86-.66.48.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65,181.5c-.07.2-.12.4-.19.59l-.75-.52c.05-.2.12-.4.19-.6l.75.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2,140.14l-.71.67c-.11-.29-.22-.58-.34-.87l.72-.67.33.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,129.28l-.66.68-.43-.9.66-.68c.14.3.28.6.43.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9,82.52l-.81.79-.46-.6.81-.79.46.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,104.64c-.17.23-.35.44-.53.66-.21-.29-.42-.59-.64-.88l.53-.66c.21.3.43.59.64.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,89.15l-.48.61-.76-.82c.15-.21.31-.42.47-.62l.77.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,138l-.7.67-.36-.88.71-.67c.12.29.24.58.35.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,131.47l-.67.68c-.13-.3-.28-.6-.41-.9.22-.22.44-.45.67-.67.14.29.28.59.41.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.18,135.82l-.69.68c-.13-.29-.25-.59-.38-.89.24-.22.47-.45.7-.68.12.3.25.6.37.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.61,133.65c-.23.22-.46.45-.68.68-.13-.3-.27-.6-.4-.89l.68-.68c.14.3.27.59.4.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.92,113.62l-.57.67-.57-.9.57-.67.57.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,82.68l-.46.59-.82-.79c.16-.2.32-.39.47-.59l.81.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.87,184.13l-.29.55-.66-.51c.09-.19.19-.37.29-.56l.66.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,178.61c-.05.21-.11.42-.16.63l-.8-.55c.06-.21.11-.42.17-.63l.79.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.94,70.2l-.86.69-.48-.55.85-.68c.16.18.33.35.49.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,66.33,93.7,67c-.17-.18-.34-.35-.5-.53l.84-.64.51.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8,106.61c-.22.29-.43.59-.64.89l-.54-.66.63-.89.55.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,99.89l-.69.87-.51-.65.68-.87c.17.22.34.44.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,80.35l-.83.78-.46-.6.82-.77.47.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.33,182.8l-.24.58c-.23-.18-.47-.35-.71-.52.07-.19.16-.39.24-.58l.71.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.89,115.81l-.59.67-.55-.9.59-.67c.19.3.37.6.55.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.22,86.7l-.79.81L70,86.9l.79-.81.48.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.86,80.5l-.46.59-.83-.78.47-.58c.28.25.55.51.82.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.56,72.13l-.85.71c-.16-.19-.33-.37-.48-.56l.85-.7.48.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16,106.79c-.18.23-.37.44-.55.67-.21-.3-.42-.6-.64-.89l.55-.66c.22.29.42.59.64.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.49,78.22l-.83.76-.47-.58.83-.76.47.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.79,177.08c-.06.21-.11.43-.16.64l-.81-.55c0-.22.1-.43.16-.65l.81.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.53,180l-.18.61-.78-.53c.06-.21.13-.41.19-.62l.77.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,181.41l-.21.59-.75-.52.21-.6.75.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,184.08c-.1.19-.21.37-.31.55l-.64-.51.3-.56.65.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.25,95.4c-.25.28-.49.57-.73.86l-.5-.64.72-.86.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.19,74.11l-.85.73-.48-.57.85-.72.48.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.83,76.14l-.84.75c-.17-.19-.32-.38-.47-.58.27-.25.56-.49.84-.74l.47.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,86.86l-.48.62c-.26-.28-.52-.55-.79-.82l.48-.61.79.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,72.25l-.48.56-.86-.71.48-.55.86.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.66,91c-.26.27-.51.55-.76.83l-.49-.62.76-.84.49.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.82,118l-.6.68-.54-.91.6-.67.54.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7,108.77l-.62.9-.56-.67.62-.9c.18.23.37.45.56.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.66,182.74c-.09.19-.18.38-.26.57l-.7-.52c.09-.2.17-.39.26-.58l.7.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.19,68.14l-.85.67-.51-.54.86-.66c.16.18.33.35.5.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.33,148.35l-.76.67c-.09-.29-.18-.57-.28-.85l.77-.66.27.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.35,91.17c-.16.21-.32.42-.49.62-.25-.28-.5-.56-.76-.83l.49-.63.76.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.78,102l-.67.88-.53-.66.67-.87c.18.21.35.44.53.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.52,184l-.33.55-.63-.52.33-.55.63.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.44,84.46l-.81.8-.48-.61.81-.8.48.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.25,109c-.18.23-.37.45-.56.67-.21-.29-.41-.59-.62-.89l.57-.67.61.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.7,120.19c-.2.23-.41.46-.62.68-.17-.3-.34-.6-.52-.9.21-.22.42-.45.62-.68.18.3.35.6.52.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,178.5c-.06.21-.13.42-.19.62l-.79-.54c.06-.21.12-.42.19-.63l.79.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.45,66.18l-.84.64c-.18-.18-.35-.36-.53-.53.28-.22.57-.42.84-.64.18.18.36.35.53.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,146.26l-.75.66-.31-.85.77-.67c.09.29.2.57.29.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.19,102.19l-.53.66L180,102l.54-.65.67.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,84.61l-.48.61-.81-.8.49-.6.8.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.33,181.33l-.24.59-.73-.53c.07-.2.15-.4.23-.59l.74.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.64,110.94l-.6.9-.57-.67c.2-.3.39-.6.6-.9l.57.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.86,184l-.35.55-.61-.52.34-.56.62.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.57,124.41c-.16.3-.33.6-.48.9-.22-.22-.43-.45-.65-.68.16-.3.32-.6.49-.9.2.23.43.45.64.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.82,70l-.86.68c-.17-.18-.34-.36-.5-.55l.86-.68.5.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.89,179.92c-.08.2-.14.41-.21.61l-.77-.54.21-.61.77.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,122.39c-.21.23-.42.46-.64.68-.16-.3-.34-.6-.5-.9l.63-.68.51.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68,141.85c-.12.29-.24.58-.34.87L62.6,142c.11-.29.22-.58.34-.87l.74.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,97.49c-.24.28-.48.57-.71.86-.18-.21-.35-.43-.53-.65.25-.28.48-.57.72-.86l.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,182.68c-.1.19-.19.38-.28.57l-.69-.53.28-.58.69.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.62,144.14l-.75.67-.33-.86.76-.67c.11.28.21.57.32.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,82.26l-.82.78-.48-.6.82-.78.48.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.16,177c-.07.21-.13.43-.19.64l-.8-.56.18-.64.81.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.14,139.7c-.12.29-.24.58-.35.87l-.73-.67c.11-.3.23-.59.35-.88l.73.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7,168.9l-.18.71-.83-.59c0-.24.11-.48.17-.73l.84.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.31,93c-.25.28-.51.56-.75.84l-.51-.63c.25-.29.5-.56.75-.84.16.21.34.42.51.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31,111.13c-.19.22-.39.44-.58.67l-.6-.9c.19-.22.39-.44.58-.67l.6.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.34,124.59l-.64.68c-.17-.3-.33-.6-.49-.9.21-.23.43-.45.65-.68l.48.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.61,104.15,63,105l-.55-.66.66-.88.55.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2,142c-.25.22-.5.44-.74.67-.11-.29-.23-.58-.35-.87l.75-.67.34.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.22,88.86l-.49.62-.78-.83.49-.62c.26.28.53.55.78.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.65,137.54c-.12.29-.25.58-.37.88l-.72-.68c.12-.29.24-.59.37-.88l.72.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.44,71.92l-.86.71-.5-.56.86-.7c.16.19.33.37.5.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2,135.37c-.13.29-.27.59-.39.88l-.71-.68.39-.88.71.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.79,133.19c-.14.3-.28.59-.41.89l-.7-.69c.14-.29.27-.59.42-.88.22.23.46.45.69.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.63,113.13c-.2.29-.39.59-.59.89-.2-.22-.4-.44-.59-.67.19-.3.39-.6.59-.9.19.23.39.45.59.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,80.1l-.84.77-.48-.59.83-.77.49.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,126.79l-.66.68q-.23-.45-.48-.9l.67-.68.47.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.73,139.86l-.72.68c-.12-.3-.24-.59-.37-.88l.74-.68c.12.3.24.59.35.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.91,175.39c-.07.22-.12.44-.18.66l-.82-.57c.06-.22.12-.44.19-.66l.81.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,170.55l-.18.7c-.27-.2-.55-.39-.83-.58,0-.24.11-.48.17-.71l.84.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1,68c-.28.21-.57.43-.85.66l-.53-.55.85-.65.53.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.37,104.33l-.55.66-.67-.88.56-.66.66.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.81,129l-.67.68-.46-.89.68-.69.45.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.06,73.9c-.28.23-.57.47-.85.72l-.5-.57.86-.72c.16.19.33.37.49.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.37,182.62c-.11.19-.21.38-.31.57l-.67-.53.3-.57.68.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.23,137.7c-.23.23-.47.46-.72.68l-.37-.88.72-.68c.12.3.25.59.37.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.69,181.26c-.08.2-.17.39-.26.59l-.72-.54.26-.59.72.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.34,78l-.85.76L79,78.15l.85-.75c.16.19.32.39.49.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.06,80.24l-.49.6-.83-.78.49-.58.83.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,173.8l-.18.67-.82-.57.18-.68.82.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.33,172.19c0,.23-.11.46-.17.68-.28-.19-.56-.38-.83-.58,0-.23.11-.46.17-.69l.83.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.69,75.92l-.85.74-.49-.58.85-.74.49.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.48,131.17l-.69.68c-.14-.29-.28-.59-.43-.89l.68-.68c.15.3.3.59.44.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.69,135.54l-.71.67c-.13-.29-.26-.59-.4-.88l.71-.68c.14.3.27.59.4.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11,133.36l-.7.68-.42-.89.7-.68.42.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.47,165.35c-.07.25-.13.49-.19.74l-.83-.61c.06-.25.12-.5.19-.75l.83.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.74,178.4c-.06.21-.14.41-.2.62l-.79-.55.21-.63.78.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.32,113.31c-.19.23-.39.45-.59.67l-.59-.89c.2-.23.4-.45.59-.68.2.3.4.6.59.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,86.42c-.27.27-.54.54-.8.82l-.5-.62.8-.81.5.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,161.7c-.08.26-.15.52-.21.77l-.83-.62c.07-.26.13-.52.21-.78.27.22.55.42.83.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.26,179.83c-.08.2-.15.4-.23.61l-.76-.55c.07-.2.16-.4.24-.61l.75.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71,99.59l-.7.87-.54-.65.71-.87c.17.22.35.43.53.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.48,106.3c-.22.3-.44.59-.65.89l-.57-.67.65-.88c.19.22.37.44.57.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,86.58c-.16.21-.33.41-.5.62l-.8-.81c.17-.21.34-.41.5-.62l.8.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,182.57l-.33.57-.66-.54.33-.57.66.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.43,90.71l-.77.84-.51-.64c.26-.27.51-.55.77-.83l.51.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.73,69.83l-.86.68L90.35,70l.86-.67c.17.18.34.37.52.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,95.11l-.74.85c-.17-.22-.35-.43-.52-.64.24-.29.5-.57.74-.86l.52.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,115.5c-.2.22-.4.45-.61.67-.19-.3-.37-.6-.57-.89l.61-.68c.19.3.39.59.57.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.51,106.48l-.57.67-.65-.89.57-.67c.22.3.43.6.65.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,176.85l-.21.63-.79-.55c.06-.22.14-.43.2-.65l.8.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,167.05c-.07.24-.14.48-.2.73-.28-.2-.56-.4-.83-.61.06-.24.12-.49.19-.73l.84.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,181.19c-.09.19-.18.39-.28.59l-.71-.54c.09-.2.18-.4.28-.6l.71.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.26,84.19l-.82.8-.5-.61.82-.79.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.61,90.88l-.52.63-.77-.84.51-.62.78.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87,148.1c-.25.22-.52.44-.77.67-.1-.29-.2-.57-.31-.85l.78-.67.3.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,182.52c-.12.19-.24.38-.35.57l-.64-.54.34-.57.65.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38,108.47l-.63.89-.58-.67.63-.89c.2.22.38.44.58.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,67.82c-.28.22-.57.43-.85.66l-.54-.55.85-.65.54.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.22,117.69c-.2.23-.41.45-.62.68l-.56-.9.63-.68.55.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.45,159.74c-.08.26-.16.52-.23.78l-.83-.63c.08-.26.15-.52.23-.78l.83.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.35,71.73l-.86.7L88,71.87l.86-.69c.17.18.34.37.52.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6,163.44c-.08.25-.15.51-.21.76l-.84-.62.21-.76.84.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14,178.3l-.23.62c-.25-.19-.52-.36-.77-.55.07-.21.15-.42.23-.63l.77.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.66,179.75c-.09.2-.18.4-.26.6l-.75-.54c.08-.21.17-.41.26-.62l.75.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5,101.71l-.69.88-.55-.66.69-.88c.18.23.37.45.55.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.32,175.27c-.07.22-.14.44-.2.65l-.82-.56.21-.67.81.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.13,168.73c-.07.24-.13.48-.2.72l-.84-.6c.06-.24.13-.48.2-.72l.84.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.55,82l-.83.79-.5-.61L77,81.4l.51.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,108.64l-.58.68c-.21-.3-.42-.6-.64-.89l.59-.68.63.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.52,146l-.77.66-.33-.85c.26-.22.52-.44.77-.67l.33.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.05,173.67c-.07.22-.14.44-.2.67l-.82-.58c.06-.22.13-.45.2-.68l.82.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.45,170.4c-.07.23-.13.47-.2.7l-.83-.59c.06-.24.12-.47.19-.71l.84.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.77,143.72c-.12.29-.23.57-.34.86l-.76-.67c.11-.29.22-.58.34-.86l.76.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.47,181.12c-.11.2-.2.39-.3.59l-.71-.54c.1-.2.2-.4.31-.59l.7.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.62,88.42l-.8.82-.51-.63c.26-.27.53-.54.79-.82l.52.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,101.89l-.55.66-.7-.88c.19-.22.38-.43.56-.66l.69.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11,119.89l-.64.68-.54-.9.64-.68.54.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,182.48l-.37.57-.63-.54c.12-.19.24-.38.37-.57.21.18.42.37.63.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.76,172c-.07.23-.13.46-.2.69l-.83-.59c.07-.23.13-.46.2-.69l.83.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,73.69l-.85.72-.52-.57.86-.72.51.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.87,79.86l-.84.76L78.52,80l.84-.77.51.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72,97.19l-.73.86-.54-.65.73-.86c.17.22.36.44.54.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.59,75.7l-.86.73-.51-.58.85-.73.52.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.33,110.64l-.62.89c-.21-.22-.4-.45-.6-.67l.62-.9.6.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.22,77.75l-.85.75-.51-.58c.28-.26.56-.5.85-.75l.51.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,141.58c-.13.29-.24.58-.36.87l-.75-.68.36-.87.75.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.09,92.76l-.76.84L68.8,93l.76-.84c.18.21.36.42.53.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.44,88.58l-.52.62c-.26-.28-.52-.55-.79-.82l.52-.62c.26.27.53.54.79.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.12,143.87l-.76.68c-.11-.29-.23-.58-.35-.86l.77-.68c.11.29.23.58.34.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.19,124.12c-.18.29-.34.59-.51.89l-.66-.68.51-.9q.31.34.66.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,122.09c-.21.23-.43.45-.65.68-.17-.3-.34-.6-.52-.9.22-.23.44-.45.65-.68.18.3.35.6.52.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.67,69.66l-.86.67-.54-.55.85-.67.55.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,176.74c-.08.21-.15.42-.23.64l-.79-.57c.07-.21.15-.43.23-.64l.79.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93,165.17c-.07.25-.15.49-.22.74l-.84-.61c.07-.25.14-.5.22-.75.27.21.55.41.84.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.64,157.76c-.09.26-.17.53-.25.79l-.82-.64c.08-.27.16-.53.25-.8.28.21.55.43.82.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.34,103.85l-.68.88q-.3-.33-.57-.66c.22-.3.45-.59.68-.88q.27.33.57.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.07,179.67c-.1.2-.19.4-.28.6l-.74-.55c.09-.2.19-.4.28-.61l.74.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,110.82l-.6.67c-.2-.3-.42-.59-.63-.89.2-.23.41-.45.61-.67l.62.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,92.92l-.53.64-.76-.84c.17-.22.35-.43.53-.64l.76.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.69,141.74l-.76.67c-.11-.29-.23-.57-.36-.86l.76-.68.36.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.76,124.29c-.22.23-.44.46-.67.68-.17-.29-.33-.59-.51-.89l.67-.69.51.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.88,181.07l-.33.58-.69-.54.33-.59.69.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.76,161.5l-.24.78c-.27-.22-.55-.42-.83-.63.08-.26.16-.52.23-.78q.42.33.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,67.67l-.85.66-.56-.55.84-.65.57.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.56,178.21c-.09.2-.17.41-.25.62l-.77-.56.25-.63.77.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.85,86.16,74,87l-.52-.62.81-.81.52.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.78,135.09c-.15.29-.29.59-.42.88-.25-.22-.49-.45-.72-.68.13-.3.27-.59.41-.89l.73.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.21,139.59l-.74.68c-.13-.29-.25-.59-.38-.88l.74-.68c.13.3.26.58.38.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.32,112.82l-.61.9L62.1,113l.6-.89.62.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.52,126.49l-.68.69c-.16-.3-.32-.6-.49-.9l.68-.69.49.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.67,104c-.18.22-.38.44-.57.66l-.68-.88c.19-.22.39-.44.57-.66.23.29.46.58.68.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75,175.15c-.08.22-.15.44-.22.66l-.81-.58c.07-.22.15-.44.23-.66l.8.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7,137.42l-.73.69c-.13-.3-.27-.59-.4-.88l.73-.68.4.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.26,166.88l-.22.73L81.2,167c.07-.25.14-.49.22-.74l.84.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.24,128.69l-.69.68-.48-.89c.23-.23.47-.46.69-.69l.48.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.29,71.55c-.29.23-.58.46-.86.7l-.54-.57.86-.69.54.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.15,135.25l-.73.69c-.14-.3-.27-.59-.42-.89l.73-.68.42.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.92,130.88l-.71.69c-.14-.3-.3-.59-.45-.89l.7-.69.46.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55,133.07l-.71.69c-.15-.3-.29-.6-.44-.89l.71-.69c.15.3.3.59.44.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.48,99.3l-.72.86c-.19-.22-.37-.44-.56-.65l.72-.87.56.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.67,113l-.61.68-.61-.89.61-.68c.21.29.41.59.61.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.25,90.44l-.78.83-.53-.64.78-.83c.18.22.36.42.53.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3,181l-.35.59-.67-.55.34-.59.68.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.87,155.75l-.27.8-.82-.65.27-.81.82.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.12,83.94l-.82.79c-.18-.2-.35-.4-.52-.61l.82-.79.52.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21,106l-.67.89-.58-.67.66-.89c.19.23.39.45.59.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,173.54c-.07.22-.16.45-.23.67l-.81-.58c.07-.23.14-.45.22-.68l.82.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.59,168.57c-.08.24-.15.48-.22.72l-.84-.6c.07-.24.14-.48.22-.73l.84.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.34,115c-.2.3-.39.6-.59.89l-.62-.68c.19-.3.39-.6.59-.9l.62.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,179.6c-.11.2-.21.4-.31.6l-.72-.55c.09-.21.19-.41.3-.61l.73.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.79,94.82l-.75.85c-.19-.21-.37-.43-.55-.65l.76-.84.54.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.22,171.9c-.08.23-.16.46-.23.69l-.82-.59c.07-.23.14-.46.22-.69l.83.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.91,170.25c-.08.23-.15.46-.22.7l-.83-.6c.07-.23.14-.47.22-.7l.83.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9,73.5l-.86.71-.54-.58.86-.71.54.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.08,163.26c-.08.25-.16.5-.23.75l-.84-.62c.08-.25.15-.51.23-.76l.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.41,176.64c-.09.21-.17.42-.25.63l-.79-.56c.08-.22.17-.43.26-.65l.78.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81,90.6l-.53.63-.79-.83.54-.63.78.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.63,69.5l-.86.67c-.18-.19-.37-.37-.56-.56l.85-.66.57.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,159.54c-.09.26-.18.52-.26.78l-.83-.63.25-.79.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81,106.18l-.59.67c-.22-.3-.45-.59-.67-.88.2-.23.4-.45.59-.68l.67.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,178.12c-.09.21-.19.41-.28.62l-.76-.56c.09-.21.18-.42.28-.63l.76.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.43,81.76l-.83.78c-.18-.2-.36-.4-.53-.61l.84-.77.52.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,115.19c-.2.23-.42.45-.62.68l-.6-.89.63-.69c.2.3.4.6.59.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.26,95c-.18.21-.36.43-.55.64l-.75-.85c.18-.21.37-.42.55-.64l.75.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,181c-.12.19-.25.38-.37.58l-.66-.55c.12-.2.24-.4.37-.59l.66.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.41,117.21c-.2.3-.39.6-.58.9-.21-.23-.42-.46-.64-.68.2-.3.39-.6.58-.9.22.23.42.46.64.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.77,79.63l-.84.76-.53-.6.84-.76c.18.2.36.39.53.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.14,77.53l-.86.75c-.17-.2-.35-.39-.53-.59L83.6,77l.54.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.13,153.71c-.09.27-.19.54-.29.81l-.81-.65c.09-.27.19-.55.29-.82l.81.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.28,101.42l-.71.87-.57-.66.7-.87.58.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.47,88.15l-.81.82-.53-.63.8-.81.54.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.94,179.53l-.33.6c-.23-.19-.47-.37-.71-.55.1-.21.21-.41.32-.61l.72.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.57,117.39l-.64.68c-.19-.3-.38-.6-.58-.9.22-.23.44-.45.65-.68l.57.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.21,175c-.08.22-.17.43-.25.65l-.8-.57c.08-.22.16-.44.25-.66.27.19.54.38.8.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.42,165l-.24.75-.84-.62q.1-.37.24-.75c.28.21.55.42.84.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,145.74l-.78.68-.35-.86.78-.67c.12.28.24.57.35.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.17,180.92l-.39.58-.65-.55.39-.59.65.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.62,88.3l-.54.64-.81-.82q.28-.32.54-.63l.81.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.34,143.47c-.13.28-.24.57-.36.86l-.78-.68c.12-.29.25-.57.37-.86l.77.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,108.34l-.6.68-.66-.89c.2-.23.41-.45.6-.68.23.3.44.6.66.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.25,71.38l-.86.69-.56-.57.86-.68.56.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.76,101.59l-.58.66-.71-.87.58-.66.71.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.52,96.91c-.24.28-.5.57-.74.86l-.56-.66.74-.85c.19.21.38.43.56.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.93,92.48l-.78.84-.55-.64.78-.84c.18.21.36.43.55.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,157.55l-.27.79-.83-.64c.09-.27.18-.53.28-.8l.82.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,119.59l-.66.69c-.19-.3-.38-.6-.56-.9l.65-.69.57.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.46,178c-.1.2-.21.41-.3.62l-.75-.56c.09-.21.2-.42.3-.63l.75.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.27,161.31c-.09.26-.18.52-.26.77-.28-.2-.56-.42-.83-.63.07-.26.16-.51.25-.77l.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,176.54l-.27.64-.78-.57c.09-.22.18-.43.28-.65.25.2.51.39.77.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,173.42c-.09.22-.17.44-.25.67l-.82-.59.25-.67.82.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75,166.71l-.24.73-.84-.61.24-.73.84.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.43,151.65c-.11.28-.21.55-.31.83l-.81-.67c.1-.27.2-.55.31-.82l.81.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.58,143.61l-.77.68-.37-.85.77-.68c.13.28.25.57.37.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,141.33l-.39.86c-.25-.23-.5-.46-.76-.68.13-.29.26-.58.38-.87l.77.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.62,180.89c-.14.19-.28.38-.41.58l-.63-.56.41-.58.63.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.73,85.91c-.28.26-.55.53-.82.8l-.54-.62.81-.81.55.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.61,69.35l-.85.67-.58-.56L97,68.8l.58.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.15,92.64l-.55.64c-.26-.28-.53-.56-.78-.84.18-.21.37-.42.55-.64l.78.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.53,97.07l-.56.66c-.24-.29-.5-.57-.75-.86.19-.22.39-.43.57-.65l.74.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.39,179.47c-.12.2-.23.4-.34.6l-.71-.56c.12-.2.24-.4.35-.61l.7.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.86,123.83c-.18.29-.35.6-.53.89l-.68-.69.53-.89.68.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.31,121.79l-.67.69-.54-.9.67-.69.54.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,171.77c-.08.23-.17.46-.24.69l-.83-.59c.08-.23.16-.46.25-.69l.82.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.08,168.42l-.24.71-.84-.6c.08-.24.16-.48.25-.72l.83.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.11,103.56l-.69.88-.59-.67.69-.88.59.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.86,73.31,90,74l-.55-.58.86-.7.55.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4,170.11c-.09.23-.16.46-.24.7l-.83-.6c.07-.24.15-.48.24-.71l.83.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.13,141.48l-.77.67-.38-.86.76-.68c.13.29.27.58.39.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,110.52l-.61.68c-.22-.3-.43-.6-.65-.89.21-.23.42-.45.62-.68.22.29.43.59.64.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.12,124c-.23.22-.45.45-.68.68-.18-.29-.35-.59-.53-.89l.68-.69.53.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,83.69l-.83.8c-.18-.21-.37-.41-.54-.62l.83-.79.54.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.64,139.32l-.75.68c-.13-.29-.27-.58-.41-.87l.76-.68.4.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93,103.73c-.2.22-.4.44-.59.67l-.7-.88c.2-.22.4-.44.59-.67.24.29.47.58.7.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7,174.93c-.1.22-.19.44-.28.66l-.79-.58c.08-.22.18-.44.27-.66l.8.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.42,155.53l-.3.81-.82-.65c.09-.27.19-.54.29-.81l.83.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6,163.07c-.08.26-.17.51-.26.76l-.84-.63c.09-.25.17-.5.26-.76l.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.12,90.17l-.8.83c-.18-.21-.37-.42-.55-.64l.79-.82.56.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.89,126.2l-.7.69-.51-.9.69-.69c.18.3.35.6.52.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.93,178c-.11.21-.22.41-.32.62-.25-.18-.49-.37-.74-.57l.32-.62.74.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.12,137.15l-.75.69-.43-.88.75-.69c.14.3.29.59.43.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.86,179.41c-.12.2-.24.4-.37.6l-.69-.56c.13-.2.25-.4.37-.6.24.18.47.37.69.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.29,99l-.73.87L68,99.22l.73-.87c.19.23.39.44.58.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.36,81.53c-.29.26-.57.51-.85.78L80,81.7c.27-.27.56-.52.84-.78.18.21.36.41.55.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.61,128.4l-.7.69c-.16-.3-.33-.59-.5-.89l.71-.69.49.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.09,77.33l-.86.74-.55-.59.85-.74c.19.19.37.39.56.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,135c-.25.22-.49.46-.74.69-.14-.3-.29-.59-.44-.89l.74-.69.44.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.71,79.4l-.85.76-.55-.6.85-.76c.18.21.37.4.55.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.48,159.34c-.09.26-.19.52-.27.79l-.84-.65c.09-.26.18-.52.28-.78.27.22.55.43.83.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3,130.6l-.72.69c-.15-.3-.31-.59-.48-.89l.72-.69.48.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.36,176.45c-.11.21-.21.42-.3.64l-.77-.58c.09-.21.2-.42.3-.64l.77.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,132.79l-.73.69-.46-.88.73-.7c.15.3.3.6.46.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.63,94.55l-.76.84-.57-.65.77-.84c.19.21.37.43.56.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.24,71.22l-.86.69q-.28-.3-.57-.57c.28-.24.57-.46.85-.69l.58.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,112.7l-.64.69-.62-.9.63-.68.63.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,90.32c-.18.22-.37.43-.55.64l-.8-.82.56-.64.79.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.62,69.22l-.85.66-.6-.57c.29-.21.57-.44.85-.65l.6.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.45,94.71l-.57.64-.77-.84.57-.65.77.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.48,173.3l-.28.67-.81-.59.27-.67.82.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.94,164.82l-.26.75-.84-.62c.08-.25.17-.5.26-.75l.84.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.35,179.36c-.14.2-.27.4-.4.6-.22-.19-.44-.38-.67-.56.12-.21.26-.41.39-.61l.68.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,105.88l-.61.68c-.23-.3-.45-.59-.69-.88l.61-.68.69.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.36,87.9l-.81.81L75,88.08l.81-.81.56.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7,153.49c-.11.27-.21.54-.31.82l-.82-.66c.1-.28.2-.55.31-.82l.82.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.94,114.9c-.22.22-.43.45-.65.68l-.61-.89.65-.69.61.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.42,177.89l-.35.62-.72-.57c.11-.2.22-.42.34-.62l.73.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.22,171.65c-.1.23-.19.45-.28.68l-.82-.59.27-.7.83.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.28,166.56c-.09.24-.18.48-.26.73l-.84-.62.26-.74.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.85,73.14l-.86.7-.57-.58.86-.7.57.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.75,88.05l-.56.63-.81-.82.56-.63.81.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1,101.14l-.73.87-.59-.67.72-.87.6.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.93,170c-.1.23-.19.47-.27.7l-.83-.6c.08-.24.17-.48.26-.71l.84.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.61,168.27c-.09.24-.18.48-.26.72l-.84-.61c.08-.25.17-.48.26-.72l.84.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2,174.83l-.3.66-.79-.59.3-.66.79.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82,161.13c-.1.26-.19.51-.28.77l-.84-.64c.08-.26.18-.51.28-.77l.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.83,179.32c-.14.2-.27.4-.41.59l-.66-.56.41-.6.66.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.73,157.35l-.3.79-.83-.65c.09-.26.19-.53.29-.79l.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.86,176.36c-.11.21-.22.43-.32.64l-.77-.58.33-.64.76.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.41,145.5l-.79.67c-.12-.28-.25-.56-.37-.85l.79-.68c.13.29.25.57.37.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8,92.21l-.78.84c-.2-.21-.39-.43-.57-.65l.78-.83.57.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.87,117.09l-.66.69c-.19-.3-.4-.59-.6-.89.22-.23.45-.46.66-.69.21.29.4.59.6.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.64,85.66l-.82.8c-.19-.2-.38-.42-.56-.62l.82-.8c.19.21.38.41.56.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,143.22l-.39.86-.78-.68c.13-.29.25-.58.39-.86.25.23.52.45.78.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.37,96.63l-.75.86L70,96.83l.75-.85c.2.21.39.43.58.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,101.3l-.6.67-.72-.87.6-.66.72.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.25,119.13c-.2.3-.39.6-.58.9l-.67-.69c.19-.31.38-.6.58-.9l.67.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.26,71.07l-.86.68-.6-.57.86-.68.6.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.14,108.05c-.2.23-.41.45-.62.68-.21-.3-.44-.59-.67-.89.21-.22.42-.45.62-.68l.67.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,151.43c-.12.27-.23.55-.33.82l-.82-.66.33-.83.82.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3,92.37l-.58.65c-.26-.29-.52-.56-.78-.84l.57-.65.79.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.92,177.83c-.12.2-.25.41-.36.61l-.72-.57.36-.62c.25.19.48.39.72.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.34,179.28l-.44.6-.64-.57.43-.6.65.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.71,96.79l-.58.66c-.26-.28-.51-.57-.76-.85l.58-.66.76.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,143.36l-.79.69c-.12-.29-.26-.57-.39-.86l.79-.69.39.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,83.46l-.83.79c-.2-.2-.38-.41-.57-.62l.84-.78.56.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.77,119.3l-.68.69-.58-.9c.23-.23.45-.45.67-.69l.59.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,173.19c-.11.22-.2.45-.3.67l-.8-.59c.09-.23.2-.45.29-.68l.81.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.16,162.9c-.1.25-.19.5-.28.76L81,163c.1-.26.19-.51.28-.76l.85.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.31,81.31l-.85.77-.56-.61c.28-.26.56-.52.85-.77l.56.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,79.2l-.85.75-.57-.6c.28-.26.57-.51.86-.76l.56.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.94,103.28l-.71.87c-.21-.22-.41-.44-.61-.67.23-.3.47-.58.71-.87l.61.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.58,123.55c-.19.29-.37.59-.55.89l-.7-.69.55-.9c.23.24.46.47.7.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.84,179.25l-.45.59-.63-.57c.14-.2.3-.4.45-.6.21.2.43.38.63.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.52,141.22l-.77.68c-.14-.29-.28-.57-.41-.86l.78-.69.4.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.62,121.5l-.69.7c-.18-.3-.37-.6-.56-.9l.68-.69.57.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,155.33c-.1.27-.21.53-.31.8-.28-.22-.56-.43-.83-.66.1-.26.2-.53.31-.8l.83.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,89.92l-.8.82-.57-.64.8-.82c.19.21.39.42.57.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.37,176.28c-.11.22-.23.43-.34.64l-.75-.58c.11-.22.23-.43.34-.64l.75.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2,110.23l-.64.68-.66-.89.64-.68.66.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.73,174.74l-.33.65c-.25-.19-.51-.39-.78-.58.11-.22.21-.44.33-.66l.78.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.06,159.15c-.1.27-.21.53-.3.79l-.84-.65.3-.78.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.87,73l-.86.7c-.2-.2-.4-.39-.59-.59l.86-.69c.2.19.4.38.59.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75,171.53c-.09.23-.2.45-.29.68l-.82-.6c.1-.23.19-.46.3-.69l.81.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.44,177.77l-.39.61-.7-.57c.13-.2.25-.41.38-.62l.71.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13,103.44l-.61.68c-.23-.3-.48-.59-.71-.88l.61-.67.71.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,164.66c-.09.25-.19.5-.28.74l-.84-.62c.09-.25.18-.5.28-.75l.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,139.06l-.77.69c-.14-.29-.28-.58-.43-.87l.77-.69c.15.29.29.58.43.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.43,123.71l-.69.7-.56-.9c.24-.23.47-.46.7-.7.19.3.37.6.55.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.09,90.06l-.57.65-.81-.83.57-.64.81.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.48,136.89l-.76.69c-.14-.29-.29-.59-.44-.88L177,136c.14.3.29.59.44.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.29,70.94l-.85.67L97.83,71l.85-.67.61.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.48,169.84c-.11.23-.2.47-.3.7l-.82-.61c.09-.23.19-.47.29-.7l.83.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,125.92l-.7.69-.54-.89c.24-.23.48-.46.71-.7.18.3.36.6.53.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.84,166.4c-.1.25-.19.49-.28.73l-.85-.62c.1-.24.19-.49.29-.73l.84.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.17,168.13c-.1.24-.2.48-.29.72l-.84-.62.29-.72.84.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,134.71l-.75.69c-.15-.29-.31-.58-.46-.88l.75-.69c.16.29.31.58.46.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.94,128.12l-.72.7-.52-.89.72-.7.52.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.94,98.9l-.6.66-.75-.86.6-.66.75.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.29,87.65l-.82.81c-.19-.21-.39-.42-.57-.63l.82-.81.57.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.29,132.52l-.74.69-.49-.88c.25-.23.5-.46.74-.7l.49.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.58,94.43l-.58.66-.78-.85.58-.65c.26.28.53.56.78.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.63,130.32l-.73.7c-.16-.3-.33-.59-.5-.89l.73-.69.5.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.21,112.41l-.65.69c-.21-.3-.43-.6-.65-.89l.66-.69.64.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,177.72l-.41.61-.69-.58.41-.62.69.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.31,153.28c-.11.28-.23.54-.33.81-.28-.21-.56-.44-.83-.66l.33-.82.83.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.91,176.21c-.13.21-.25.43-.37.64l-.74-.59.37-.64.74.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.54,173.09c-.11.22-.21.44-.32.67l-.79-.6c.1-.22.21-.45.32-.67l.79.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4,161l-.3.77-.84-.64c.09-.26.19-.52.3-.77l.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.84,87.79c-.19.22-.39.43-.58.64l-.82-.81L166,87c.27.27.54.54.82.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,105.6l-.62.68c-.23-.3-.47-.59-.7-.88.21-.23.42-.45.62-.68.24.29.47.58.7.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.33,157.15,78,158l-.84-.66c.1-.26.21-.53.32-.79l.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,174.65l-.34.65-.77-.59.34-.65.77.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6,85.43c-.28.26-.56.52-.83.79l-.58-.63L80,84.8l.58.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.18,114.61c-.21.23-.44.46-.66.69l-.63-.89.66-.7.63.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.51,177.67l-.43.61c-.23-.18-.46-.38-.68-.57.14-.21.28-.42.43-.62l.68.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.94,83.24l-.85.78-.58-.62.85-.78.58.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31,171.41l-.31.69-.81-.61c.1-.23.21-.46.32-.69l.8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75,162.74c-.1.25-.21.5-.3.75l-.85-.63c.1-.26.2-.51.31-.77l.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.79,145.26l-.8.68-.39-.85.8-.69.39.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3,81.1l-.85.76c-.19-.2-.39-.4-.58-.61l.85-.77.58.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4,92.11l-.59.65-.8-.84.59-.64c.27.27.54.55.8.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65,151.22c-.12.27-.24.54-.35.82l-.83-.67c.12-.28.23-.55.36-.83l.82.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.63,143c-.14.29-.28.57-.41.86l-.8-.69c.14-.28.27-.57.41-.85l.8.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.46,176.15l-.39.63-.73-.59.39-.63.73.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.12,116.81l-.68.69-.61-.89.67-.7.62.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.05,177.63l-.45.61-.66-.58.45-.62.66.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.34,107.77l-.64.68c-.22-.3-.45-.59-.69-.88l.64-.69c.23.3.47.59.69.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.84,96.52l-.6.66-.78-.85c.21-.21.41-.44.61-.66.25.29.51.57.77.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05,169.72c-.11.23-.22.46-.31.7l-.83-.61c.1-.24.21-.48.32-.71l.82.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1,164.51c-.11.24-.21.49-.31.74l-.84-.63c.09-.25.2-.5.3-.75l.85.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,143.12l-.8.69c-.13-.29-.27-.57-.41-.86l.8-.69c.13.29.27.58.41.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,173l-.34.67-.79-.6c.11-.23.22-.45.34-.67l.79.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.67,159c-.11.26-.22.52-.32.78l-.84-.64c.1-.27.21-.53.32-.79l.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.12,140.83c-.15.29-.29.57-.43.86L68.9,141l.43-.86.79.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.75,168c-.1.24-.2.47-.31.71l-.83-.62.31-.72.83.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.43,166.26l-.31.73-.83-.63c.09-.24.2-.49.3-.73l.84.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.63,155.13c-.11.27-.23.53-.34.8l-.83-.66c.1-.27.22-.53.33-.8l.84.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.83,174.57l-.36.65-.76-.59.36-.66.76.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,89.67l-.81.82-.59-.64.81-.82.59.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,119c-.22.24-.45.47-.69.7-.19-.3-.4-.6-.6-.89l.69-.7c.21.3.41.6.6.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,177.6l-.47.61-.65-.59L114,177l.65.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,149.13c-.12.28-.25.55-.37.83-.28-.22-.55-.45-.82-.68.12-.28.24-.56.37-.83l.82.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,89.81l-.6.65-.81-.82.59-.64.82.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.87,141l-.79.69c-.14-.29-.28-.57-.43-.86l.79-.69.43.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,176.09c-.13.21-.27.42-.41.63l-.71-.59.41-.64.71.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.35,123.27c-.19.3-.39.6-.57.9l-.71-.7c.18-.3.37-.6.56-.9l.72.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87,121.22c-.23.23-.46.47-.7.7l-.58-.89c.23-.24.46-.47.7-.7l.58.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.39,109.94l-.65.69c-.22-.3-.45-.59-.68-.89l.66-.68.67.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,72.69l-.86.69-.63-.59.86-.69.63.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.17,177.57c-.16.21-.33.41-.49.61l-.63-.59c.16-.2.32-.41.49-.61l.63.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,103.16c-.2.23-.41.46-.62.68l-.73-.87.63-.68.72.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,138.81l-.78.69-.45-.87.78-.69c.15.29.31.58.45.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,171.31c-.11.22-.23.45-.34.68l-.8-.61c.11-.23.22-.46.34-.69l.8.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,160.78c-.11.26-.22.51-.32.77l-.85-.65.33-.77.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.69,123.43c-.23.24-.47.47-.71.7l-.57-.89.71-.7c.19.3.39.59.57.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.74,177.55l-.51.61-.62-.59.51-.61.62.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.68,94.17l-.61.66-.79-.84.61-.65.79.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.89,87.56l-.6.63-.83-.8.6-.64.83.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,136.63l-.77.7-.47-.88.77-.69c.16.29.32.58.47.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.06,98.63l-.62.67-.76-.86.62-.67.76.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,147c-.14.28-.27.56-.4.84l-.81-.68c.12-.28.25-.57.39-.85.27.24.54.46.82.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,153.08c-.11.27-.24.54-.36.81l-.83-.66c.11-.28.24-.55.36-.82.28.22.56.44.83.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,174.49l-.39.65-.75-.59.39-.66c.25.2.5.41.75.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47,125.64l-.72.7c-.18-.3-.37-.59-.56-.89l.73-.7.55.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6,85.21l-.85.79c-.2-.22-.4-.42-.59-.64l.84-.79.6.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.6,176l-.43.63-.71-.59.43-.63.71.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,177.54l-.53.6-.6-.59.53-.61.6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,172.9c-.13.22-.25.44-.37.67l-.78-.61c.12-.22.25-.44.36-.67l.79.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.21,134.45l-.77.7-.48-.88.76-.7.49.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,157c-.12.26-.23.53-.34.79l-.84-.66c.1-.27.22-.53.34-.79L80,157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21,127.85l-.73.7-.54-.89.73-.7c.18.3.37.59.54.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.58,132.26l-.75.69-.51-.88.76-.7c.16.3.33.59.5.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,83l-.85.78-.6-.63.85-.77L85,83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4,112.13c-.21.23-.44.46-.66.69l-.67-.89.67-.69c.23.3.45.59.66.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.91,130.06l-.74.69c-.17-.29-.34-.59-.52-.88l.74-.7.52.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.65,169.6c-.12.23-.23.46-.34.7l-.81-.62c.1-.23.22-.47.33-.7l.82.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.37,162.58c-.11.25-.22.5-.32.75l-.85-.64c.11-.25.21-.51.33-.76l.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.59,74.62l-.86.71-.63-.6L96,74l.63.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.41,105.32c-.21.23-.43.45-.65.68l-.71-.87.64-.68.72.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.37,167.87c-.12.24-.23.48-.34.71L91.2,168c.11-.24.22-.48.34-.72l.83.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.87,144.89l-.42.85-.81-.69c.13-.28.27-.56.41-.85l.82.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.72,164.36l-.33.74-.84-.64c.11-.25.21-.49.33-.74l.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.05,166.12l-.33.73-.83-.63c.1-.24.21-.49.33-.73l.83.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.18,176l-.45.62c-.23-.19-.45-.4-.69-.59l.45-.63.69.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.46,91.86l-.6.65-.82-.83.61-.65c.28.28.55.55.81.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.32,151c-.12.27-.25.54-.37.82l-.83-.67c.12-.28.24-.55.37-.83l.83.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.38,114.33l-.68.69c-.22-.29-.43-.59-.65-.89l.68-.69.65.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,174.42c-.13.22-.26.44-.4.65l-.74-.59.4-.66.74.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.12,145l-.8.69-.42-.85.81-.69c.14.29.28.57.41.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.51,171.2l-.36.69-.8-.61.36-.69.8.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.32,158.8l-.34.78-.85-.66.34-.78.85.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.34,142.75l-.43.85c-.28-.22-.54-.45-.81-.68.14-.29.28-.58.43-.86l.81.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.92,96.26l-.62.67-.78-.85.62-.66.78.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3,172.82c-.13.22-.26.44-.38.66l-.78-.6.39-.68.77.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.19,76.6l-.86.73-.63-.61.86-.72.63.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,154.94c-.12.27-.25.53-.36.8l-.85-.67c.12-.26.24-.53.37-.8.27.23.56.44.84.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.78,176c-.16.2-.31.41-.47.62l-.68-.59.47-.64.68.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.49,107.49l-.66.69c-.23-.3-.47-.59-.7-.88l.66-.69c.23.29.47.58.7.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.32,116.53l-.7.7-.63-.89.69-.7.64.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.66,142.89l-.8.68-.44-.85.81-.69c.15.28.29.57.43.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.2,89.57l-.61.65-.83-.81.62-.65.82.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.28,169.49q-.19.34-.36.69l-.82-.61.36-.7c.28.2.55.41.82.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.72,148.92l-.4.82-.83-.67.4-.84.83.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.38,175.91c-.16.21-.33.41-.49.63l-.66-.61.49-.62.66.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.62,174.36l-.43.65-.73-.6.42-.65.74.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.68,160.62c-.12.25-.24.51-.35.76l-.85-.64c.11-.26.23-.52.35-.77l.85.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.68,74.49l-.86.7-.64-.61.86-.7.64.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.22,118.74l-.71.7c-.2-.3-.41-.6-.62-.89l.71-.7c.2.3.41.59.62.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,140.73l-.8.7-.45-.87.79-.69c.16.28.31.57.46.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.62,85l-.85.79-.61-.63.85-.79.61.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,175.88l-.51.63-.65-.61.51-.63.65.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,82.83l-.86.77c-.21-.21-.42-.41-.62-.63l.86-.77.62.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,167.75c-.13.24-.24.47-.36.71l-.83-.63.36-.71.83.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,162.42l-.35.75-.84-.64c.11-.25.22-.5.35-.75l.84.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4,102.9c-.22.22-.44.45-.65.68l-.74-.87.64-.68.75.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.73,93.92l-.62.66-.81-.83.63-.66.8.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.54,109.67l-.67.69-.69-.88.67-.69.69.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.14,171.11l-.39.68-.79-.61.38-.69.8.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.93,172.74c-.14.22-.28.44-.41.66l-.77-.61.41-.66.77.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.65,152.88c-.12.27-.25.55-.38.81l-.84-.67.38-.81.84.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.65,156.79c-.13.26-.25.53-.37.79l-.84-.66c.11-.27.24-.53.36-.8l.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.08,121l-.72.7-.61-.89.72-.7c.21.29.41.59.61.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64,138.56c-.26.24-.53.47-.8.7-.15-.29-.31-.58-.47-.87l.79-.69c.16.29.33.57.48.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7,166c-.11.24-.24.49-.35.73l-.84-.63.36-.74.83.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,164.21,89,165l-.84-.64.35-.75.85.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.61,175.86c-.18.21-.36.41-.53.62l-.64-.6.53-.63.64.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.14,98.37l-.64.67-.78-.85.64-.67.78.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.14,146.8c-.13.28-.28.56-.41.84L73.9,147l.42-.85.82.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.37,125.23l-.57.89-.74-.71.57-.89.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.24,174.31c-.16.21-.31.43-.45.64l-.72-.6c.14-.22.3-.43.45-.65l.72.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,123.16l-.73.71c-.19-.3-.39-.6-.59-.89l.73-.71.59.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.07,136.39l-.78.69-.49-.87.78-.7.49.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.23,175.85c-.19.2-.37.41-.55.62-.2-.21-.41-.41-.62-.61l.55-.63.62.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.29,76.45l-.87.72-.64-.61.86-.72c.21.21.43.41.65.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86,146.93l-.83.68q-.19-.42-.42-.84l.83-.68.42.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.69,125.38l-.74.7-.57-.89.73-.7c.2.29.39.59.58.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46,134.2l-.77.7-.51-.88.78-.7c.17.29.34.58.5.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.44,127.59l-.75.7-.56-.89.75-.7.56.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.83,132l-.77.7-.53-.88.77-.7.53.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,111.86l-.68.69-.68-.88.68-.69.68.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.15,129.8l-.76.7-.54-.88.76-.71.54.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,169.39q-.21.35-.39.69l-.8-.62.38-.7.81.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49,91.62l-.63.65-.82-.82.63-.66.82.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,158.63c-.13.26-.25.52-.37.78l-.85-.66c.12-.26.24-.52.37-.78l.85.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6,144.67l-.44.85-.81-.69c.14-.28.28-.57.43-.85l.82.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.87,174.26l-.47.64-.71-.61.47-.64.71.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.51,105.05l-.66.69-.73-.87.66-.69.73.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56,172.67l-.42.66-.76-.61c.14-.23.29-.45.43-.67l.75.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,150.81c-.14.27-.27.54-.4.82L76.8,151c.13-.27.26-.55.4-.82l.84.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.88,78.47l-.87.74-.64-.62.87-.74.64.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.79,171l-.41.67-.78-.61c.13-.23.26-.46.4-.69l.79.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,154.75l-.38.8-.85-.67c.13-.26.26-.53.38-.8l.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41,144.8l-.82.69c-.14-.28-.29-.56-.43-.85L170,144c.14.29.29.57.43.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,96c-.21.22-.43.44-.64.67l-.8-.84.64-.67.8.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.67,167.64c-.13.23-.26.47-.38.71-.27-.22-.55-.42-.82-.63.12-.24.25-.48.38-.72l.82.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53,114.06c-.23.23-.47.46-.7.7l-.67-.89c.24-.23.47-.46.7-.7l.67.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.37,160.46l-.38.77-.84-.66c.12-.25.24-.51.37-.77l.85.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09,142.53l-.45.85-.82-.69c.15-.29.3-.58.46-.86l.81.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,174.22c-.17.21-.33.43-.49.64l-.69-.61c.16-.22.32-.44.49-.65l.69.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.32,87c-.28.27-.57.53-.84.8l-.64-.64.85-.8.63.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.38,165.87c-.13.24-.26.48-.38.72l-.83-.63.37-.74.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.72,162.28c-.13.25-.25.5-.37.75l-.85-.65.37-.75.85.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.07,82.64l-.86.77-.63-.63.86-.77.63.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.69,84.79l-.86.79c-.21-.22-.43-.43-.63-.65.28-.26.57-.51.85-.78l.64.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.06,164.08l-.37.74-.85-.64.38-.75.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,76.31l-.86.72c-.23-.2-.44-.41-.66-.62l.86-.71.66.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93,142.66l-.81.69c-.15-.28-.3-.57-.46-.85l.82-.7.45.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.22,172.6l-.45.67-.74-.62.44-.67.75.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59,107.22l-.67.69-.72-.87.67-.69c.24.29.49.58.72.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.45,148.71c-.14.28-.28.55-.41.83l-.84-.68.42-.84.83.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46,116.26l-.7.71-.66-.89c.24-.24.48-.47.71-.71l.65.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.62,140.37c-.17.28-.33.57-.48.86l-.81-.7.48-.86.81.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.16,174.18l-.51.64-.68-.61.51-.65.68.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.59,169.29l-.4.69-.8-.62c.13-.24.27-.47.4-.7l.8.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.36,156.62l-.39.79-.84-.67c.12-.27.25-.53.38-.79l.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.45,171l-.43.67-.77-.62c.14-.22.28-.46.43-.68l.77.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.74,93.68c-.21.22-.43.44-.64.67l-.81-.83c.21-.23.43-.45.64-.67l.81.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.38,152.69c-.13.28-.27.55-.4.81l-.84-.67c.13-.27.26-.54.4-.81l.84.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42,140.5l-.81.7c-.15-.29-.31-.58-.47-.86l.81-.7c.16.28.32.57.47.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82,174.15l-.53.64-.67-.62.53-.64.67.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.37,118.48l-.72.7-.64-.89.72-.7.64.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.46,102.64l-.66.68-.76-.86.66-.69.76.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,78.32l-.87.73-.66-.62.87-.73.66.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,172.55c-.15.22-.31.43-.47.65l-.73-.61c.15-.23.31-.45.47-.67l.73.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,98.12l-.65.67c-.27-.28-.53-.56-.79-.85l.65-.67c.27.28.53.56.79.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9,146.59l-.44.84-.83-.69c.14-.28.29-.56.44-.84l.83.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.64,109.4l-.69.7-.71-.88.69-.69.71.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.48,174.13c-.18.22-.37.42-.55.64l-.65-.62c.18-.22.37-.43.55-.64l.65.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.88,138.33l-.81.7c-.16-.29-.32-.58-.49-.87.27-.23.54-.46.8-.7l.5.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.36,167.53c-.14.23-.27.47-.41.71l-.81-.63c.13-.24.26-.48.4-.72l.82.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.23,120.69l-.73.7-.62-.89.73-.7c.21.29.42.59.62.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.73,158.47c-.14.26-.27.52-.39.77l-.86-.66c.13-.26.26-.52.4-.78l.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.15,174.12l-.57.63-.63-.62.56-.64.64.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.23,125l-.59.89-.75-.7c.19-.3.39-.6.59-.89l.75.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.13,146.71l-.83.69-.45-.83c.28-.24.56-.46.83-.7q.23.44.45.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.29,136.14l-.79.71L171,136l.79-.71.51.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,76.19l-.86.71L99,76.28l.86-.71.68.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.82,174.11l-.59.63-.62-.63.59-.63.62.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.06,122.91l-.74.7-.61-.89.75-.71.6.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13,170.87l-.45.68-.76-.63.45-.68.76.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.08,165.75c-.14.24-.27.48-.4.72l-.83-.64c.13-.24.26-.48.4-.72l.83.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.09,160.31c-.13.26-.27.51-.4.76l-.85-.65.4-.77.85.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.28,169.2c-.14.23-.29.46-.42.69l-.79-.63q.2-.34.42-.69l.79.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68,134l-.79.71-.53-.88.79-.71c.17.3.36.59.53.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.79,150.62l-.42.81-.84-.68.42-.82.84.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.56,172.5l-.49.65-.72-.62.49-.66.72.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.86,125.12l-.75.71-.6-.89c.25-.24.51-.47.75-.71l.6.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.74,154.58c-.14.26-.27.53-.4.8-.29-.22-.57-.45-.85-.68.13-.26.26-.53.4-.8l.85.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.38,144.46c-.16.28-.31.56-.46.85l-.83-.7c.16-.28.31-.56.46-.85l.83.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,111.6l-.7.7c-.23-.3-.46-.6-.7-.89.24-.23.47-.46.7-.7l.7.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,131.75l-.79.71c-.17-.3-.36-.59-.54-.88l.78-.71c.19.3.36.59.55.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.77,164l-.4.74-.83-.65c.12-.25.26-.49.39-.74l.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.62,127.33l-.77.71-.57-.88c.25-.24.5-.48.76-.71l.58.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.43,162.14l-.39.75-.84-.65.39-.76.84.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.18,82.46l-.87.77-.65-.64.86-.76.66.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.34,129.55l-.77.7-.57-.88.78-.71c.18.3.37.59.56.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.57,104.8l-.68.69c-.24-.3-.5-.58-.74-.87.22-.24.45-.46.68-.69l.74.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,95.77l-.66.67-.81-.84.66-.67.81.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.66,144.58c-.27.24-.55.47-.83.7-.15-.28-.3-.57-.46-.85l.83-.69.46.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.34,100.24l-.67.69-.78-.86c.23-.22.45-.45.67-.68l.78.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.25,172.45l-.51.66-.71-.63.51-.66.71.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.14,78.18l-.87.73-.68-.63.87-.73.68.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.89,142.31l-.48.85-.82-.7.47-.85.83.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,113.8l-.72.7-.68-.88c.24-.24.48-.47.71-.71l.69.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.06,167.43l-.42.71-.81-.64.42-.71.81.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.83,170.8c-.16.23-.32.45-.47.68l-.75-.63.46-.68.76.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.11,156.45l-.41.79-.85-.67c.13-.27.27-.53.41-.79l.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.23,148.51c-.15.28-.29.56-.44.83l-.84-.68c.14-.28.29-.56.44-.84l.84.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.16,142.44l-.82.69-.48-.85.82-.7c.17.29.33.57.48.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,169.12l-.45.69-.78-.64c.14-.23.29-.46.44-.69l.79.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.65,107l-.69.69-.74-.87q.36-.35.69-.69c.25.28.5.57.74.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.94,172.42l-.53.65-.69-.63.53-.66c.23.22.47.42.69.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.15,152.51c-.15.27-.29.54-.43.81l-.85-.68c.14-.27.28-.54.43-.81.28.23.56.46.85.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72,93.45l-.67.67-.82-.83.66-.66.83.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.43,140.15c-.17.28-.33.57-.49.85l-.82-.7.49-.86.82.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.57,116l-.73.7c-.22-.3-.44-.59-.67-.88l.73-.71.67.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8,165.64l-.42.72-.82-.64L96,165l.82.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.48,158.32l-.42.77-.85-.66.41-.78.86.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.63,140.28l-.82.7c-.16-.29-.32-.58-.49-.86l.82-.71.49.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.65,172.39c-.19.21-.37.43-.55.65l-.68-.63.55-.66.68.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54,170.74l-.49.68-.74-.63.48-.68.75.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,138l-.51.86-.81-.7c.16-.29.34-.58.51-.87L75,138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48,102.39l-.68.69c-.25-.29-.51-.58-.77-.86l.68-.69c.26.28.52.57.77.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,97.88l-.67.68-.8-.85c.23-.22.45-.45.67-.68l.8.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.51,163.83c-.15.25-.29.49-.42.74l-.84-.65.42-.74.84.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7,146.39c-.16.28-.31.56-.46.84l-.84-.69.46-.84.84.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.84,160.17l-.42.76-.85-.66.42-.77.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.18,162l-.42.75-.84-.66.42-.75.84.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.47,118.22l-.73.71-.66-.89.74-.71c.22.3.44.59.65.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.36,172.36c-.19.22-.39.43-.57.65l-.66-.63.56-.66.67.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3,78.05l-.87.73-.69-.64.86-.72.7.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.69,109.15l-.7.7-.72-.88c.23-.23.47-.46.7-.7l.72.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.07,138.1l-.81.7-.52-.86.82-.71.51.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.79,167.34l-.44.7-.81-.64.45-.71.8.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35,146.51l-.84.69-.46-.83.84-.7.46.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.71,169l-.47.69-.77-.64.47-.69.77.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.52,154.41c-.15.26-.29.53-.43.8l-.85-.68.42-.8.86.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07,172.35l-.59.64-.65-.63.59-.65c.21.21.44.42.65.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.34,120.43l-.74.72-.64-.89.74-.71c.22.29.43.59.64.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,150.43l-.44.82-.85-.69.44-.82.85.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.78,172.34l-.6.64-.63-.64.6-.65c.21.22.43.43.63.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.47,135.91l-.8.71c-.18-.29-.35-.58-.54-.87l.81-.71c.18.29.36.58.53.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.13,124.73l-.61.89-.76-.71.6-.89.77.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26,170.69l-.51.67-.73-.63c.17-.22.33-.45.51-.68l.73.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.36,127l-.6.88-.77-.71c.2-.29.39-.59.6-.88l.77.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2,144.26l-.48.84-.83-.7c.15-.28.31-.56.47-.84l.84.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.18,122.65l-.75.71-.63-.88.75-.71c.21.29.43.59.63.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.84,133.72l-.8.71-.54-.88.79-.71c.19.29.37.58.55.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93,95.54l-.67.68-.82-.84.67-.67c.28.27.55.55.82.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.59,104.55l-.7.69c-.25-.29-.5-.58-.76-.86l.7-.7.76.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,124.87l-.76.71-.62-.88.77-.71c.21.29.41.59.61.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7,111.34c-.23.24-.47.47-.71.71l-.71-.88.71-.71c.25.29.48.59.71.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.55,165.54c-.15.24-.3.48-.44.72l-.82-.65c.14-.24.29-.48.44-.72l.82.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,131.51l-.79.71-.57-.87.79-.72.57.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.86,144.37c-.27.24-.55.47-.83.7l-.48-.84.83-.7q.26.42.48.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.89,156.29l-.43.79-.86-.67c.14-.27.29-.53.44-.79l.85.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.75,127.09l-.78.71-.59-.88.77-.71.6.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,129.31l-.78.7-.58-.87.78-.72.58.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,170.65l-.53.67c-.23-.22-.48-.43-.72-.64l.53-.67.72.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,169l-.49.69-.76-.64.48-.69.77.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.48,77.93l-.87.72-.7-.63.86-.72.71.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.73,142.1l-.5.85-.83-.7.5-.85.83.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,148.32l-.46.83-.84-.69c.14-.28.3-.55.46-.83l.84.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.54,167.25l-.47.71-.79-.65.46-.71.8.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.27,163.72l-.45.73L95,163.8c.14-.25.29-.49.44-.74l.83.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26,158.17c-.15.26-.3.51-.44.77l-.85-.67.43-.78.86.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,152.34l-.45.81-.85-.69.45-.81c.28.24.57.46.85.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.68,113.55l-.73.7-.69-.88.72-.71.7.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,161.88l-.44.75-.84-.66c.15-.25.3-.5.44-.75l.84.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.61,160l-.43.77-.85-.67c.14-.26.29-.51.44-.76l.84.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.35,142.22l-.83.71-.5-.85.83-.71.5.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,170.61c-.18.22-.37.44-.54.67l-.71-.64L113,170c.24.21.48.42.71.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.66,106.72l-.7.7-.75-.87.7-.7c.25.29.51.58.75.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.28,139.93l-.51.86-.82-.7c.16-.29.33-.58.51-.86l.82.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,168.91l-.51.69c-.24-.22-.5-.43-.75-.64.16-.24.34-.47.51-.7l.75.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.11,97.65l-.68.68-.81-.84.69-.68.8.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.63,115.76l-.74.71-.69-.89.74-.71.69.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48,170.58l-.57.66-.69-.64c.19-.22.37-.45.57-.67l.69.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,140.06l-.83.71-.51-.86.82-.71.52.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.32,165.44c-.16.24-.32.48-.47.72l-.81-.65c.15-.24.3-.48.46-.72l.82.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.54,146.2c-.17.28-.33.56-.49.84l-.84-.7c.15-.28.32-.56.48-.84l.85.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.07,80l-.87.73L98.5,80l.87-.74.7.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.32,154.25l-.45.79-.85-.68.45-.8.85.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.87,137.76c-.18.28-.36.57-.53.86l-.82-.71.53-.87.82.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.3,167.17l-.48.71-.79-.65.49-.71.78.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.23,170.56l-.58.66-.68-.65.58-.66.68.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54,146.31l-.85.7-.48-.83.84-.71c.16.29.33.56.49.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.41,150.26l-.47.81-.85-.69.47-.82.85.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,118l-.74.71-.68-.88.75-.71c.23.29.45.59.67.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.22,137.88l-.82.71c-.18-.29-.35-.58-.54-.86l.83-.71c.17.29.36.57.53.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.71,108.91l-.72.7c-.25-.29-.5-.58-.74-.88l.72-.7.74.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,170.54l-.6.66-.66-.65.59-.66.67.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.05,163.61l-.46.74-.83-.66.46-.74.83.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,168.86c-.18.22-.36.45-.53.68-.25-.22-.49-.43-.75-.64.18-.23.35-.47.53-.69l.75.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7,156.14l-.46.79-.85-.68.45-.79.86.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.75,170.53l-.62.66-.65-.65.62-.66.65.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05,144.06c-.17.28-.33.56-.49.84l-.85-.7.5-.84.84.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.41,120.19c-.25.24-.5.48-.76.71L169,120c.26-.24.51-.47.76-.72l.66.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.61,135.69c-.27.24-.54.48-.82.71-.18-.29-.36-.58-.55-.86l.82-.72.55.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,161.77l-.46.74-.84-.66c.16-.25.31-.5.46-.75l.84.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.08,124.5l-.63.88-.78-.72.63-.88.78.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.07,158l-.46.77-.85-.67.45-.78.86.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.42,159.91c-.16.25-.31.5-.46.76l-.84-.67.45-.77.85.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,126.72l-.62.88-.78-.72c.2-.29.4-.59.61-.88l.79.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.56,104.31l-.71.7c-.25-.29-.51-.57-.77-.86l.71-.7c.26.28.52.57.77.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.25,122.41l-.77.72-.64-.89.77-.71c.22.29.43.58.64.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,144.17l-.84.71c-.17-.28-.34-.56-.5-.84l.84-.71c.17.28.34.56.5.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,133.49l-.8.71-.57-.87.81-.71c.19.29.38.58.56.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,165.35l-.48.72-.81-.65c.16-.24.32-.49.49-.73.27.22.53.45.8.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.08,167.1l-.5.7-.78-.65.5-.7c.27.21.52.43.78.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,111.1l-.73.71c-.25-.29-.49-.59-.73-.88l.73-.71c.24.3.49.59.73.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,168.81l-.55.68-.73-.65c.18-.23.36-.46.55-.68l.73.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.06,124.63l-.78.72c-.2-.3-.42-.59-.63-.88l.78-.72.63.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.78,152.18l-.46.8-.86-.68c.15-.27.31-.54.47-.81.29.22.57.45.85.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.29,131.28l-.8.72-.59-.88.81-.71.58.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9,148.14l-.49.83-.85-.7.49-.83.85.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.84,126.85l-.79.72-.61-.88.78-.72.62.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,129.07l-.79.72-.6-.88.79-.72.6.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6,141.9l-.52.85-.83-.7c.16-.29.34-.57.52-.86l.83.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5,142l-.84.71-.52-.85c.28-.24.55-.48.84-.71.17.28.34.57.52.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.53,168.77l-.57.68-.72-.65.56-.69c.24.23.49.44.73.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7,113.3,168,114c-.23-.3-.47-.59-.71-.88l.74-.71.72.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,163.52l-.48.73-.82-.66.48-.74.82.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.16,154.09l-.47.8c-.28-.23-.57-.45-.85-.69l.47-.79.85.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.63,106.49l-.72.7-.76-.87.72-.7.76.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.88,167l-.53.7-.77-.66.53-.7.77.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.18,139.73c-.19.28-.36.57-.54.86l-.83-.71c.17-.29.35-.58.54-.86l.83.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.41,146c-.17.27-.34.55-.5.83l-.85-.7c.16-.28.33-.56.5-.84l.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.91,165.27l-.51.72-.8-.66.51-.72.8.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.32,168.74l-.59.68-.7-.66.58-.68.71.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.93,139.85l-.84.71c-.17-.28-.35-.57-.54-.86l.84-.71.54.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.57,161.66c-.16.25-.33.49-.48.74l-.83-.66c.16-.25.31-.5.48-.75l.83.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.27,150.09c-.17.27-.33.54-.49.81l-.85-.69.48-.82c.29.23.58.46.86.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.54,156l-.47.79-.86-.69c.15-.26.32-.52.47-.78l.86.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,115.52l-.75.71-.71-.88.76-.71c.23.29.47.58.7.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.68,146.12l-.84.71-.51-.84.85-.7c.17.28.34.55.5.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.79,137.55c-.19.28-.38.57-.56.86l-.82-.71c.17-.29.36-.58.55-.87l.83.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25,159.79c-.17.25-.33.5-.48.76l-.84-.68c.15-.25.32-.5.48-.76l.84.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9,157.9l-.47.77-.85-.67c.15-.26.31-.52.47-.78l.85.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.11,168.72l-.6.67-.69-.66.6-.68.69.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68,167l-.54.7-.76-.66.54-.7.76.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.33,137.67l-.83.71-.55-.86.83-.72.55.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.92,168.7c-.21.22-.42.44-.62.67l-.68-.66c.2-.23.41-.45.62-.68.22.23.45.45.68.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.68,108.67l-.74.71-.75-.87.73-.71.76.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.55,117.73c-.25.25-.51.48-.76.72l-.69-.88.76-.72.69.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.72,168.69c-.21.22-.43.44-.63.67l-.67-.66.63-.68.67.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,143.87c-.18.28-.35.56-.52.84l-.85-.7c.17-.28.35-.56.52-.85l.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68,163.43l-.51.72-.81-.66.5-.73.82.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,152l-.49.8c-.29-.22-.57-.46-.85-.69l.48-.8.86.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.72,165.2l-.52.71-.79-.66.53-.72.78.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.7,135.47l-.82.72-.57-.87.82-.71c.2.29.39.58.57.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.43,120c-.25.25-.51.48-.77.72l-.68-.88.78-.72.67.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.16,144l-.85.71-.52-.84.84-.71c.18.28.36.56.53.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,148l-.51.83-.85-.7.51-.83.85.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5,166.94l-.56.69-.75-.66.56-.7.75.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.27,126.5l-.63.88-.79-.72c.2-.3.41-.59.63-.88l.79.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.05,133.27l-.82.72-.59-.87.82-.72.59.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.28,122.18l-.78.72-.66-.88.78-.72c.22.29.45.58.66.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.69,110.87l-.75.71-.74-.87L166,110c.24.3.49.59.74.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.41,161.56c-.17.24-.34.49-.5.74-.28-.22-.56-.44-.83-.67l.5-.75.83.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.52,141.71l-.54.85c-.28-.24-.57-.47-.84-.71.17-.29.35-.57.53-.85l.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.36,131.06l-.81.72-.61-.87.81-.72.61.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,124.4c-.26.25-.53.48-.79.72l-.65-.88.79-.72.65.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,154l-.49.79c-.29-.23-.58-.45-.86-.69l.5-.79L90,154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63,128.85l-.8.72-.62-.88L167,128l.61.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,126.63l-.8.72c-.2-.3-.42-.59-.63-.88l.8-.72c.21.29.43.58.63.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.6,141.82l-.84.71-.54-.84.84-.72.54.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.32,166.89c-.19.24-.39.47-.58.7l-.73-.67.58-.69.73.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1,159.68l-.5.75-.84-.67.5-.77.84.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,155.87l-.5.78-.85-.69c.16-.26.32-.52.49-.78l.86.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,165.14l-.55.71-.77-.67c.17-.24.36-.48.54-.71l.78.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,157.78c-.17.25-.33.51-.49.77l-.85-.68c.16-.26.33-.52.5-.78l.84.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52,163.34l-.52.73-.81-.67.52-.73.81.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.66,113.07l-.75.72-.73-.88.75-.71.73.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.57,106.26l-.74.71-.78-.87.74-.7.78.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.11,139.54l-.55.85-.84-.71c.18-.29.36-.58.55-.86l.84.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.32,145.84c-.18.28-.35.56-.53.83l-.85-.7.52-.84.86.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.16,149.93l-.51.81-.85-.7c.16-.27.33-.55.51-.82l.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.16,166.86l-.6.69-.72-.66c.2-.23.39-.47.6-.7l.72.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,139.65l-.84.72-.56-.86.84-.72c.19.29.37.58.56.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.74,137.35c-.2.29-.39.57-.57.86l-.84-.72.57-.86.84.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,166.84l-.62.69c-.23-.23-.47-.45-.71-.67l.62-.7.71.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,115.29c-.25.24-.51.47-.76.72l-.72-.88.76-.72c.25.29.49.58.72.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,165.08c-.19.23-.38.47-.56.71l-.77-.67c.19-.24.37-.48.57-.72l.76.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.27,161.47c-.18.24-.35.49-.53.74l-.82-.68c.18-.24.35-.5.53-.74l.82.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.55,151.87c-.18.27-.34.54-.51.81l-.86-.7.51-.81.86.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.84,166.82l-.63.69-.69-.68c.21-.22.41-.46.63-.69l.69.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,137.47l-.83.71-.58-.86.84-.72c.19.29.39.58.57.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.88,143.7l-.54.83c-.29-.23-.57-.47-.85-.71L83,143l.85.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,108.45l-.75.71-.77-.87.75-.71.77.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38,163.27c-.18.24-.37.48-.54.72l-.8-.67.54-.73.8.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.69,166.81l-.65.69-.68-.68.65-.69.68.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54,166.81l-.67.68c-.21-.23-.44-.45-.66-.68l.66-.68c.23.22.45.45.67.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.53,117.51l-.78.72c-.23-.3-.47-.59-.7-.88l.77-.72.71.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,147.81l-.53.82-.85-.7.52-.83.86.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,159.57c-.18.25-.35.5-.52.76l-.84-.68c.17-.26.35-.51.52-.76l.84.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.25,143.8l-.85.71-.55-.84.85-.71c.19.28.37.56.55.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.93,153.81l-.51.79-.86-.69.51-.79.86.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.76,135.27l-.83.72c-.2-.29-.4-.57-.59-.86l.83-.73.59.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.26,165l-.58.71-.76-.68c.2-.23.39-.47.58-.71l.76.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.65,157.67c-.17.25-.35.5-.52.76l-.84-.69.52-.77.84.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3,155.74c-.17.26-.35.52-.51.78-.29-.22-.57-.46-.86-.69.17-.26.34-.52.52-.78l.85.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.42,119.73l-.79.72-.69-.88.78-.72c.24.29.47.58.7.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.09,133.06l-.83.73-.61-.87c.28-.24.56-.48.83-.73.2.3.41.58.61.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.47,141.53l-.56.84-.85-.71.56-.85.85.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.29,126.28c-.21.3-.44.59-.65.88l-.81-.72.65-.88.81.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.62,110.65l-.76.71-.76-.87.76-.71c.25.28.51.57.76.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.27,122l-.79.72c-.23-.29-.46-.58-.68-.88l.79-.72c.23.29.46.58.68.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.15,161.38c-.19.25-.37.49-.54.74l-.82-.68.54-.74.82.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.39,130.85l-.83.72-.62-.87.82-.72.63.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.25,163.2l-.56.72-.79-.67c.18-.25.37-.49.56-.73l.79.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.13,165l-.6.7-.74-.67c.19-.24.39-.48.59-.71l.75.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.09,124.18l-.8.73-.66-.88.8-.73.66.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.67,141.64l-.85.71-.56-.84c.28-.25.57-.48.85-.72.19.28.38.56.56.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.09,149.77c-.18.27-.36.54-.53.82l-.86-.71c.17-.27.35-.54.53-.81l.86.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.65,128.63l-.81.73c-.21-.3-.43-.59-.64-.88l.82-.72.63.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89,126.41l-.81.72-.65-.87.81-.73.65.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.26,145.67l-.55.84-.85-.71c.17-.29.36-.56.54-.84l.86.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.08,139.35l-.57.85-.85-.71.58-.86.84.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.59,112.85l-.76.72-.75-.87.77-.72.74.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,165l-.61.71-.74-.68.62-.71.73.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.87,159.48l-.54.75-.83-.69.54-.75.83.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.48,151.73c-.19.27-.36.54-.54.8l-.85-.7c.17-.26.34-.53.53-.8l.86.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.07,139.46l-.85.72c-.19-.29-.38-.57-.58-.85l.85-.72c.2.28.39.57.58.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.14,163.14l-.58.72-.78-.67c.19-.25.38-.49.58-.73l.78.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.89,164.93c-.22.23-.43.46-.64.7-.23-.23-.48-.45-.72-.68l.63-.71.73.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.56,157.56l-.54.76q-.42-.33-.84-.69l.54-.77.84.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.85,153.69l-.53.78-.85-.7L93,153l.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,161.3l-.56.74c-.26-.23-.53-.45-.81-.68l.57-.74.8.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.22,155.63c-.19.25-.36.52-.54.77l-.85-.69.54-.78.85.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.55,115.07l-.78.72-.74-.87.78-.73.74.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.84,143.52l-.56.84-.86-.71.57-.84.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,164.91c-.21.24-.43.47-.65.7l-.71-.69.65-.7.71.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.65,147.66l-.55.81c-.28-.23-.58-.46-.86-.7l.55-.83.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.44,137.27l-.85.72-.59-.85.84-.73c.2.29.41.57.6.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.66,164.9c-.22.24-.45.46-.66.7l-.7-.69.66-.7.7.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3,143.62l-.85.72-.57-.84.86-.71c.19.27.38.55.56.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55,164.9l-.68.69-.68-.69.68-.7.68.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,163.09l-.59.72-.77-.68.59-.73.77.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.47,117.29l-.79.73-.72-.88.79-.73.72.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78,135.07l-.84.73-.61-.87.84-.72.61.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.79,159.39l-.56.75-.82-.69.55-.75.83.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.45,141.36c-.19.28-.39.56-.57.84l-.86-.72c.19-.28.38-.57.58-.84l.85.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,149.63l-.55.81-.86-.71.55-.81.86.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,161.23l-.58.74-.79-.69.57-.74.8.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.36,119.52l-.8.72-.71-.87.8-.73.71.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.09,132.86l-.84.73-.62-.87.84-.72c.2.29.41.57.62.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.94,163.05c-.2.24-.42.47-.61.72l-.76-.69.61-.72.76.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.71,141.46l-.86.72c-.19-.28-.38-.57-.58-.85l.86-.72c.19.28.39.56.58.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,145.52c-.19.27-.37.55-.56.83l-.86-.72c.18-.28.37-.55.56-.83l.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.22,121.74l-.8.73-.7-.87.8-.73.7.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.49,157.46l-.56.76-.83-.69c.18-.26.37-.51.56-.77l.83.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.37,130.65l-.83.73-.64-.87.83-.73.64.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43,151.6l-.55.8-.86-.7.55-.81.86.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.05,124l-.81.73-.68-.87.81-.73.68.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.63,128.43l-.83.72-.65-.87.82-.73.66.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.85,126.2l-.81.73-.67-.87.82-.73.66.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.16,155.52c-.19.25-.37.51-.56.77l-.84-.69c.18-.27.36-.53.55-.79l.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8,153.56c-.18.27-.37.53-.55.79l-.85-.7c.18-.26.37-.52.55-.79l.85.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.09,139.18l-.6.85-.85-.73c.19-.28.39-.57.6-.85l.85.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86,163l-.64.71-.75-.69.64-.72.75.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.49,112.64l-.78.73-.76-.87.78-.73.76.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,161.17l-.6.74-.79-.69.6-.74.79.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72,159.31l-.58.75-.81-.69.57-.75.82.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.08,139.28l-.85.72-.59-.85.85-.72.59.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.78,163c-.22.24-.44.47-.65.71l-.74-.69.65-.72c.25.24.5.46.74.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.63,147.51c-.2.27-.38.55-.57.82l-.86-.72.57-.82.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.84,143.36l-.58.84-.86-.72.58-.84.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7,163l-.66.71-.72-.7c.21-.24.44-.47.66-.71l.72.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.42,163l-.72.7L125,163l.72-.7.67.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.44,114.86l-.79.73-.75-.87.79-.73.75.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.44,137.09l-.86.72c-.2-.28-.4-.57-.61-.85l.85-.73c.21.29.42.57.62.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.44,157.37c-.2.25-.39.51-.58.76l-.83-.7.58-.76.83.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63,163c-.22.24-.46.47-.68.7l-.71-.69.68-.71.71.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.49,163l-.71.7-.68-.7.71-.71c.23.24.45.48.68.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,161.12l-.61.73-.78-.69.61-.74.78.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.56,163l-.69.7-.7-.7.7-.71.69.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,149.5l-.57.8-.86-.71.57-.81.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.66,159.24l-.59.75-.81-.7.6-.75.8.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36,117.08l-.79.73-.74-.87.8-.73.73.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.12,155.42l-.57.77-.84-.7.57-.78.84.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,134.89l-.85.72-.63-.85.85-.74.63.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.47,141.19l-.6.84-.86-.72.6-.84.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.41,151.48c-.2.26-.39.53-.57.79l-.86-.7.57-.8.86.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.78,153.45l-.58.79-.85-.71.58-.79c.28.24.56.48.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.24,145.37l-.59.82c-.29-.23-.57-.48-.86-.72l.58-.82.87.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.76,161.08c-.21.24-.43.48-.63.72l-.77-.69c.2-.24.41-.49.63-.73.25.24.51.46.77.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.71,141.29l-.86.72-.6-.84.86-.73.6.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.26,119.31l-.81.73-.72-.87.81-.73.72.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.06,132.67l-.85.73-.64-.86.84-.73c.22.29.43.58.65.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.65,128.12,83,129l-.83-.73.67-.87.83.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.13,121.54l-.82.73-.71-.87.82-.73.71.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.33,130.45l-.84.74-.66-.87.84-.73.66.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,157.29l-.6.76-.82-.7.59-.76.83.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.13,139c-.22.28-.41.56-.62.85-.28-.25-.57-.49-.86-.73.2-.29.41-.57.62-.85l.86.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,123.77l-.82.74c-.23-.3-.46-.59-.7-.88l.82-.73.7.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.57,128.23l-.84.73-.67-.86.84-.74.67.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,161l-.65.73-.76-.7.65-.73.76.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.62,159.18l-.61.74-.8-.7.62-.75.79.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.78,126l-.82.74-.69-.88.83-.73.68.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.63,147.37l-.58.82-.86-.72c.19-.27.38-.55.58-.82l.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.07,139.11l-.86.72-.62-.84.86-.73.62.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,112.44l-.79.73-.77-.87.79-.73.77.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.87,143.21c-.21.28-.4.56-.6.83l-.87-.72.6-.83.87.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67,161l-.66.73-.75-.7.66-.73.75.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.1,155.33c-.2.25-.39.51-.59.77l-.84-.71.6-.77.83.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,149.37l-.59.81c-.28-.25-.57-.48-.86-.72l.59-.81.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.77,153.35l-.59.78-.85-.71.59-.78.85.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.64,161l-.68.72-.74-.71.68-.72.74.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.41,151.37c-.2.26-.4.52-.59.79l-.86-.71c.2-.27.39-.54.59-.8l.86.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.51,161l-.74.71c-.22-.25-.45-.48-.68-.72l.74-.72c.22.25.45.49.68.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.6,159.12l-.63.75-.79-.71c.2-.24.41-.5.63-.74l.79.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,136.91l-.86.73c-.2-.28-.41-.57-.63-.85l.86-.73.63.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.3,114.66l-.8.73-.76-.87.8-.73.76.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61,161l-.7.71-.72-.71.69-.72.73.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.54,161l-.72.71-.7-.71.73-.72.69.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.39,157.22l-.61.75-.82-.7c.2-.25.4-.51.61-.76l.82.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.57,161l-.7.71-.72-.71.71-.72.71.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.52,141l-.62.84-.86-.73.61-.84.87.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.27,145.23c-.21.27-.41.55-.61.82l-.86-.72.6-.83.87.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.7,134.71l-.85.73-.64-.86.85-.73.64.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.23,116.89l-.81.73-.75-.87.81-.73q.38.42.75.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,159.08c-.21.25-.44.49-.65.74-.25-.24-.52-.47-.78-.71.21-.25.43-.49.65-.74l.78.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.11,155.24c-.21.26-.41.52-.62.77l-.83-.71.61-.77.84.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,132.49l-.85.74-.66-.86.85-.74.66.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,119.11l-.82.74-.74-.87c.28-.24.55-.49.82-.74l.74.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.67,147.24c-.2.28-.41.54-.61.82l-.86-.72.6-.82.87.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.38,157.15c-.21.26-.42.5-.62.76l-.81-.71.62-.76.81.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.19,138.85l-.63.85c-.28-.25-.57-.49-.86-.73l.63-.85.86.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.57,159l-.66.74-.77-.71.66-.74.77.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.78,153.26l-.61.78-.84-.72.61-.78.84.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.24,130.27l-.84.74-.68-.87.85-.73.67.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,121.35l-.82.73-.73-.87.83-.73c.24.29.49.58.72.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.06,149.26c-.21.26-.41.53-.61.8l-.86-.72.61-.81.86.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,151.26c-.2.27-.4.53-.61.79l-.85-.72c.21-.26.4-.53.61-.79l.85.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,143.07l-.62.83-.86-.73c.2-.28.41-.55.62-.83l.86.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.47,128l-.84.74-.69-.86.84-.74c.23.29.47.57.69.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.85,123.58l-.83.74-.71-.87.83-.74.71.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,138.94l-.87.74-.63-.85.86-.73.64.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,125.81l-.83.74-.7-.87.83-.74.7.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,159c-.23.24-.46.48-.68.73l-.76-.71c.22-.25.45-.49.68-.74l.76.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39,157.1l-.65.75-.79-.71c.21-.25.42-.51.64-.76l.8.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12,155.17l-.63.77-.82-.72c.2-.26.42-.51.63-.77l.82.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.57,159l-.69.73-.75-.72.69-.73.75.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,159c-.25.24-.51.47-.75.71-.23-.24-.47-.48-.7-.73l.75-.72.7.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.33,136.75l-.86.73c-.21-.29-.43-.57-.65-.85l.86-.73c.22.28.44.56.65.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,145.1l-.62.82-.87-.73.62-.82.87.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,159l-.71.72-.74-.72c.24-.24.48-.48.71-.73l.74.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.59,159l-.74.72c-.23-.24-.47-.48-.7-.73l.73-.72.71.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.58,159l-.72.73-.72-.73.72-.72.72.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.12,114.47l-.81.74-.78-.87.82-.73c.26.29.52.57.77.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.59,140.89l-.63.84L90.1,141l.63-.84.86.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.82,153.17l-.63.78-.84-.72.63-.78.84.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.41,157.05c-.22.26-.45.5-.66.75l-.8-.72c.22-.25.45-.49.67-.75l.79.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.73,147.13l-.63.81c-.28-.25-.57-.49-.86-.73l.62-.82.87.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,134.54l-.86.74-.66-.86.86-.74.66.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.48,151.16l-.63.79-.85-.72.63-.79.85.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,116.7l-.82.74-.77-.87.82-.74.77.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,149.15c-.21.27-.42.53-.62.8l-.86-.72.62-.81.86.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.15,155.1l-.65.77-.81-.72.64-.77.82.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.89,132.32l-.86.74-.68-.85.86-.75c.22.29.45.57.68.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,118.93l-.82.74-.76-.87.83-.74.75.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,157c-.23.24-.46.49-.68.74L113,157l.68-.75.78.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,142.94l-.63.82L92.5,143l.64-.83.86.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.13,130.1l-.86.74c-.22-.29-.46-.57-.69-.86l.85-.74c.24.28.47.57.7.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,121.16l-.84.75-.74-.87.83-.74.75.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.34,127.87c-.28.25-.56.5-.85.74l-.7-.86c.28-.25.57-.49.85-.75l.7.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,153.1l-.64.77-.83-.72.64-.78c.28.24.56.48.83.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,123.4l-.84.74-.73-.86.84-.75.73.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.47,157c-.23.24-.47.49-.69.74L115,157l.69-.75c.26.24.52.48.77.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,125.63l-.85.75-.72-.87.85-.74.72.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,155.05l-.66.76-.81-.72.66-.77.81.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.41,145c-.22.27-.43.54-.64.82l-.86-.74.63-.82.87.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.51,157c-.24.24-.47.49-.71.74L117,157c.24-.25.47-.5.71-.74l.76.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54,151.08l-.64.78-.85-.72.65-.79.84.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.81,147l-.64.8c-.29-.24-.58-.48-.86-.73l.63-.81.87.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7,140.76c-.22.28-.44.55-.65.83l-.87-.74.65-.83.87.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55,157l-.72.73-.75-.73.72-.74.75.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18,149.05l-.63.8-.86-.73.64-.8.85.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.59,157c-.24.24-.49.48-.73.73-.24-.25-.49-.49-.74-.73l.74-.74c.25.24.49.49.73.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.24,155c-.22.25-.45.5-.67.76l-.8-.73.67-.76c.27.25.54.48.8.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.93,153l-.66.77-.83-.72.66-.78.83.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,134.38l-.86.74c-.23-.28-.46-.56-.68-.85l.86-.74c.23.28.46.56.68.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,142.81c-.22.28-.44.55-.65.83l-.87-.74c.21-.28.44-.55.65-.83l.87.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.31,155c-.23.25-.47.5-.7.76l-.79-.73.69-.76.8.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.75,132.16l-.86.75-.69-.86.86-.75.69.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,151l-.66.78-.84-.73.66-.78.84.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.76,118.76l-.83.74-.77-.86.84-.75.76.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.52,144.86l-.66.82L97,145c.21-.28.43-.55.65-.82l.87.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,129.93l-.86.75c-.23-.29-.47-.57-.71-.86l.86-.74.71.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,153l-.67.77-.82-.73.67-.77.82.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28,149l-.66.8-.85-.74.66-.79.85.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,154.93c-.24.26-.48.5-.71.76l-.78-.74.7-.75.79.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.91,146.92l-.66.8c-.28-.25-.57-.49-.86-.73l.66-.81.86.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65,121l-.84.75-.75-.86.84-.75.75.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.18,127.7l-.85.75-.72-.86.85-.75.72.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,123.23l-.85.75-.74-.87.84-.74.75.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.36,125.47c-.28.25-.57.49-.85.75l-.73-.87.85-.74.73.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.45,154.91l-.72.75-.77-.73c.23-.26.48-.51.72-.76l.77.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.53,154.9l-.74.75-.76-.74.73-.75.77.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,152.92c-.23.26-.47.51-.69.77l-.81-.73c.22-.26.46-.51.69-.77l.81.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38,148.88c-.22.27-.44.53-.67.79l-.84-.73.67-.8.84.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.64,144.76l-.67.82-.86-.74c.22-.28.45-.55.67-.82l.86.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.18,152.88l-.7.77-.8-.74.7-.77.8.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,146.82l-.68.81c-.28-.25-.56-.5-.85-.74l.67-.81.86.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.59,132l-.87.75-.71-.85.87-.75.71.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.16,146.75c-.23.26-.46.53-.68.8l-.86-.75.69-.8c.28.25.57.49.85.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.79,144.67l-.69.81-.86-.75q.35-.39.69-.81l.86.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.69,104a80.81,80.81,0,0,0-74.78,35.62,1,1,0,0,1-1.76-.16h0L236.92,78.69l-4-9.22a122.49,122.49,0,1,0-9.24,122.06,3.25,3.25,0,0,0,.31-3.12L206,146.64a2.16,2.16,0,0,0-4,.23c-12.12,39.5-52.89,66.47-98.08,56.64a81.77,81.77,0,0,1-62.5-63c-11.26-53.72,29.42-101,81.16-101A83.05,83.05,0,0,1,197.11,86q1.72,3.54,3.14,7.26l34.17,79.08,3.72,8.62a16.13,16.13,0,0,1-.16,13.14l-44.11,95.8a3.3,3.3,0,0,0,4.08,4.49l42-14.58a6,6,0,0,0,3.44-3.13L262,236.21l1.14-2.48a2.68,2.68,0,0,1,4.57-.5,80.86,80.86,0,0,0,49.19,30.6,82.31,82.31,0,0,0,15.25,1.43A80.83,80.83,0,0,0,339.69,104Zm2,120.8a41.48,41.48,0,0,1-49.86-49.85,40.69,40.69,0,0,1,30.75-30.78A41.49,41.49,0,0,1,372.48,194,40.7,40.7,0,0,1,341.7,224.75Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklogomark);
export default __webpack_public_path__ + "static/media/black logo mark.60ce1004f57abeb047df6a4a20498b3c.svg";
export { ForwardRef as ReactComponent };